
const { useState, useEffect, useMemo } = React;

/* ---------- Supabase Auth ---------- */
const SB_URL = 'https://auth.gayworkation.com';
const SB_ANON_KEY = 'sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH';
// EMAIL_TO_USER wurde entfernt — Mapping kommt aus trainer.app_users via /api/app-users
const sb = window.supabase ? window.supabase.createClient(SB_URL, SB_ANON_KEY) : null;

/* ---------- Palette & Typo ---------- */
const C = {
  bg: "#10201B", surface: "#18302A", surface2: "#1F3D34", line: "#2C4A40",
  text: "#EAF1ED", muted: "#8AA59B", accent: "#E8B04B", accent2: "#5FB99A",
  danger: "#E07A5F",
};
const GROUP = {
  Brust: "#E8957A", Rücken: "#7AA8E8", Schulter: "#E8C36B",
  Arme: "#C39BE8", Beine: "#7FD0A2", Bauch: "#AEB9B3",
};
const FONT = '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
const NUM = { fontVariantNumeric: "tabular-nums" };

/* ---------- Übungs-Katalog (Name, Gruppe, konkrete Muskeln, Tags) ---------- */
const CATALOG = [
  // Brust
  { n: "Bankdrücken (Langhantel)", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter, Trizeps", t: ["brust"] },
  { n: "Schrägbank DB-Brustdrücken", g: "Brust", m: "obere Brust (Pectoralis major, klavikulär), vordere Schulter, Trizeps", t: ["brust", "brust_o"] },
  { n: "Schrägbank Langhantel-Drücken", g: "Brust", m: "obere Brust (Pectoralis major, klavikulär), vordere Schulter, Trizeps", t: ["brust", "brust_o"] },
  { n: "Flachbank DB-Drücken", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter, Trizeps", t: ["brust"] },
  { n: "Negativbank-Drücken", g: "Brust", m: "untere Brust (Pectoralis major, sternal), Trizeps", t: ["brust", "brust_u"] },
  { n: "Brustpresse (Maschine)", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter, Trizeps", t: ["brust"] },
  { n: "Pec Fly", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter", t: ["brust"] },
  { n: "Kabel-Crossover", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter", t: ["brust"] },
  { n: "Liegestütze", g: "Brust", m: "Brust (Pectoralis major), Trizeps, vordere Schulter, Rumpf", t: ["brust"] },
  // Rücken
  { n: "Latzug (breit)", g: "Rücken", m: "breiter Rückenmuskel (Latissimus dorsi), Bizeps", t: ["lat"] },
  { n: "Latzug (eng)", g: "Rücken", m: "breiter Rückenmuskel (Latissimus, unterer Anteil), Bizeps", t: ["lat"] },
  { n: "Latzug Maschine", g: "Rücken", m: "breiter Rückenmuskel (Latissimus dorsi), Bizeps", t: ["lat"], comp: true },
  { n: "Klimmzug", g: "Rücken", m: "breiter Rückenmuskel (Latissimus), oberer Rücken, Bizeps", t: ["lat"] },
  { n: "Langhantelrudern", g: "Rücken", m: "mittlerer Rücken (Rhomboiden, Trapez), Latissimus, hintere Schulter", t: ["ruecken_m", "lat"] },
  { n: "T-Bar Rudern", g: "Rücken", m: "mittlerer Rücken (Rhomboiden, Trapez), Latissimus", t: ["ruecken_m", "lat"] },
  { n: "Rudern am Kabel", g: "Rücken", m: "mittlerer Rücken (Rhomboiden, Trapez), Latissimus", t: ["ruecken_m"] },
  { n: "Maschinen-Rudern", g: "Rücken", m: "mittlerer Rücken (Rhomboiden, Trapez), Latissimus", t: ["ruecken_m"] },
  { n: "Einarmiges DB-Rudern", g: "Rücken", m: "mittlerer Rücken (Latissimus, Rhomboiden), hintere Schulter", t: ["ruecken_m", "lat"] },
  { n: "Überzüge", g: "Rücken", m: "breiter Rückenmuskel (Latissimus), Brust", t: ["lat"] },
  { n: "Reverse Fly", g: "Rücken", m: "hintere Schulter (Deltoideus posterior), oberer Rücken", t: ["delt_h", "ruecken_m"] },
  { n: "Kreuzheben", g: "Rücken", m: "unterer Rücken (Erector spinae), Gesäß, Beinbeuger, Trapez", t: ["ruecken_u", "ham", "glute"] },
  { n: "Rückenstrecker (Hyperextension)", g: "Rücken", m: "unterer Rücken (Erector spinae), Gesäß, Beinbeuger", t: ["ruecken_u"] },
  { n: "Rücken Extension Gerät", g: "Rücken", m: "unterer Rücken (Erector spinae), Gesäß, Beinbeuger", t: ["ruecken_u"], comp: false },
  // Schulter
  { n: "Schulterdrücken (DB)", g: "Schulter", m: "vordere Schulter (Deltoideus anterior), seitliche Schulter, Trizeps", t: ["delt_v"] },
  { n: "Overhead Press (Langhantel)", g: "Schulter", m: "vordere Schulter (Deltoideus anterior), seitliche Schulter, Trizeps", t: ["delt_v"] },
  { n: "Schulterdrücken (Maschine)", g: "Schulter", m: "vordere/seitliche Schulter (Deltoideus), Trizeps", t: ["delt_v"] },
  { n: "Arnold Press", g: "Schulter", m: "vordere & seitliche Schulter (Deltoideus ant./lat.), Trizeps", t: ["delt_v", "delt_s"] },
  { n: "Seitheben", g: "Schulter", m: "seitliche Schulter (Deltoideus lateralis)", t: ["delt_s"] },
  { n: "Kabel-Seitheben", g: "Schulter", m: "seitliche Schulter (Deltoideus lateralis)", t: ["delt_s"] },
  { n: "Frontheben", g: "Schulter", m: "vordere Schulter (Deltoideus anterior)", t: ["delt_v"] },
  { n: "Face Pulls", g: "Schulter", m: "hintere Schulter (Deltoideus posterior), oberer Trapez", t: ["delt_h"] },
  { n: "Upright Row", g: "Schulter", m: "seitliche Schulter (Deltoideus lateralis), Trapez", t: ["delt_s", "traps"] },
  { n: "Nackenheben (Shrugs)", g: "Schulter", m: "Trapez (oberer Anteil)", t: ["traps"] },
  // Arme – Bizeps
  { n: "Bizeps DB-Curls", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"] },
  { n: "Langhantel-Curls", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"] },
  { n: "SZ-Curls", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"] },
  { n: "Hammer DB Curls", g: "Arme", m: "Oberarm (Brachialis), Bizeps, Unterarm (Brachioradialis)", t: ["bizeps", "brachialis"] },
  { n: "Hammer Curls Seil", g: "Arme", m: "Unterarm (Brachioradialis), Bizeps (Biceps brachii), Oberarm (Brachialis)", t: ["bizeps", "brachialis"], comp: false },
  { n: "Preacher-Curls", g: "Arme", m: "Bizeps (kurzer Kopf, Biceps brachii)", t: ["bizeps"] },
  { n: "Preacher Curls Maschine", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"], comp: false },
  { n: "Konzentrations-Curls", g: "Arme", m: "Bizeps (Biceps brachii, Peak)", t: ["bizeps"] },
  { n: "Kabel-Curls", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"] },
  { n: "Schrägbank-Curls (Incline)", g: "Arme", m: "Bizeps (langer Kopf, Dehnung)", t: ["bizeps"] },
  { n: "Spider-Curls", g: "Arme", m: "Bizeps (kurzer Kopf)", t: ["bizeps"] },
  // Arme – Trizeps & Unterarm
  { n: "Trizeps Pushdown", g: "Arme", m: "Trizeps (seitlicher Kopf, Triceps brachii)", t: ["tri_seit"] },
  { n: "Trizeps Pushdown (Untergriff)", g: "Arme", m: "Trizeps (mittlerer/innerer Kopf)", t: ["tri_med", "tri_seit"] },
  { n: "Überkopf-Trizeps (Seil)", g: "Arme", m: "Trizeps (langer Kopf, Triceps brachii)", t: ["tri_lang"] },
  { n: "French Press", g: "Arme", m: "Trizeps (langer Kopf)", t: ["tri_lang"] },
  { n: "Enges Bankdrücken", g: "Arme", m: "Trizeps (alle Köpfe), Brust, vordere Schulter", t: ["tri_seit", "tri_lang"] },
  { n: "Dips", g: "Arme", m: "Trizeps, untere Brust, vordere Schulter", t: ["tri_seit", "brust_u"] },
  { n: "Kickbacks", g: "Arme", m: "Trizeps (seitlicher & langer Kopf)", t: ["tri_seit", "tri_lang"] },
  { n: "Trizeps-Maschine", g: "Arme", m: "Trizeps (alle Köpfe)", t: ["tri_seit", "tri_lang"] },
  { n: "Handgelenks-Curls", g: "Arme", m: "Unterarm-Beuger (Flexoren)", t: ["unterarm"] },
  // Beine
  { n: "Kniebeuge", g: "Beine", m: "Quadrizeps, Gesäß (Glutaeus maximus), Beinbeuger, Rumpf", t: ["quad", "glute"] },
  { n: "Frontkniebeuge", g: "Beine", m: "Quadrizeps (betont), Gesäß, Rumpf", t: ["quad"] },
  { n: "Beinpresse", g: "Beine", m: "Quadrizeps, Gesäß (Glutaeus)", t: ["quad", "glute"] },
  { n: "Goblet-Kniebeuge", g: "Beine", m: "Quadrizeps, Gesäß, Rumpf", t: ["quad", "glute"] },
  { n: "Hackenschmidt-Kniebeuge", g: "Beine", m: "Quadrizeps (betont), Gesäß", t: ["quad"] },
  { n: "Ausfallschritte", g: "Beine", m: "Quadrizeps, Gesäß (Glutaeus), Beinbeuger", t: ["quad", "glute"] },
  { n: "Bulgarian Split Squat", g: "Beine", m: "Quadrizeps, Gesäß (Glutaeus)", t: ["quad", "glute"] },
  { n: "Beinstrecker", g: "Beine", m: "Quadrizeps (Rectus femoris, Vasti)", t: ["quad"] },
  { n: "Beinbeuger", g: "Beine", m: "Beinbeuger (Hamstrings: Biceps femoris u. a.)", t: ["ham"] },
  { n: "Beinbeuger (sitzend)", g: "Beine", m: "Beinbeuger (Hamstrings)", t: ["ham"] },
  { n: "Rumänisches Kreuzheben (DB)", g: "Beine", m: "Beinbeuger (Hamstrings), Gesäß (Glutaeus), unterer Rücken", t: ["ham", "glute"] },
  { n: "Hip Thrust", g: "Beine", m: "Gesäß (Glutaeus maximus), Beinbeuger", t: ["glute", "ham"] },
  { n: "Abduktoren-Maschine", g: "Beine", m: "Gesäß (Glutaeus medius), Abduktoren", t: ["abd", "glute"] },
  { n: "Adduktoren-Maschine", g: "Beine", m: "Adduktoren (Oberschenkelinnenseite)", t: ["add"] },
  { n: "Wadenheben", g: "Beine", m: "Wade (Gastrocnemius)", t: ["wade"] },
  { n: "Wadenheben (sitzend)", g: "Beine", m: "Wade (Soleus)", t: ["wade"] },
  // Bauch
  { n: "Plank", g: "Bauch", m: "Rumpf (Transversus, gerade Bauchmuskeln)", t: ["rumpf", "bauch_g"], timed: true },
  { n: "Side Plank", g: "Bauch", m: "seitliche Bauchmuskeln (Obliquus), Rumpf", t: ["bauch_s", "rumpf"], timed: true },
  { n: "Crunch / Kabel-Crunch", g: "Bauch", m: "gerade Bauchmuskeln (Rectus abdominis)", t: ["bauch_g"] },
  { n: "Crunch auf Ball", g: "Bauch", m: "gerade Bauchmuskeln (Rectus abdominis), seitliche Bauchmuskeln (Obliquus)", t: ["bauch_g", "bauch_s"], comp: false },
  { n: "Beinheben", g: "Bauch", m: "untere gerade Bauchmuskeln (Rectus abdominis)", t: ["bauch_g"] },
  { n: "Hängendes Beinheben", g: "Bauch", m: "untere Bauchmuskeln (Rectus abdominis), Hüftbeuger", t: ["bauch_g"] },
  { n: "Russian Twist", g: "Bauch", m: "seitliche Bauchmuskeln (Obliquus)", t: ["bauch_s"] },
  { n: "Käfer (Dead Bug)", g: "Bauch", m: "Rumpf (tiefe Bauchmuskeln, Transversus)", t: ["rumpf"] },
  { n: "Ab Wheel (Bauchroller)", g: "Bauch", m: "gerade Bauchmuskeln (Rectus), Rumpf", t: ["bauch_g", "rumpf"] },
  { n: "Mountain Climbers", g: "Bauch", m: "Rumpf, Hüftbeuger, gerade Bauchmuskeln", t: ["rumpf", "bauch_g"] },

  // ===== TRX / Schlingentrainer =====
  { n: "TRX Rudern", g: "Rücken", m: "Latissimus, mittlerer Rücken, Bizeps, hintere Schulter", t: ["ruecken_m", "lat"], cat: "trx" },
  { n: "TRX Power Pull", g: "Rücken", m: "Latissimus, Rücken, Bizeps", t: ["lat", "ruecken_m"], cat: "trx" },
  { n: "TRX Y-Fly", g: "Schulter", m: "hintere Schulter, unterer Trapez", t: ["delt_h", "traps"], cat: "trx" },
  { n: "TRX T-Fly", g: "Schulter", m: "hintere Schulter, mittlerer Rücken", t: ["delt_h", "ruecken_m"], cat: "trx" },
  { n: "TRX Face Pull", g: "Schulter", m: "hintere Schulter, Trapez", t: ["delt_h", "traps"], cat: "trx" },
  { n: "TRX Brustpresse", g: "Brust", m: "Brust (Pectoralis), Trizeps, vordere Schulter", t: ["brust"], cat: "trx" },
  { n: "TRX Brustfliegende", g: "Brust", m: "Brust (Pectoralis), vordere Schulter", t: ["brust"], cat: "trx" },
  { n: "TRX Atomic Push-up", g: "Brust", m: "Brust, Trizeps, Rumpf", t: ["brust", "rumpf"], cat: "trx" },
  { n: "TRX Bizeps-Curl", g: "Arme", m: "Bizeps (Biceps brachii)", t: ["bizeps"], cat: "trx" },
  { n: "TRX Trizeps-Strecken", g: "Arme", m: "Trizeps (alle Köpfe)", t: ["tri_lang", "tri_seit"], cat: "trx" },
  { n: "TRX Kniebeuge", g: "Beine", m: "Quadrizeps, Gesäß, Beinbeuger", t: ["quad", "glute"], cat: "trx" },
  { n: "TRX Ausfallschritt", g: "Beine", m: "Quadrizeps, Gesäß, Beinbeuger", t: ["quad", "glute"], cat: "trx" },
  { n: "TRX Pistol Squat (assistiert)", g: "Beine", m: "Quadrizeps, Gesäß", t: ["quad", "glute"], cat: "trx" },
  { n: "TRX Hamstring Curl", g: "Beine", m: "Beinbeuger (Hamstrings), Gesäß", t: ["ham", "glute"], cat: "trx" },
  { n: "TRX Hip Press", g: "Beine", m: "Gesäß (Glutaeus), Beinbeuger", t: ["glute", "ham"], cat: "trx" },
  { n: "TRX Plank", g: "Bauch", m: "Rumpf, gerade Bauchmuskeln", t: ["rumpf", "bauch_g"], cat: "trx", timed: true },
  { n: "TRX Pike", g: "Bauch", m: "gerade Bauchmuskeln, Rumpf, Schulter", t: ["bauch_g", "rumpf"], cat: "trx" },
  { n: "TRX Knee Tuck", g: "Bauch", m: "untere/gerade Bauchmuskeln, Rumpf", t: ["bauch_g", "rumpf"], cat: "trx" },
  { n: "TRX Mountain Climber", g: "Bauch", m: "Rumpf, Hüftbeuger, Bauchmuskeln", t: ["rumpf", "bauch_g"], cat: "trx" },
  { n: "TRX Oblique Crunch", g: "Bauch", m: "seitliche Bauchmuskeln (Obliquus)", t: ["bauch_s"], cat: "trx" },

  // ===== Calisthenics / Eigengewicht =====
  { n: "Klimmzug breit (Wide)", g: "Rücken", m: "Latissimus (breit), Bizeps, hintere Schulter", t: ["lat"], cat: "cali" },
  { n: "Chin-up (Untergriff)", g: "Rücken", m: "Latissimus, Bizeps", t: ["lat", "bizeps"], cat: "cali" },
  { n: "Australian Pull-up (Inverted Row)", g: "Rücken", m: "mittlerer Rücken, Latissimus, Bizeps", t: ["ruecken_m", "lat"], cat: "cali" },
  { n: "Muscle-up", g: "Rücken", m: "Latissimus, Brust, Trizeps, Bizeps", t: ["lat", "brust"], cat: "cali" },
  { n: "Diamant-Liegestütze", g: "Arme", m: "Trizeps, Brust", t: ["tri_seit", "brust"], cat: "cali" },
  { n: "Breite Liegestütze", g: "Brust", m: "Brust (Pectoralis), vordere Schulter, Trizeps", t: ["brust"], cat: "cali" },
  { n: "Negativ-Liegestütze", g: "Brust", m: "obere Brust, vordere Schulter, Trizeps", t: ["brust", "brust_o"], cat: "cali" },
  { n: "Pike-Liegestütze", g: "Schulter", m: "vordere/seitliche Schulter, Trizeps", t: ["delt_v"], cat: "cali" },
  { n: "Handstand-Liegestütze", g: "Schulter", m: "Schulter (Deltoideus), Trizeps", t: ["delt_v"], cat: "cali" },
  { n: "Archer-Liegestütze", g: "Brust", m: "Brust (einseitig betont), Trizeps", t: ["brust"], cat: "cali" },
  { n: "Barren-Dips", g: "Arme", m: "Trizeps, untere Brust, vordere Schulter", t: ["tri_seit", "brust_u"], cat: "cali" },
  { n: "Bank-Dips", g: "Arme", m: "Trizeps", t: ["tri_seit"], cat: "cali" },
  { n: "Pistol Squat", g: "Beine", m: "Quadrizeps, Gesäß", t: ["quad", "glute"], cat: "cali" },
  { n: "Sissy Squat", g: "Beine", m: "Quadrizeps (Rectus femoris)", t: ["quad"], cat: "cali" },
  { n: "Nordic Hamstring Curl", g: "Beine", m: "Beinbeuger (Hamstrings, exzentrisch)", t: ["ham"], cat: "cali" },
  { n: "Glute Bridge", g: "Beine", m: "Gesäß (Glutaeus), Beinbeuger", t: ["glute", "ham"], cat: "cali" },
  { n: "Wadenheben (Körpergewicht)", g: "Beine", m: "Wade (Gastrocnemius)", t: ["wade"], cat: "cali" },
  { n: "L-Sit", g: "Bauch", m: "gerade Bauchmuskeln, Hüftbeuger", t: ["bauch_g", "rumpf"], cat: "cali", timed: true },
  { n: "Toes to Bar", g: "Bauch", m: "gerade/untere Bauchmuskeln, Unterarm", t: ["bauch_g"], cat: "cali" },
  { n: "Hollow Body Hold", g: "Bauch", m: "gerade Bauchmuskeln, Rumpf", t: ["bauch_g", "rumpf"], cat: "cali", timed: true },
  { n: "Dragon Flag", g: "Bauch", m: "gerade Bauchmuskeln, Rumpf", t: ["bauch_g", "rumpf"], cat: "cali" },
  { n: "Burpee", g: "Beine", m: "Ganzkörper: Beine, Brust, Rumpf", t: ["quad", "rumpf", "brust"], cat: "cali" },

  // ----- Keiser (pneumatische Kabel-Stationen): statt Gewicht wird der pneumatische Wert eingestellt -----
  { n: "Keiser Brustpresse", g: "Brust", m: "Brust (Pectoralis), Trizeps, vordere Schulter", t: ["brust"], cat: "keiser", pneu: true },
  { n: "Pec Fly sitzend Keiser", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter", t: ["brust"], cat: "keiser", pneu: true, comp: false },
  // Kabel-Fly an der Keiser-Säule – die Zughöhe macht es zu drei verschiedenen Übungen:
  { n: "Keiser Kabel-Fly von unten (obere Brust)", g: "Brust", m: "obere Brust (Schlüsselbeinanteil), vordere Schulter – Pulleys tief, Zug nach oben", t: ["brust", "brust_o"], cat: "keiser", pneu: true },
  { n: "Keiser Kabel-Fly Mitte (mittlere Brust)", g: "Brust", m: "mittlere/sternale Brust, vordere Schulter – Pulleys auf Brusthöhe, waagerecht", t: ["brust"], cat: "keiser", pneu: true },
  { n: "Keiser Kabel-Fly von oben (untere Brust)", g: "Brust", m: "untere Brust, vordere Schulter – Pulleys hoch, Zug nach unten", t: ["brust", "brust_u"], cat: "keiser", pneu: true },
  // Keiser Pec Fly (Butterfly-Station) – Sitzhöhe/Griffhöhe steuert den betonten Brustanteil:
  { n: "Keiser Pec Fly (oben)", g: "Brust", m: "obere Brust (Schlüsselbeinanteil), vordere Schulter – Griffe tief, Zug leicht aufwärts", t: ["brust", "brust_o"], cat: "keiser", pneu: true, comp: false },
  { n: "Keiser Pec Fly (Mitte)", g: "Brust", m: "mittlere/sternale Brust, vordere Schulter – Griffe auf Brusthöhe, waagerecht", t: ["brust"], cat: "keiser", pneu: true, comp: false },
  { n: "Keiser Pec Fly (unten)", g: "Brust", m: "untere Brust, vordere Schulter – Griffe hoch, Zug leicht abwärts", t: ["brust", "brust_u"], cat: "keiser", pneu: true, comp: false },
  { n: "Keiser Latzug", g: "Rücken", m: "Latissimus, Bizeps, hintere Schulter", t: ["lat"], cat: "keiser", pneu: true },
  { n: "Keiser Kabel-Rudern", g: "Rücken", m: "Latissimus, mittlerer Rücken, Bizeps, Trapez", t: ["ruecken_m", "lat"], cat: "keiser", pneu: true },
  { n: "Keiser Schulterdrücken", g: "Schulter", m: "vordere/seitliche Schulter, Trizeps", t: ["delt_v"], cat: "keiser", pneu: true },
  { n: "Keiser Seitheben am Kabel", g: "Schulter", m: "seitliche Schulter (Deltoideus)", t: ["delt_s"], cat: "keiser", pneu: true },
  { n: "Keiser Bizeps-Curl", g: "Arme", m: "Bizeps (Biceps brachii), Unterarm", t: ["bizeps"], cat: "keiser", pneu: true },
  { n: "Keiser Trizeps-Pushdown", g: "Arme", m: "Trizeps (alle Köpfe)", t: ["tri_seit", "tri_lang"], cat: "keiser", pneu: true },
  { n: "Keiser Kniebeuge", g: "Beine", m: "Quadrizeps, Gesäß, Beinbeuger", t: ["quad", "glute"], cat: "keiser", pneu: true },
  { n: "Keiser Beinpresse", g: "Beine", m: "Quadrizeps, Gesäß, Beinbeuger", t: ["quad", "glute"], cat: "keiser", pneu: true },
  { n: "Keiser Hip Extension (Kabel)", g: "Beine", m: "Gesäß (Glutaeus), Beinbeuger", t: ["glute", "ham"], cat: "keiser", pneu: true },
  { n: "Keiser Kabel-Crunch", g: "Bauch", m: "gerade Bauchmuskeln (Rectus abdominis)", t: ["bauch_g"], cat: "keiser", pneu: true },
  // Rotation/Holzhacker – Zughöhe ändert den Schwerpunkt:
  { n: "Keiser Holzhacker von oben (High-to-Low)", g: "Bauch", m: "seitliche Bauchmuskeln (Obliquus), Rumpf, Latissimus – Pulley hoch, diagonal nach unten", t: ["bauch_s", "rumpf"], cat: "keiser", pneu: true },
  { n: "Keiser Holzhacker von unten (Low-to-High)", g: "Bauch", m: "seitliche Bauchmuskeln (Obliquus), Rumpf, vordere Schulter – Pulley tief, diagonal nach oben", t: ["bauch_s", "rumpf"], cat: "keiser", pneu: true },

  // ===== EGym (elektronische Kraftmaschinen, egym.com – Widerstand wird elektronisch eingestellt, Anzeige als Gewicht) =====
  { n: "EGym Brustpresse", g: "Brust", m: "Brust (Pectoralis), Trizeps, vordere Schulter", t: ["brust"], cat: "egym" },
  { n: "EGym Butterfly", g: "Brust", m: "Brust (Pectoralis major), vordere Schulter", t: ["brust"], cat: "egym", comp: false },
  { n: "EGym Latzug", g: "Rücken", m: "Latissimus, Bizeps, hintere Schulter", t: ["lat"], cat: "egym" },
  { n: "EGym Rudern", g: "Rücken", m: "mittlerer Rücken (Rhomboiden, Trapez), Latissimus, Bizeps", t: ["ruecken_m", "lat"], cat: "egym" },
  { n: "EGym Reverse Fly", g: "Schulter", m: "hintere Schulter (Deltoideus posterior), oberer Rücken", t: ["delt_h", "ruecken_m"], cat: "egym", comp: false },
  { n: "EGym Rückenstrecker", g: "Rücken", m: "unterer Rücken (Erector spinae), Gesäß, Beinbeuger", t: ["ruecken_u"], cat: "egym", comp: false },
  { n: "EGym Schulterpresse", g: "Schulter", m: "vordere/seitliche Schulter (Deltoideus), Trizeps", t: ["delt_v"], cat: "egym" },
  { n: "EGym Bizeps-Curl", g: "Arme", m: "Bizeps (Biceps brachii), Unterarm", t: ["bizeps"], cat: "egym", comp: false },
  { n: "EGym Trizeps-Presse", g: "Arme", m: "Trizeps (alle Köpfe)", t: ["tri_seit", "tri_lang"], cat: "egym", comp: false },
  { n: "EGym Beinpresse", g: "Beine", m: "Quadrizeps, Gesäß (Glutaeus), Beinbeuger", t: ["quad", "glute"], cat: "egym" },
  { n: "EGym Beinstrecker", g: "Beine", m: "Quadrizeps (Rectus femoris, Vasti)", t: ["quad"], cat: "egym", comp: false },
  { n: "EGym Beinbeuger", g: "Beine", m: "Beinbeuger (Hamstrings)", t: ["ham"], cat: "egym", comp: false },
  { n: "EGym Abduktoren", g: "Beine", m: "Gesäß (Glutaeus medius), Abduktoren (Hüftabspreizer)", t: ["abd", "glute"], cat: "egym", comp: false },
  { n: "EGym Adduktoren", g: "Beine", m: "Adduktoren (Oberschenkelinnenseite)", t: ["add"], cat: "egym", comp: false },
  { n: "EGym Glutes (Hip Extension)", g: "Beine", m: "Gesäß (Glutaeus maximus), Beinbeuger", t: ["glute", "ham"], cat: "egym" },
  { n: "EGym Bauchpresse", g: "Bauch", m: "gerade Bauchmuskeln (Rectus abdominis)", t: ["bauch_g"], cat: "egym" },
];

// Eigene (vom Nutzer angelegte) Übungen – modulweit, wird aus dem App-State gespeist.
let CUSTOM = [];
// Overrides auf den festen Katalog (eingebaute Übungen umbenennen/löschen) – aus dem App-State gespeist.
let EX_OVERRIDES = { renames: {}, hidden: [] };
// Zu einem (evtl. umbenannten) Anzeigenamen den ursprünglichen Katalognamen finden.
const originalName = (cur) => Object.keys(EX_OVERRIDES.renames).find((k) => EX_OVERRIDES.renames[k] === cur) || cur;
// Effektiver Katalog: ausgeblendete Übungen entfernt, Umbenennungen angewandt.
const effectiveCatalog = () => CATALOG
  .filter((e) => !EX_OVERRIDES.hidden.includes(e.n))
  .map((e) => EX_OVERRIDES.renames[e.n] ? { ...e, n: EX_OVERRIDES.renames[e.n] } : e);
// Katalog + eigene Übungen, per Name dedupliziert (Katalog gewinnt, falls eine eigene Übung
// denselben Namen wie ein Katalogeintrag trägt – z. B. nachträglich in den Katalog übernommen).
const allEx = () => {
  const seen = new Set();
  return effectiveCatalog().concat(CUSTOM).filter((e) => seen.has(e.n) ? false : seen.add(e.n));
};
const CAT_LABEL = { trx: "TRX", cali: "Calisthenics", keiser: "Keiser", egym: "EGym", custom: "Eigene" };
const CAT_ORDER = { kraft: 0, undefined: 0, egym: 0.5, trx: 1, cali: 2, keiser: 3, custom: 4 };
const exCat = (e) => e && e.cat ? e.cat : "kraft";
// Alle im CATALOG hinterlegten Gerätekategorien (aus dem cat-Feld), z. B. trx, cali, keiser, egym.
const DEVICE_CATS = [...new Set(CATALOG.map((e) => e.cat).filter(Boolean))];
// Vom Nutzer global ausgeschlossene Gerätekategorien (persistiert im KV Store) – aus dem App-State gespeist.
let EXCLUDED_CATS = [];
// Katalog + eigene Übungen, ohne Übungen aus ausgeschlossenen Gerätekategorien – für automatische Auswahl.
const availableEx = () => allEx().filter((e) => !EXCLUDED_CATS.includes(exCat(e)));
const LIB = CATALOG.map((e) => ({ name: e.n, group: e.g, muscle: e.m }));
const find = (name) => allEx().find((e) => e.n === name);
const ex = (name, sets, reps) => {
  const f = find(name) || { n: name, g: "Sonstige", m: "" };
  return { name: f.n, group: f.g, muscle: f.m, targetSets: sets, targetReps: reps };
};
// Alternativen: nach Relevanz gefiltert, Reihenfolge Kraft -> TRX -> Calisthenics (-> Eigene).
const alternatives = (name, max = 10) => {
  const self = find(name);
  if (!self) return [];
  return availableEx().filter((e) => e.n !== name)
    .map((e) => ({ e, shared: (e.t || []).filter((tg) => (self.t || []).includes(tg)).length, same: e.g === self.g ? 1 : 0 }))
    .filter((o) => o.shared > 0)
    .sort((a, b) => (CAT_ORDER[exCat(a.e)] - CAT_ORDER[exCat(b.e)]) || (b.shared - a.shared) || (b.same - a.same))
    .slice(0, max)
    .map((o) => ({ name: o.e.n, group: o.e.g, muscle: o.e.m, cat: exCat(o.e) }));
};
const getInfo = (name) => {
  const f = find(name);
  const i = INFO[name];
  return {
    group: f ? f.g : "Sonstige",
    muscles: f ? f.m : "",
    desc: i ? i.desc : (f ? `Übung für ${f.g}.` : "Eigene Übung."),
    cues: i ? i.cues : ["Sauber und kontrolliert ausführen", "Volle Bewegungsamplitude nutzen", "Zielmuskel bewusst anspannen", "Letzte 1-2 Wdh nahe ans Versagen"],
  };
};

const PLAN = {
  "Beine": [
    ex("Kniebeuge", 4, "8-12"), ex("Rumänisches Kreuzheben (DB)", 3, "8-12"),
    ex("Ausfallschritte", 3, "10/Bein"), ex("Beinstrecker", 3, "12-15"),
    ex("Beinbeuger", 3, "12-15"), ex("Beinbeuger (sitzend)", 3, "12-15"),
    ex("Wadenheben", 4, "15"), ex("Crunch / Kabel-Crunch", 3, "15"),
    ex("Beinheben", 3, "12-15"),
  ],
  "Oberkörper A": [
    ex("Schrägbank DB-Brustdrücken", 4, "8-12"), ex("Pec Fly", 3, "10-12"),
    ex("Latzug (breit)", 3, "8-12"), ex("Rudern am Kabel", 3, "10-12"),
    ex("Schulterdrücken (DB)", 3, "8-12"), ex("Seitheben", 3, "12-15"),
    ex("Trizeps Pushdown", 3, "10-12"), ex("Face Pulls", 3, "15"),
    ex("Bizeps DB-Curls", 3, "8-12"), ex("Hammer DB Curls", 3, "10-12"),
    ex("Crunch / Kabel-Crunch", 3, "15"), ex("Side Plank", 3, "30 Sek/Seite"),
  ],
  "Oberkörper B": [
    ex("Latzug (eng)", 4, "8-12"), ex("Einarmiges DB-Rudern", 3, "10-12"),
    ex("Face Pulls", 3, "15"), ex("Flachbank DB-Drücken", 3, "8-12"),
    ex("Pec Fly", 3, "10-12"), ex("Seitheben", 3, "12-15"),
    ex("SZ-Curls", 3, "8-12"), ex("Preacher-Curls", 3, "10-12"),
    ex("Trizeps Pushdown (Untergriff)", 3, "10-12"), ex("Überkopf-Trizeps (Seil)", 3, "10-12"),
    ex("Beinheben", 3, "15"), ex("Russian Twist", 3, "20"),
  ],
  "Ganzkörper (optional)": [
    ex("Beinpresse", 3, "10"), ex("Flachbank DB-Drücken", 3, "8-12"),
    ex("Latzug (breit)", 3, "10-12"), ex("Seitheben", 3, "12-15"),
    ex("Bizeps DB-Curls", 3, "10-12"), ex("Trizeps Pushdown", 3, "10-12"),
    ex("Wadenheben", 4, "15"), ex("Plank", 3, "30-60 Sek"),
  ],
};
const BASE_DAYS = Object.keys(PLAN);
const DAYMETA = {
  "Beine": "Mo · Quads, Hamstrings, Waden, Bauch",
  "Oberkörper A": "Do · Push-Schwerpunkt",
  "Oberkörper B": "Fr · Pull-Schwerpunkt",
  "Ganzkörper (optional)": "Sa/So · Bonus",
};

const planMeta = (day, plan) => {
  if (DAYMETA[day]) return DAYMETA[day];
  const groups = [...new Set((plan[day] || []).map((e) => e.group))].join(', ');
  return groups || 'Profilbasierter Trainingstag';
};
const tokenizeList = (text) => String(text || '')
  .split(/[,\n;]/)
  .map((x) => x.trim().toLowerCase())
  .filter(Boolean);
const isAvoided = (exercise, profile) => {
  const tokens = tokenizeList(profile?.avoidedExercises + '\n' + profile?.restrictions);
  if (!tokens.length) return false;
  const hay = `${exercise.name} ${exercise.group} ${exercise.muscle}`.toLowerCase();
  return tokens.some((t) => t.length >= 3 && hay.includes(t));
};
const withAvoidance = (exercise, profile) => {
  if (!isAvoided(exercise, profile)) return exercise;
  const alt = alternatives(exercise.name, 10).find((a) => !isAvoided(a, profile));
  return alt ? { ...exercise, name: alt.name, group: alt.group, muscle: alt.muscle } : exercise;
};
const trimDay = (items, maxExercises) => items.slice(0, maxExercises);
const generatedDay = (items, profile, maxExercises) => trimDay(items.map((e) => withAvoidance(e, profile)), maxExercises);
const generatePlanBase = (profile) => {
  const days = Number(profile?.trainingDays || 4);
  const minutes = Number(profile?.sessionMinutes || 60);
  const max = minutes <= 40 ? 6 : minutes <= 55 ? 8 : 12;
  if (days <= 2) {
    return {
      "Ganzkörper A": generatedDay([
        ex("Beinpresse", 3, "8-12"), ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Latzug (breit)", 3, "8-12"), ex("Rudern am Kabel", 3, "10-12"), ex("Seitheben", 3, "12-15"), ex("Trizeps Pushdown", 2, "10-12"), ex("Bizeps DB-Curls", 2, "10-12"), ex("Plank", 3, "30-60 Sek"),
      ], profile, max),
      "Ganzkörper B": generatedDay([
        ex("Rumänisches Kreuzheben (DB)", 3, "8-12"), ex("Flachbank DB-Drücken", 3, "8-12"), ex("Latzug (eng)", 3, "8-12"), ex("Einarmiges DB-Rudern", 3, "10-12"), ex("Face Pulls", 3, "15"), ex("Hammer DB Curls", 2, "10-12"), ex("Überkopf-Trizeps (Seil)", 2, "10-12"), ex("Beinheben", 3, "12-15"),
      ], profile, max),
    };
  }
  if (days === 3) {
    return {
      "Ganzkörper A": generatedDay([ex("Kniebeuge", 3, "8-12"), ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Latzug (breit)", 3, "8-12"), ex("Seitheben", 3, "12-15"), ex("Trizeps Pushdown", 2, "10-12"), ex("Crunch / Kabel-Crunch", 3, "15")], profile, max),
      "Ganzkörper B": generatedDay([ex("Rumänisches Kreuzheben (DB)", 3, "8-12"), ex("Flachbank DB-Drücken", 3, "8-12"), ex("Rudern am Kabel", 3, "10-12"), ex("Face Pulls", 3, "15"), ex("Bizeps DB-Curls", 2, "10-12"), ex("Plank", 3, "30-60 Sek")], profile, max),
      "Ganzkörper C": generatedDay([ex("Beinpresse", 3, "10"), ex("Pec Fly", 3, "10-12"), ex("Latzug (eng)", 3, "8-12"), ex("Einarmiges DB-Rudern", 3, "10-12"), ex("Seitheben", 3, "12-15"), ex("Hammer DB Curls", 2, "10-12"), ex("Überkopf-Trizeps (Seil)", 2, "10-12"), ex("Beinheben", 3, "15")], profile, max),
    };
  }
  const base = {
    "Beine": generatedDay(PLAN["Beine"], profile, max),
    "Oberkörper A": generatedDay(PLAN["Oberkörper A"], profile, max),
    "Oberkörper B": generatedDay(PLAN["Oberkörper B"], profile, max),
    "Ganzkörper optional": generatedDay(PLAN["Ganzkörper (optional)"], profile, max),
  };
  if (days >= 5) {
    base["Schwachstellen/Arme"] = generatedDay([ex("Seitheben", 4, "12-15"), ex("Face Pulls", 3, "15"), ex("Bizeps DB-Curls", 3, "10-12"), ex("Hammer DB Curls", 3, "10-12"), ex("Trizeps Pushdown", 3, "10-12"), ex("Überkopf-Trizeps (Seil)", 3, "10-12"), ex("Crunch / Kabel-Crunch", 3, "15")], profile, max);
  }
  if (days >= 6) {
    base["Mobility & Core"] = generatedDay([ex("Plank", 3, "30-60 Sek"), ex("Side Plank", 3, "30 Sek/Seite"), ex("Käfer (Dead Bug)", 3, "10/Seite"), ex("Mountain Climbers", 3, "30 Sek"), ex("Wadenheben", 3, "15")], profile, Math.min(max, 6));
  }
  return base;
};

// Ziel-abhängiges Satz-/Wdh-Schema. Zeit-basierte Übungen (Plank etc.) bleiben unberührt.
const GOAL_SCHEME = {
  "Kraft": { reps: "5-8", isoReps: "8-10", setsDelta: 1, note: "Schwer, 5–8 Wdh, lange Pausen (2–3 Min)" },
  "Muskelaufbau": { reps: null, isoReps: null, setsDelta: 0, note: "8–12 Wdh, 60–90 s Pause" },
  "Fitness": { reps: "10-15", isoReps: "12-15", setsDelta: 0, note: "10–15 Wdh, zügiges Tempo" },
  "Fettverlust": { reps: "12-15", isoReps: "12-20", setsDelta: 0, note: "12–15 Wdh, kurze Pausen (45–60 s)" },
  "Mobility/Reha": { reps: "12-15", isoReps: "12-15", setsDelta: -1, note: "Leicht, sauber, 12–15 Wdh" },
};
const COMPOUND_HINT = ["Kniebeuge", "Beinpresse", "Kreuzheben", "Bankdrücken", "Langhantel-Drücken", "Overhead Press", "Rudern", "Klimmzug", "Latzug", "Brustdrücken", "Schulterdrücken", "Drücken"];
const isCompound = (name) => {
  const f = find(name);
  if (f && typeof f.comp === "boolean") return f.comp; // explizit gesetzter Typ (eigene Übungen)
  return COMPOUND_HINT.some((c) => name.includes(c));
};
const applyGoalToPlan = (plan, goal) => {
  const scheme = GOAL_SCHEME[goal] || GOAL_SCHEME["Muskelaufbau"];
  const out = {};
  Object.keys(plan).forEach((day) => {
    out[day] = (plan[day] || []).map((e) => {
      if (/Sek|Seite/.test(e.targetReps)) return e; // Zeit/Halteübungen unverändert
      const compound = isCompound(e.name);
      const reps = compound ? (scheme.reps || e.targetReps) : (scheme.isoReps || e.targetReps);
      const sets = Math.max(2, (e.targetSets || 3) + (compound ? scheme.setsDelta : 0));
      return { ...e, targetReps: reps, targetSets: sets };
    });
  });
  return out;
};
const generatePlanFromProfile = (profile) => applyGoalToPlan(generatePlanBase(profile), profile?.goal);

/* ---------- Wählbare Aufteilungen (Splits) ---------- */
const SPLIT_TEMPLATES = {
  PUSH: [ex("Bankdrücken (Langhantel)", 4, "6-10"), ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Schulterdrücken (DB)", 3, "8-12"), ex("Seitheben", 3, "12-15"), ex("Trizeps Pushdown", 3, "10-12"), ex("Überkopf-Trizeps (Seil)", 2, "10-12")],
  PULL: [ex("Klimmzug", 4, "6-10"), ex("Langhantelrudern", 3, "8-12"), ex("Latzug (breit)", 3, "10-12"), ex("Face Pulls", 3, "15"), ex("Bizeps DB-Curls", 3, "10-12"), ex("Hammer DB Curls", 2, "10-12")],
  LEGS: [ex("Kniebeuge", 4, "6-10"), ex("Rumänisches Kreuzheben (DB)", 3, "8-12"), ex("Beinpresse", 3, "10-12"), ex("Beinbeuger", 3, "10-12"), ex("Wadenheben", 4, "12-15"), ex("Beinheben", 3, "15")],
  UPPER: [ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Langhantelrudern", 3, "8-12"), ex("Schulterdrücken (DB)", 3, "8-12"), ex("Latzug (breit)", 3, "10-12"), ex("Bizeps DB-Curls", 3, "10-12"), ex("Trizeps Pushdown", 3, "10-12")],
  LOWER: [ex("Kniebeuge", 4, "6-10"), ex("Rumänisches Kreuzheben (DB)", 3, "8-12"), ex("Beinpresse", 3, "10-12"), ex("Wadenheben", 4, "12-15"), ex("Crunch / Kabel-Crunch", 3, "15"), ex("Beinheben", 3, "15")],
  FB_A: [ex("Kniebeuge", 3, "8-12"), ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Latzug (breit)", 3, "10-12"), ex("Seitheben", 3, "12-15"), ex("Trizeps Pushdown", 2, "10-12"), ex("Crunch / Kabel-Crunch", 3, "15")],
  FB_B: [ex("Rumänisches Kreuzheben (DB)", 3, "8-12"), ex("Flachbank DB-Drücken", 3, "8-12"), ex("Rudern am Kabel", 3, "10-12"), ex("Face Pulls", 3, "15"), ex("Bizeps DB-Curls", 2, "10-12"), ex("Plank", 3, "30-60 Sek")],
  FB_C: [ex("Beinpresse", 3, "10-12"), ex("Pec Fly", 3, "10-12"), ex("Latzug (eng)", 3, "8-12"), ex("Einarmiges DB-Rudern", 3, "10-12"), ex("Hammer DB Curls", 2, "10-12"), ex("Beinheben", 3, "15")],
  BRUST: [ex("Bankdrücken (Langhantel)", 4, "6-10"), ex("Schrägbank DB-Brustdrücken", 3, "8-12"), ex("Flachbank DB-Drücken", 3, "8-12"), ex("Pec Fly", 3, "10-12"), ex("Kabel-Crossover", 3, "12-15"), ex("Liegestütze", 2, "15")],
  RUECKEN: [ex("Klimmzug", 4, "6-10"), ex("Langhantelrudern", 3, "8-12"), ex("Latzug (breit)", 3, "10-12"), ex("Rudern am Kabel", 3, "10-12"), ex("Einarmiges DB-Rudern", 3, "10-12"), ex("Reverse Fly", 3, "15")],
  SCHULTER: [ex("Overhead Press (Langhantel)", 4, "6-10"), ex("Schulterdrücken (DB)", 3, "8-12"), ex("Seitheben", 4, "12-15"), ex("Frontheben", 3, "12-15"), ex("Face Pulls", 3, "15"), ex("Nackenheben (Shrugs)", 3, "12-15")],
  ARME: [ex("SZ-Curls", 3, "8-12"), ex("Bizeps DB-Curls", 3, "10-12"), ex("Hammer DB Curls", 3, "10-12"), ex("Enges Bankdrücken", 3, "8-12"), ex("Trizeps Pushdown", 3, "10-12"), ex("Überkopf-Trizeps (Seil)", 3, "10-12")],
};
const PLAN_STYLES = [
  { id: "auto", label: "Automatisch (nach Tagen)" },
  { id: "ok_beine", label: "OK A · Beine · OK B · Ganzkörper" },
  { id: "ganzkoerper", label: "Ganzkörper" },
  { id: "ppl", label: "Push / Pull / Beine" },
  { id: "oberunter", label: "Oberkörper / Unterkörper" },
  { id: "split", label: "5er-Split (Brust/Rücken/Schulter/Beine/Arme)" },
];
const planMaxExercises = (profile) => { const m = Number(profile?.sessionMinutes || 60); return m <= 40 ? 6 : m <= 55 ? 8 : 12; };
const buildFromSequence = (seq, days, profile) => {
  const max = planMaxExercises(profile);
  const picks = []; for (let i = 0; i < days; i++) picks.push(seq[i % seq.length]);
  const total = {}; picks.forEach(([b]) => (total[b] = (total[b] || 0) + 1));
  const seen = {}; const out = {};
  picks.forEach(([b, items]) => {
    seen[b] = (seen[b] || 0) + 1;
    const label = total[b] > 1 ? `${b} ${String.fromCharCode(64 + seen[b])}` : b;
    out[label] = generatedDay(items, profile, max);
  });
  return out;
};
const T = SPLIT_TEMPLATES;
// Bei 4–5 Trainingstagen wird der letzte Tag als „optional" gekennzeichnet (kann bei Zeitmangel
// entfallen). Verändert nur das Label des letzten Tages, wenn es nicht ohnehin schon „optional" enthält.
const markOptionalLastDay = (plan, days) => {
  if (days < 4 || days > 5) return plan;
  const keys = Object.keys(plan);
  if (!keys.length) return plan;
  const last = keys[keys.length - 1];
  if (/optional/i.test(last)) return plan;
  const out = {};
  keys.forEach((k) => { out[k === last ? `${last} (optional)` : k] = plan[k]; });
  return out;
};
const generatePlanStyled = (profile, style) => {
  const days = Math.max(1, Math.min(7, Number(profile?.trainingDays || 4)));
  let plan;
  if (style === "ok_beine") plan = buildFromSequence([["Oberkörper A", PLAN["Oberkörper A"]], ["Beine", PLAN["Beine"]], ["Oberkörper B", PLAN["Oberkörper B"]], ["Ganzkörper optional", PLAN["Ganzkörper (optional)"]]], days, profile);
  else if (style === "ppl") plan = buildFromSequence([["Push", T.PUSH], ["Pull", T.PULL], ["Beine", T.LEGS]], days, profile);
  else if (style === "oberunter") plan = buildFromSequence([["Oberkörper", T.UPPER], ["Unterkörper", T.LOWER]], days, profile);
  else if (style === "ganzkoerper") plan = buildFromSequence([["Ganzkörper", T.FB_A], ["Ganzkörper", T.FB_B], ["Ganzkörper", T.FB_C]], days, profile);
  else if (style === "split") plan = buildFromSequence([["Brust", T.BRUST], ["Rücken", T.RUECKEN], ["Schulter", T.SCHULTER], ["Beine", T.LEGS], ["Arme", T.ARME]], days, profile);
  else plan = generatePlanBase(profile);
  return markOptionalLastDay(applyGoalToPlan(plan, profile?.goal), days);
};
/* ---------- Pausenzeiten (Sekunden), evidenzbasiert ----------
   Quellen: Schoenfeld et al. 2016 (3 vs 1 min, JSCR); de Salles et al. 2009 (Sports Med Review);
   Grgic et al. 2018 (Systematic Review, JSCR); "Give it a rest" Bayesian-Meta-Analyse 2024
   (Frontiers Sports Act Living).
   Kernaussagen:
   - Hypertrophie-Boden ~60 s; unter 60 s mindert den Muskelaufbau.
   - Schwere Mehrgelenkübungen: 2–3 min (Kraftfokus bis 3–5 min).
   - Isolation/kleine Muskeln erholen schneller → 60–120 s genügen.
   - Bei gleichem Volumen sind 2 vs 3 min für Hypertrophie kaum verschieden; längere Pausen
     helfen v. a. Trainierten, die Wiederholungen über die Sätze zu halten.
   Zwei Kontexte: zwischen Sätzen (REST_BY_NAME / setRestSeconds) und nach einer Übung
   (exerciseRestSeconds – etwas mehr für Isolation/Core, da die nächste Übung frisch startet). */
const REST_BY_NAME = {};
const _setRest = (sec, names) => names.forEach((n) => (REST_BY_NAME[n] = sec));
_setRest(180, ["Kniebeuge", "Frontkniebeuge", "Hackenschmidt-Kniebeuge", "Kreuzheben", "Bankdrücken (Langhantel)", "Schrägbank Langhantel-Drücken", "Negativbank-Drücken", "Overhead Press (Langhantel)", "Langhantelrudern", "T-Bar Rudern", "Beinpresse", "Klimmzug"]);
_setRest(150, ["Schrägbank DB-Brustdrücken", "Flachbank DB-Drücken", "Brustpresse (Maschine)", "Liegestütze", "Enges Bankdrücken", "Dips", "Schulterdrücken (DB)", "Schulterdrücken (Maschine)", "Arnold Press", "Latzug (breit)", "Latzug (eng)", "Rudern am Kabel", "Maschinen-Rudern", "Einarmiges DB-Rudern", "Rumänisches Kreuzheben (DB)", "Ausfallschritte", "Bulgarian Split Squat", "Goblet-Kniebeuge", "Hip Thrust", "Beinbeuger", "Beinbeuger (sitzend)", "Beinstrecker", "Upright Row", "Rückenstrecker (Hyperextension)", "Rücken Extension Gerät", "Latzug Maschine"]);
_setRest(90, ["Pec Fly", "Kabel-Crossover", "Überzüge", "Reverse Fly", "Seitheben", "Kabel-Seitheben", "Frontheben", "Face Pulls", "Nackenheben (Shrugs)", "Bizeps DB-Curls", "Langhantel-Curls", "SZ-Curls", "Hammer DB Curls", "Hammer Curls Seil", "Preacher-Curls", "Preacher Curls Maschine", "Konzentrations-Curls", "Kabel-Curls", "Schrägbank-Curls (Incline)", "Spider-Curls", "Trizeps Pushdown", "Trizeps Pushdown (Untergriff)", "Überkopf-Trizeps (Seil)", "French Press", "Kickbacks", "Trizeps-Maschine", "Wadenheben", "Wadenheben (sitzend)", "Abduktoren-Maschine", "Adduktoren-Maschine", "Handgelenks-Curls", "Pec Fly sitzend Keiser", "Keiser Pec Fly (oben)", "Keiser Pec Fly (Mitte)", "Keiser Pec Fly (unten)"]);
_setRest(60, ["Beinheben", "Hängendes Beinheben", "Crunch / Kabel-Crunch", "Crunch auf Ball", "Plank", "Side Plank", "Russian Twist", "Mountain Climbers", "Käfer (Dead Bug)", "Ab Wheel (Bauchroller)"]);
// Pause ZWISCHEN Sätzen (gleiche Übung).
const setRestSeconds = (name, goal) => {
  let base = REST_BY_NAME[name];
  if (base == null) {
    const g = (find(name) || {}).g;
    base = g === "Bauch" ? 60 : (g === "Arme" || g === "Schulter") ? 90 : (g === "Brust" || g === "Rücken" || g === "Beine") ? 150 : 120;
  }
  if (goal === "Kraft" && base >= 150) base += 60;          // schwere Sätze: bis ~4 min
  else if (goal === "Fettverlust") base = Math.max(45, base - 15); // dichtere Sätze, aber >=45 s
  return base;
};
// Pause NACH einer Übung (vor der nächsten): mind. ~2 min, da der erste Satz frisch begonnen wird
// und die Station umgebaut wird; >3 min ist beim Wechsel des Bewegungsmusters nicht nötig.
const exerciseRestSeconds = (name, goal) => Math.min(180, Math.max(120, setRestSeconds(name, goal)));

// Kurzversion einer Einheit: wichtigste Übungen zuerst (Grundübungen), Sätze gedeckelt.
const shortenForTime = (items) => {
  if (!items || items.length <= 3) return items || [];
  const ranked = [...items].map((e, i) => ({ e, i, score: (isCompound(e.name) ? 0 : 1) + i * 0.01 })).sort((a, b) => a.score - b.score);
  const keep = Math.max(3, Math.ceil(items.length * 0.55));
  const chosen = ranked.slice(0, keep).sort((a, b) => a.i - b.i).map((o) => o.e);
  return chosen.map((e) => ({ ...e, targetSets: Math.min(e.targetSets || 3, 3) }));
};


/* ---------- Speicher: funktioniert in jedem Hosting ----------
   Modus "proxy":  über /api/kv (server.js / Cloudflare Function), Key bleibt serverseitig.
   Modus "direct": direkt an die Supabase-Cloud, Konfiguration aus window.TRAINER_CONFIG (config.js).
   So läuft die App sowohl hinter dem Node-Server als auch statisch gehostet. */
const CFG = (typeof window !== "undefined" && window.TRAINER_CONFIG) || {};
let STORE_MODE = null; // "proxy" | "direct" | "none"
const sbHeaders = () => ({ apikey: CFG.SUPABASE_KEY, Authorization: `Bearer ${CFG.SUPABASE_KEY}`, "Content-Type": "application/json" });
const sbTable = () => `${CFG.SUPABASE_URL}/rest/v1/training_kv`;

async function resolveMode() {
  if (STORE_MODE) return STORE_MODE;
  // 1) Proxy verfügbar? (liefert JSON mit value-Feld)
  try {
    const r = await fetch(`/api/kv?key=__ping__`);
    if (r.ok && (r.headers.get("content-type") || "").includes("application/json")) {
      const j = await r.json();
      if (j && "value" in j) { STORE_MODE = "proxy"; return STORE_MODE; }
    }
  } catch {}
  // 2) Direkt-Modus, wenn config.js vorhanden
  if (CFG.SUPABASE_URL && CFG.SUPABASE_KEY) { STORE_MODE = "direct"; return STORE_MODE; }
  return "none"; // NICHT cachen → nach Reconnect erneut proben (sonst bliebe die App offline „taub")
}

// Offline-Fallback-Cache: letzter erfolgreich geladener/gespeicherter Wert je Schlüssel in
// localStorage. Reads liefern offline den letzten Stand, statt zu hängen. (Voller Sync-Replay = Phase 3.)
const lsGet = (k) => { try { return localStorage.getItem("ttc:" + k); } catch { return null; } };
const lsSet = (k, v) => { try { if (v == null) localStorage.removeItem("ttc:" + k); else localStorage.setItem("ttc:" + k, v); } catch {} };

// --- Offline-Schreib-Queue (Phase 3): fehlgeschlagene Writes puffern, bei Reconnect nachsenden.
// Whole-Key-JSON-Blobs → Last-Write-Wins pro Schlüssel (nur der neueste Op je Key zählt).
const loadQueue = () => { try { return JSON.parse(localStorage.getItem("ttq") || "{}") || {}; } catch { return {}; } };
const saveQueue = (q) => { try { localStorage.setItem("ttq", JSON.stringify(q)); } catch {} };
const emitQueueChanged = () => { try { window.dispatchEvent(new Event("tt-queue-changed")); } catch {} };
const enqueueWrite = (k, op, value) => { const q = loadQueue(); q[k] = { op, value: value == null ? undefined : value, ts: Date.now() }; saveQueue(q); emitQueueChanged(); };
const dequeueWrite = (k) => { const q = loadQueue(); if (k in q) { delete q[k]; saveQueue(q); emitQueueChanged(); } };
const pendingSyncCount = () => Object.keys(loadQueue()).length;

// Reine Netzwerk-Writes (werfen bei Offline → Aufrufer puffert).
async function netSet(k, v) {
  const mode = await resolveMode();
  if (mode === "direct") {
    const r = await fetch(`${sbTable()}?on_conflict=key`, { method: "POST", headers: { ...sbHeaders(), Prefer: "resolution=merge-duplicates,return=minimal" }, body: JSON.stringify({ key: k, value: v, updated_at: new Date().toISOString() }) });
    return r.ok;
  }
  const r = await fetch(`/api/kv`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ key: k, value: v }) });
  return r.ok;
}
async function netDel(k) {
  const mode = await resolveMode();
  if (mode === "direct") { await fetch(`${sbTable()}?key=eq.${encodeURIComponent(k)}`, { method: "DELETE", headers: sbHeaders() }); return true; }
  await fetch(`/api/kv?key=${encodeURIComponent(k)}`, { method: "DELETE" });
  return true;
}
let _flushing = false;
async function flushQueue() {
  if (_flushing) return pendingSyncCount();
  _flushing = true;
  try {
    const q = loadQueue();
    for (const k of Object.keys(q)) {
      const it = q[k];
      let ok = false;
      try { ok = it.op === "del" ? await netDel(k) : await netSet(k, it.value); } catch { ok = false; }
      if (ok) dequeueWrite(k); else break; // noch offline / Fehler → später erneut
    }
  } finally { _flushing = false; }
  return pendingSyncCount();
}

const store = {
  async get(k) {
    const mode = await resolveMode();
    try {
      let value = null;
      if (mode === "direct") {
        const r = await fetch(`${sbTable()}?key=eq.${encodeURIComponent(k)}&select=value`, { headers: sbHeaders() });
        if (!r.ok) return lsGet(k);
        const rows = await r.json();
        value = rows && rows.length ? rows[0].value : null;
      } else {
        const r = await fetch(`/api/kv?key=${encodeURIComponent(k)}`);
        if (!r.ok) return lsGet(k);
        const j = await r.json();
        value = j && j.value != null ? j.value : null;
      }
      if (value != null) lsSet(k, value); // Offline-Cache aktualisieren
      return value;
    } catch { return lsGet(k); } // offline: letzter bekannter Stand statt hängen
  },
  async set(k, v) {
    lsSet(k, v); // optimistisch offline-cachen (Lese-Konsistenz nach Reload)
    try {
      const ok = await netSet(k, v);
      if (ok) { dequeueWrite(k); return true; }
      return false; // Server erreichbar, aber Ablehnung → echter Fehler (kein Offline-Fall)
    } catch {
      enqueueWrite(k, "set", v); // offline → puffern, bei Reconnect nachsenden
      return true;               // optimistisch: UI läuft weiter (Wert ist lokal + in Queue)
    }
  },
  async del(k) {
    lsSet(k, null);
    try {
      const ok = await netDel(k);
      if (ok) { dequeueWrite(k); return true; }
      return true;
    } catch {
      enqueueWrite(k, "del");
      return true;
    }
  },
  // Verbindung ok, sobald ein Modus (Proxy oder Direkt) verfügbar ist.
  async ping() {
    const mode = await resolveMode();
    if (mode === "none") return false;
    if (mode === "direct") {
      try {
        const r = await fetch(`${sbTable()}?select=key&limit=1`, { headers: sbHeaders() });
        return r.ok;
      } catch { return false; }
    }
    return true; // Proxy wurde in resolveMode bereits validiert
  },
};

/* ---------- Helpers ---------- */
const uid = () => Math.random().toString(36).slice(2, 9);
const bestSet = (sets) => {
  if (!sets || !sets.length) return null;
  return [...sets].sort((a, b) => ((b.sec || 0) - (a.sec || 0)) || (b.weight - a.weight) || (b.reps - a.reps))[0];
};
// Zeit-Halteübungen (Sekunden statt Wiederholungen)
const isTimedReps = (reps) => /sek|sec/i.test(String(reps || ""));
const isTimedEx = (ex) => { const c = find(ex && ex.name); return (c && c.timed) || isTimedReps(ex && ex.targetReps); };
const isPneuEx = (ex) => { const c = find(ex && ex.name); return !!(c && c.pneu); };
// Satz lesbar formatieren (Zeit vs. Gewicht×Wdh)
const fmtSet = (x) => x == null ? "" : (x.sec != null ? `${x.sec} Sek` : (x.pneu ? `${x.weight} × ${x.reps}` : `${x.weight} kg × ${x.reps}`));
const fmtSetShort = (x) => x == null ? "" : (x.sec != null ? `${x.sec}s` : `${x.weight}×${x.reps}`);
// Robuste Zahl: akzeptiert Komma UND Punkt als Dezimaltrenner (z.B. "62,5" und "62.5" → 62.5).
// Sind beide vorhanden, gilt das letzte Zeichen als Dezimaltrenner, das andere als Tausendertrenner.
const parseNum = (v) => {
  if (v == null) return NaN;
  let s = String(v).trim().replace(/\s/g, "");
  if (s === "") return NaN;
  const lc = s.lastIndexOf(","), ld = s.lastIndexOf(".");
  if (lc > -1 && ld > -1) {
    const dec = lc > ld ? "," : ".";
    const thou = dec === "," ? "." : ",";
    s = s.split(thou).join("").replace(dec, ".");
  } else {
    s = s.replace(",", ".");
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
};
const fmtDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" });
};
// Beidhändige Kurzhantel-Übungen: eingetragenes Gewicht gilt PRO HAND → fürs Volumen (Tonnage) ×2.
// (Einarmige/Einzelhantel-Übungen wie Goblet, einarmiges Rudern, Konzentrations-Curls bleiben ×1.)
const PER_SIDE = new Set([
  "Schrägbank DB-Brustdrücken", "Flachbank DB-Drücken", "Schulterdrücken (DB)", "Arnold Press",
  "Seitheben", "Frontheben", "Reverse Fly", "Bizeps DB-Curls", "Hammer DB Curls",
  "Rumänisches Kreuzheben (DB)", "Schrägbank-Curls (Incline)", "Spider-Curls", "Nackenheben (Shrugs)",
]);
const exLoadMul = (exName) => { if (PER_SIDE.has(exName)) return 2; const c = find(exName); return (c && c.perSide) ? 2 : 1; };
const setLoad = (exName, x) => (Number(x.weight) || 0) * (Number(x.reps) || 0) * exLoadMul(exName);
const volume = (s) => (s.exercises || []).reduce((t, e) => t + (e.sets || []).reduce((u, x) => u + setLoad(e.name, x), 0), 0);
const totalSets = (s) => (s.exercises || []).reduce((t, e) => t + (e.sets || []).length, 0);
// Konditions-Einheiten (Cardio/Yoga) erkennen
const isCond = (s) => s && (s.type === "cardio" || s.type === "yoga" || s.type === "core");
const condIcon = (t) => (t === "yoga" ? "★" : t === "core" ? "🔥" : "♥");
const condAccent = (t) => (t === "yoga" ? C.accent : t === "core" ? C.accent2 : C.danger);
const rirLabel = (rir) => {
  if (rir === undefined || rir === null || rir === "") return "RIR –";
  const n = Number(rir);
  if (Number.isNaN(n)) return "RIR –";
  const note = n === 0 ? "Versagen" : n <= 2 ? "ideal" : "leicht";
  return `RIR ${n} · RPE ${10 - n} · ${note}`;
};
// RIR-Farbskala: 0 rot → 2 gelb → 4 grün
const RIR_COLORS = ["#E0564A", "#E8804B", "#E8B04B", "#A9C25E", "#5FB99A"];
const rirColor = (n) => {
  const v = Number(n);
  return Number.isNaN(v) ? C.muted : (RIR_COLORS[Math.max(0, Math.min(4, v))] || C.muted);
};


const defaultProfile = (name) => ({
  name,
  goal: "Muskelaufbau",
  experience: "Fortgeschritten",
  trainingDays: 4,
  sessionMinutes: 60,
  restrictions: "",
  preferredExercises: "",
  avoidedExercises: "",
  notes: "",
  countSecondary: false, // Sekundäre Muskelbeteiligung ins Volumen zählen (Standard aus)
  updatedAt: null,
});
const PROFILE_GOALS = ["Muskelaufbau", "Kraft", "Fitness", "Fettverlust", "Mobility/Reha"];
const EXPERIENCE_LEVELS = ["Anfänger", "Fortgeschritten", "Erfahren"];


const TRAINING_USERS = ["Petja", "Panda", "Fant"];
const parseStored = (v, fallback = null) => {
  if (v == null) return fallback;
  if (typeof v === "string") {
    try { return JSON.parse(v); } catch { return fallback; }
  }
  return v;
};
const safeText = (v) => String(v ?? "").replace(/[<>&"]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]));
const isoDateOnly = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toISOString().slice(0, 10);
};
const buildExportRows = async () => {
  const rows = [];
  const summary = [];
  const raw = [];
  const addSession = (user, status, s) => {
    if (!s) return;
    const exercises = Array.isArray(s.exercises) ? s.exercises : [];
    summary.push({
      Nutzer: user,
      Status: status,
      Datum: isoDateOnly(s.dateISO),
      Training: s.day || "",
      Uebungen: exercises.length,
      Saetze: totalSets(s),
      Volumen_kg: Math.round(volume(s)),
      Session_ID: s.id || "",
    });
    if (!exercises.length) {
      rows.push({ Nutzer: user, Status: status, Datum: isoDateOnly(s.dateISO), Training: s.day || "", Uebung: "", Muskelgruppe: "", Muskel: "", Ziel_Saetze: "", Ziel_Wdh: "", Satz: "", Gewicht_kg: "", Wiederholungen: "", Volumen_kg: "", Session_ID: s.id || "" });
      return;
    }
    exercises.forEach((e) => {
      const sets = Array.isArray(e.sets) ? e.sets : [];
      if (!sets.length) {
        rows.push({ Nutzer: user, Status: status, Datum: isoDateOnly(s.dateISO), Training: s.day || "", Uebung: e.name || "", Muskelgruppe: e.group || "", Muskel: e.muscle || "", Ziel_Saetze: e.targetSets || "", Ziel_Wdh: e.targetReps || "", Satz: "", Gewicht_kg: "", Wiederholungen: "", Volumen_kg: "", Session_ID: s.id || "" });
        return;
      }
      sets.forEach((set, idx) => {
        const weight = Number(set.weight || 0);
        const reps = Number(set.reps || 0);
        rows.push({ Nutzer: user, Status: status, Datum: isoDateOnly(s.dateISO), Training: s.day || "", Uebung: e.name || "", Muskelgruppe: e.group || "", Muskel: e.muscle || "", Ziel_Saetze: e.targetSets || "", Ziel_Wdh: e.targetReps || "", Satz: idx + 1, Gewicht_kg: weight, Wiederholungen: reps, Volumen_kg: setLoad(e.name, set), Session_ID: s.id || "" });
      });
    });
  };
  const bodyMetrics = [];
  const workouts = [];
  for (const user of TRAINING_USERS) {
    const history = parseStored(await store.get(`tt_${user}_history`), []) || [];
    const active = parseStored(await store.get(`tt_${user}_active`), null);
    const coaching = parseStored(await store.get(`tt_${user}_coaching`), null);
    const profile = parseStored(await store.get(`tt_${user}_profile`), null);
    const plan = parseStored(await store.get(`tt_${user}_plan`), null);
    raw.push({ user, profile, plan, history, active, coaching });
    history.forEach((s) => addSession(user, "abgeschlossen", s));
    addSession(user, "aktiv", active);
    (parseStored(await store.get(`tt_${user}_bodymetrics`), []) || []).forEach((m) => bodyMetrics.push({
      Nutzer: user, Datum: isoDateOnly(m.dateISO), Gewicht_kg: m.weightKg, BMI: m.bmi, KFA_pct: m.fatTotal, Fettmasse_kg: m.fatMassKg,
      KFA_Arme: m.fatArms, KFA_Torso: m.fatTorso, KFA_Beine: m.fatLegs, Muskel_pct: m.musclePct, Muskelmasse_kg: m.muscleMassKg,
      Musk_Torso_kg: m.muscleTrunk, Musk_ArmL_kg: m.muscleArmL, Musk_ArmR_kg: m.muscleArmR, Musk_BeinL_kg: m.muscleLegL, Musk_BeinR_kg: m.muscleLegR,
      Wasser_pct: m.bodyWaterPct, Viszeral: m.visceralFat, Grundumsatz_kcal: m.bmr, Stoffwechselalter: m.metabolicAge, Knochen_kg: m.boneMassKg,
      Ruhepuls: m.restingHR, HRV_ms: m.hrv, Schlaf_h: m.sleepHours, Aktiv_kcal: m.activeKcal, Nahrung_kcal: m.dietaryKcal, Protein_g: m.proteinG, Schritte: m.steps, VO2max: m.vo2max,
    }));
    (parseStored(await store.get(`tt_${user}_workouts`), []) || []).forEach((w) => workouts.push({
      Nutzer: user, Start: w.start ? String(w.start).slice(0, 16).replace("T", " ") : "", Typ: w.type || "", Dauer_min: w.durationMin, kcal: w.kcal, avgHR: w.avgHR, maxHR: w.maxHR, HR_Recovery: w.hrRecovery,
    }));
  }
  return { rows, summary, raw, bodyMetrics, workouts };
};
const tableHtml = (title, rows) => {
  const columns = rows.length ? Object.keys(rows[0]) : ["Info"];
  const body = rows.length ? rows : [{ Info: "Keine Daten vorhanden" }];
  const actualColumns = Object.keys(body[0]);
  return `<h2>${safeText(title)}</h2><table border="1"><thead><tr>${actualColumns.map((c) => `<th>${safeText(c)}</th>`).join("")}</tr></thead><tbody>${body.map((r) => `<tr>${actualColumns.map((c) => `<td>${safeText(r[c])}</td>`).join("")}</tr>`).join("")}</tbody></table>`;
};
const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
// Vollständiger CLIENT-Export (trainer2 wird statisch unter /v2/ ausgeliefert – der alte
// Server-Endpunkt /export träfe die falsche App). Baut die .xls-Arbeitsmappe im Browser aus
// den echten Daten (KV + Withings via Supabase-JWT) und lädt sie als Blob herunter – umgeht
// Routing- und Content-Disposition-Probleme (v. a. iOS Safari).
const exportExcel = async (sbToken) => {
  try {
    const { rows, summary, raw, bodyMetrics, workouts } = await buildExportRows();
    let withings = [];
    if (sbToken && window.supabase) {
      try {
        const sbc = window.supabase.createClient(SB_URL, SB_ANON_KEY, {
          global: { headers: { Authorization: `Bearer ${sbToken}` } },
          db: { schema: "trainer" },
          auth: { persistSession: false, autoRefreshToken: false },
        });
        const { data } = await sbc.from("body_measurements")
          .select("measured_at,weight_kg,fat_ratio_pct,fat_mass_kg,fat_free_mass_kg,muscle_mass_kg,bone_mass_kg,water_mass_kg,visceral_fat,bmr_kcal")
          .order("measured_at", { ascending: false }).limit(730);
        withings = (data || []).map((r) => ({
          Datum: (r.measured_at || "").slice(0, 10), Gewicht_kg: r.weight_kg, KFA_pct: r.fat_ratio_pct, Fettmasse_kg: r.fat_mass_kg,
          Fettfrei_kg: r.fat_free_mass_kg, Muskelmasse_kg: r.muscle_mass_kg, Knochen_kg: r.bone_mass_kg, Wasser_kg: r.water_mass_kg,
          Viszeral: r.visceral_fat, Grundumsatz_kcal: r.bmr_kcal,
        }));
      } catch (e) { /* Withings optional – Rest exportiert trotzdem */ }
    }
    const stamp = new Date().toISOString().slice(0, 10);
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Trainingstagebuch Export ${stamp}</title></head><body>`
      + tableHtml("Zusammenfassung", summary) + "<br>"
      + tableHtml("Saetze", rows) + "<br>"
      + tableHtml("Koerpermetriken (Apple Health / TANITA)", bodyMetrics) + "<br>"
      + tableHtml("Workouts (Apple Health)", workouts) + "<br>"
      + tableHtml("Koerperkomposition (Withings)", withings)
      + `<h2>Rohdaten JSON</h2><pre>${safeText(JSON.stringify(raw, null, 2))}</pre></body></html>`;
    const blob = new Blob([String.fromCharCode(0xFEFF), html], { type: "application/vnd.ms-excel;charset=utf-8" });
    downloadBlob(blob, `Trainingstagebuch-Export-${stamp}.xls`);
  } catch (e) {
    window.alert("Export fehlgeschlagen: " + (e && e.message ? e.message : e));
  }
};


// Wiederholungs-Spanne aus Ziel-Text ("8-12", "15", "10/Bein")
const repsLow = (t) => { const m = String(t).match(/\d+/); return m ? parseInt(m[0], 10) : 8; };
const repsHigh = (t) => { const m = String(t).match(/\d+/g); return m ? parseInt(m[m.length - 1], 10) : repsLow(t); };

// Progressive-Overload-Vorschlag: RIR/RPE steuert, wie aggressiv gesteigert wird.
// Übungs-spezifische Last-Schritte (z. B. Beinpresse nur in groben Stufen einstellbar).
const STEP_OVERRIDE = [{ match: "Beinpresse", step: 5 }];
const weightStep = (w, name) => {
  if (name) { const o = STEP_OVERRIDE.find((x) => name.includes(x.match)); if (o) return o.step; }
  return Number(w || 0) >= 40 ? 2 : 1;
};
// Vorschlag für Zeit-Halteübungen (Sekunden).
const timedSuggestion = (exercise, last) => {
  const low = repsLow(exercise.targetReps), high = repsHigh(exercise.targetReps);
  if (!last || last.sec == null) return { weight: 0, reps: 0, sec: low, text: `Ziel: ${low}–${high} Sek halten, sauber & stabil`, tone: "neutral" };
  const s = Number(last.sec) || 0;
  if (s >= high) return { weight: 0, reps: 0, sec: s + 5, text: `Letztes Mal ${s} Sek – länger halten (+5 s) oder erschweren`, tone: "progress" };
  return { weight: 0, reps: 0, sec: Math.min(high, s + 5), text: `Letztes Mal ${s} Sek – Ziel ${high} Sek`, tone: "progress" };
};
// ===================== Autoregulierte Progression =====================
// Steigern (GREEN) und Deload (RED) hängen an OBJEKTIVEN Wiederholungszahlen
// relativ zum Zielbereich – NICHT an der unzuverlässigen RIR-Schätzung
// (Forschung: Anfänger überschätzen RIR um 2–3 Wdh; verlässlich erst nahe am
// Versagen). 0 RIR im letzten Satz ist neutral bis gut, solange genug Wdh
// erreicht werden; negativ wird Versagen erst UNTERHALB des Zielbereichs.
//
// Übungsabhängiger Modus (Evidenz: Versagen an Verbundübungen bringt mehr
// ZNS-Ermüdung + Verletzungsrisiko, Isolation hat besseres Risiko-Nutzen-Verhältnis):
//   - "double"  Verbundübungen: Double Progression – erst steigern, wenn ALLE
//               Arbeitssätze die Obergrenze treffen (konservativ).
//   - "last"    Isolationsübungen: letzter Satz reicht (AMRAP), Versagen ok.
const progMode = (name) => (isCompound(name) ? "double" : "last");

// Klassifiziert eine Einheit (Array von Arbeitssätzen) relativ zum Zielbereich.
const classifyPerf = (working, repMin, prog, mode) => {
  if (!working || !working.length) return null;
  const last = working[working.length - 1];
  const lastReps = Number(last.reps || 0);
  const rir = last.rir === undefined || last.rir === null || last.rir === "" ? null : Number(last.rir);
  const allTop = working.every((s) => Number(s.reps || 0) >= prog);
  if (lastReps >= prog && (mode === "last" || allTop)) return "GREEN"; // verdient (RIR egal, auch 0)
  if (lastReps >= repMin) return "YELLOW";                            // im Bereich, halten
  if (rir === 0) return "RED";                                        // Versagen UNTER Bereich
  return "GREY";                                                     // unter Bereich, aber nicht ausgereizt
};

// Aufeinanderfolgende RED-Einheiten (jüngste zuerst) – Streak gegen Tagesform-Rauschen.
const redStreakFor = (seq, repMin, prog, mode) => {
  let n = 0;
  for (let i = (seq || []).length - 1; i >= 0; i--) {
    if (classifyPerf(seq[i], repMin, prog, mode) === "RED") n++;
    else break;
  }
  return n;
};

// Progressive-Overload-Vorschlag. ctx (optional) = { working, load, redStreak }:
//   working   = Arbeitssätze der LETZTEN Einheit dieser Übung (chronologisch)
//   load      = damals verwendetes Gewicht/Wert
//   redStreak = Anzahl aufeinanderfolgender RED-Einheiten (inkl. dieser)
// Ohne ctx fällt die Funktion auf den einzelnen Best-Satz `last` zurück.
const suggestion = (exercise, last, unit, ctx) => {
  const u = unit === undefined ? "kg" : unit; // Keiser: "" (pneumatischer Wert, keine kg)
  const us = u ? ` ${u}` : "";
  const W = u ? "Gewicht" : "Wert";
  const low = repsLow(exercise.targetReps), high = repsHigh(exercise.targetReps);
  const mid = Math.round((low + high) / 2); // mittlere empfohlene Wdh-Zahl
  const prog = high; // Obergrenze des Zielbereichs verdient eine Steigerung
  const working = ctx && ctx.working && ctx.working.length ? ctx.working : last ? [last] : [];
  if (!working.length) return { weight: "", reps: low, text: u ? "Erste Erfassung – Startgewicht selbst wählen" : "Erste Erfassung – Startwert selbst wählen", tone: "neutral" };

  const mode = progMode(exercise.name);
  const lastSet = working[working.length - 1];
  const curLoad = Number((ctx && ctx.load != null ? ctx.load : lastSet.weight) || 0);
  const step = weightStep(curLoad, exercise.name);
  const heavier = Math.round((curLoad + step) * 10) / 10;
  const same = curLoad;
  const lastReps = Number(lastSet.reps || 0);
  const rir = lastSet.rir === undefined || lastSet.rir === null || lastSet.rir === "" ? null : Number(lastSet.rir);
  const early = working.slice(0, -1);
  // Gate: frühe Sätze sollen nicht ins Versagen kippen, sonst ist GREEN kein sauberes Signal.
  const earlyFatigue = early.some((s) => Number(s.reps || 0) < low || Number(s.rir) === 0);
  const cls = classifyPerf(working, low, prog, mode);
  const redStreak = ctx && ctx.redStreak ? ctx.redStreak : cls === "RED" ? 1 : 0;

  // Früher Progressionspfad (Top-Set-/Backoff-Logik, v. a. Mehrsatz/Verbund):
  // ALLE frühen Sätze an der Obergrenze MIT Reserve (RIR > 0) und der letzte Satz bis zum
  // Versagen (RIR 0) in der oberen Bereichshälfte (≥ Mitte, aber noch < Obergrenze).
  // Das ist ein klares „bereit zum Steigern"-Signal: Gewicht rauf, ersten Satz hart anpeilen,
  // Folgesätze regelt die In-Session-Logik bei Bedarf runter.
  const earlyTopReserve = early.length > 0 && early.every((s) => {
    const r = Number(s.reps || 0);
    const q = s.rir === undefined || s.rir === null || s.rir === "" ? null : Number(s.rir);
    return r >= prog && q != null && q > 0;
  });
  if (cls !== "RED" && earlyTopReserve && rir === 0 && lastReps >= mid && lastReps < prog) {
    return {
      weight: heavier, reps: mid, tone: "progress",
      text: `Frühe Sätze an der Obergrenze mit Reserve, letzter Satz bis zum Versagen (${lastReps} Wdh) – ${heavier}${us}: ersten Satz hart (~${mid}) anpeilen, Folgesätze ggf. reduzieren.`,
    };
  }

  if (cls === "GREEN") {
    if (earlyFatigue) {
      return { weight: same, reps: low, text: `Letzter Satz stark, aber frühe Sätze brachen ein – ${W} halten, erst stabilisieren.`, tone: "neutral" };
    }
    // Steigern nur, wenn nach dem Sprung noch mind. die mittlere Wdh-Zahl drin ist.
    // Reserve (RIR > 1) ist der Indikator dafür; ohne RIR-Angabe gilt die Obergrenze als Beleg.
    const hasReserve = rir == null || rir > 1;
    if (hasReserve) {
      return {
        weight: heavier, reps: mid, tone: "progress",
        text: mode === "double"
          ? `Alle Sätze ≥ ${prog} Wdh${rir != null ? `, RIR ${rir}` : ""} – genug Reserve: ${heavier}${us} × ${mid} (mittlere Wdh).`
          : `${lastReps} Wdh${rir != null ? ` bei RIR ${rir}` : ""} – genug Reserve: ${heavier}${us} × ${mid} (mittlere Wdh).`,
      };
    }
    // Obergrenze erreicht, aber keine Reserve (RIR ≤ 1): noch nicht steigern, sonst fällst du unter die mittlere Wdh-Zahl.
    return { weight: same, reps: prog, tone: "neutral", text: `Obergrenze erreicht, aber nur RIR ${rir} – ${same}${us} halten und Reserve aufbauen, bevor das ${W} steigt.` };
  }

  if (cls === "YELLOW") {
    const target = Math.min(prog, Math.max(low, lastReps + 1));
    return {
      weight: same, reps: target, tone: "neutral",
      text: mode === "double" && lastReps >= prog
        ? `Letzter Satz oben, aber noch nicht alle Sätze bei ${prog} – ${same}${us} halten, alle Sätze auf ${prog} bringen.`
        : `Im Zielbereich (${lastReps}/${prog}) – ${same}${us} halten, Reps Richtung ${prog} aufbauen.`,
    };
  }

  if (cls === "GREY") {
    const reserve = rir == null ? "Reserve" : `${rir} RIR`;
    return { weight: same, reps: low, tone: "easy", text: `Nur ${lastReps} Wdh, aber mit ${reserve} abgebrochen – ${same}${us} halten und nächstes Mal wirklich nah ans Versagen.` };
  }

  // RED: Versagen UNTER dem Zielbereich.
  if (redStreak >= 2) {
    const reduced = Math.max(0, Math.round(curLoad * 0.9 * 2) / 2); // −10 %, auf 0,5 gerundet
    return { weight: reduced, reps: low, tone: "caution", text: `${redStreak}× Versagen unter ${low} Wdh – ${W} −10 % auf ${reduced}${us}, sauber neu aufbauen.` };
  }
  return { weight: same, reps: low, tone: "caution", text: `Versagen unter Zielbereich (${lastReps}/${low} Wdh) – ${same}${us} halten, Schlaf/Erholung prüfen.` };
};

// In-Session-Empfehlung für den NÄCHSTEN Satz, basierend auf dem zuletzt erfassten Satz:
//   1) Max-Wdh erreicht UND RIR > 1 (Reserve) -> Gewicht hoch, Ziel mittlere Wdh-Zahl.
//   2) Mindest-Wdh nicht erreicht -> Gewicht runter, Ziel mittlere Wdh-Zahl.
//   sonst: Gewicht halten und sauber weiter.
const nextSetAdvice = (exercise, set, unit, setIndex) => {
  const u = unit === undefined ? "kg" : unit;
  const us = u ? ` ${u}` : "";
  const W = u ? "Gewicht" : "Wert";
  const low = repsLow(exercise.targetReps), high = repsHigh(exercise.targetReps);
  const mid = Math.round((low + high) / 2);
  const reps = Number(set.reps || 0);
  const w = Number(set.weight || 0);
  const rir = set.rir === undefined || set.rir === null || set.rir === "" ? null : Number(set.rir);
  const step = weightStep(w, exercise.name);
  const heavier = Math.round((w + step) * 10) / 10;
  const lighter = Math.max(0, Math.round((w - step) * 10) / 10);
  if (reps >= high && rir != null && rir > 1) {
    return { weight: heavier, reps: mid, tone: "progress", text: `Letzter Satz ${reps} Wdh bei RIR ${rir} – genug Reserve: nächster Satz ${heavier}${us} × ${mid}.` };
  }
  // Früh (Satz 1–2) schon an der Untergrenze UND nahe am Versagen (RIR ≤ 1): weil die Kraft
  // mit jedem Satz sinkt, fallen die Folgesätze sonst unter den Zielbereich → jetzt reduzieren.
  if (setIndex != null && setIndex <= 2 && reps > 0 && reps <= low && rir != null && rir <= 1) {
    return { weight: lighter, reps: mid, tone: "caution", text: `Untergrenze (${reps} Wdh) bei RIR ${rir} schon in Satz ${setIndex} – die Folgesätze fallen sonst drunter: ${W} runter auf ${lighter}${us} × ${mid}.` };
  }
  if (reps > 0 && reps < low) {
    return { weight: lighter, reps: mid, tone: "caution", text: `Nur ${reps} Wdh (unter ${low}) – ${W} runter: nächster Satz ${lighter}${us} × ${mid}.` };
  }
  return { weight: w, reps: Math.max(reps || low, low), tone: "neutral", text: `Im Zielbereich (${reps}/${high}) – ${w}${us} halten, sauber weiter.` };
};

/* ===================== Analytics: Volumen & Auswertung ===================== */
// Zielkorridor harter Sätze je Muskelgruppe und Woche (Hypertrophie-Richtwert).
const MUSCLE_GROUPS = ["Brust", "Rücken", "Schulter", "Arme", "Beine", "Bauch"];
const SET_MIN = 10, SET_MAX = 20;
const CORE_SETS = 2; // ein Core-Block bei Cardio/Yoga zählt als 2 effektive Bauch-Sätze (gerade Bauchmuskeln)
// Ein Satz zählt als "hart", sobald Wiederholungen erfasst sind (kein Aufwärm-Flag vorhanden).
const isWorkingSet = (x) => Number(x?.reps || 0) > 0 || Number(x?.sec || 0) > 0;
const est1RM = (w, r) => Number(w || 0) * (1 + Number(r || 0) / 30); // Epley

// Wochenanfang (Montag, lokal) als Date.
const startOfWeek = (date) => {
  const d = new Date(date); d.setHours(0, 0, 0, 0);
  const day = (d.getDay() + 6) % 7; // Mo=0 … So=6
  d.setDate(d.getDate() - day);
  return d;
};
const weekKey = (iso) => {
  const d = startOfWeek(new Date(iso));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const fmtWeekRange = (mondayKey) => {
  const a = new Date(mondayKey + "T00:00:00"); const b = new Date(a); b.setDate(b.getDate() + 6);
  const f = (d) => d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
  return `${f(a)} – ${f(b)}`;
};
// Harte Sätze je Muskelgruppe über mehrere Einheiten (nur Primärgruppe).
const setsByGroup = (sessions) => {
  const m = {}; MUSCLE_GROUPS.forEach((g) => (m[g] = 0));
  (sessions || []).forEach((s) => (s.exercises || []).forEach((e) => {
    if (!(e.group in m)) return; // "Sonstige" o.ä. ignorieren
    m[e.group] += (e.sets || []).filter(isWorkingSet).length;
  }));
  return m;
};

/* ---------- Muskel-Beteiligung auf KONKRETEN Muskeln (Primär 1,0 / Sekundär s. u.) ---------- */
// Sekundärer Volumenfaktor je Muskel – nur wirksam, wenn die Sekundärzählung aktiv ist (Profil-Schalter).
// Kleine Muskeln zählen bei Verbundübungen NICHT (0), größere anteilig (0,25).
const SECONDARY_FACTORS = {
  biceps: 0, triceps: 0, forearm: 0, delt_r: 0, delt_s: 0, calves: 0, obliques: 0, abductors: 0, adductors: 0,
  chest: 0.25, chest_up: 0.25, chest_low: 0.25, lats: 0.25, traps: 0.25, quads: 0.25, hams: 0.25, glutes: 0.25, delt_f: 0.25, abs: 0.25, lowback: 0.25,
};
// Global aus dem Profil gespiegelt (wie CUSTOM/EX_OVERRIDES/EXCLUDED_CATS): Sekundäre Muskelbeteiligung
// überhaupt mitzählen. Standard aus → alle Sekundärfaktoren 0.
let COUNT_SECONDARY = false;
const secondaryFactor = (mid) => COUNT_SECONDARY ? (SECONDARY_FACTORS[mid] || 0) : 0;
// Konkrete Muskeln: Label, Muskelgruppe, zugehörige body-muscles-IDs.
const MUSCLES = {
  chest:     { de: "Brustmuskel",          grp: "Brust",    lib: ["chest-upper-left", "chest-upper-right", "chest-lower-left", "chest-lower-right"] },
  chest_up:  { de: "obere Brust (Schlüsselbein)", grp: "Brust", lib: ["chest-upper-left", "chest-upper-right"] },
  chest_low: { de: "untere Brust",         grp: "Brust",    lib: ["chest-lower-left", "chest-lower-right"] },
  delt_f:    { de: "vordere Schulter",     grp: "Schulter", lib: ["shoulder-front-left", "shoulder-front-right"] },
  delt_s:    { de: "seitliche Schulter",   grp: "Schulter", lib: ["shoulder-side-left", "shoulder-side-right"] },
  delt_r:    { de: "hintere Schulter",     grp: "Schulter", lib: ["deltoid-rear-left", "deltoid-rear-right"] },
  traps:     { de: "Trapez / Nacken",      grp: "Schulter", lib: ["traps-upper-left", "traps-mid-left", "traps-lower-left", "traps-upper-right", "traps-mid-right", "traps-lower-right"] },
  lats:      { de: "Latissimus / oberer Rücken", grp: "Rücken", lib: ["lats-upper-left", "lats-mid-left", "lats-lower-left", "lats-upper-right", "lats-mid-right", "lats-lower-right"] },
  lowback:   { de: "unterer Rücken",       grp: "Rücken",   lib: ["lower-back-erectors-left", "lower-back-ql-left", "lower-back-erectors-right", "lower-back-ql-right", "spine"] },
  biceps:    { de: "Bizeps",               grp: "Arme",     lib: ["biceps-left", "biceps-right"] },
  triceps:   { de: "Trizeps",              grp: "Arme",     lib: ["triceps-long-left", "triceps-lateral-left", "triceps-long-right", "triceps-lateral-right"] },
  forearm:   { de: "Unterarm",             grp: "Arme",     lib: ["forearm-left", "forearm-right", "forearm-flexors-left", "forearm-extensors-left", "forearm-flexors-right", "forearm-extensors-right"] },
  quads:     { de: "Quadrizeps",           grp: "Beine",    lib: ["quads-left", "quads-right"] },
  hams:      { de: "Beinbeuger",           grp: "Beine",    lib: ["hamstrings-medial-left", "hamstrings-lateral-left", "hamstrings-medial-right", "hamstrings-lateral-right"] },
  glutes:    { de: "Gesäß",                grp: "Beine",    lib: ["gluteus-maximus-left", "gluteus-maximus-right"] },
  calves:    { de: "Waden",                grp: "Beine",    lib: ["calves-gastroc-medial-left", "calves-gastroc-lateral-left", "calves-soleus-left", "calves-gastroc-medial-right", "calves-gastroc-lateral-right", "calves-soleus-right"] },
  adductors: { de: "Adduktoren",           grp: "Beine",    lib: ["adductors-left", "adductors-right"] },
  abductors: { de: "Abduktoren",           grp: "Beine",    lib: ["gluteus-medius-left", "gluteus-medius-right"] },
  abs:       { de: "Bauch (gerade)",       grp: "Bauch",    lib: ["abs-upper-left", "abs-upper-right", "abs-lower-left", "abs-lower-right"] },
  obliques:  { de: "seitlicher Bauch",     grp: "Bauch",    lib: ["obliques-left", "obliques-right"] },
};
const muscleGroup = (mid) => (MUSCLES[mid] || {}).grp;
const muscleLabel = (mid) => (MUSCLES[mid] || {}).de || mid;
// Muskelspezifische Wochenvolumen-Landmarken (effektive Sätze/Woche) nach Israetel/Renaissance
// Periodization (Hypertrophy Training Guide) und Schoenfeld: mv = Maintenance Volume (Erhalt),
// mev = Minimum Effective Volume (Minimum für Wachstum), mav = Maximum Adaptive Volume (obere
// produktive Grenze). Werte sind Richtwerte je Einzelmuskel und dienen der Volumen-Priorisierung.
const MUSCLE_VOLUME_TARGETS = {
  chest:     { mv: 8, mev: 10, mav: 20 }, // große Muskeln: hohes MAV
  chest_up:  { mv: 2, mev: 4,  mav: 10 }, // Teilregion der Brust (ergänzend)
  chest_low: { mv: 2, mev: 3,  mav: 8 },
  lats:      { mv: 8, mev: 10, mav: 20 },
  quads:     { mv: 8, mev: 10, mav: 18 },
  glutes:    { mv: 4, mev: 6,  mav: 16 },
  hams:      { mv: 6, mev: 8,  mav: 16 }, // mittlere Muskeln
  traps:     { mv: 4, mev: 6,  mav: 16 },
  delt_f:    { mv: 0, mev: 6,  mav: 12 }, // vordere Schulter bekommt viel indirektes Druckvolumen
  delt_s:    { mv: 6, mev: 8,  mav: 22 }, // seitliche Schulter verträgt sehr hohes Volumen
  delt_r:    { mv: 4, mev: 6,  mav: 16 },
  lowback:   { mv: 2, mev: 4,  mav: 12 },
  biceps:    { mv: 6, mev: 8,  mav: 18 }, // kleine Muskeln: niedrigeres MAV
  triceps:   { mv: 4, mev: 6,  mav: 18 },
  calves:    { mv: 6, mev: 8,  mav: 16 },
  abs:       { mv: 0, mev: 6,  mav: 16 },
  adductors: { mv: 0, mev: 4,  mav: 12 },
  abductors: { mv: 0, mev: 4,  mav: 12 },
  forearm:   { mv: 2, mev: 4,  mav: 12 }, // sehr klein: viel indirektes Griff-Volumen
  obliques:  { mv: 0, mev: 4,  mav: 12 },
};
// Geprüfte Pro-Übung-Zuordnung: p = primär (1,0), s = sekundär (0,5).
const EX_MUSCLES = {
  "Keiser Brustpresse": { p: ["chest"], s: ["triceps", "delt_f"] },
  "Pec Fly sitzend Keiser": { p: ["chest"], s: ["delt_f"] },
  "Keiser Kabel-Fly von unten (obere Brust)": { p: ["chest_up"], s: ["delt_f"] },
  "Keiser Kabel-Fly Mitte (mittlere Brust)": { p: ["chest"], s: ["delt_f"] },
  "Keiser Kabel-Fly von oben (untere Brust)": { p: ["chest_low"], s: ["delt_f"] },
  "Keiser Pec Fly (oben)": { p: ["chest_up"], s: ["delt_f"] },
  "Keiser Pec Fly (Mitte)": { p: ["chest"], s: ["delt_f"] },
  "Keiser Pec Fly (unten)": { p: ["chest_low"], s: ["delt_f"] },
  "Keiser Latzug": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Keiser Kabel-Rudern": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "Keiser Schulterdrücken": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Keiser Seitheben am Kabel": { p: ["delt_s"], s: [] },
  "Keiser Bizeps-Curl": { p: ["biceps"], s: ["forearm"] },
  "Keiser Trizeps-Pushdown": { p: ["triceps"], s: [] },
  "Keiser Kniebeuge": { p: ["quads", "glutes"], s: ["hams"] },
  "Keiser Beinpresse": { p: ["quads", "glutes"], s: ["hams"] },
  "Keiser Hip Extension (Kabel)": { p: ["glutes", "hams"], s: ["lowback"] },
  "Keiser Kabel-Crunch": { p: ["abs"], s: [] },
  "Keiser Holzhacker von oben (High-to-Low)": { p: ["obliques"], s: ["abs", "lats"] },
  "Keiser Holzhacker von unten (Low-to-High)": { p: ["obliques"], s: ["abs", "delt_f"] },
  "EGym Brustpresse": { p: ["chest"], s: ["triceps", "delt_f"] },
  "EGym Butterfly": { p: ["chest"], s: ["delt_f"] },
  "EGym Latzug": { p: ["lats"], s: ["biceps", "delt_r"] },
  "EGym Rudern": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "EGym Reverse Fly": { p: ["delt_r"], s: ["traps"] },
  "EGym Rückenstrecker": { p: ["lowback"], s: ["glutes", "hams"] },
  "EGym Schulterpresse": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "EGym Bizeps-Curl": { p: ["biceps"], s: ["forearm"] },
  "EGym Trizeps-Presse": { p: ["triceps"], s: [] },
  "EGym Beinpresse": { p: ["quads", "glutes"], s: ["hams"] },
  "EGym Beinstrecker": { p: ["quads"], s: [] },
  "EGym Beinbeuger": { p: ["hams"], s: ["calves"] },
  "EGym Abduktoren": { p: ["abductors", "glutes"], s: [] },
  "EGym Adduktoren": { p: ["adductors"], s: [] },
  "EGym Glutes (Hip Extension)": { p: ["glutes", "hams"], s: ["lowback"] },
  "EGym Bauchpresse": { p: ["abs"], s: [] },
  "Bankdrücken (Langhantel)": { p: ["chest"], s: ["triceps", "delt_f"] },
  "Schrägbank DB-Brustdrücken": { p: ["chest_up"], s: ["delt_f", "triceps"] },
  "Schrägbank Langhantel-Drücken": { p: ["chest_up"], s: ["delt_f", "triceps"] },
  "Flachbank DB-Drücken": { p: ["chest"], s: ["delt_f", "triceps"] },
  "Negativbank-Drücken": { p: ["chest_low"], s: ["triceps"] },
  "Brustpresse (Maschine)": { p: ["chest"], s: ["delt_f", "triceps"] },
  "Pec Fly": { p: ["chest"], s: ["delt_f"] },
  "Kabel-Crossover": { p: ["chest"], s: ["delt_f"] },
  "Liegestütze": { p: ["chest"], s: ["triceps", "delt_f", "abs"] },
  "Latzug (breit)": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Latzug (eng)": { p: ["lats"], s: ["biceps"] },
  "Latzug Maschine": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Klimmzug": { p: ["lats"], s: ["biceps", "delt_r", "forearm"] },
  "Langhantelrudern": { p: ["lats"], s: ["delt_r", "biceps", "lowback", "traps"] },
  "T-Bar Rudern": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "Rudern am Kabel": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "Maschinen-Rudern": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Einarmiges DB-Rudern": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Überzüge": { p: ["lats"], s: ["chest", "triceps"] },
  "Reverse Fly": { p: ["delt_r"], s: ["traps"] },
  "Kreuzheben": { p: ["lowback", "glutes", "hams"], s: ["lats", "traps", "quads", "forearm"] },
  "Rückenstrecker (Hyperextension)": { p: ["lowback"], s: ["glutes", "hams"] },
  "Rücken Extension Gerät": { p: ["lowback"], s: ["glutes", "hams"] },
  "Schulterdrücken (DB)": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Overhead Press (Langhantel)": { p: ["delt_f"], s: ["delt_s", "triceps", "traps"] },
  "Schulterdrücken (Maschine)": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Arnold Press": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Seitheben": { p: ["delt_s"], s: [] },
  "Kabel-Seitheben": { p: ["delt_s"], s: [] },
  "Frontheben": { p: ["delt_f"], s: [] },
  "Face Pulls": { p: ["delt_r"], s: ["traps"] },
  "Upright Row": { p: ["delt_s"], s: ["traps", "biceps"] },
  "Nackenheben (Shrugs)": { p: ["traps"], s: [] },
  "Bizeps DB-Curls": { p: ["biceps"], s: ["forearm"] },
  "Langhantel-Curls": { p: ["biceps"], s: ["forearm"] },
  "SZ-Curls": { p: ["biceps"], s: ["forearm"] },
  "Hammer DB Curls": { p: ["biceps"], s: ["forearm"] },
  "Hammer Curls Seil": { p: ["biceps"], s: ["forearm"] },
  "Preacher-Curls": { p: ["biceps"], s: [] },
  "Preacher Curls Maschine": { p: ["biceps"], s: [] },
  "Konzentrations-Curls": { p: ["biceps"], s: [] },
  "Kabel-Curls": { p: ["biceps"], s: [] },
  "Schrägbank-Curls (Incline)": { p: ["biceps"], s: [] },
  "Spider-Curls": { p: ["biceps"], s: [] },
  "Trizeps Pushdown": { p: ["triceps"], s: [] },
  "Trizeps Pushdown (Untergriff)": { p: ["triceps"], s: [] },
  "Überkopf-Trizeps (Seil)": { p: ["triceps"], s: [] },
  "Dips": { p: ["triceps"], s: ["chest_low", "delt_f"] },
  "Enges Bankdrücken": { p: ["triceps"], s: ["chest", "delt_f"] },
  "French Press": { p: ["triceps"], s: [] },
  "Kickbacks": { p: ["triceps"], s: [] },
  "Trizeps-Maschine": { p: ["triceps"], s: [] },
  "Handgelenks-Curls": { p: ["forearm"], s: [] },
  "Kniebeuge": { p: ["quads", "glutes"], s: ["hams", "lowback", "abs"] },
  "Frontkniebeuge": { p: ["quads"], s: ["glutes", "abs"] },
  "Goblet-Kniebeuge": { p: ["quads"], s: ["glutes", "abs"] },
  "Hackenschmidt-Kniebeuge": { p: ["quads"], s: ["glutes"] },
  "Beinpresse": { p: ["quads", "glutes"], s: ["hams"] },
  "Ausfallschritte": { p: ["quads", "glutes"], s: ["hams"] },
  "Bulgarian Split Squat": { p: ["quads", "glutes"], s: ["hams"] },
  "Rumänisches Kreuzheben (DB)": { p: ["hams", "glutes"], s: ["lowback"] },
  "Beinstrecker": { p: ["quads"], s: [] },
  "Beinbeuger": { p: ["hams"], s: [] },
  "Beinbeuger (sitzend)": { p: ["hams"], s: [] },
  "Hip Thrust": { p: ["glutes"], s: ["hams"] },
  "Abduktoren-Maschine": { p: ["abductors"], s: [] },
  "Adduktoren-Maschine": { p: ["adductors"], s: [] },
  "Wadenheben": { p: ["calves"], s: [] },
  "Wadenheben (sitzend)": { p: ["calves"], s: [] },
  "Beinheben": { p: ["abs"], s: ["obliques"] },
  "Hängendes Beinheben": { p: ["abs"], s: ["obliques", "forearm"] },
  "Crunch / Kabel-Crunch": { p: ["abs"], s: [] },
  "Crunch auf Ball": { p: ["abs"], s: ["obliques"] },
  "Plank": { p: ["abs"], s: ["obliques"] },
  "Side Plank": { p: ["obliques"], s: ["abs"] },
  "Russian Twist": { p: ["obliques"], s: ["abs"] },
  "Käfer (Dead Bug)": { p: ["abs"], s: [] },
  "Ab Wheel (Bauchroller)": { p: ["abs"], s: ["lats"] },
  "Mountain Climbers": { p: ["abs"], s: ["obliques"] },
  // TRX
  "TRX Rudern": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "TRX Power Pull": { p: ["lats"], s: ["biceps", "delt_r"] },
  "TRX Y-Fly": { p: ["delt_r"], s: ["traps"] },
  "TRX T-Fly": { p: ["delt_r"], s: ["traps", "lats"] },
  "TRX Face Pull": { p: ["delt_r"], s: ["traps"] },
  "TRX Brustpresse": { p: ["chest"], s: ["triceps", "delt_f"] },
  "TRX Brustfliegende": { p: ["chest"], s: ["delt_f"] },
  "TRX Atomic Push-up": { p: ["chest"], s: ["triceps", "delt_f", "abs"] },
  "TRX Bizeps-Curl": { p: ["biceps"], s: ["forearm"] },
  "TRX Trizeps-Strecken": { p: ["triceps"], s: [] },
  "TRX Kniebeuge": { p: ["quads", "glutes"], s: ["hams"] },
  "TRX Ausfallschritt": { p: ["quads", "glutes"], s: ["hams"] },
  "TRX Pistol Squat (assistiert)": { p: ["quads", "glutes"], s: ["hams"] },
  "TRX Hamstring Curl": { p: ["hams"], s: ["glutes"] },
  "TRX Hip Press": { p: ["glutes"], s: ["hams"] },
  "TRX Plank": { p: ["abs"], s: ["obliques"] },
  "TRX Pike": { p: ["abs"], s: ["delt_f"] },
  "TRX Knee Tuck": { p: ["abs"], s: ["obliques"] },
  "TRX Mountain Climber": { p: ["abs"], s: ["obliques"] },
  "TRX Oblique Crunch": { p: ["obliques"], s: ["abs"] },
  // Calisthenics
  "Klimmzug breit (Wide)": { p: ["lats"], s: ["biceps", "delt_r"] },
  "Chin-up (Untergriff)": { p: ["lats"], s: ["biceps"] },
  "Australian Pull-up (Inverted Row)": { p: ["lats"], s: ["biceps", "delt_r", "traps"] },
  "Muscle-up": { p: ["lats"], s: ["chest", "triceps", "biceps", "delt_f"] },
  "Diamant-Liegestütze": { p: ["triceps"], s: ["chest", "delt_f"] },
  "Breite Liegestütze": { p: ["chest"], s: ["delt_f", "triceps"] },
  "Negativ-Liegestütze": { p: ["chest_up"], s: ["delt_f", "triceps"] },
  "Pike-Liegestütze": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Handstand-Liegestütze": { p: ["delt_f"], s: ["delt_s", "triceps"] },
  "Archer-Liegestütze": { p: ["chest"], s: ["triceps", "delt_f"] },
  "Barren-Dips": { p: ["triceps"], s: ["chest_low", "delt_f"] },
  "Bank-Dips": { p: ["triceps"], s: ["delt_f"] },
  "Pistol Squat": { p: ["quads", "glutes"], s: ["hams"] },
  "Sissy Squat": { p: ["quads"], s: [] },
  "Nordic Hamstring Curl": { p: ["hams"], s: ["glutes"] },
  "Glute Bridge": { p: ["glutes"], s: ["hams"] },
  "Wadenheben (Körpergewicht)": { p: ["calves"], s: [] },
  "L-Sit": { p: ["abs"], s: ["obliques"] },
  "Toes to Bar": { p: ["abs"], s: ["obliques", "forearm"] },
  "Hollow Body Hold": { p: ["abs"], s: ["obliques"] },
  "Dragon Flag": { p: ["abs"], s: ["obliques"] },
  "Burpee": { p: ["quads"], s: ["chest", "glutes", "abs"] },
};
const GROUP_DEFAULT_MUSCLES = { "Brust": ["chest"], "Rücken": ["lats"], "Schulter": ["delt_f", "delt_s"], "Arme": ["biceps", "triceps"], "Beine": ["quads", "glutes"], "Bauch": ["abs"] };
// {muscleId: faktor} – primär 1,0 / sekundär 0,5. Fallback für eigene Übungen über die Gruppe.
// skipGroupDefault: wenn true, wird der GROUP_DEFAULT_MUSCLES-Fallback übersprungen.
// Nutzen: Defizit-Berechnung und Erholungsprüfung, wo der Fallback fälschlicherweise
// alle Muskeln einer Gruppe (z. B. Bizeps UND Trizeps für "Arme") als primär belastet zählt.
const exerciseMuscleInvolvement = (exercise, skipGroupDefault) => {
  const t = EX_MUSCLES[exercise.name];
  const inv = {};
  if (t) {
    (t.p || []).forEach((m) => (inv[m] = 1));
    (t.s || []).forEach((m) => { if (inv[m] == null) inv[m] = secondaryFactor(m); });
    return inv;
  }
  // Eigene Übung mit vom KI-Trainer ergänzter Zuordnung?
  const c = find(exercise.name);
  if (c && c.inv) {
    (c.inv.p || []).forEach((m) => { if (MUSCLES[m]) inv[m] = 1; });
    (c.inv.s || []).forEach((m) => { if (MUSCLES[m] && inv[m] == null) inv[m] = secondaryFactor(m); });
    if (Object.keys(inv).length) return inv;
  }
  if (skipGroupDefault) return inv; // leeres Objekt – kein explizites Mapping vorhanden
  (GROUP_DEFAULT_MUSCLES[exercise.group] || []).forEach((m) => (inv[m] = 1));
  return inv;
};
// Anzeige-Variante: Sekundärmuskeln immer mit 0,5 unabhängig von COUNT_SECONDARY.
const exerciseMuscleInvolvementDisplay = (exercise) => {
  const t = EX_MUSCLES[exercise.name];
  const inv = {};
  if (t) {
    (t.p || []).forEach((m) => (inv[m] = 1));
    (t.s || []).forEach((m) => { if (inv[m] == null) inv[m] = 0.5; });
    return inv;
  }
  const c = find(exercise.name);
  if (c && c.inv) {
    (c.inv.p || []).forEach((m) => { if (MUSCLES[m]) inv[m] = 1; });
    (c.inv.s || []).forEach((m) => { if (MUSCLES[m] && inv[m] == null) inv[m] = 0.5; });
    if (Object.keys(inv).length) return inv;
  }
  (GROUP_DEFAULT_MUSCLES[exercise.group] || []).forEach((m) => (inv[m] = 1));
  return inv;
};
// {group: faktor} – pro Gruppe der höchste Beteiligungsfaktor ihrer Muskeln.
const exerciseGroupInvolvement = (exercise) => {
  const mi = exerciseMuscleInvolvement(exercise);
  const g = {};
  Object.keys(mi).forEach((m) => { const grp = muscleGroup(m); if (!grp) return; g[grp] = Math.max(g[grp] || 0, mi[m]); });
  return g;
};
const involvementParts = (exercise) => {
  const mi = exerciseMuscleInvolvement(exercise);
  return { primary: Object.keys(mi).filter((m) => mi[m] >= 1), secondary: Object.keys(mi).filter((m) => mi[m] < 1) };
};
// Effektive Sätze je Muskelgruppe (höchster Faktor je Gruppe). logSecondary===false -> ohne Sekundär.
const effectiveSetsByGroup = (sessions) => {
  const m = {}; MUSCLE_GROUPS.forEach((g) => (m[g] = 0));
  (sessions || []).forEach((s) => { if (isCond(s)) { if (s.type === "core") m["Bauch"] += CORE_SETS; return; } (s.exercises || []).forEach((e) => {
    const n = (e.sets || []).filter(isWorkingSet).length; if (!n) return;
    const noSec = s.logSecondary === false || e.logSecondary === false;
    const inv = exerciseGroupInvolvement(e);
    Object.keys(inv).forEach((g) => { if (!(g in m)) return; const f = inv[g]; if (f < 1 && noSec) return; m[g] += n * f; });
  }); });
  return m;
};
// Effektive Sätze je konkretem Muskel.
// skipGroupDefault: an exerciseMuscleInvolvement durchreichen – wenn true, werden Custom-Übungen
// ohne explizites Mapping ignoriert statt über GROUP_DEFAULT_MUSCLES alle Muskeln einer Gruppe zu zählen.
const effectiveSetsByMuscle = (sessions, skipGroupDefault) => {
  const m = {};
  (sessions || []).forEach((s) => { if (isCond(s)) { if (s.type === "core") m["abs"] = (m["abs"] || 0) + CORE_SETS; return; } (s.exercises || []).forEach((e) => {
    const n = (e.sets || []).filter(isWorkingSet).length; if (!n) return;
    const noSec = s.logSecondary === false || e.logSecondary === false;
    const mi = exerciseMuscleInvolvement(e, skipGroupDefault);
    Object.keys(mi).forEach((mid) => { const f = mi[mid]; if (f < 1 && noSec) return; m[mid] = (m[mid] || 0) + n * f; });
  }); });
  return m;
};
// Sessions der letzten `days` Tage (rollierendes Fenster) – Basis fürs Ist-Wochenvolumen.
const sessionsInLastDays = (history, days) => {
  const now = Date.now();
  return (history || []).filter((s) => {
    const d = (now - new Date(s.dateISO).getTime()) / 86400000;
    return d >= 0 && d < days;
  });
};
// Körperkomposition-Trend aus den Withings/Messwerten (neueste zuerst): Δ Muskelmasse und Δ Fettmasse
// gegenüber einer Basislinie ~3 Wochen zuvor. null, wenn zu wenig Daten für einen Trend vorliegen.
const bodyCompTrend = (measurements) => {
  const m = (measurements || []).filter((x) => x && x.dateISO);
  if (m.length < 2) return null;
  const latest = m[0];
  const tL = new Date(latest.dateISO).getTime();
  const base = m.find((x) => (tL - new Date(x.dateISO).getTime()) / 86400000 >= 21) || m[m.length - 1];
  if (base === latest) return null;
  const num = (v) => (typeof v === "number" && isFinite(v)) ? v : null;
  const diff = (a, b) => (num(a) != null && num(b) != null) ? a - b : null;
  return { muscleDelta: diff(latest.muscleMassKg, base.muscleMassKg), fatDelta: diff(latest.fatMassKg, base.fatMassKg) };
};
// Verschiebung des Zielvolumens zwischen MEV (0) und MAV (1) je nach Messwert-Trend:
// – Fett sinkt deutlich (Diät) → bei MEV bleiben (Regeneration im Defizit).
// – Muskelmasse stagniert/sinkt → Reiz erhöhen, Richtung MAV.
// – sonst / keine Messdaten → Standard-MEV.
const growthBias = (measurements) => {
  const t = bodyCompTrend(measurements);
  if (!t) return 0;
  if (t.fatDelta != null && t.fatDelta <= -0.5) return 0;
  if (t.muscleDelta != null && t.muscleDelta <= 0.2) return 0.5;
  return 0;
};
// Angepasstes Zielvolumen je Muskel (zwischen MEV und MAV, je nach growthBias).
const muscleVolumeTargets = (measurements) => {
  const bias = growthBias(measurements);
  const out = {};
  Object.keys(MUSCLE_VOLUME_TARGETS).forEach((mid) => {
    const t = MUSCLE_VOLUME_TARGETS[mid];
    out[mid] = t.mev + bias * (t.mav - t.mev);
  });
  return out;
};
// Fixer Defizit-Bonus für Muskeln, die der KI-Trainer aktiv verstärken will. Entspricht ~einem halben
// MEV-Anteil und hebt empfohlene Muskeln über gleich stark defizitäre, aber nicht empfohlene.
// KEIN Ziel-Aufblasen auf MAV – das echte Trainings-Defizit dominiert; der Bonus ist reiner Tie-Breaker.
const AI_PRIORITY_DEFICIT_BONUS = 0.5;
// Defizit-Score je Muskel: (angepasstes Ziel − Ist-Volumen der letzten 7 Tage) / MEV.
// > 0 = unter dem Ziel (untertrainiert → wird bevorzugt), < 0 = über dem Ziel.
// boost (optional): Set von Muskel-IDs, die der KI-Trainer empfiehlt – sie bekommen einen fixen Bonus,
// aber kein künstlich aufgeblasenes Ziel, damit ein tatsächlich untrainierter Muskel (0 Sätze/Woche)
// immer Vorrang vor einem bereits auf MEV trainierten KI-Muskel behält.
const muscleDeficitScores = (history, measurements, boost) => {
  // Rollierende 7 Tage – gleiche Zeitbasis wie dayTargetVolRest.
  // skipGroupDefault=true: Custom-Übungen ohne explizites Mapping nicht über GROUP_DEFAULT_MUSCLES
  // zählen, damit z. B. eine Bizeps-Custom-Übung (Gruppe "Arme") nicht fälschlicherweise auch
  // Trizeps-Sätze zurechnet und dessen Defizit auf 0 drückt.
  const actual = effectiveSetsByMuscle(sessionsInLastDays(history, 7), true);
  const targets = muscleVolumeTargets(measurements);
  const boosted = boost || new Set();
  const out = {};
  Object.keys(MUSCLE_VOLUME_TARGETS).forEach((mid) => {
    const lm = MUSCLE_VOLUME_TARGETS[mid];
    const mev = lm.mev || 1;
    const tgt = targets[mid]; // echtes Ziel (MEV…MAV je growthBias), OHNE künstliche MAV-Anhebung
    const bonus = boosted.has(mid) ? AI_PRIORITY_DEFICIT_BONUS : 0;
    out[mid] = (tgt - (actual[mid] || 0)) / mev + bonus;
  });
  return out;
};
const fmtSets = (n) => (Math.round(n * 10) / 10).toLocaleString("de-DE");
// History in Wochen-Buckets (neueste zuerst).
const weeklyBuckets = (history) => {
  const map = new Map();
  (history || []).forEach((s) => {
    const k = weekKey(s.dateISO);
    if (!map.has(k)) map.set(k, []);
    map.get(k).push(s);
  });
  return [...map.entries()].sort((a, b) => b[0].localeCompare(a[0]))
    .map(([key, sessions]) => ({ key, sessions }));
};
const groupStatus = (n) => (n === 0 ? "none" : n < SET_MIN ? "low" : n > SET_MAX ? "high" : "ok");
const STATUS_COLOR = { none: C.line, low: C.accent, ok: C.accent2, high: C.danger };
// Hinweise zur Balance einer Woche.
const balanceHints = (counts) => {
  const hints = [];
  MUSCLE_GROUPS.forEach((g) => {
    const n = counts[g];
    if (n === 0) hints.push({ tone: "low", text: `${g}: diese Woche nicht trainiert` });
    else if (n < SET_MIN) hints.push({ tone: "low", text: `${g}: nur ${n} Sätze – Ziel ≥ ${SET_MIN}` });
    else if (n > SET_MAX + 4) hints.push({ tone: "high", text: `${g}: ${n} Sätze – sehr viel, Erholung beachten` });
  });
  const push = counts["Brust"], pull = counts["Rücken"];
  if (push && pull) {
    if (push > pull * 1.5) hints.push({ tone: "high", text: `Push-lastig: Brust ${push} vs. Rücken ${pull} Sätze` });
    else if (pull > push * 1.5) hints.push({ tone: "ok", text: `Pull-Schwerpunkt: Rücken ${pull} vs. Brust ${push} – meist unkritisch` });
  }
  if (!hints.length) hints.push({ tone: "ok", text: "Ausgewogene Woche – alle Gruppen im Zielkorridor." });
  return hints;
};

// ----- Cardio / Yoga -----
const CARDIO_ACTIVITIES = ["Laufen Indoor", "Fahrrad", "Sitzfahrrad", "Stepper", "Rudern", "SkiErg", "Seilspringen"];
const CARDIO_ICON = { "Laufen Indoor": "🏃", "Fahrrad": "🚴", "Sitzfahrrad": "🚲", "Stepper": "🪜", "Rudern": "🚣", "SkiErg": "⛷️", "Seilspringen": "🪢" };

// ----- Tages-Ringe (Apple-Fitness-Stil) -----
const RING_GROUPS = ["Brust", "Rücken", "Arme", "Beine"];
const DAY_RING_TARGET = 6; // harte Sätze je Gruppe und Tag, ab denen der Ring schließt
const dayKey = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const byDay = (history) => {
  const m = new Map();
  (history || []).forEach((s) => { const k = dayKey(s.dateISO); if (!m.has(k)) m.set(k, []); m.get(k).push(s); });
  return m;
};

/* ---------- Trainingsstatistik (für Plan-Generator-Defaults) ---------- */
// Ein „Trainingstag" = Kalendertag mit mindestens einem Kraft-Workout (≥ 1 harter Satz).
const isStrengthSession = (s) => s && !isCond(s) && (s.exercises || []).some((e) => (e.sets || []).some(isWorkingSet));
// Ø Trainingstage/Woche im letzten Monat – NUR Wochen mit ≥ 1 Training zählen. null ohne Daten.
const avgTrainingDaysPerWeek = (history) => {
  const cutoff = Date.now() - 31 * 86400000;
  const byWeek = new Map(); // weekKey -> Set(dayKey)
  (history || []).forEach((s) => {
    if (!isStrengthSession(s) || new Date(s.dateISO).getTime() < cutoff) return;
    const wk = weekKey(s.dateISO);
    if (!byWeek.has(wk)) byWeek.set(wk, new Set());
    byWeek.get(wk).add(dayKey(s.dateISO));
  });
  if (!byWeek.size) return null;
  let sum = 0; byWeek.forEach((d) => (sum += d.size));
  return sum / byWeek.size;
};
// Ø Trainingsdauer (Minuten) der letzten 2 Wochen aus den Satz-Zeitstempeln (letzter − erster Satz je
// Einheit). Einheiten mit < 2 Zeitstempeln oder unplausibler Spanne (> 5 h) werden verworfen. null ohne Daten.
const avgSessionMinutes = (history) => {
  const cutoff = Date.now() - 14 * 86400000;
  const durations = [];
  (history || []).forEach((s) => {
    if (!isStrengthSession(s) || new Date(s.dateISO).getTime() < cutoff) return;
    const ts = (s.exercises || []).flatMap((e) => (e.sets || []).map((x) => x.ts && new Date(x.ts).getTime()))
      .filter((t) => t && isFinite(t));
    if (ts.length < 2) return;
    const span = (Math.max(...ts) - Math.min(...ts)) / 60000;
    if (span > 0 && span < 300) durations.push(span);
  });
  if (!durations.length) return null;
  return durations.reduce((a, b) => a + b, 0) / durations.length;
};

/* ---------- Muskelabdeckungs-Check (MEV) für generierte Pläne ---------- */
// Hauptmuskeln, deren MEV je Woche im Plan gedeckt sein sollte. Sub-Regionen (obere/untere Brust)
// und indirekt gut versorgte Muskeln (vordere Schulter, Unterarm, Trapez, unterer Rücken) sind
// bewusst ausgenommen, damit der Check nicht überempfindlich auslöst.
const COVERAGE_MUSCLES = ["chest", "lats", "delt_s", "delt_r", "biceps", "triceps", "quads", "hams", "glutes", "calves", "abs"];
// Effektive Ziel-Wochensätze je Muskel aus einem Plan (Ziel-Sätze × Beteiligung, Sekundär 0,5).
const planMuscleSets = (plan) => {
  const out = {};
  Object.keys(plan || {}).forEach((day) => (plan[day] || []).forEach((e) => {
    const inv = exerciseMuscleInvolvementDisplay(e);
    const sets = Number(e.targetSets) || 0;
    Object.keys(inv).forEach((mid) => { out[mid] = (out[mid] || 0) + sets * inv[mid]; });
  }));
  return out;
};
// Hauptmuskeln unter MEV. Liefert [{ mid, have, mev, need }] (need = fehlende Sätze, aufgerundet).
const planCoverageGaps = (plan) => {
  const have = planMuscleSets(plan);
  return COVERAGE_MUSCLES.map((mid) => {
    const mev = (MUSCLE_VOLUME_TARGETS[mid] || {}).mev || 0;
    const cur = have[mid] || 0;
    return { mid, have: cur, mev, need: Math.max(0, Math.ceil(mev - cur)) };
  }).filter((g) => g.need > 0);
};
// Wählt eine passende Zusatzübung (primär auf den Muskel), die nicht vermieden wird und noch nicht
// im Plan steht. Isolationsübungen werden für gezielte Abdeckung bevorzugt.
const suggestSupplement = (mid, plan, profile, used) => {
  const cand = availableEx().filter((e) => {
    if (used.has(e.n)) return false;
    const inv = exerciseMuscleInvolvement({ name: e.n, group: e.g });
    return (inv[mid] || 0) >= 1 && !isAvoided({ name: e.n, group: e.g, muscle: e.m }, profile);
  });
  cand.sort((a, b) => (isCompound(a.n) ? 1 : 0) - (isCompound(b.n) ? 1 : 0) || a.n.localeCompare(b.n));
  return cand[0] || null;
};
// Ergänzt den Plan um optionale Zusatzübungen, bis jeder Hauptmuskel sein MEV erreicht.
// Rückgabe: { plan, added: [{ name, muscle }], gapMuscles: [mid] }.
const ensureMuscleCoverage = (plan, profile) => {
  const gaps = planCoverageGaps(plan);
  if (!gaps.length) return { plan, added: [], gapMuscles: [] };
  const used = new Set(Object.keys(plan || {}).flatMap((d) => (plan[d] || []).map((e) => e.name)));
  const supplements = [];
  gaps.forEach(({ mid, need }) => {
    const e = suggestSupplement(mid, plan, profile, used);
    if (!e) return;
    used.add(e.n);
    const sets = Math.max(2, Math.min(4, need));
    supplements.push({ item: { ...ex(e.n, sets, isCompound(e.n) ? "8-12" : "10-15"), optional: true }, coverMuscle: muscleLabel(mid) });
  });
  if (!supplements.length) return { plan, added: [], gapMuscles: gaps.map((g) => g.mid) };
  const dayName = "Zusatz (optional)";
  const next = { ...plan, [dayName]: [...(plan[dayName] || []), ...supplements.map((s) => s.item)] };
  return { plan: next, added: supplements.map((s) => ({ name: s.item.name, muscle: s.coverMuscle })), gapMuscles: gaps.map((g) => g.mid) };
};
// Ring-Füllungen (0..1) je Gruppe + Flags für Yoga/Cardio eines Tages
const dayRings = (sessions) => {
  const strength = (sessions || []).filter((s) => !isCond(s));
  const counts = setsByGroup(strength);
  const fills = {}; RING_GROUPS.forEach((g) => (fills[g] = Math.min(1, (counts[g] || 0) / DAY_RING_TARGET)));
  return {
    fills, counts,
    yoga: (sessions || []).some((s) => s.type === "yoga"),
    cardio: (sessions || []).some((s) => s.type === "cardio"),
    core: (sessions || []).some((s) => s.type === "core"),
    hasStrength: strength.length > 0,
    closed: RING_GROUPS.filter((g) => (counts[g] || 0) >= DAY_RING_TARGET).length,
  };
};

/* ---------- Muskelkarte: Mapping (nutzt vorhandene Katalog-Tags, keine Erfindung) ---------- */
const TAG_MUSCLE = {
  brust: "chest", brust_o: "chest", brust_u: "chest",
  delt_v: "front-delts", delt_s: "side-delts", delt_h: "rear-delts",
  bizeps: "biceps", brachialis: "biceps", unterarm: "forearm",
  tri_seit: "triceps", tri_med: "triceps", tri_lang: "triceps",
  lat: "lats", ruecken_m: "upper-back", ruecken_u: "lower-back", traps: "traps",
  quad: "quads", ham: "hamstrings", glute: "glutes", wade: "calves", add: "adductors", abd: "glutes",
  bauch_g: "abs", bauch_s: "obliques", rumpf: "abs",
};
const GROUP_MUSCLE = {
  "Brust": ["chest"], "Rücken": ["lats", "upper-back"], "Schulter": ["front-delts", "side-delts", "rear-delts"],
  "Arme": ["biceps", "triceps"], "Beine": ["quads", "hamstrings", "glutes"], "Bauch": ["abs"],
};
const MUSCLE_LABEL = {
  chest: "Brust", "front-delts": "vordere Schulter", "side-delts": "seitliche Schulter", "rear-delts": "hintere Schulter",
  biceps: "Bizeps", forearm: "Unterarm", triceps: "Trizeps", lats: "Latissimus", "upper-back": "oberer Rücken",
  "lower-back": "unterer Rücken", traps: "Trapez", quads: "Quadrizeps", hamstrings: "Beinbeuger", glutes: "Gesäß",
  calves: "Waden", adductors: "Adduktoren", abs: "Bauch", obliques: "seitl. Bauch",
};
// Muskeln einer Übung: erst Katalog-Tags, sonst Gruppe.
const exerciseMuscles = (exercise) => {
  const cat = find(exercise.name);
  if (cat && cat.t && cat.t.length) {
    const set = new Set();
    cat.t.forEach((tg) => { if (TAG_MUSCLE[tg]) set.add(TAG_MUSCLE[tg]); });
    if (set.size) return [...set];
  }
  return GROUP_MUSCLE[exercise.group] || [];
};
// Adapter: Sessions -> exercises-Liste fürs MuscleMap (eine Position je tatsächlich trainierter Übung).
const sessionsToMuscleExercises = (sessions) => {
  const out = [];
  (sessions || []).filter((s) => !isCond(s)).forEach((s) => (s.exercises || []).forEach((e) => {
    if (!(e.sets || []).some(isWorkingSet)) return;
    out.push({ name: e.name, muscles: exerciseMuscles(e) });
  }));
  return out;
};

// Plateau-Erkennung: kein neuer e1RM-Bestwert über die letzten 3 Einheiten einer Übung.
const detectPlateau = (name, history, excludeId) => {
  const series = [...(history || [])]
    .filter((h) => !isCond(h) && h.id !== excludeId)
    .sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO))
    .map((h) => {
      const e = (h.exercises || []).find((x) => x.name === name && (x.sets || []).some(isWorkingSet));
      if (!e) return null;
      return e.sets.reduce((m, x) => Math.max(m, est1RM(x.weight, x.reps)), 0) || null;
    })
    .filter((v) => v != null);
  if (series.length < 4) return null;
  const recentMax = Math.max(...series.slice(-3));
  const beforeMax = Math.max(...series.slice(0, -3));
  if (recentMax <= beforeMax * 1.005) {
    return { sessions: 3, text: "Plateau: seit 3 Einheiten kein Fortschritt – Deload (−10 %) oder Übung wechseln." };
  }
  return null;
};

// Auswertung einer abgeschlossenen Einheit (regelbasiert, ohne KI).
const analyzeSession = (session, history) => {
  const others = (history || []).filter((h) => h.id !== session.id);
  const prevSame = others.filter((h) => h.day === session.day)
    .sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO))[0] || null;
  const vol = volume(session), sets = totalSets(session);
  const volPrev = prevSame ? volume(prevSame) : null;
  const volPct = volPrev && volPrev > 0 ? Math.round(((vol - volPrev) / volPrev) * 100) : null;

  const allSets = (session.exercises || []).flatMap((e) => (e.sets || []).filter(isWorkingSet));
  const withRir = allSets.filter((x) => x.rir != null && x.rir !== "");
  const avgRir = withRir.length ? withRir.reduce((t, x) => t + Number(x.rir), 0) / withRir.length : null;
  const failCount = withRir.filter((x) => Number(x.rir) === 0).length;
  const easyCount = withRir.filter((x) => Number(x.rir) >= 3).length;

  const prs = [];
  (session.exercises || []).forEach((e) => {
    const todayBest = (e.sets || []).reduce((best, x) => {
      const v = est1RM(x.weight, x.reps); return v > best.v ? { v, x } : best;
    }, { v: 0, x: null });
    if (!todayBest.x || !Number(todayBest.x.weight)) return;
    let prevMax = 0;
    others.forEach((h) => (h.exercises || []).filter((x) => x.name === e.name).forEach((pe) =>
      (pe.sets || []).forEach((x) => { prevMax = Math.max(prevMax, est1RM(x.weight, x.reps)); })));
    if (prevMax > 0 && todayBest.v > prevMax + 0.01) prs.push({ name: e.name, weight: todayBest.x.weight, reps: todayBest.x.reps });
  });

  const groups = effectiveSetsByGroup([session]);
  const muscles = effectiveSetsByMuscle([session]);
  const tips = (session.exercises || []).map((e) => {
    const working = (e.sets || []).filter(isWorkingSet);
    if (!working.length) return null;
    const pl = detectPlateau(e.name, history, session.id);
    if (pl) return { name: e.name, group: e.group, muscle: e.muscle, text: pl.text, tone: "caution" };
    // Chronologische Arbeitssatz-Reihen dieser Übung (inkl. dieser Einheit) für Streak/Modus.
    const seq = [...(history || [])]
      .filter((h) => !isCond(h))
      .sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO))
      .map((h) => (h.exercises || []).find((x) => x.name === e.name))
      .filter((x) => x && (x.sets || []).some(isWorkingSet))
      .map((x) => (x.sets || []).filter(isWorkingSet));
    const lo = repsLow(e.targetReps), hi = repsHigh(e.targetReps);
    const redStreak = redStreakFor(seq, lo, hi, progMode(e.name));
    const load = Number(working[working.length - 1].weight || 0);
    const sug = suggestion(e, bestSet(working), isPneuEx(e) ? "" : "kg", { working, load, redStreak });
    return { name: e.name, group: e.group, muscle: e.muscle, text: sug.text, tone: sug.tone };
  }).filter(Boolean);
  const plateaus = (session.exercises || []).map((e) => detectPlateau(e.name, history, session.id) ? e.name : null).filter(Boolean);

  // Kurzfazit ableiten.
  let verdict, verdictTone = "ok";
  if (prs.length) { verdict = `Stark – ${prs.length} neue${prs.length > 1 ? "" : "r"} Rekord${prs.length > 1 ? "e" : ""} heute.`; verdictTone = "progress"; }
  else if (plateaus.length) { verdict = `${plateaus.length} Übung${plateaus.length > 1 ? "en" : ""} stagniert – Zeit für Deload oder Variation.`; verdictTone = "caution"; }
  else if (avgRir != null && avgRir < 0.7) { verdict = "Sehr hart trainiert – plane gute Erholung, nicht jede Einheit ans Limit."; verdictTone = "caution"; }
  else if (volPct != null && volPct >= 5) { verdict = `Solide Steigerung: +${volPct}% Volumen gegenüber dem letzten „${session.day}".`; verdictTone = "progress"; }
  else if (avgRir != null && avgRir >= 2.6) { verdict = "Noch Reserven – beim nächsten Mal etwas mehr Gewicht oder Wdh."; verdictTone = "easy"; }
  else if (volPct != null && volPct <= -8) { verdict = `Etwas weniger Volumen als letztes Mal (${volPct}%). Müdigkeit oder Deload?`; verdictTone = "caution"; }
  else verdict = "Saubere Einheit – Kurs halten und nächste Woche progressiv steigern.";

  return { vol, sets, volPct, prevSame, avgRir, failCount, easyCount, prs, groups, muscles, tips, plateaus, verdict, verdictTone };
};

/* ===================================================================== */
function App() {
  const [ready, setReady] = useState(false);
  const [authUser, setAuthUser] = useState(null); // Supabase auth user
  const [sbToken, setSbToken] = useState(null);   // JWT access token for Edge Functions
  const [user, setUser] = useState(null);
  const [view, setView] = useState("home");
  const [withingsReturnTo, setWithingsReturnTo] = useState("home");
  const [session, setSession] = useState(null);
  const [history, setHistory] = useState([]);
  const [active, setActive] = useState(null);
  const [profile, setProfile] = useState(null);
  const [customPlan, setCustomPlan] = useState(null);
  const [picker, setPicker] = useState(null); // {mode:'add'} | {mode:'swap', exId}
  const [detailEx, setDetailEx] = useState(null);
  const [detailCtx, setDetailCtx] = useState("view"); // Kontext des Detail-Popups: "session" | "dynamic" | "view"
  const [dyn, setDyn] = useState(null); // Dynamisches Training: {groups, duration, variant, items} | null
  const [analysisSession, setAnalysisSession] = useState(null);
  const [cond, setCond] = useState(null); // Cardio/Yoga-Erfassung
  const [dbError, setDbError] = useState(false);
  const [quickMode, setQuickMode] = useState(false); // "Wenig Zeit"-Modus
  const [customExercises, setCustomExercises] = useState([]); // eigene Übungen (im Katalog)
  const [exerciseOverrides, setExerciseOverrides] = useState({ renames: {}, hidden: [] }); // Umbenennen/Löschen eingebauter Übungen
  const [excludedCats, setExcludedCats] = useState([]); // global ausgeschlossene Gerätekategorien
  const [aiCoach, setAiCoach] = useState(null); // KI-Trainer-Daten aus der DB
  const [bodyMetrics, setBodyMetrics] = useState([]); // Körpermesswerte (datierte Reihe)
  const [bodyPhotos, setBodyPhotos] = useState([]); // TANITA-Fotos (Metadaten, Server pflegt tt_{user}_photos)
  const [diaryPhotos, setDiaryPhotos] = useState([]); // Foto-Tagebuch (Metadaten, Bilder lokal auf dem Mac Mini)
  const [measurements, setMeasurements] = useState([]); // Körperkomposition (Withings, Supabase), neueste zuerst
  useEffect(() => { CUSTOM = customExercises; }, [customExercises]);
  useEffect(() => { EX_OVERRIDES = exerciseOverrides; }, [exerciseOverrides]);
  useEffect(() => { EXCLUDED_CATS = excludedCats; }, [excludedCats]);
  useEffect(() => { COUNT_SECONDARY = !!(profile && profile.countSecondary); }, [profile]);
  const [rest, setRest] = useState(null); // Pausen-Timer: {id,total,label}
  const [timerOff, setTimerOff] = useState(false); // Pausen-Timer für diese Einheit aus
  const [appUsers, setAppUsers] = useState([]); // aus trainer.app_users (Mapping E-Mail → Username)
  const [pendingSync, setPendingSync] = useState(pendingSyncCount()); // offline gepufferte Writes

  useEffect(() => { setReady(true); }, []);

  // Offline-Schreib-Queue: bei Reconnect / regelmäßig / nach jedem Puffern nachsenden.
  useEffect(() => {
    const refresh = () => setPendingSync(pendingSyncCount());
    const tryFlush = async () => { await flushQueue(); refresh(); };
    window.addEventListener("online", tryFlush);
    window.addEventListener("tt-queue-changed", refresh);
    refresh();
    tryFlush(); // beim Start eventuelle Reste nachsenden
    const iv = setInterval(() => { if (navigator.onLine && pendingSyncCount() > 0) tryFlush(); }, 20000);
    return () => { window.removeEventListener("online", tryFlush); window.removeEventListener("tt-queue-changed", refresh); clearInterval(iv); };
  }, []);

  // User-Konfiguration aus DB laden (trainer.app_users via /api/app-users).
  useEffect(() => {
    fetch('/api/app-users')
      .then((r) => r.ok ? r.json() : Promise.reject(new Error('app-users')))
      .then((rows) => {
        const arr = Array.isArray(rows) ? rows : [];
        setAppUsers(arr);
        try { localStorage.setItem('ttc:appUsers', JSON.stringify(arr)); } catch (e) {}
      })
      .catch(() => {
        // Offline / Server nicht erreichbar: letzte bekannte Nutzerliste verwenden, sonst hängt die App bei „Lade…".
        try { const c = JSON.parse(localStorage.getItem('ttc:appUsers') || '[]'); if (Array.isArray(c) && c.length) setAppUsers(c); } catch (e) {}
      });
  }, []);

  // Auth: Supabase-Session holen und bei Änderungen reagieren.
  useEffect(() => {
    if (!sb) { setReady(true); return; }
    sb.auth.getSession().then(({ data: { session: s } }) => {
      if (s) { setAuthUser(s.user); setSbToken(s.access_token); }
    });
    const { data: { subscription } } = sb.auth.onAuthStateChange((_, s) => {
      setAuthUser(s ? s.user : null);
      setSbToken(s ? s.access_token : null);
    });
    return () => subscription.unsubscribe();
  }, []);

  // Sobald authUser und appUsers bekannt, Username ableiten und App-Daten laden.
  useEffect(() => {
    if (!authUser || user || !appUsers.length) return;
    const entry = authUser.email ? appUsers.find((u) => u.auth_email === authUser.email) : null;
    if (entry) selectUser(entry.username);
  }, [authUser, appUsers]);

  // Körperkomposition (Withings) aus Supabase laden – speist die Volumen-Zielanpassung des dynamischen
  // Trainings (Muskelmasse-/Fett-Trend). Optional: ohne Daten bleibt es beim Standard-MEV.
  useEffect(() => {
    if (!sbToken || !window.supabase) { setMeasurements([]); return; }
    let cancelled = false;
    const sbc = window.supabase.createClient(SB_URL, SB_ANON_KEY, {
      global: { headers: { Authorization: `Bearer ${sbToken}` } },
      db: { schema: "trainer" },
      auth: { persistSession: false, autoRefreshToken: false },
    });
    sbc.from("body_measurements")
      .select("measured_at,muscle_mass_kg,fat_mass_kg,fat_ratio_pct,weight_kg")
      .order("measured_at", { ascending: false }).limit(90)
      .then(({ data }) => {
        if (cancelled) return;
        setMeasurements((data || []).map((r) => ({
          dateISO: r.measured_at, muscleMassKg: r.muscle_mass_kg, fatMassKg: r.fat_mass_kg,
          fatPct: r.fat_ratio_pct, weightKg: r.weight_kg,
        })));
      })
      .catch(() => { if (!cancelled) setMeasurements([]); });
    return () => { cancelled = true; };
  }, [sbToken]);

  // ctxKind wird nur beim Öffnen aus einer Karte gesetzt; beim Blättern durch Alternativen bleibt er erhalten.
  const openDetail = (ex, ctxId, ctxKind) => { if (ctxKind) setDetailCtx(ctxKind); setDetailEx({ name: ex.name, group: ex.group, muscle: ex.muscle, sessionExId: ctxId !== undefined ? ctxId : ex.sessionExId }); setView("detail"); };
  // Aus der Detailseite: Übung im laufenden Training ersetzen oder ergänzen.
  const replaceInSession = (altDef) => {
    if (!session || !detailEx || !detailEx.sessionExId) return;
    setSession((s) => ({ ...s, exercises: s.exercises.map((e) => e.id === detailEx.sessionExId
      ? { ...altDef, id: e.id, targetSets: e.targetSets, targetReps: e.targetReps, sets: [] } : e) }));
    setView("session");
  };
  const addToSession = (altDef) => {
    if (!session) return;
    setSession((s) => ({ ...s, exercises: [...s.exercises, { ...altDef, targetSets: 3, targetReps: "8-12", id: uid(), sets: [] }] }));
    setView("session");
  };
  // Aus der Detailseite: Übung im dynamischen Training ersetzen oder ergänzen (gleiche Logik wie im Training).
  const replaceInDynamic = (altDef) => {
    if (!dyn || !detailEx || !detailEx.sessionExId) return;
    setDyn((d) => ({ ...d, items: (d.items || []).map((e) => e.id === detailEx.sessionExId
      ? { ...e, name: altDef.name, group: altDef.group, muscle: altDef.muscle || "", cat: altDef.cat || e.cat, isNew: false } : e) }));
    setView("dynamic");
  };
  const addToDynamic = (altDef) => {
    if (!dyn) return;
    setDyn((d) => ({ ...d, items: [...(d.items || []), { name: altDef.name, group: altDef.group, muscle: altDef.muscle || "", cat: altDef.cat, targetSets: 3, targetReps: isTimedEx({ name: altDef.name }) ? "30-45 Sek" : "8-12", isNew: false, id: uid() }] }));
    setView("dynamic");
  };
  // Übung dauerhaft von der automatischen Auswahl ausnehmen: zur Vermeidungsliste im Profil hinzufügen.
  const excludeExercise = async (name) => {
    if (!name || !profile) return;
    const cur = profile.avoidedExercises || "";
    if (!tokenizeList(cur).includes(name.toLowerCase())) {
      const saved = { ...profile, avoidedExercises: cur.trim() ? `${cur}, ${name}` : name, updatedAt: new Date().toISOString() };
      setProfile(saved);
      await store.set(`tt_${user}_profile`, JSON.stringify(saved));
    }
    setDyn((d) => d ? { ...d, items: (d.items || []).filter((e) => e.name !== name) } : d);
    setView(detailCtx === "dynamic" ? "dynamic" : (session ? "session" : "home"));
    window.alert(`„${name}" wird künftig nicht mehr automatisch vorgeschlagen.`);
  };
  // Aktuelle Übungszusammenstellung als Plan-Vorlage speichern.
  const saveSessionAsTemplate = async () => {
    if (!session || !(session.exercises || []).length) { window.alert("Keine Übungen zum Speichern."); return; }
    const name = window.prompt("Name für die Vorlage:", session.day && session.day !== "Freies Training" ? session.day : "Eigener Tag");
    if (!name || !name.trim()) return;
    const items = session.exercises.map((e) => ({ name: e.name, group: e.group, muscle: e.muscle || "", targetSets: e.targetSets || 3, targetReps: e.targetReps || "8-12", id: uid() }));
    if (await persistPlan({ ...currentPlan, [name.trim()]: items })) window.alert(`Als Vorlage gespeichert: „${name.trim()}"`);
  };

  const selectUser = async (u) => {
    setDbError(!(await store.ping()));
    const h = await store.get(`tt_${u}_history`);
    const a = await store.get(`tt_${u}_active`);
    const p = await store.get(`tt_${u}_profile`);
    const plan = await store.get(`tt_${u}_plan`);
    const loadedProfile = { ...defaultProfile(u), ...(parseStored(p, null) || {}) };
    setHistory(parseStored(h, []) || []);
    setActive(parseStored(a, null));
    setProfile(loadedProfile);
    setCustomPlan(parseStored(plan, null) || generatePlanFromProfile(loadedProfile));
    const ce = parseStored(await store.get("tt_customExercises"), []) || [];
    CUSTOM = ce; setCustomExercises(ce);
    const ov = parseStored(await store.get("tt_exerciseOverrides"), null);
    const overrides = { renames: (ov && ov.renames) || {}, hidden: (ov && ov.hidden) || [] };
    EX_OVERRIDES = overrides; setExerciseOverrides(overrides);
    const ec = (parseStored(await store.get("tt_excludedCategories"), []) || []).filter((c) => DEVICE_CATS.includes(c));
    EXCLUDED_CATS = ec; setExcludedCats(ec);
    setAiCoach(parseStored(await store.get(`tt_${u}_aicoach`), null));
    setBodyMetrics(parseStored(await store.get(`tt_${u}_bodymetrics`), []) || []);
    setBodyPhotos(parseStored(await store.get(`tt_${u}_photos`), []) || []);
    loadDiaryPhotos(u);
    setTimerOff(false); setRest(null);
    setUser(u); setSession(null); setView("home");
  };
  // KI-Trainer: Vorschlag anwenden/ablehnen + Status zurückschreiben.
  const applyPlanChange = (plan, ch) => {
    if (!ch || !ch.op) return plan;
    const day = ch.day; if (day && !plan[day] && ch.op !== "add_day") return plan;
    const np = { ...plan };
    const list = day ? [...(np[day] || [])] : null;
    if (ch.op === "add" && ch.name) { if (!list.some((e) => e.name === ch.name)) { const c = find(ch.name) || {}; list.push({ name: ch.name, group: c.g || ch.group || "Sonstige", muscle: c.m || "", targetSets: ch.sets || 3, targetReps: ch.reps || "8-12" }); } np[day] = list; }
    else if (ch.op === "remove" && ch.name) { np[day] = list.filter((e) => e.name !== ch.name); }
    else if (ch.op === "replace" && ch.name && ch.toName) { const c = find(ch.toName) || {}; np[day] = list.map((e) => e.name === ch.name ? { ...e, name: ch.toName, group: c.g || e.group, muscle: c.m || "" } : e); }
    else if (ch.op === "set_sets" && ch.name) { np[day] = list.map((e) => e.name === ch.name ? { ...e, targetSets: ch.sets || e.targetSets } : e); }
    else if (ch.op === "set_reps" && ch.name) { np[day] = list.map((e) => e.name === ch.name ? { ...e, targetReps: ch.reps || e.targetReps } : e); }
    else if (ch.op === "add_day" && ch.day && Array.isArray(ch.exercises)) { np[ch.day] = ch.exercises.map((x) => { const c = find(x.name) || {}; return { name: x.name, group: c.g || x.group || "Sonstige", muscle: c.m || "", targetSets: x.sets || 3, targetReps: x.reps || "8-12" }; }); }
    else return plan;
    return np;
  };
  const decideSuggestion = async (sid, accept) => {
    if (!aiCoach) return;
    const sug = (aiCoach.suggestions || []).find((s) => s.id === sid);
    let planChanged = false;
    if (accept && sug && sug.change) {
      const np = applyPlanChange(currentPlan, sug.change);
      if (np !== currentPlan) { const ok = await persistPlan(np); if (!ok) return; planChanged = true; }
    }
    const next = { ...aiCoach, suggestions: (aiCoach.suggestions || []).map((s) => s.id === sid ? { ...s, status: accept ? "accepted" : "declined", appliedAt: new Date().toISOString() } : s) };
    setAiCoach(next);
    await store.set(`tt_${user}_aicoach`, JSON.stringify(next));
    if (planChanged) window.alert("Plan angepasst.");
  };
  const registerCustom = async (def) => {
    if (!def || !def.name || allEx().some((e) => e.n === def.name)) return;
    const entry = { n: def.name, g: def.group || "Sonstige", m: def.muscle || "", t: [], cat: "custom" };
    if (typeof def.comp === "boolean") entry.comp = def.comp; // Typ: Compound/Isolation
    const next = [...customExercises, entry];
    CUSTOM = next; setCustomExercises(next);
    await store.set("tt_customExercises", JSON.stringify(next));
  };
  const persistCustom = async (next) => { CUSTOM = next; setCustomExercises(next); await store.set("tt_customExercises", JSON.stringify(next)); };
  const persistOverrides = async (next) => { EX_OVERRIDES = next; setExerciseOverrides(next); await store.set("tt_exerciseOverrides", JSON.stringify(next)); };
  const isCustomName = (name) => customExercises.some((e) => e.n === name);
  // Übung umbenennen – eigene Übungen direkt, eingebaute über die Overrides-Ebene.
  const renameExercise = async (oldName, newName) => {
    newName = String(newName || "").trim();
    if (!newName || newName === oldName) return;
    if (allEx().some((e) => e.n === newName)) { window.alert("Eine Übung mit diesem Namen existiert bereits."); return; }
    if (isCustomName(oldName)) {
      await persistCustom(customExercises.map((e) => e.n === oldName ? { ...e, n: newName } : e));
    } else {
      const orig = originalName(oldName);
      await persistOverrides({ ...exerciseOverrides, renames: { ...exerciseOverrides.renames, [orig]: newName } });
    }
  };
  // Übung löschen – eigene Übungen raus aus der Liste, eingebaute ausblenden.
  const deleteExercise = async (name) => {
    if (isCustomName(name)) {
      await persistCustom(customExercises.filter((e) => e.n !== name));
    } else {
      const orig = originalName(name);
      const renames = { ...exerciseOverrides.renames }; delete renames[orig];
      const hidden = exerciseOverrides.hidden.includes(orig) ? exerciseOverrides.hidden : [...exerciseOverrides.hidden, orig];
      await persistOverrides({ renames, hidden });
    }
  };
  // Typ (Compound/Isolation) einer eigenen Übung setzen.
  const setExerciseType = async (name, comp) => {
    if (!isCustomName(name)) return;
    await persistCustom(customExercises.map((e) => e.n === name ? { ...e, comp } : e));
  };
  // Gerätekategorie global ein-/ausschließen (persistiert im KV Store, wirkt auf Auto-Plan & dynamisches Training).
  const toggleExcludedCat = async (cat, excluded) => {
    if (!DEVICE_CATS.includes(cat)) return;
    const next = excluded ? [...new Set([...excludedCats, cat])] : excludedCats.filter((c) => c !== cat);
    EXCLUDED_CATS = next; setExcludedCats(next);
    await store.set("tt_excludedCategories", JSON.stringify(next));
  };
  // Übung von automatischen/dynamischen Plänen aus- bzw. wieder einschließen (nutzt avoidedExercises).
  const toggleAvoidExercise = async (name, avoid) => {
    if (!name || !profile) return;
    const cur = profile.avoidedExercises || "";
    const has = tokenizeList(cur).includes(name.toLowerCase());
    let nextVal;
    if (avoid) { if (has) return; nextVal = cur.trim() ? `${cur}, ${name}` : name; }
    else {
      if (!has) return;
      nextVal = cur.split(/[,\n;]/).map((s) => s.trim()).filter(Boolean)
        .filter((s) => s.toLowerCase() !== name.toLowerCase()).join(", ");
    }
    const saved = { ...profile, avoidedExercises: nextVal, updatedAt: new Date().toISOString() };
    setProfile(saved);
    await store.set(`tt_${user}_profile`, JSON.stringify(saved));
  };
  const switchUser = () => {
    setUser(null); setSession(null); setActive(null); setProfile(null); setCustomPlan(null); setHistory([]); setDyn(null); setView("home");
  };
  const logout = async () => {
    if (sb) await sb.auth.signOut();
    setAuthUser(null); setSbToken(null);
    setUser(null); setSession(null); setActive(null); setProfile(null); setCustomPlan(null); setHistory([]); setDyn(null); setView("home");
  };
  const saveProfile = async (nextProfile) => {
    const saved = { ...nextProfile, updatedAt: new Date().toISOString() };
    setProfile(saved);
    await store.set(`tt_${user}_profile`, JSON.stringify(saved));
    setView("home");
  };
  const currentPlan = customPlan || generatePlanFromProfile(profile || defaultProfile(user || ""));
  const saveGeneratedPlan = async (nextPlan) => {
    const wrapped = nextPlan;
    setCustomPlan(wrapped);
    await store.set(`tt_${user}_plan`, JSON.stringify(wrapped));
    setView("home");
  };
  const persistPlan = async (nextPlan) => {
    const ok = await store.set(`tt_${user}_plan`, JSON.stringify(nextPlan));
    if (!ok) { setDbError(true); window.alert("Speichern fehlgeschlagen – keine Verbindung zur Datenbank."); return false; }
    setCustomPlan(nextPlan);
    return true;
  };
  // Manuellen Trainingstag anlegen/überschreiben (wird in den Plan eingefügt)
  const saveManualDay = async (name, items) => {
    const key = name.trim();
    if (!key || !items.length) return;
    const nextPlan = { ...currentPlan, [key]: items };
    if (await persistPlan(nextPlan)) setView("home");
  };
  const deletePlanDay = async (name) => {
    const nextPlan = { ...currentPlan };
    delete nextPlan[name];
    await persistPlan(nextPlan);
  };

  useEffect(() => {
    if (user && session) store.set(`tt_${user}_active`, JSON.stringify(session));
  }, [session, user]);

  // letzte Bestleistung je Übungsname aus History
  const lastBest = useMemo(() => {
    const m = {};
    [...history].filter((s) => !session || s.id !== session.id)
      .sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO)).forEach((s) => {
      (s.exercises || []).forEach((e) => { const b = bestSet(e.sets); if (b) m[e.name] = { ...b, date: s.dateISO }; });
    });
    return m;
  }, [history, session]);

  // Chronologische Arbeitssatz-Reihen je Übung (für autoregulierte Progression: Modus + RED-Streak).
  const lastPerf = useMemo(() => {
    const m = {};
    [...history].filter((s) => !isCond(s) && (!session || s.id !== session.id))
      .sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO)).forEach((s) => {
      (s.exercises || []).forEach((e) => {
        const w = (e.sets || []).filter(isWorkingSet);
        if (w.length) (m[e.name] = m[e.name] || []).push(w);
      });
    });
    return m;
  }, [history, session]);

  const plateau = useMemo(() => {
    const m = {};
    if (session) (session.exercises || []).forEach((e) => { const p = detectPlateau(e.name, history, session.id); if (p) m[e.name] = p; });
    return m;
  }, [session, history]);

  const startDay = (day) => {
    let list = currentPlan[day] || [];
    if (quickMode) list = shortenForTime(list);
    const exercises = list.map((e) => ({ ...e, id: uid(), sets: [] }));
    const s = { id: uid(), day, dateISO: new Date().toISOString(), exercises };
    setTimerOff(false); setRest(null);
    setSession(s); setActive(null); setView("session");
  };
  const startFree = () => {
    const s = { id: uid(), day: "Freies Training", dateISO: new Date().toISOString(), exercises: [] };
    setTimerOff(false); setRest(null);
    setSession(s); setActive(null); setView("session");
  };
  const startDynamic = (items) => {
    const exercises = (items || []).map((e) => ({ ...e, id: uid(), sets: [] }));
    const s = { id: uid(), day: "Dynamisches Training", dateISO: new Date().toISOString(), exercises };
    setTimerOff(false); setRest(null); setDyn(null);
    setSession(s); setActive(null); setView("session");
  };
  const resume = () => { setTimerOff(false); setRest(null); setSession(active); setActive(null); setView("session"); };
  const discardActive = () => { setActive(null); store.del(`tt_${user}_active`); };
  const editSession = (s) => {
    if (isCond(s)) {
      setCond({ id: s.id, type: s.type, activity: s.activity, dateISO: s.dateISO, durationMin: s.durationMin || "", distanceKm: s.distanceKm || "", note: s.note || "" });
      setView("conditioning");
      return;
    }
    setTimerOff(false); setRest(null); setSession(JSON.parse(JSON.stringify(s))); setActive(null); setView("session");
  };
  const deleteSession = async (id) => {
    const next = history.filter((h) => h.id !== id);
    setHistory(next); await store.set(`tt_${user}_history`, JSON.stringify(next));
  };

  const setSessionDate = (iso) => setSession((s) => ({ ...s, dateISO: iso }));
  const startRest = (name, mode) => {
    if (timerOff) return;
    const total = mode === "exercise" ? exerciseRestSeconds(name, profile?.goal) : setRestSeconds(name, profile?.goal);
    setRest({ id: uid(), total, label: name || "Pause", mode: mode || "set" });
  };
  const skipRest = () => setRest(null);
  const toggleTimer = () => setTimerOff((v) => { const nv = !v; if (nv) setRest(null); return nv; });
  // Körpermesswerte speichern/löschen (an die KI-DB übergeben via tt_{user}_bodymetrics).
  const saveBodyMetric = async (m) => {
    const num = (v) => { const n = parseNum(v); return Number.isFinite(n) ? n : null; };
    const FIELDS = ["weightKg", "bmi", "fatTotal", "fatMassKg", "fatArms", "fatTorso", "fatLegs",
      "musclePct", "muscleMassKg", "muscleTrunk", "muscleArmL", "muscleArmR", "muscleLegL", "muscleLegR",
      "bodyWaterPct", "visceralFat", "bmr", "metabolicAge", "boneMassKg"];
    const entry = { id: m.id || uid(), dateISO: m.dateISO || new Date().toISOString() };
    FIELDS.forEach((k) => { entry[k] = num(m[k]); });
    const next = [entry, ...bodyMetrics.filter((x) => x.id !== entry.id)].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));
    const ok = await store.set(`tt_${user}_bodymetrics`, JSON.stringify(next));
    if (!ok) { setDbError(true); window.alert("Speichern fehlgeschlagen – keine Verbindung zur Datenbank."); return; }
    setBodyMetrics(next);
  };
  const deleteBodyMetric = async (id) => {
    const next = bodyMetrics.filter((x) => x.id !== id);
    const ok = await store.set(`tt_${user}_bodymetrics`, JSON.stringify(next));
    if (ok) setBodyMetrics(next);
  };
  // TANITA-Fotos: Upload/Löschen laufen über den Server (/api/photo), der die Datei ablegt
  // und die Metadaten in tt_{user}_photos pflegt. Anzeige liest tt_{user}_photos.
  const loadBodyPhotos = async (u) => setBodyPhotos(parseStored(await store.get(`tt_${u}_photos`), []) || []);
  const uploadBodyPhotos = async (items) => {
    let ok = 0;
    for (const it of items) {
      try {
        const r = await fetch(`/api/photo?user=${encodeURIComponent(user)}`, {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ takenAt: it.takenAt, dataUrl: it.dataUrl }),
        });
        if (r.ok) ok++;
      } catch (e) { /* ignorieren, Zähler bleibt */ }
    }
    await loadBodyPhotos(user);
    return ok;
  };
  const deleteBodyPhoto = async (id) => {
    try { await fetch(`/api/photo?user=${encodeURIComponent(user)}&id=${encodeURIComponent(id)}`, { method: "DELETE" }); } catch (e) {}
    await loadBodyPhotos(user);
  };
  // Foto-Tagebuch: Fortschrittsfotos liegen als Dateien lokal auf dem Mac Mini (photos/<user>/),
  // nur die Metadaten-Liste kommt vom Server (/api/phototagebuch) aus tt_{user}_phototagebuch.
  const loadDiaryPhotos = async (u) => {
    try {
      const r = await fetch(`/api/phototagebuch?user=${encodeURIComponent(u)}`);
      if (r.ok) { const j = await r.json(); setDiaryPhotos(j.photos || []); }
    } catch (e) { /* offline: alte Anzeige behalten */ }
  };
  const uploadDiaryPhoto = async (dataUrl, pose, takenAt) => {
    try {
      const r = await fetch(`/api/phototagebuch?user=${encodeURIComponent(user)}`, {
        method: "POST", headers: { "content-type": "application/json" },
        body: JSON.stringify({ dataUrl, pose, takenAt }),
      });
      await loadDiaryPhotos(user);
      return r.ok;
    } catch (e) { return false; }
  };
  const deleteDiaryPhoto = async (file) => {
    try { await fetch(`/api/phototagebuch?user=${encodeURIComponent(user)}&file=${encodeURIComponent(file)}`, { method: "DELETE" }); } catch (e) {}
    await loadDiaryPhotos(user);
  };
  // --- Voll-Backup (JSON) exportieren / importieren: alle tt_-Schlüssel (je Nutzer + global) für Gerätewechsel/Restore ---
  const BACKUP_PER_USER = ["history", "active", "plan", "profile", "coaching", "aicoach", "bodymetrics", "workouts", "photos"];
  const BACKUP_GLOBALS = ["tt_customExercises", "tt_exerciseOverrides", "tt_coachKnowledge", "tt_excludedCategories"];
  const backupKeyList = () => {
    const keys = [];
    for (const u of TRAINING_USERS) for (const k of BACKUP_PER_USER) keys.push(`tt_${u}_${k}`);
    return [...keys, ...BACKUP_GLOBALS];
  };
  const exportJson = async () => {
    try {
      const out = { app: "Trainingstagebuch", exportedAt: new Date().toISOString(), version: 1, keys: {} };
      for (const key of backupKeyList()) {
        const v = await store.get(key);
        if (v != null) out.keys[key] = v; // Roh-JSON-String (wie in der DB)
      }
      const n = Object.keys(out.keys).length;
      if (!n) { window.alert("Keine Daten zum Sichern gefunden."); return; }
      const blob = new Blob([JSON.stringify(out, null, 2)], { type: "application/json" });
      downloadBlob(blob, `Trainingstagebuch-Backup-${new Date().toISOString().slice(0, 10)}.json`);
    } catch (e) { window.alert("Backup fehlgeschlagen: " + (e && e.message ? e.message : e)); }
  };
  const importJson = async (file) => {
    try {
      const data = JSON.parse(await file.text());
      const keys = data && data.keys;
      if (!keys || typeof keys !== "object") { window.alert("Ungültige Backup-Datei (kein 'keys'-Objekt)."); return; }
      const names = Object.keys(keys).filter((k) => /^tt_[A-Za-z0-9_]+$/.test(k)); // nur tt_-Schlüssel
      if (!names.length) { window.alert("Backup enthält keine gültigen Daten."); return; }
      if (!window.confirm(`${names.length} Datensätze importieren?\nVorhandene Daten mit gleichem Schlüssel werden ÜBERSCHRIEBEN. Zur Sicherheit vorher ein Backup exportieren.`)) return;
      let ok = 0, fail = 0;
      for (const key of names) {
        let val = keys[key];
        if (typeof val !== "string") val = JSON.stringify(val); // erlaubt String- ODER Objekt-Werte
        if (await store.set(key, val)) ok++; else fail++;
      }
      if (user) await selectUser(user); // aktuellen Nutzer + Globals frisch laden
      window.alert(`Import fertig: ${ok} übernommen${fail ? `, ${fail} fehlgeschlagen` : ""}.`);
    } catch (e) { window.alert("Import fehlgeschlagen: " + (e && e.message ? e.message : e)); }
  };
  const update = (fn) => setSession((s) => { const n = { ...s, exercises: s.exercises.map(fn) }; return n; });
  const addSet = (exId, set) => {
    // Zeitstempel der Erfassung mitspeichern → erlaubt Pausenzeit-Analyse (Differenz aufeinanderfolgender Sätze).
    const stamped = { ...set, ts: new Date().toISOString() };
    update((e) => e.id === exId ? { ...e, sets: [...e.sets, stamped] } : e);
    // Pause wird beim "Übung abschließen" gestartet, nicht mehr nach jedem Satz.
  };
  const delSet = (exId, i) => update((e) => e.id === exId ? { ...e, sets: e.sets.filter((_, k) => k !== i) } : e);
  const removeEx = (exId) => setSession((s) => ({ ...s, exercises: s.exercises.filter((e) => e.id !== exId) }));
  const toggleSessionSecondary = () => setSession((s) => (s ? { ...s, logSecondary: s.logSecondary === false } : s));

  const addExercise = (def) => {
    registerCustom(def);
    if (picker && picker.mode === "swap") {
      setSession((s) => ({ ...s, exercises: s.exercises.map((e) => e.id === picker.exId
        ? { ...def, id: e.id, targetSets: e.targetSets, targetReps: e.targetReps, sets: [] } : e) }));
    } else {
      setSession((s) => ({ ...s, exercises: [...s.exercises, { ...def, targetSets: 3, targetReps: isTimedEx(def) ? "30-45 Sek" : "8-12", id: uid(), sets: [] }] }));
    }
    setPicker(null);
  };

  const finish = async () => {
    let next;
    if (history.some((h) => h.id === session.id)) {
      next = history.map((h) => (h.id === session.id ? session : h));
    } else if (totalSets(session) > 0 || (session.note && session.note.trim())) {
      next = [session, ...history];
    } else {
      next = history;
    }
    next = [...next].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));
    const ok = await store.set(`tt_${user}_history`, JSON.stringify(next));
    if (!ok) {
      setDbError(true);
      window.alert("Speichern fehlgeschlagen – keine Verbindung zur Datenbank. Bitte den Server prüfen/neu starten. Deine Eingaben bleiben erhalten.");
      return;
    }
    setHistory(next); await store.del(`tt_${user}_active`);
    const done = session;
    setSession(null);
    if (totalSets(done) > 0) { setAnalysisSession(done); setView("analysis"); }
    else { setView("home"); }
  };
  const cancelSession = async () => { await store.del(`tt_${user}_active`); setSession(null); setView("home"); };
  const openAnalysis = (s) => { setAnalysisSession(s); setView("analysis"); };

  // Cardio / Yoga
  const startCond = (type, activity) => {
    setCond({ id: uid(), type, activity, dateISO: new Date().toISOString(), durationMin: "", distanceKm: "", note: "" });
    setView("conditioning");
  };
  const saveCond = async (c) => {
    const entry = { id: c.id, type: c.type, activity: c.activity, dateISO: c.dateISO, durationMin: Number(c.durationMin) || 0, note: c.note || "" };
    if (c.type === "cardio") entry.distanceKm = parseNum(c.distanceKm) || 0;
    const next = [entry, ...history.filter((h) => h.id !== c.id)].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));
    const ok = await store.set(`tt_${user}_history`, JSON.stringify(next));
    if (!ok) { setDbError(true); window.alert("Speichern fehlgeschlagen – keine Verbindung zur Datenbank."); return; }
    setHistory(next); setCond(null); setView("calendar");
  };

  if (!ready) return (
    <div style={{ background: C.bg, color: C.muted, fontFamily: FONT, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span className="text-sm tracking-widest uppercase">Lade Tagebuch…</span>
    </div>
  );

  if (!authUser) return (
    <div style={{ background: C.bg, color: C.text, fontFamily: FONT, minHeight: "100vh" }}>
      <LoginScreen />
    </div>
  );

  if (authUser && !user) {
    if (!appUsers.length) return <div style={{ background: C.bg, color: C.muted, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: FONT }}>Lade…</div>;
    return <UserSelect onSelect={selectUser} appUsers={appUsers} />;
  }

  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: FONT, minHeight: "100vh" }}>
      <div className="mx-auto" style={{ maxWidth: 480 }}>
        {dbError && (
          <div className="mx-5 mt-3 rounded-xl p-3 text-sm" style={{ background: "rgba(224,122,95,0.15)", border: `1px solid ${C.danger}` }}>
            <b style={{ color: C.danger }}>Keine Verbindung zur Datenbank.</b> <span style={{ color: C.text }}>Deine Daten sind sicher, werden aber gerade nicht geladen. Läuft der aktuelle Server (mit <code>/api/kv</code>)? Nach Neustart hier neu laden.</span>
            <button onClick={async () => { if (user) await selectUser(user); }} className="ml-1 underline font-semibold" style={{ color: C.accent2 }}>Neu laden</button>
          </div>
        )}
        {pendingSync > 0 && (
          <div className="mx-5 mt-3 rounded-xl p-3 text-sm flex items-center justify-between gap-2" style={{ background: "rgba(95,185,154,0.14)", border: `1px solid ${C.accent2}` }}>
            <span style={{ color: C.text }}>⏳ {pendingSync} Änderung{pendingSync === 1 ? "" : "en"} offline gespeichert – {navigator.onLine ? "werden synchronisiert…" : "warten auf Netz."}</span>
            <button onClick={async () => { setPendingSync(await flushQueue()); }} className="underline font-semibold shrink-0" style={{ color: C.accent2 }}>Jetzt senden</button>
          </div>
        )}
        {view === "home" && (
          <Home history={history} active={active} user={user} profile={profile} plan={currentPlan} onSwitch={switchUser} onLogout={logout}
            onStart={startDay} onFree={startFree}
            onResume={resume} onDiscard={discardActive} onHistory={() => setView("history")} onProfile={() => setView("profile")} onPlan={() => setView("plan")}
            onDynamic={() => setView("dynamic")}
            onPlanBuilder={() => setView("planbuilder")} onDeleteDay={deletePlanDay}
            quickMode={quickMode} onToggleQuick={() => setQuickMode((q) => !q)}
            onBalance={() => setView("balance")} onCalendar={() => setView("calendar")} onMuscles={() => setView("muscles")}
            onStartCond={startCond} onAiCoach={() => setView("aicoach")} onPotential={() => setView("potential")} aiCoachCount={(aiCoach && (aiCoach.suggestions || []).filter((s) => s.status === "pending").length) || 0}
            bodyMetrics={bodyMetrics} measurements={measurements} onBodyMetrics={() => setView("bodymetrics")} onTools={() => setView("tools")}
            onPhotoDiary={() => setView("phototagebuch")}
            onExport={() => exportExcel(sbToken)} onExportJson={exportJson} onImportJson={importJson}
            onLastAnalysis={() => { const s = history.find((h) => !isCond(h)); if (s) openAnalysis(s); }} />
        )}
        {view === "aicoach" && (
          <AiCoachView coach={aiCoach} history={history} measurements={measurements} onBack={() => setView("home")} onDecide={decideSuggestion} onPotential={() => setView("potential")} />
        )}
        {view === "potential" && (
          <MusclePotentialView history={history} measurements={measurements} onBack={() => setView("home")} />
        )}
        {view === "bodymetrics" && (
          <BodyMetricsView metrics={bodyMetrics} photos={bodyPhotos} onSave={saveBodyMetric} onDelete={deleteBodyMetric}
            onAddPhotos={uploadBodyPhotos} onDeletePhoto={deleteBodyPhoto} onBack={() => setView("home")} sbToken={sbToken} />
        )}
        {view === "phototagebuch" && (
          <PhotoDiaryView photos={diaryPhotos} user={user} onUpload={uploadDiaryPhoto} onDelete={deleteDiaryPhoto} onBack={() => setView("home")} bodyMetrics={bodyMetrics} measurements={measurements} />
        )}
        {view === "withings" && (
          <WithingsView sbToken={sbToken} onBack={() => setView(withingsReturnTo)} />
        )}
        {view === "tools" && (
          <ToolsView onBack={() => setView("home")} />
        )}
        {view === "balance" && (
          <WeeklyVolume history={history} onBack={() => setView("home")} onAnalyze={openAnalysis} />
        )}
        {view === "calendar" && (
          <Calendar history={history} onBack={() => setView("home")} onAnalyze={openAnalysis} onOpenDetail={(ex) => openDetail(ex, undefined, "view")} />
        )}
        {view === "muscles" && (
          <MusclesView history={history} onBack={() => setView("home")} />
        )}
        {view === "conditioning" && cond && (
          <ConditioningSession entry={cond} onChange={setCond} onSave={saveCond} onCancel={() => { setCond(null); setView("home"); }} />
        )}
        {view === "analysis" && analysisSession && (
          <SessionAnalysis session={analysisSession} history={history} onBack={() => setView("home")} onHistory={() => setView("history")} onOpenDetail={(ex) => openDetail(ex, undefined, "view")} />
        )}
        {view === "session" && session && (
          <Session session={session} lastBest={lastBest} lastPerf={lastPerf} plateau={plateau} isEdit={history.some((h) => h.id === session.id)}
            onAddSet={addSet} onDelSet={delSet} onOpenDetail={(ex, id) => openDetail(ex, id, "session")}
            onRemove={removeEx} onSwap={(exId) => setPicker({ mode: "swap", exId })}
            onAdd={() => setPicker({ mode: "add" })} onFinish={finish} onCancel={cancelSession} onDate={setSessionDate} onSaveTemplate={saveSessionAsTemplate}
            onRest={(name, mode) => startRest(name, mode)} timerOff={timerOff} onToggleTimer={toggleTimer} onToggleSecondary={toggleSessionSecondary}
            onNote={(v) => setSession((s) => ({ ...s, note: v }))}
            onExerciseDone={(id, done) => setSession((s) => ({ ...s, exercises: s.exercises.map((e) => e.id === id ? { ...e, done } : e) }))} />
        )}
        {view === "history" && (
          <History history={history} onBack={() => setView("home")} onOpen={editSession} onDelete={deleteSession} onAnalyze={openAnalysis} />
        )}
        {view === "profile" && profile && (
          <ProfileEditor profile={profile} onBack={() => setView("home")} onSave={saveProfile}
            sbToken={sbToken} onWithings={() => { setWithingsReturnTo("profile"); setView("withings"); }}
            onManageExercises={() => setView("exercises")} />
        )}
        {view === "exercises" && (
          <ExerciseManager exercises={allEx()} profile={profile} onBack={() => setView("profile")}
            onRename={renameExercise} onDelete={deleteExercise} onAdd={registerCustom}
            onSetType={setExerciseType} onToggleAvoid={toggleAvoidExercise}
            excludedCats={excludedCats} onToggleCat={toggleExcludedCat} />
        )}
        {view === "plan" && profile && (
          <PlanGenerator profile={profile} currentPlan={currentPlan} history={history} measurements={measurements} onBack={() => setView("home")} onSave={saveGeneratedPlan} />
        )}
        {view === "planbuilder" && (
          <PlanBuilder existingPlan={currentPlan} profile={profile} recommended={aiRecommendedNames(aiCoach)} history={history} measurements={measurements} onBack={() => setView("home")} onSave={saveManualDay} onDeleteDay={deletePlanDay} onRegisterCustom={registerCustom} />
        )}
        {view === "dynamic" && (
          <DynamicTraining history={history} profile={profile} plan={currentPlan} aiCoach={aiCoach} measurements={measurements} dyn={dyn} onChange={setDyn}
            onBack={() => { setDyn(null); setView("home"); }} onStart={startDynamic}
            onOpenDetail={(item) => openDetail(item, item.id, "dynamic")} />
        )}
        {view === "detail" && detailEx && (
          <ExerciseDetail exercise={detailEx} history={history} onOpen={openDetail}
            canEditSession={(detailCtx === "session" && !!session) || (detailCtx === "dynamic" && !!dyn)}
            onReplace={detailCtx === "dynamic" ? replaceInDynamic : replaceInSession}
            onAddToSession={detailCtx === "dynamic" ? addToDynamic : addToSession}
            onExclude={detailCtx === "dynamic" ? excludeExercise : undefined}
            onBack={() => setView(detailCtx === "dynamic" ? "dynamic" : (session ? "session" : "home"))} />
        )}
      </div>
      {rest && <RestTimer rest={rest} onClose={skipRest} />}
      {picker && <Picker mode={picker.mode} onPick={addExercise} onClose={() => setPicker(null)} />}
    </div>
  );
}

/* ---------- Home ---------- */
/* ---------- Pausen-Stoppuhr (sticky unten) ---------- */
function RestTimer({ rest, onClose }) {
  const [left, setLeft] = useState(rest.total);
  const endRef = React.useRef(Date.now() + rest.total * 1000);
  const firedRef = React.useRef(false);
  useEffect(() => {
    endRef.current = Date.now() + rest.total * 1000; firedRef.current = false; setLeft(rest.total);
    const iv = setInterval(() => {
      const l = Math.max(0, Math.round((endRef.current - Date.now()) / 1000));
      setLeft(l);
      if (l <= 0 && !firedRef.current) {
        firedRef.current = true;
        try { navigator.vibrate && navigator.vibrate([120, 60, 120]); } catch (e) {}
        setTimeout(onClose, 2000);
      }
    }, 250);
    return () => clearInterval(iv);
  }, [rest.id]);
  const adjust = (d) => { endRef.current += d * 1000; if (d > 0) firedRef.current = false; };
  const done = left <= 0;
  const mm = Math.floor(left / 60), ss = left % 60;
  const pct = rest.total ? Math.max(0, Math.min(100, (left / rest.total) * 100)) : 0;
  return (
    <div className="fixed left-0 right-0 px-4 z-40" style={{ bottom: 92 }}>
      <div className="mx-auto" style={{ maxWidth: 480 }}>
        <div className="rounded-2xl p-3 shadow-lg" style={{ background: C.surface2, border: `1px solid ${done ? C.accent2 : C.accent}` }}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold truncate pr-2" style={{ color: C.muted }}>{done ? "Pause vorbei – los!" : `${rest.mode === "exercise" ? "Pause nach Übung" : "Pause zwischen Sätzen"} · ${rest.label}`}</span>
            <span className="font-extrabold text-xl" style={{ ...NUM, color: done ? C.accent2 : C.text }}>{mm}:{String(ss).padStart(2, "0")}</span>
          </div>
          <div className="rounded-full overflow-hidden mb-2.5" style={{ height: 6, background: "#0E1B17" }}>
            <div style={{ height: "100%", width: `${pct}%`, background: done ? C.accent2 : C.accent, transition: "width .25s linear" }} />
          </div>
          <div className="flex gap-2">
            <button onClick={() => adjust(-15)} className="rounded-lg px-3 py-2 text-xs font-bold" style={{ color: C.muted, border: `1px solid ${C.line}` }}>−15s</button>
            <button onClick={() => adjust(15)} className="rounded-lg px-3 py-2 text-xs font-bold" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>+15s</button>
            <button onClick={onClose} className="flex-1 rounded-lg px-3 py-2 text-xs font-bold" style={{ background: C.accent, color: "#1A140A" }}>Überspringen</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ---------- Swipe-to-Delete (Touch-Wischen + Lösch-Button) ---------- */
function SwipeToDelete({ onDelete, children, confirmText }) {
  const REVEAL = 76;
  const [dx, setDx] = useState(0);
  const [anim, setAnim] = useState(false);
  const startX = React.useRef(null);
  const baseRef = React.useRef(0);
  const movedRef = React.useRef(false);
  const openRef = React.useRef(false);
  const settle = (toOpen) => { openRef.current = toOpen; baseRef.current = toOpen ? -REVEAL : 0; setAnim(true); setDx(toOpen ? -REVEAL : 0); };
  const onTouchStart = (e) => { startX.current = e.touches[0].clientX; movedRef.current = false; setAnim(false); };
  const onTouchMove = (e) => {
    if (startX.current == null) return;
    const d = e.touches[0].clientX - startX.current;
    if (Math.abs(d) > 6) movedRef.current = true;
    setDx(Math.max(-REVEAL - 16, Math.min(0, baseRef.current + d)));
  };
  const onTouchEnd = () => { if (startX.current == null) return; startX.current = null; settle(dx < -REVEAL / 2); };
  // Start-Klick nur unterdrücken, wenn gerade gewischt wurde oder die Reihe offen ist.
  const onClickCapture = (e) => {
    if (movedRef.current || openRef.current) {
      e.preventDefault(); e.stopPropagation();
      if (openRef.current && !movedRef.current) settle(false);
      movedRef.current = false;
    }
  };
  const trash = () => { if (window.confirm(confirmText || "Löschen?")) { settle(false); onDelete && onDelete(); } };
  return (
    <div className="relative rounded-2xl overflow-hidden">
      <div className="absolute inset-y-0 right-0 flex items-center justify-center" style={{ width: REVEAL, background: C.danger }}>
        <button onClick={trash} aria-label="Löschen" className="w-full h-full flex items-center justify-center text-xl" style={{ color: "#180A07" }}>🗑</button>
      </div>
      <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onClickCapture={onClickCapture}
        style={{ transform: `translateX(${dx}px)`, transition: anim ? "transform .2s ease" : "none", touchAction: "pan-y", position: "relative" }}>
        {children}
      </div>
    </div>
  );
}

function Home({ history, active, user, profile, plan, onSwitch, onLogout, onStart, onFree, onResume, onDiscard, onHistory, onProfile, onPlan, onPlanBuilder, onDynamic, onBalance, onLastAnalysis, onCalendar, onMuscles, onStartCond, onDeleteDay, quickMode, onToggleQuick, onAiCoach, onPotential, aiCoachCount, bodyMetrics, measurements, onBodyMetrics, onTools, onPhotoDiary, onWithings, onExport, onExportJson, onImportJson }) {
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="assets/logo.png?v=2" alt="Logo" className="w-8 h-8 rounded-full object-cover shrink-0" style={{ background: "#fff" }} />
            <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Trainingstagebuch</div>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={onSwitch} className="text-xs font-semibold rounded-full px-3 py-1" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>{user} · wechseln</button>
            <button onClick={onLogout} className="text-xs font-semibold rounded-full px-3 py-1" style={{ color: C.muted, border: `1px solid ${C.line}` }}>Abmelden</button>
          </div>
        </div>
        <div className="flex justify-center mt-5">
          <img src={`assets/logo-${String(user || "").toLowerCase()}.jpg`} alt={user}
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "assets/logo.png?v=2"; }}
            className="w-36 h-36 rounded-full object-cover" style={{ background: "#fff", boxShadow: `0 0 0 1px ${C.line}` }} />
        </div>
        <h1 className="text-3xl font-extrabold mt-4" style={{ letterSpacing: "-0.02em" }}>Heute trainieren</h1>
        <p className="text-sm mt-1" style={{ color: C.muted }}>Wähle deinen Tag. Plan ist hinterlegt, Abweichen jederzeit möglich.</p>
      </header>

      <button onClick={onAiCoach} className="w-full text-left rounded-2xl p-4 mb-5" style={{ background: C.surface2, border: `1px solid ${aiCoachCount > 0 ? C.accent : C.line}` }}>
        <div className="flex items-center justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>🤖 KI-Trainer</div>
            <div className="font-bold mt-1">Analyse & Plan-Vorschläge</div>
            <div className="text-xs mt-1" style={{ color: C.muted }}>{aiCoachCount > 0 ? `${aiCoachCount} offene${aiCoachCount === 1 ? "r" : ""} Vorschlag${aiCoachCount === 1 ? "" : "schläge"} zum Bestätigen` : "Stündlich aktualisierte Einschätzung"}</div>
          </div>
          {aiCoachCount > 0
            ? <span className="text-xs font-bold rounded-full px-3 py-1 shrink-0" style={{ background: C.accent, color: "#1A140A" }}>{aiCoachCount}</span>
            : <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Öffnen</span>}
        </div>
      </button>

      {active && (
        <div className="rounded-2xl p-4 mb-5" style={{ background: C.surface2, border: `1px solid ${C.accent}` }}>
          <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>Laufende Einheit</div>
          <div className="font-bold mt-1">{active.day}</div>
          <div className="text-xs" style={{ color: C.muted }}>{fmtDate(active.dateISO)} · {totalSets(active)} Sätze erfasst</div>
          <div className="flex gap-2 mt-3">
            <button onClick={onResume} className="flex-1 rounded-xl py-2.5 font-semibold text-sm" style={{ background: C.accent, color: "#1A140A" }}>Fortsetzen</button>
            <button onClick={onDiscard} className="rounded-xl py-2.5 px-4 font-semibold text-sm" style={{ background: "transparent", color: C.muted, border: `1px solid ${C.line}` }}>Verwerfen</button>
          </div>
        </div>
      )}

      <button onClick={onToggleQuick} className="w-full mb-3 rounded-xl px-4 py-2.5 flex items-center justify-between" style={{ background: quickMode ? C.surface2 : "transparent", border: `1px solid ${quickMode ? C.accent : C.line}` }}>
        <span className="text-sm font-semibold" style={{ color: quickMode ? C.accent : C.text }}>⏱ Wenig Zeit heute</span>
        <span className="text-[10px] font-bold rounded-full px-2 py-0.5" style={{ background: quickMode ? C.accent : "#0E1B17", color: quickMode ? "#1A140A" : C.muted }}>{quickMode ? "AN · Kurzversion" : "AUS"}</span>
      </button>

      <div className="flex flex-col gap-3">
        {Object.keys(plan).map((d) => (
          <SwipeToDelete key={d} confirmText={`Trainingstag „${d}" wirklich löschen?`} onDelete={() => onDeleteDay && onDeleteDay(d)}>
            <button onClick={() => onStart(d)}
              className="w-full block text-left p-4"
              style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-bold text-lg">{d}</div>
                  <div className="text-xs mt-0.5" style={{ color: C.muted }}>{planMeta(d, plan)}</div>
                </div>
                <div className="text-xs font-semibold rounded-full px-3 py-1" style={{ background: C.surface2, color: quickMode ? C.accent : C.accent2 }}>{quickMode ? `${shortenForTime(plan[d]).length} Üb. · kurz` : `${plan[d].length} Üb.`}</div>
              </div>
              <div className="flex flex-wrap gap-1.5 mt-3">
                {[...new Set(plan[d].map((e) => e.group))].map((g) => (
                  <span key={g} className="text-[10px] font-semibold rounded-md px-2 py-0.5" style={{ background: "#0E1B17", color: GROUP[g] || C.muted }}>{g}</span>
                ))}
              </div>
            </button>
          </SwipeToDelete>
        ))}
      </div>
      <p className="text-[11px] mt-2" style={{ color: C.muted }}>Tipp: Tag nach links wischen, um ihn zu löschen.</p>

      {onDynamic && (
        <button onClick={onDynamic} className="w-full mt-3 rounded-2xl p-4 text-left" style={{ background: C.surface2, border: `1px solid ${C.accent}` }}>
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>🤖 Dynamisches Training</div>
              <div className="font-bold mt-1">Frisch zusammengestellt</div>
              <div className="text-xs mt-1" style={{ color: C.muted }}>Dauer wählen · nach Volumen, Erholung &amp; Balance · inkl. neuer Übungen</div>
            </div>
            <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Öffnen</span>
          </div>
        </button>
      )}

      <button onClick={onFree} className="w-full mt-3 rounded-2xl p-4 font-semibold" style={{ background: "transparent", color: C.text, border: `1px dashed ${C.line}` }}>+ Freies Training</button>

      <div className="mt-6 mb-1 text-xs uppercase tracking-[0.2em]" style={{ color: C.accent }}>Cardio, Yoga & Core</div>
      <div className="flex flex-wrap gap-2">
        <button onClick={() => onStartCond("yoga", "Yoga")} className="rounded-xl px-3 py-2.5 text-sm font-semibold" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>★ Yoga</button>
        <button onClick={() => onStartCond("core", "Core")} className="rounded-xl px-3 py-2.5 text-sm font-semibold" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>🔥 Core</button>
        {CARDIO_ACTIVITIES.map((a) => (
          <button key={a} onClick={() => onStartCond("cardio", a)} className="rounded-xl px-3 py-2.5 text-sm font-semibold" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }}>
            <span style={{ color: C.danger }}>♥</span> {CARDIO_ICON[a]} {a}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2 mt-6">
        <button onClick={onCalendar} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>
          📅 Kalender
        </button>
        <button onClick={onBalance} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>
          Wochenvolumen
        </button>
        <button onClick={onMuscles} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>
          🗺 Muskelkarte
        </button>
        <button onClick={onPotential} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>
          💪 Muskel-Potenzial
        </button>
        <button onClick={onTools} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>
          🧮 Rechner
        </button>
        <button onClick={onPhotoDiary} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>
          📸 Foto-Tagebuch
        </button>
        <button onClick={onLastAnalysis} disabled={!history.length} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface, color: history.length ? C.accent : C.muted, border: `1px solid ${C.line}`, opacity: history.length ? 1 : 0.6 }}>
          Letzte Auswertung
        </button>
        <button onClick={onHistory} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>
          Verlauf ({history.length})
        </button>
        <button onClick={() => onExport && onExport()} className="w-full rounded-xl py-3 text-sm font-semibold text-center block" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>
          Excel-Export
        </button>
      </div>

      <div className="mt-3">
        <div className="text-[11px] mb-1.5" style={{ color: C.muted }}>Voll-Backup (JSON) – für Gerätewechsel & Wiederherstellung:</div>
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => onExportJson && onExportJson()} className="w-full rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>
            ⭳ JSON-Backup
          </button>
          <label className="w-full rounded-xl py-3 text-sm font-semibold text-center cursor-pointer" style={{ background: C.surface, color: C.accent, border: `1px solid ${C.line}` }}>
            ⭱ Import
            <input type="file" accept="application/json,.json" className="hidden"
              onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ""; if (f && onImportJson) onImportJson(f); }} />
          </label>
        </div>
      </div>

      {(() => {
        // Neueste Messung über BEIDE Quellen: lokale Erfassung (tt_*_bodymetrics) und
        // Withings/Supabase (measurements). Sonst zeigt die Karte veraltete Werte, wenn
        // seit der letzten manuellen Eingabe nur noch automatisch synchronisiert wurde.
        const byDay = new Map();
        // Erst KV-Einträge (HAE / manuell), dann Withings-Messungen.
        // Pro Tag: Felder zusammenführen (merge), nicht erster-gewinnt – sonst gehen
        // Withings-Felder (muscleMassKg, fatMassKg) verloren, wenn HAE denselben Tag hat.
        [...(bodyMetrics || []), ...(measurements || []).map((m) => ({
          dateISO: m.dateISO, weightKg: m.weightKg, fatTotal: m.fatPct,
          fatMassKg: m.fatMassKg, muscleMassKg: m.muscleMassKg,
        }))].forEach((e) => {
          if (!e || !e.dateISO) return;
          const k = e.dateISO.slice(0, 10);
          if (!byDay.has(k)) { byDay.set(k, { ...e }); }
          else { const ex = byDay.get(k); for (const f of Object.keys(e)) { if (e[f] != null && ex[f] == null) ex[f] = e[f]; } }
        });
        const merged = [...byDay.values()].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));
        const latest = merged[0];
        const prev = merged[1];
        // HAE-Einträge liefern nur weightKg + fatTotal (KFA), aber keine fatMassKg/muscleMassKg –
        // die kommen nur von der Waage. Fettmasse rechnerisch ableiten, Muskelwerte aus dem
        // letzten Scan nachziehen, sonst zeigt die Karte "—" trotz vorhandenem Gewicht+KFA.
        const fatMassKg = latest && latest.fatMassKg != null
          ? latest.fatMassKg
          : (latest && latest.weightKg != null && latest.fatTotal != null
            ? +(latest.weightKg * latest.fatTotal / 100).toFixed(2)
            : null);
        const muscleFrom = latest && latest.muscleMassKg != null ? latest : merged.find((e) => e.muscleMassKg != null);
        const muscleMassKg = muscleFrom ? muscleFrom.muscleMassKg : null;
        const muscleStale = muscleFrom && muscleFrom !== latest;
        const prevMuscleFrom = muscleFrom ? merged.find((e) => e !== muscleFrom && e.muscleMassKg != null) : null;
        const pctFrom = latest && latest.musclePct != null ? latest : merged.find((e) => e.musclePct != null);
        const musclePct = pctFrom ? pctFrom.musclePct : null;
        const fmtV = (v, u) => (v == null ? "—" : `${v}${u}`);
        const trd = (cur, prv, inv) => {
          if (cur == null || prv == null) return null;
          const up = cur > prv;
          const good = inv ? !up : up;
          return <span style={{ marginLeft: 4, fontSize: 11, color: good ? "#3DBE7B" : "#D94545" }}>{up ? "↑" : "↓"}</span>;
        };
        return (
          <>
            <div className="mt-8 mb-1 text-xs uppercase tracking-[0.2em]" style={{ color: C.accent }}>Körpermesswerte</div>
            <button onClick={onBodyMetrics} className="w-full text-left rounded-2xl p-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0 flex-1">
                  {latest ? (
                    <>
                      <div className="font-bold text-sm mb-1">{fmtV(latest.weightKg, " kg")} · zuletzt {fmtDate(latest.dateISO)}</div>
                      <div className="flex flex-col gap-0.5 text-xs" style={{ color: C.muted }}>
                        <div>KFA ges. <b style={{ color: C.text }}>{fmtV(latest.fatTotal, " %")}</b>{trd(latest.fatTotal, prev?.fatTotal, true)} · Fettmasse <b style={{ color: C.text }}>{fmtV(fatMassKg, " kg")}</b>{trd(fatMassKg, prev?.fatMassKg, true)}</div>
                        <div>Muskeln <b style={{ color: C.text }}>{fmtV(muscleMassKg, " kg")}</b>{trd(muscleMassKg, prevMuscleFrom?.muscleMassKg, false)}{muscleStale && <span style={{ marginLeft: 4, fontSize: 10, color: C.muted }}>(Scan {fmtDate(muscleFrom.dateISO)})</span>}{musclePct != null && <> · Muskel % <b style={{ color: C.text }}>{fmtV(musclePct, " %")}</b>{pctFrom === latest && trd(musclePct, prev?.musclePct, false)}</>}</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="font-bold">Noch keine Werte</div>
                      <div className="text-xs mt-1" style={{ color: C.muted }}>Gewicht, KFA, Muskelmasse, segmentale Werte</div>
                    </>
                  )}
                </div>
                <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>{latest ? "Öffnen" : "Erfassen"}</span>
              </div>
            </button>
            <p className="text-[11px] mt-1" style={{ color: C.muted }}>Werden an den KI-Trainer übergeben und fließen in die Einschätzung ein.</p>
            {onWithings && (
              <button onClick={onWithings} className="w-full mt-2 text-left rounded-2xl p-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
                <div className="flex items-center justify-between gap-3">
                  <div><div className="font-bold">Withings Body Scan</div><div className="text-xs mt-0.5" style={{ color: C.muted }}>Automatisch synchronisierte Körperzusammensetzung &amp; Segmental</div></div>
                  <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Öffnen</span>
                </div>
              </button>
            )}
          </>
        );
      })()}

      <div className="mt-8 mb-1 text-xs uppercase tracking-[0.2em]" style={{ color: C.accent }}>Plan & Profil</div>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <button onClick={onPlan} className="rounded-2xl p-4 text-left" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="font-bold text-sm">Plan-Generator</div>
          <div className="text-xs mt-1" style={{ color: C.muted }}>{Object.keys(plan).length} Tage · aus Profil</div>
          <span className="inline-block mt-2 text-[10px] font-semibold rounded-full px-2 py-0.5" style={{ color: C.accent, border: `1px solid ${C.line}` }}>automatisch</span>
        </button>
        <button onClick={onPlanBuilder} className="rounded-2xl p-4 text-left" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="font-bold text-sm">Eigener Tag</div>
          <div className="text-xs mt-1" style={{ color: C.muted }}>Generieren o. manuell · Alternativen</div>
          <span className="inline-block mt-2 text-[10px] font-semibold rounded-full px-2 py-0.5" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Tag bauen</span>
        </button>
      </div>
      {profile && (
        <button onClick={onProfile} className="w-full text-left rounded-2xl p-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>Profil</div>
              <div className="font-bold mt-1">{profile.goal} · {profile.trainingDays} Tage/Woche · {profile.sessionMinutes} Min</div>
              <div className="text-xs mt-1" style={{ color: C.muted }}>{profile.experience}{profile.restrictions ? ` · Einschränkungen: ${profile.restrictions}` : " · keine Einschränkungen hinterlegt"}</div>
            </div>
            <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Bearbeiten</span>
          </div>
        </button>
      )}

      <p className="text-[11px] text-center mt-4" style={{ color: C.muted }}>
        Hinweis: Eiweißziel ~115 g wurde nierenschonend angesetzt – vom Arzt bestätigen lassen.
      </p>
    </div>
  );
}

/* ---------- Session ---------- */
const dateInputValue = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
function Session({ session, lastBest, lastPerf, plateau, isEdit, onAddSet, onDelSet, onOpenDetail, onRemove, onSwap, onAdd, onFinish, onCancel, onDate, onSaveTemplate, onRest, timerOff, onToggleTimer, onToggleSecondary, onNote, onExerciseDone }) {
  const vol = volume(session), sets = totalSets(session);
  const onChangeDate = (e) => {
    const v = e.target.value;
    if (!v) return;
    const [y, m, dd] = v.split("-").map(Number);
    const d = new Date(session.dateISO);
    if (Number.isNaN(d.getTime())) d.setTime(Date.now());
    d.setFullYear(y, m - 1, dd);
    onDate && onDate(d.toISOString());
  };
  const todayValue = dateInputValue(new Date().toISOString());
  const [openId, setOpenId] = useState(null); // aktuell aufgeklappte Übung (Akkordeon)
  // Abgeschlossene Übungen: initial aus den Übungsdaten (e.done), damit der „abgeschlossen"-
  // Vermerk beim Nachbearbeiten einer gespeicherten Einheit erhalten bleibt.
  const [doneIds, setDoneIds] = useState(() => {
    const d = {}; (session.exercises || []).forEach((e) => { if (e.done) d[e.id] = true; }); return d;
  });
  const toggleOpen = (id) => setOpenId((cur) => (cur === id ? null : id));
  const completeExercise = (id, name) => {
    setDoneIds((d) => ({ ...d, [id]: true }));
    setOpenId((cur) => (cur === id ? null : cur));
    onExerciseDone && onExerciseDone(id, true); // Status in den Session-/Übungsdaten persistieren
    onRest && onRest(name, "exercise"); // Pause nach der Übung (vor der nächsten)
  };
  return (
    <div className="pb-28">
      <header className="sticky top-0 z-10 px-5 pt-6 pb-4" style={{ background: C.bg, borderBottom: `1px solid ${C.line}` }}>
        <div className="flex items-start justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.2em]" style={{ color: C.accent }}>{fmtDate(session.dateISO)}{isEdit ? " · bearbeiten" : ""}</div>
            <h1 className="text-2xl font-extrabold" style={{ letterSpacing: "-0.02em" }}>{session.day}</h1>
          </div>
          <button onClick={onCancel} className="text-xs font-semibold mt-1" style={{ color: C.muted }}>{isEdit ? "Zurück" : "Abbrechen"}</button>
        </div>
        <div className="flex items-center justify-between gap-2 mt-3">
          <div className="flex items-center gap-2">
            <span className="text-[10px] uppercase tracking-widest" style={{ color: C.muted }}>Datum</span>
            <input type="date" value={dateInputValue(session.dateISO)} max={todayValue} onChange={onChangeDate}
              className="text-sm font-semibold rounded-lg px-2.5 py-1.5 outline-none"
              style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, colorScheme: "dark" }} />
          </div>
          {(() => {
            const on = session.logSecondary !== false;
            return (
              <button onClick={onToggleSecondary} className="flex items-center gap-2 shrink-0" title="Sekundärmuskeln für diese Einheit mitzählen">
                <span className="text-[10px] uppercase tracking-widest text-right" style={{ color: on ? C.accent2 : C.muted }}>Sekundär<br />{on ? "an" : "aus"}</span>
                <span className="rounded-full" style={{ width: 42, height: 24, background: on ? C.accent2 : "#16302A", border: `1px solid ${C.line}`, position: "relative", transition: "background .2s" }}>
                  <span style={{ position: "absolute", top: 2, left: on ? 20 : 2, width: 18, height: 18, borderRadius: 99, background: "#EAF1ED", transition: "left .2s" }} />
                </span>
              </button>
            );
          })()}
        </div>
        <div className="flex gap-4 mt-2 text-sm">
          <span style={{ color: C.muted }}>Sätze <b style={{ color: C.text, ...NUM }}>{sets}</b></span>
          <span style={{ color: C.muted }}>Volumen <b style={{ color: C.text, ...NUM }}>{Math.round(vol).toLocaleString("de-DE")}</b> kg</span>
        </div>
      </header>

      <div className="px-5 pt-4 flex flex-col gap-4">
        {session.exercises.length === 0 && (
          <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
            <div className="font-semibold">Noch keine Übung</div>
            <div className="text-sm mt-1" style={{ color: C.muted }}>Füge unten deine erste Übung hinzu.</div>
          </div>
        )}
        {session.exercises.map((e) => (
          <ExerciseCard key={e.id} exercise={e} last={lastBest[e.name]} lastSeq={lastPerf && lastPerf[e.name]} plateau={plateau && plateau[e.name]} onOpenDetail={(ex) => onOpenDetail(ex, ex.id)}
            onAddSet={(s) => onAddSet(e.id, s)} onDelSet={(i) => onDelSet(e.id, i)}
            onRemove={() => onRemove(e.id)} onSwap={() => onSwap(e.id)}
            timerOff={timerOff} onRest={() => onRest && onRest(e.name, "set")} isEdit={isEdit}
            expanded={openId === e.id} done={!!doneIds[e.id]} onToggle={() => toggleOpen(e.id)} onComplete={() => completeExercise(e.id, e.name)} />
        ))}
        <button onClick={onAdd} className="rounded-2xl py-4 font-semibold" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>+ Übung hinzufügen</button>
        {session.exercises.length > 0 && (
          <button onClick={onSaveTemplate} className="rounded-2xl py-3 font-semibold text-sm" style={{ background: "transparent", color: C.accent, border: `1px solid ${C.line}` }}>★ Als Vorlage speichern</button>
        )}
        <button onClick={onToggleTimer} className="rounded-2xl p-4 flex items-center justify-between" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-left">
            <div className="font-semibold text-sm" style={{ color: C.text }}>Pausen-Timer</div>
            <div className="text-xs mt-0.5" style={{ color: C.muted }}>{timerOff ? "Für diese Einheit aus" : "Startet automatisch nach jedem Satz und nach dem Abschließen einer Übung"}</div>
          </div>
          <span className="shrink-0 rounded-full" style={{ width: 46, height: 26, background: timerOff ? "#0E1B17" : C.accent2, border: `1px solid ${C.line}`, position: "relative", transition: "background .2s" }}>
            <span style={{ position: "absolute", top: 2, left: timerOff ? 2 : 22, width: 20, height: 20, borderRadius: 99, background: "#EAF1ED", transition: "left .2s" }} />
          </span>
        </button>

        <div className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>📝 Notiz zu dieser Einheit</div>
          <textarea value={session.note || ""} onChange={(e) => onNote && onNote(e.target.value)} rows={3}
            placeholder="Für dich selbst oder den KI-Trainer – z.B. Schlaf, Energie, Schmerzen, Motivation, Fokus. Wird an den KI-Trainer übermittelt und in die Beratung einbezogen."
            className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}`, minHeight: 76, resize: "vertical" }} />
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 px-5 py-4" style={{ background: "linear-gradient(to top, " + C.bg + " 70%, transparent)" }}>
        <div className="mx-auto" style={{ maxWidth: 480 }}>
          <button onClick={onFinish} className="w-full rounded-2xl py-4 font-bold text-lg active:scale-[0.99] transition-transform" style={{ background: C.accent, color: "#1A140A" }}>
            {isEdit ? "Änderungen speichern" : "Einheit beenden \u0026 speichern"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------- ExerciseCard ---------- */
function ExerciseCard({ exercise, last, lastSeq, plateau, onOpenDetail, onAddSet, onDelSet, onRemove, onSwap, onRest, timerOff, isEdit, expanded, done, onToggle, onComplete }) {
  const timed = isTimedEx(exercise);
  const pneu = isPneuEx(exercise);
  const perSide = exLoadMul(exercise.name) === 2; // beidhändig: Eingabe je Hand, Volumen ×2
  // Kontext für die autoregulierte Progression: letzte Einheit + RED-Streak.
  const progCtx = (() => {
    const seq = lastSeq && lastSeq.length ? lastSeq : last ? [[last]] : [];
    if (!seq.length) return undefined;
    const working = seq[seq.length - 1];
    const lo = repsLow(exercise.targetReps), hi = repsHigh(exercise.targetReps);
    return {
      working,
      load: Number((working[working.length - 1] || {}).weight || 0),
      redStreak: redStreakFor(seq, lo, hi, progMode(exercise.name)),
    };
  })();
  const lastInSession = exercise.sets[exercise.sets.length - 1];
  // Liegt schon ein Satz dieser Einheit vor, steuert die In-Session-Logik den nächsten Satz;
  // sonst kommt der Vorschlag aus der letzten Einheit (autoregulierte Progression).
  const sug = timed
    ? timedSuggestion(exercise, last)
    : lastInSession && lastInSession.reps != null
      ? nextSetAdvice(exercise, lastInSession, pneu ? "" : "kg", exercise.sets.length)
      : suggestion(exercise, last, pneu ? "" : "kg", progCtx);
  const [weight, setWeight] = useState(() => (timed ? 0 : sug.weight));
  const [reps, setReps] = useState(() => (timed ? 0 : sug.reps));
  const [sec, setSec] = useState(() => (lastInSession && lastInSession.sec != null) ? lastInSession.sec : (sug.sec || repsLow(exercise.targetReps) || 30));
  const [rir, setRir] = useState(() => lastInSession?.rir ?? 2);
  const gc = GROUP[exercise.group] || C.muted;

  const myBest = bestSet(exercise.sets);
  const beat = myBest && last && (timed ? ((myBest.sec || 0) > (last.sec || 0)) : (myBest.weight > last.weight || (myBest.weight === last.weight && myBest.reps > last.reps)));

  const save = () => {
    const rirValue = Math.max(0, Math.min(4, parseInt(rir, 10) || 0));
    if (timed) {
      const sc = parseInt(sec, 10) || 0;
      if (sc <= 0) return;
      onAddSet({ sec: sc, rir: rirValue, rpe: 10 - rirValue });
      if (!timerOff && !isEdit) onRest && onRest(); // Satzpause automatisch nach jedem Satz
      return;
    }
    const w = parseNum(weight) || 0;
    const r = parseInt(reps, 10) || 0;
    if (r <= 0) return;
    const newSet = { weight: w, reps: r, rir: rirValue, rpe: 10 - rirValue, ...(pneu ? { pneu: true } : {}) };
    onAddSet(newSet);
    // Satzpause automatisch nach jedem geloggten Satz starten (nicht beim Nachbearbeiten einer gespeicherten Einheit).
    if (!timerOff && !isEdit) onRest && onRest();
    // Nächsten Satz direkt anpassen: Max-Wdh+Reserve -> schwerer, unter Mindest-Wdh -> leichter.
    const next = nextSetAdvice(exercise, newSet, pneu ? "" : "kg", exercise.sets.length + 1);
    setWeight(next.weight);
    setReps(next.reps);
  };
  const step = (set, val, d, min = 0) => set(Math.max(min, (parseNum(val) || 0) + d));
  const setsCount = exercise.sets.length;
  const summary = setsCount > 0 ? `${setsCount} Satz${setsCount === 1 ? "" : "e"} erfasst` : "Noch keine Sätze";

  return (
    <div className="rounded-2xl overflow-hidden" style={{ background: C.surface, border: `1px solid ${expanded ? C.accent2 : done ? "#1D3A31" : C.line}` }}>
      {/* Kopfzeile – immer sichtbar, antippen klappt auf/zu */}
      <button onClick={onToggle} className="w-full p-4 flex items-center justify-between gap-3 text-left">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.18em] flex items-center gap-1.5">
            <span style={{ width: 7, height: 7, borderRadius: 99, background: gc, display: "inline-block" }} />
            <span style={{ color: gc }}>{exercise.group}</span>
            {done && <span style={{ color: C.accent2 }}>· ✓ abgeschlossen</span>}
          </div>
          <div className="font-bold text-lg leading-tight mt-1 truncate" style={{ color: C.text }}>{exercise.name}</div>
          <div className="text-xs mt-0.5 flex items-center gap-1.5 flex-wrap" style={{ color: C.muted }}>
            <span>{summary}{last ? ` · zuletzt ${fmtSet(last)}` : ""}</span>
            {!expanded && beat && <span className="rounded px-1.5 py-0.5 font-bold" style={{ background: C.accent, color: "#1A140A" }}>Bestwert ↑</span>}
            {!expanded && plateau && <span style={{ color: C.danger }}>⚠</span>}
          </div>
        </div>
        <span className="shrink-0 text-base" style={{ color: C.accent2, transform: expanded ? "rotate(90deg)" : "none", transition: "transform .15s" }}>▸</span>
      </button>

      {expanded && (
        <div>
          {/* Werkzeugleiste */}
          <div className="px-4 pb-2 flex items-center gap-1.5">
            <button onClick={() => onOpenDetail(exercise)} className="text-xs rounded-lg px-2 py-1" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>ⓘ Info</button>
            {!timerOff && <button onClick={onRest} title="Satzpause starten" className="text-xs rounded-lg px-2 py-1" style={{ color: C.accent, border: `1px solid ${C.line}` }}>⏱ Satzpause</button>}
            <span className="flex-1" />
            <button onClick={onSwap} title="Tauschen" className="text-xs rounded-lg px-2 py-1" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>↺</button>
            <button onClick={onRemove} title="Entfernen" className="text-xs rounded-lg px-2 py-1" style={{ color: C.muted, border: `1px solid ${C.line}` }}>✕</button>
          </div>

          <div className="px-4">
            {(() => {
              const ip = involvementParts(exercise);
              return (
                <div className="text-xs" style={{ color: C.muted }}>
                  <span style={{ color: C.accent2 }}>{ip.primary.map(muscleLabel).join(", ")}</span>
                  {ip.secondary.length > 0 && <span> · sek.: {ip.secondary.map(muscleLabel).join(", ")}</span>}
                </div>
              );
            })()}
            <div className="text-xs mt-0.5" style={{ color: C.muted }}>Ziel: {exercise.targetSets} Sätze · {exercise.targetReps}{timed ? "" : " Wdh"}</div>
            <div className="mt-2 text-xs flex flex-col gap-0.5">
              {last && <span style={{ color: C.muted }}>Letztes Mal: <b style={{ color: C.text, ...NUM }}>{fmtSet(last)}</b></span>}
              {plateau && <span className="rounded-md px-2 py-0.5 font-bold inline-block w-max" style={{ background: "rgba(224,122,95,0.18)", color: C.danger }}>⚠ {plateau.text}</span>}
              <span className="flex items-center gap-2 flex-wrap">
                <span style={{ color: sug.tone === "caution" ? C.danger : sug.tone === "easy" ? C.accent : C.accent2 }}>{sug.text}</span>
                {sug.tone === "caution" && <span className="rounded-md px-2 py-0.5 font-bold" style={{ background: "rgba(224,122,95,0.18)", color: C.danger }}>vorsichtig</span>}
                {sug.tone === "easy" && <span className="rounded-md px-2 py-0.5 font-bold" style={{ background: C.accent, color: "#1A140A" }}>zu leicht</span>}
                {beat && <span className="rounded-md px-2 py-0.5 font-bold" style={{ background: C.accent, color: "#1A140A" }}>Bestwert ↑</span>}
              </span>
            </div>
          </div>

          {exercise.sets.length > 0 && (
            <div className="px-4 pt-2 pb-2 flex flex-col gap-1.5">
              {exercise.sets.map((s, i) => (
                <div key={i} className="flex items-center justify-between rounded-lg px-3 py-2" style={{ background: "#0E1B17" }}>
                  <span className="text-xs font-semibold" style={{ color: C.muted }}>Satz {i + 1}</span>
                  <span className="font-bold" style={{ ...NUM }}>{fmtSet(s)} <span className="text-[10px] font-semibold ml-1" style={{ color: rirColor(s.rir) }}>{rirLabel(s.rir)}</span></span>
                  <button onClick={() => onDelSet(i)} className="text-xs" style={{ color: C.danger }}>entfernen</button>
                </div>
              ))}
            </div>
          )}

          <div className="p-4 pt-2" style={{ borderTop: `1px solid ${C.line}` }}>
            {timed ? (
              <Field label="Dauer (Sekunden)">
                <Stepper value={sec} onChange={setSec} onMinus={() => step(setSec, sec, -5)} onPlus={() => step(setSec, sec, 5)} placeholder="0" />
              </Field>
            ) : (
              <div className="grid grid-cols-2 gap-2">
                <Field label={pneu ? "Keiser-Wert (pneum.)" : perSide ? "Gewicht je Hand (kg)" : "Gewicht (kg)"}>
                  <Stepper value={weight} onChange={setWeight} onMinus={() => step(setWeight, weight, -1)} onPlus={() => step(setWeight, weight, 1)} placeholder="0" />
                </Field>
                <Field label="Wdh">
                  <Stepper value={reps} onChange={setReps} onMinus={() => step(setReps, reps, -1)} onPlus={() => step(setReps, reps, 1)} placeholder="0" />
                </Field>
              </div>
            )}
            <div className="mt-3">
              <div className="text-[10px] uppercase tracking-widest mb-2" style={{ color: C.muted }}>{timed ? "Anstrengung (0 = bis ans Limit gehalten)" : "RIR: Wie viele Wiederholungen wären noch gegangen?"}</div>
              <div className="grid grid-cols-5 gap-1.5">
                {[0, 1, 2, 3, 4].map((n) => {
                  const sel = Number(rir) === n;
                  const col = RIR_COLORS[n];
                  return (
                    <button key={n} onClick={() => setRir(n)} className="rounded-xl py-2 font-bold text-sm transition-colors" style={{ background: sel ? col : "#0E1B17", color: sel ? "#10201B" : col, border: `1px solid ${sel ? col : C.line}` }}>{n}</button>
                  );
                })}
              </div>
              <div className="text-xs mt-2 font-semibold" style={{ color: rirColor(rir) }}>{rirLabel(rir)}</div>
            </div>
            <button onClick={save} className="w-full mt-3 rounded-xl py-3 font-bold" style={{ background: C.accent2, color: "#0C1A15" }}>Satz speichern</button>
            <button onClick={onComplete} className="w-full mt-2 rounded-lg py-2 text-xs font-semibold" style={{ background: "transparent", color: C.muted, border: `1px solid ${C.line}` }}>✓ Übung abschließen{timerOff ? "" : " (Pause startet)"}</button>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div className="flex-1">
      <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>{label}</div>
      {children}
    </div>
  );
}
function Stepper({ value, onChange, onMinus, onPlus, placeholder }) {
  return (
    <div className="flex items-center rounded-xl overflow-hidden" style={{ border: `1px solid ${C.line}`, background: "#0E1B17" }}>
      <button onClick={onMinus} className="px-3 text-lg" style={{ color: C.muted, height: 44 }}>−</button>
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} inputMode="decimal"
        className="w-full text-center font-bold bg-transparent outline-none" style={{ color: C.text, ...NUM }} />
      <button onClick={onPlus} className="px-3 text-lg" style={{ color: C.accent2, height: 44 }}>+</button>
    </div>
  );
}

/* ---------- Picker ---------- */
function Picker({ mode, onPick, onClose, recommended }) {
  const rec = recommended || new Set();
  const [q, setQ] = useState("");
  const [grp, setGrp] = useState("Alle");
  const [catF, setCatF] = useState("Alle");
  const [custom, setCustom] = useState("");
  const [customGrp, setCustomGrp] = useState("Brust");
  const groups = ["Alle", ...Object.keys(GROUP)];
  const cats = [["Alle", "Alle"], ["kraft", "Kraft"], ["egym", "EGym"], ["trx", "TRX"], ["cali", "Calisthenics"], ["keiser", "Keiser"], ["custom", "Eigene"]];
  const list = allEx().map((e) => ({ name: e.n, group: e.g, muscle: e.m, cat: exCat(e) }))
    .filter((e) =>
      (grp === "Alle" || e.group === grp) &&
      (catF === "Alle" || e.cat === catF) &&
      (q === "" || e.name.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.55)" }} onClick={onClose}>
      <div className="w-full" style={{ maxWidth: 480, background: C.bg, borderTop: `1px solid ${C.line}`, maxHeight: "85vh" }}
        onClick={(e) => e.stopPropagation()}>
        <div className="px-5 pt-4 pb-3 sticky top-0" style={{ background: C.bg }}>
          <div className="flex items-center justify-between">
            <h2 className="font-extrabold text-lg">{mode === "swap" ? "Übung tauschen" : "Übung hinzufügen"}</h2>
            <button onClick={onClose} className="text-sm font-semibold" style={{ color: C.muted }}>Schließen</button>
          </div>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Suchen…"
            className="w-full mt-3 rounded-xl px-3 py-2.5 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />
          <div className="flex gap-1.5 mt-2 overflow-x-auto pb-1">
            {groups.map((g) => (
              <button key={g} onClick={() => setGrp(g)} className="text-xs font-semibold rounded-full px-3 py-1.5 shrink-0"
                style={{ background: grp === g ? (GROUP[g] || C.accent2) : C.surface, color: grp === g ? "#0C1A15" : C.muted, border: `1px solid ${C.line}` }}>{g}</button>
            ))}
          </div>
          <div className="flex gap-1.5 mt-1.5 overflow-x-auto pb-1">
            {cats.map(([id, label]) => (
              <button key={id} onClick={() => setCatF(id)} className="text-xs font-semibold rounded-full px-3 py-1.5 shrink-0"
                style={{ background: catF === id ? C.accent : C.surface, color: catF === id ? "#1A140A" : C.muted, border: `1px solid ${C.line}` }}>{label}</button>
            ))}
          </div>
        </div>

        <div className="px-5 overflow-y-auto" style={{ maxHeight: "45vh" }}>
          <div className="flex flex-col gap-1.5 pb-2">
            {list.map((e) => (
              <button key={e.name} onClick={() => onPick(e)} className="text-left rounded-xl px-3 py-2.5 flex items-center justify-between gap-2"
                style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <span className="font-semibold truncate">{e.name}</span>
                <span className="flex items-center gap-1 shrink-0">
                  {rec.has(e.name) && <span className="text-[10px] font-bold rounded-md px-2 py-0.5" style={{ color: "#1A140A", background: C.accent }}>🤖 KI</span>}
                  {e.cat && e.cat !== "kraft" && <span className="text-[10px] font-semibold rounded-md px-2 py-0.5" style={{ color: C.accent, background: "#0E1B17", border: `1px solid ${C.line}` }}>{CAT_LABEL[e.cat] || e.cat}</span>}
                  <span className="text-[10px] font-semibold rounded-md px-2 py-0.5" style={{ color: GROUP[e.group] || C.muted, background: "#0E1B17" }}>{e.group}</span>
                </span>
              </button>
            ))}
            {list.length === 0 && <div className="text-sm py-4 text-center" style={{ color: C.muted }}>Nichts gefunden – leg unten eine eigene Übung an.</div>}
          </div>
        </div>

        <div className="px-5 py-4" style={{ borderTop: `1px solid ${C.line}` }}>
          <div className="text-[10px] uppercase tracking-widest mb-2" style={{ color: C.muted }}>Eigene Übung</div>
          <div className="flex gap-2">
            <input value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Name"
              className="flex-1 rounded-xl px-3 py-2.5 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />
            <select value={customGrp} onChange={(e) => setCustomGrp(e.target.value)}
              className="rounded-xl px-2 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }}>
              {Object.keys(GROUP).map((g) => <option key={g} value={g}>{g}</option>)}
            </select>
          </div>
          <button disabled={!custom.trim()} onClick={() => onPick({ name: custom.trim(), group: customGrp, muscle: "" })}
            className="w-full mt-2 rounded-xl py-3 font-bold disabled:opacity-40" style={{ background: C.accent, color: "#1A140A" }}>
            Hinzufügen
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------- History ---------- */
function History({ history, onBack, onOpen, onDelete, onAnalyze }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <h1 className="text-3xl font-extrabold" style={{ letterSpacing: "-0.02em" }}>Verlauf</h1>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>
      {history.length === 0 && (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Noch kein Training erfasst</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Deine abgeschlossenen Einheiten erscheinen hier.</div>
        </div>
      )}
      <div className="flex flex-col gap-3">
        {history.map((s) => (
          <div key={s.id} className="rounded-2xl" style={{ background: C.surface, border: `1px solid ${isCond(s) ? condAccent(s.type) : C.line}` }}>
            <button onClick={() => setOpen(open === s.id ? null : s.id)} className="w-full text-left p-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-bold">{isCond(s) ? `${condIcon(s.type)} ${s.activity}` : s.day}</div>
                  <div className="text-xs" style={{ color: C.muted }}>{fmtDate(s.dateISO)}</div>
                </div>
                <div className="text-right text-xs" style={{ color: C.muted }}>
                  {isCond(s) ? (
                    <>
                      <div><b style={{ color: C.text, ...NUM }}>{s.durationMin}</b> Min</div>
                      {s.type === "cardio" && s.distanceKm > 0 && <div><b style={{ color: C.text, ...NUM }}>{s.distanceKm}</b> km</div>}
                    </>
                  ) : (
                    <>
                      <div><b style={{ color: C.text, ...NUM }}>{totalSets(s)}</b> Sätze</div>
                      <div><b style={{ color: C.text, ...NUM }}>{Math.round(volume(s)).toLocaleString("de-DE")}</b> kg</div>
                    </>
                  )}
                </div>
              </div>
            </button>
            {open === s.id && isCond(s) && (
              <div className="px-4 pb-4 flex flex-col gap-2">
                <div className="text-sm" style={{ color: C.muted }}>
                  {s.activity} · {s.durationMin} Min{s.type === "cardio" && s.distanceKm > 0 ? ` · ${s.distanceKm} km` : ""}{s.note ? ` · ${s.note}` : ""}
                </div>
                <div className="flex gap-2 mt-1">
                  <button onClick={() => { if (window.confirm("Diese Einheit löschen?")) onDelete(s.id); }} className="rounded-xl py-2.5 px-4 font-semibold text-sm" style={{ background: "transparent", color: C.danger, border: `1px solid ${C.line}` }}>Löschen</button>
                </div>
              </div>
            )}
            {open === s.id && !isCond(s) && (
              <div className="px-4 pb-4 flex flex-col gap-2">
                {s.exercises.map((e, i) => (
                  <div key={i}>
                    <div className="text-xs font-semibold flex items-center gap-1.5">
                      <span style={{ width: 6, height: 6, borderRadius: 99, background: GROUP[e.group] || C.muted, display: "inline-block" }} />
                      {e.name}
                    </div>
                    <div className="flex flex-wrap gap-1.5 mt-1">
                      {e.sets.map((x, k) => (
                        <span key={k} className="text-xs rounded-md px-2 py-0.5" style={{ background: "#0E1B17", color: C.text, ...NUM }}>{fmtSetShort(x)}{x.rir !== undefined ? ` · RIR ${x.rir}` : ""}</span>
                      ))}
                      {e.sets.length === 0 && <span className="text-xs" style={{ color: C.muted }}>—</span>}
                    </div>
                  </div>
                ))}
                <div className="flex gap-2 mt-2">
                  <button onClick={() => onAnalyze && onAnalyze(s)} className="flex-1 rounded-xl py-2.5 font-semibold text-sm" style={{ background: C.accent, color: "#1A140A" }}>Auswertung</button>
                  <button onClick={() => onOpen(s)} className="flex-1 rounded-xl py-2.5 font-semibold text-sm" style={{ background: C.accent2, color: "#0C1A15" }}>Bearbeiten</button>
                  <button onClick={() => { if (window.confirm("Diese Einheit löschen?")) onDelete(s.id); }} className="rounded-xl py-2.5 px-4 font-semibold text-sm" style={{ background: "transparent", color: C.danger, border: `1px solid ${C.line}` }}>Löschen</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}



/* ---------- Plan Generator ---------- */
function PlanGenerator({ profile, currentPlan, history, measurements, onBack, onSave }) {
  const [style, setStyle] = useState("auto");
  // Ø aus dem Trainingsverlauf: Tage/Woche (letzter Monat, nur Wochen mit ≥1 Training) und Dauer (letzte 2 Wochen).
  const avgDays = useMemo(() => avgTrainingDaysPerWeek(history), [history]);
  const avgMin = useMemo(() => avgSessionMinutes(history), [history]);
  // Änderbare Defaults: mit den berechneten Ø-Werten vorbelegt, Fallback aufs Profil.
  const [daysOverride, setDaysOverride] = useState(() => avgDays != null ? Math.max(1, Math.min(7, Math.round(avgDays))) : Number(profile?.trainingDays || 4));
  const [minOverride, setMinOverride] = useState(() => avgMin != null ? Math.max(20, Math.min(180, Math.round(avgMin / 5) * 5)) : Number(profile?.sessionMinutes || 60));
  const effProfile = useMemo(() => ({ ...profile, trainingDays: daysOverride, sessionMinutes: minOverride }), [profile, daysOverride, minOverride]);
  // Plan bauen + auf MEV-Abdeckung prüfen (fehlende Hauptmuskeln → optionale Zusatzübungen).
  const built = useMemo(() => ensureMuscleCoverage(generatePlanStyled(effProfile, style), effProfile), [effProfile, style]);
  const preview = built.plan;
  const days = Object.keys(preview);
  const clamp = (v, min, max, fb) => { const n = parseInt(v, 10); return isNaN(n) ? fb : Math.max(min, Math.min(max, n)); };
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-5 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Plan-Generator</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>{profile.name}</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
        <div className="font-bold">Basis</div>
        <div className="text-sm mt-1" style={{ color: C.muted }}>{profile.goal} · {profile.experience}</div>
        <div className="text-xs mt-2" style={{ color: C.accent2 }}>Schema für Ziel „{profile.goal}": {(GOAL_SCHEME[profile.goal] || GOAL_SCHEME["Muskelaufbau"]).note}</div>
        {profile.avoidedExercises && <div className="text-xs mt-2" style={{ color: C.muted }}>Vermeidet: {profile.avoidedExercises}</div>}
      </div>

      <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Dein Ist-Schnitt</div>
        <div className="text-[11px] mb-3" style={{ color: C.muted }}>
          {avgDays != null ? `Zuletzt Ø ${fmtSets(avgDays)} Trainingstage/Woche (letzter Monat, nur Trainingswochen).` : "Noch keine Trainingsdaten für den Tage-Schnitt."}
          {" "}
          {avgMin != null ? `Ø ${Math.round(avgMin)} Min/Einheit (letzte 2 Wochen).` : "Noch keine Dauer-Daten (aus Satz-Zeitstempeln)."}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Tage/Woche</div>
            <select value={daysOverride} onChange={(e) => setDaysOverride(Number(e.target.value))}
              className="w-full rounded-xl px-3 py-2.5 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }}>
              {[1,2,3,4,5,6,7].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </label>
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Minuten/Einheit</div>
            <input type="number" min="20" max="180" value={minOverride}
              onChange={(e) => setMinOverride(clamp(e.target.value, 20, 180, minOverride))}
              className="w-full rounded-xl px-3 py-2.5 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }} />
          </label>
        </div>
        <div className="text-[11px] mt-2" style={{ color: C.muted }}>Vorbelegt aus deinem Schnitt – frei überschreibbar, bevor du den Plan erstellst.</div>
      </div>

      <label className="block mb-4">
        <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Aufteilung</div>
        <select value={style} onChange={(e) => setStyle(e.target.value)}
          className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }}>
          {PLAN_STYLES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
        <div className="text-[11px] mt-1" style={{ color: C.muted }}>{days.length} Tage · passend zu {daysOverride} Trainingstagen{daysOverride >= 4 && daysOverride <= 5 ? " · letzter Tag optional" : ""}</div>
      </label>

      {built.added.length > 0 && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: "rgba(230,190,90,0.12)", border: `1px solid ${C.accent}` }}>
          <div className="font-bold text-sm" style={{ color: C.accent }}>Optionale Zusatzübungen hinzugefügt</div>
          <div className="text-xs mt-1" style={{ color: C.text }}>Nicht alle Muskelgruppen erreichten über die Woche ihr Minimum-Volumen (MEV). Es wurden optionale Zusatzübungen ergänzt, aufgrund derer die geplante Trainingsdauer überschritten werden könnte.</div>
          <div className="text-[11px] mt-2" style={{ color: C.muted }}>Ergänzt: {built.added.map((a) => `${a.name} (${a.muscle})`).join(" · ")}</div>
        </div>
      )}

      <div className="flex flex-col gap-3">
        {days.map((day) => {
          const optionalDay = /optional/i.test(day);
          return (
          <div key={day} className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${optionalDay ? C.accent : C.line}` }}>
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="font-bold text-lg">{day}</div>
                <div className="text-xs mt-0.5" style={{ color: C.muted }}>{planMeta(day, preview)}</div>
              </div>
              <div className="text-xs font-semibold rounded-full px-3 py-1" style={{ background: C.surface2, color: optionalDay ? C.accent : C.accent2 }}>{optionalDay ? "optional · " : ""}{preview[day].length} Üb.</div>
            </div>
            <div className="mt-3 flex flex-col gap-1.5">
              {preview[day].map((e, i) => (
                <div key={`${day}-${i}`} className="text-sm rounded-lg px-3 py-2 flex items-center justify-between gap-2" style={{ background: "#0E1B17" }}>
                  <span>{e.name}{e.optional ? <span className="text-[10px] ml-1" style={{ color: C.accent }}>optional</span> : null}</span>
                  <span className="text-xs shrink-0" style={{ color: GROUP[e.group] || C.muted }}>{e.targetSets}×{e.targetReps}</span>
                </div>
              ))}
            </div>
          </div>
          );
        })}
      </div>

      <button onClick={() => onSave(preview)} className="w-full mt-5 rounded-2xl py-4 font-bold text-lg" style={{ background: C.accent, color: "#1A140A" }}>
        Diesen Plan speichern
      </button>
      <p className="text-[11px] mt-4 text-center" style={{ color: C.muted }}>Tage/Dauer oben anpassen · Aufteilung wählen · Sätze/Wdh richten sich nach deinem Ziel · Geräte/Übungen tauschst du später im Training.</p>
    </div>
  );
}

/* ---------- Manueller Plan-Builder ---------- */
// Namen aller Übungen, die der KI-Trainer zuletzt empfohlen hat (aus den change-Ops).
const aiRecommendedNames = (aiCoach) => {
  const set = new Set();
  ((aiCoach && aiCoach.suggestions) || []).forEach((s) => {
    const ch = s.change; if (!ch) return;
    if (ch.name) set.add(ch.name);
    if (ch.toName) set.add(ch.toName);
    (ch.exercises || []).forEach((e) => e && e.name && set.add(e.name));
  });
  return set;
};
// Vom KI-Trainer für die nächste Einheit betonte Übungen: nur die „mehr davon"-Seite
// (hinzufügen / neuer Tag / Ziel eines Tauschs) – bewusst ohne die „weg"-Seite von remove/replace,
// damit nichts bevorzugt wird, was der Coach reduzieren will. Abgelehnte Vorschläge zählen nicht.
const aiPriorityNames = (aiCoach) => {
  const set = new Set();
  ((aiCoach && aiCoach.suggestions) || []).forEach((s) => {
    if (s && s.status === "declined") return;
    const ch = s && s.change; if (!ch) return;
    if (ch.op === "add" && ch.name) set.add(ch.name);
    if (ch.op === "replace" && ch.toName) set.add(ch.toName);
    if (ch.op === "add_day") (ch.exercises || []).forEach((e) => e && e.name && set.add(e.name));
  });
  return set;
};
// Aus den priorisierten Übungsnamen des KI-Trainers die zu verstärkenden Muskeln ableiten:
// primäre Muskeln je Übung über EX_MUSCLES (Fallback: primaryMuscleOf für eigene Übungen).
// Diese Muskeln bekommen im Defizit-System ein angehobenes Zielvolumen.
const aiPriorityMuscles = (priority) => {
  const set = new Set();
  (priority ? [...priority] : []).forEach((name) => {
    const t = EX_MUSCLES[name];
    if (t && (t.p || []).length) { t.p.forEach((m) => set.add(m)); return; }
    const m = primaryMuscleOf(name);
    if (m) set.add(m);
  });
  return set;
};
// Optimale Übungsreihenfolge (ACSM/Erschöpfung): Verbundübungen vor Isolation,
// große vor kleinen Muskelgruppen, Rumpf/Core zuletzt (Stabilisator-Ermüdung vermeiden).
const ORDER_GROUP_RANK = { "Beine": 0, "Rücken": 1, "Brust": 2, "Schulter": 3, "Arme": 4, "Bauch": 5 };
const exerciseOrderScore = (it) => {
  if (it.group === "Bauch") return 3000; // Core immer zuletzt
  return (isCompound(it.name) ? 0 : 1000) + (ORDER_GROUP_RANK[it.group] != null ? ORDER_GROUP_RANK[it.group] : 5) * 10;
};
const orderByFatigue = (items) => (items || []).map((it, i) => ({ it, i }))
  .sort((a, b) => (exerciseOrderScore(a.it) - exerciseOrderScore(b.it)) || (a.i - b.i))
  .map((o) => o.it);

// Primärmuskel einer Übung (erster Muskel mit vollem Beteiligungsfaktor) – Basis für die
// Ausgewogenheit einzelner Muskeln innerhalb einer Gruppe (z. B. vordere vs. seitliche vs. hintere Schulter).
const primaryMuscleOf = (name, group) => {
  const inv = exerciseMuscleInvolvement({ name, group });
  return Object.keys(inv).find((m) => inv[m] >= 1) || null;
};
// Abschlag (in MEV-Einheiten, wie das Defizit), den ein Muskel je bereits gewählter Übung bekommt.
// ~1,5 MEV Vorsprung nötig, damit ein Muskel eine zweite Übung erhält – in der Praxis somit höchstens
// zwei je Muskel. Steuert diversifyByMuscle().
const DIVERSIFY_REPEAT_PENALTY = 1.5;
// Nach Präferenz sortierte Liste so umsortieren, dass unterschiedliche Primärmuskeln vorne stehen:
// je Muskel das beste Exercise zuerst, Präferenz-Reihenfolge bleibt Tiebreaker innerhalb eines Muskels.
// So deckt eine anschließende Top-n-Auswahl möglichst viele Muskeln ab, statt mehrfach denselben (z. B.
// nur vordere Schulter) zu wählen. Bereits abgedeckte Muskeln (covered, z. B. aus KI-Priorität oder
// anderen Blöcken) starten mit einer Vorbelegung und werden dadurch zurückgestellt.
// deficit (optional): {muskelId: Defizit-Score} aus muscleDeficitScores() – höherer Wert = weiter
// unter dem (mess-angepassten) Zielvolumen. Das Defizit priorisiert die Muskeln; ein Muskel mit
// deutlich höherem Defizit darf eine zweite Übung bekommen, bevor ein anderer seine erste erhält
// (defizit-basiert mit Abschlag, siehe unten – KEIN striktes Round-Robin).
const diversifyByMuscle = (sorted, covered, deficit) => {
  const def = (m) => (deficit && deficit[m] != null) ? deficit[m] : 0;
  const byMuscle = new Map(); const order = []; const noMuscle = [];
  (sorted || []).forEach((e) => {
    const m = primaryMuscleOf(e.n, e.g);
    if (!m) { noMuscle.push(e); return; }
    if (!byMuscle.has(m)) { byMuscle.set(m, []); order.push(m); }
    byMuscle.get(m).push(e);
  });
  const taken = new Map(order.map((m) => [m, (covered || []).includes(m) ? 1 : 0]));
  const out = [];
  let remaining = (sorted || []).length - noMuscle.length;
  // Defizit-basierte Auswahl mit Abschlag: je Runde gewinnt der Muskel mit dem höchsten
  // „Rest-Defizit" = Defizit − Abschlag·(schon gewählte Übungen dieses Muskels). Kein striktes
  // Round-Robin – ein Muskel mit deutlich höherem Defizit darf durchaus eine zweite Übung bekommen,
  // bevor ein anderer seine erste erhält. Der Abschlag (DIVERSIFY_REPEAT_PENALTY, in MEV-Einheiten
  // wie das Defizit) sorgt dafür, dass sich das erst ab einem klaren Defizit-Vorsprung lohnt (in der
  // Praxis höchstens zwei Übungen je Muskel). Bereits abgedeckte Muskeln (covered → taken 1) starten
  // mit einem Abschlag und werden dadurch zurückgestellt. Ohne Defizit-Map wird es reines Streuen.
  const adj = (m) => def(m) - taken.get(m) * DIVERSIFY_REPEAT_PENALTY;
  const better = (m, b) => adj(m) > adj(b);
  while (remaining > 0) {
    let best = null;
    order.forEach((m) => { if (!byMuscle.get(m).length) return; if (best === null || better(m, best)) best = m; });
    if (best === null) break;
    out.push(byMuscle.get(best).shift());
    taken.set(best, taken.get(best) + 1);
    remaining--;
  }
  return out.concat(noMuscle);
};

// Bewegungs-Familien: Übungen, die dieselbe Bewegung nur an einem anderen Gerät ausführen (Keiser/
// EGym/TRX/Maschinen-/Kabel-Varianten und bekannte Synonym-Paare wie Hip Thrust ↔ Glute Bridge).
// EX_ALIAS eignet sich dafür nicht – es bildet auf free-exercise-db-Bildnamen ab und trennt genau diese
// Varianten (Face Pulls→"face pull", TRX Face Pull fehlt; Hip Thrust/Glute Bridge/Hip Extension auf drei
// verschiedene Namen). Darum eine eigene, bewusst kuratierte Zuordnung: Übungen mit gleicher familyId
// gelten als quasi-identisch und sollen nicht gemeinsam in einem Training landen. Nicht gelistete
// Übungen bleiben eigenständig.
const EX_MOVEMENT = {
  "Brustpresse (Maschine)": "chest_press", "Keiser Brustpresse": "chest_press", "EGym Brustpresse": "chest_press", "TRX Brustpresse": "chest_press",
  "Pec Fly": "chest_fly", "Pec Fly sitzend Keiser": "chest_fly", "Keiser Pec Fly (oben)": "chest_fly", "Keiser Pec Fly (Mitte)": "chest_fly", "Keiser Pec Fly (unten)": "chest_fly", "EGym Butterfly": "chest_fly", "TRX Brustfliegende": "chest_fly",
  "Latzug (breit)": "lat_pulldown", "Latzug (eng)": "lat_pulldown", "Latzug Maschine": "lat_pulldown", "Keiser Latzug": "lat_pulldown", "EGym Latzug": "lat_pulldown",
  "Rudern am Kabel": "cable_row", "Maschinen-Rudern": "cable_row", "Keiser Kabel-Rudern": "cable_row", "EGym Rudern": "cable_row", "TRX Rudern": "cable_row",
  "Reverse Fly": "reverse_fly", "EGym Reverse Fly": "reverse_fly",
  "Schulterdrücken (Maschine)": "shoulder_press", "Keiser Schulterdrücken": "shoulder_press", "EGym Schulterpresse": "shoulder_press",
  "Seitheben": "lateral_raise", "Kabel-Seitheben": "lateral_raise", "Keiser Seitheben am Kabel": "lateral_raise",
  "Face Pulls": "face_pull", "TRX Face Pull": "face_pull",
  "Kabel-Curls": "biceps_curl_cable", "Keiser Bizeps-Curl": "biceps_curl_cable", "EGym Bizeps-Curl": "biceps_curl_cable", "TRX Bizeps-Curl": "biceps_curl_cable",
  "Trizeps Pushdown": "triceps_pushdown", "Trizeps Pushdown (Untergriff)": "triceps_pushdown", "Keiser Trizeps-Pushdown": "triceps_pushdown", "EGym Trizeps-Presse": "triceps_pushdown", "TRX Trizeps-Strecken": "triceps_pushdown",
  "Kniebeuge": "squat", "Keiser Kniebeuge": "squat", "TRX Kniebeuge": "squat",
  "Beinpresse": "leg_press", "Keiser Beinpresse": "leg_press", "EGym Beinpresse": "leg_press",
  "Beinstrecker": "leg_extension", "EGym Beinstrecker": "leg_extension",
  "Beinbeuger": "leg_curl", "Beinbeuger (sitzend)": "leg_curl", "EGym Beinbeuger": "leg_curl", "TRX Hamstring Curl": "leg_curl",
  "Hip Thrust": "hip_extension", "Glute Bridge": "hip_extension", "Keiser Hip Extension (Kabel)": "hip_extension", "EGym Glutes (Hip Extension)": "hip_extension", "TRX Hip Press": "hip_extension",
  "Abduktoren-Maschine": "abductor", "EGym Abduktoren": "abductor",
  "Crunch / Kabel-Crunch": "cable_crunch", "Keiser Kabel-Crunch": "cable_crunch", "EGym Bauchpresse": "cable_crunch",
  "Wadenheben": "calf_raise", "Wadenheben (Körpergewicht)": "calf_raise",
};
// Bewegungs-Schlüssel einer Übung. Für gelistete Varianten die familyId, sonst der Name selbst
// (eindeutig → wird nie fälschlich mit einer anderen Übung zusammengefasst).
const movementKey = (name) => EX_MOVEMENT[name] || name;
// Aus einer (nach Präferenz sortierten) Liste alle Übungen entfernen, deren Bewegung bereits vergeben
// ist (usedMv), und je Bewegungsfamilie nur die bestplatzierte behalten. Verhindert quasi-identische
// Übungen (z. B. Face Pulls + TRX Face Pull, Hip Thrust + Glute Bridge) im selben Training.
const dedupeByMovement = (sorted, usedMv) => {
  const seen = new Set(usedMv || []);
  const out = [];
  (sorted || []).forEach((e) => {
    const mv = movementKey(e.n);
    if (seen.has(mv)) return;
    seen.add(mv);
    out.push(e);
  });
  return out;
};

const targetMatches = (e, t) => t.group ? e.g === t.group
  : t.muscle ? (exerciseMuscleInvolvement({ name: e.n, group: e.g })[t.muscle] >= 1)
  : (t.tags ? (e.t || []).some((tg) => t.tags.includes(tg)) : false);
// Muskeln einer groben Gruppe (für die aufklappbare Einzelmuskel-Auswahl im Eigenen Tag).
const groupMuscles = (g) => Object.keys(MUSCLES).filter((m) => MUSCLES[m].grp === g);
// Ziel aus einer Auswahl-ID auflösen: grobe Gruppe (Brust, Beine …) ODER Einzelmuskel-ID (quads, biceps …).
const targetFromSelection = (id) => MUSCLES[id]
  ? { id, muscle: id, muscles: [id], colorGroup: MUSCLES[id].grp }
  : { id, group: id };
const selectionLabel = (id) => MUSCLES[id] ? muscleLabel(id) : id;
// Einzelnen Übungstag generieren: je gewähltem Ziel (grobe Gruppe ODER Einzelmuskel) perGroup Übungen
// aus erlaubten Quellen (ohne Dopplungen). Beim Eigenen Tag bewusst OHNE Volumen-Defizit-Priorisierung –
// die vom Nutzer gewählten Ziele bestimmen die Auswahl, nur innerhalb eines Ziels wird über die Muskeln
// gestreut (diversifyByMuscle ohne deficit).
const generateDayItems = ({ targets, cats, perGroup, profile, recommended }) => {
  const allowed = new Set(["kraft", ...(cats || [])]);
  const per = Math.max(1, Math.min(5, perGroup || 2));
  const rec = recommended || new Set();
  const out = [];
  const used = new Set();
  const usedMv = new Set(); // am selben Tag bereits vergebene Bewegungen – gegen quasi-identische Übungen
  const coveredMuscles = []; // am selben Tag bereits abgedeckte Primärmuskeln – für die Defizit-Streuung
  (targets || []).forEach((tid) => {
    const t = targetFromSelection(tid);
    if (!t) return;
    let pool = availableEx().filter((e) => targetMatches(e, t) && allowed.has(exCat(e)) && !used.has(e.n));
    const free = pool.filter((e) => !isAvoided({ name: e.n, group: e.g, muscle: e.m }, profile));
    if (free.length) pool = free;
    const sorted = pool.map((e) => ({ e, score: (rec.has(e.n) ? -3 : 0) + (isCompound(e.n) ? -1 : 0) }))
      .sort((a, b) => a.score - b.score || a.e.n.localeCompare(b.e.n)).map((o) => o.e);
    // Innerhalb des Ziels über die einzelnen Muskeln streuen (z. B. bei „Arme" Bizeps + Trizeps statt
    // 2× Bizeps); bereits am selben Tag abgedeckte Muskeln werden zurückgestellt. OHNE Defizit-Argument –
    // reines Streuen, kein Volumen-Defizit. Quasi-identische Bewegungen (usedMv) werden vorher entfernt,
    // damit z. B. nicht Face Pulls + TRX Face Pull erscheinen.
    diversifyByMuscle(dedupeByMovement(sorted, usedMv), coveredMuscles).slice(0, per).forEach((e) => {
      used.add(e.n); usedMv.add(movementKey(e.n));
      const pm = primaryMuscleOf(e.n, e.g); if (pm) coveredMuscles.push(pm);
      out.push({ name: e.n, group: e.g, muscle: e.m, targetSets: 3, targetReps: isTimedEx(e) ? "30-45 Sek" : (isCompound(e.n) ? "6-10" : "8-12"), id: uid() });
    });
  });
  return orderByFatigue(out); // optimale Reihenfolge anwenden
};

// Aufklappbare Auswahl grober Gruppen bzw. einzelner Muskeln – geteilt von „Eigener Tag" (PlanBuilder)
// und „Dynamisches Training". selected = Array aus groben Gruppen-IDs (MUSCLE_GROUPS) und/oder
// Einzelmuskel-IDs (Keys von MUSCLES). notes = Info-Text je Auswahl-ID (Volumen/Erholung).
// selected kann Gruppen-IDs ("Brust") UND/ODER Einzelmuskel-IDs ("triceps") enthalten.
// Gruppen-ID = ganze Gruppe aktiv, Einzelmuskel-IDs = nur diese Muskeln aktiv.
function MuscleTargetPicker({ selected, onToggle, notes }) {
  const sel = selected || [];
  const nts = notes || {};
  const [openGroup, setOpenGroup] = useState(null); // aufgeklappte Gruppe für die Einzelmuskel-Auswahl
  return (
    <div className="flex flex-col gap-1.5">
      {MUSCLE_GROUPS.map((g) => {
        const fullGroup = sel.includes(g); // ganze Gruppe gewählt
        const col = GROUP[g] || C.accent2;
        const muscles = groupMuscles(g);
        const open = openGroup === g;
        const subCount = muscles.filter((m) => sel.includes(m)).length;
        const active = fullGroup || subCount > 0; // irgendwas in der Gruppe ausgewählt
        return (
          <div key={g} className="rounded-xl overflow-hidden" style={{ background: active ? C.surface2 : C.surface, border: `1px solid ${active ? col : C.line}` }}>
            <div className="flex items-stretch">
              <button onClick={() => onToggle(g)} className="flex-1 min-w-0 px-3 py-2.5 flex items-center justify-between gap-2 text-left">
                <div className="flex items-center gap-2 min-w-0">
                  <span style={{ width: 9, height: 9, borderRadius: 99, background: col, display: "inline-block", opacity: active ? 1 : 0.4 }} />
                  <span className="font-bold text-sm" style={{ color: active ? C.text : C.muted }}>{g}</span>
                  {subCount > 0 && !fullGroup && <span className="text-[10px] font-bold rounded-full px-1.5 py-0.5 shrink-0" style={{ color: col, border: `1px solid ${col}` }}>{subCount}/{muscles.length}</span>}
                </div>
                <span className="text-[11px] shrink-0" style={{ color: C.muted }}>{nts[g]}</span>
              </button>
              <button onClick={() => setOpenGroup(open ? null : g)} title="Einzelne Muskeln" className="px-3 flex items-center text-sm" style={{ color: open ? C.accent2 : C.muted, borderLeft: `1px solid ${C.line}` }}>{open ? "▾" : "▸"}</button>
            </div>
            {open && (
              <div className="px-2.5 pb-2.5 pt-0.5 flex flex-col gap-1">
                {muscles.map((m) => {
                  const mon = fullGroup || sel.includes(m); // aktiv wenn Gruppe oder Einzelmuskel gewählt
                  return (
                    <button key={m} onClick={() => onToggle(m)} className="w-full rounded-lg px-3 py-2 flex items-center justify-between gap-2 text-left"
                      style={{ background: mon ? C.surface : "transparent", border: `1px solid ${mon ? col : C.line}` }}>
                      <div className="flex items-center gap-2 min-w-0">
                        <span style={{ width: 7, height: 7, borderRadius: 99, background: col, display: "inline-block", opacity: mon ? 1 : 0.35 }} />
                        <span className="text-sm truncate" style={{ color: mon ? C.text : C.muted }}>{muscleLabel(m)}</span>
                      </div>
                      <span className="text-[11px] shrink-0" style={{ color: C.muted }}>{nts[m]}</span>
                    </button>
                  );
                })}
                {fullGroup && <div className="text-[10px] px-1 pt-0.5" style={{ color: C.muted }}>Ganze Gruppe „{g}" ist gewählt. Einzelmuskel anklicken um ihn abzuwählen.</div>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function PlanBuilder({ existingPlan, profile, recommended, history, measurements, onBack, onSave, onDeleteDay, onRegisterCustom }) {
  const rec = recommended || new Set();
  // Info je Auswahl (grobe Gruppe ODER Einzelmuskel): Ist/Ziel-Wochenvolumen + Erholung.
  const targetNotes = useMemo(() => {
    const map = {};
    const volTargets = muscleVolumeTargets(measurements);
    MUSCLE_GROUPS.forEach((g) => {
      const vr = dayTargetVolRest({ group: g }, history);
      const grpTarget = groupMuscles(g).reduce((a, m) => a + (volTargets[m] || 0), 0);
      map[g] = formatVolRestNote({ ...vr, target: grpTarget });
    });
    Object.keys(MUSCLES).forEach((m) => {
      const vr = dayTargetVolRest({ muscles: [m] }, history);
      map[m] = formatVolRestNote({ ...vr, target: volTargets[m] });
    });
    return map;
  }, [history, measurements]);
  const [name, setName] = useState("");
  const [items, setItems] = useState([]);
  const [picking, setPicking] = useState(false);
  const [swapId, setSwapId] = useState(null);
  const [genGroups, setGenGroups] = useState([]);
  const [genCats, setGenCats] = useState({ egym: false, trx: false, keiser: false, cali: false });
  const [perGroup, setPerGroup] = useState(2);
  const toggleGroup = (g) => setGenGroups((x) => x.includes(g) ? x.filter((y) => y !== g) : [...x, g]);
  const generate = () => {
    if (!genGroups.length) return;
    const cats = Object.keys(genCats).filter((k) => genCats[k]);
    const result = generateDayItems({ targets: genGroups, cats, perGroup, profile, recommended: rec });
    setItems(result);
    if (!name.trim()) setName(genGroups.map(selectionLabel).join(" + "));
  };
  const add = (def) => {
    onRegisterCustom && onRegisterCustom(def);
    const made = { name: def.name, group: def.group, muscle: def.muscle || "", targetSets: 3, targetReps: isTimedEx(def) ? "30-45 Sek" : "8-12", id: uid() };
    if (swapId) {
      setItems((x) => x.map((e) => e.id === swapId ? { ...made, id: e.id, targetSets: e.targetSets, targetReps: e.targetReps } : e));
    } else {
      setItems((x) => [...x, made]);
    }
    setPicking(false); setSwapId(null);
  };
  const swap = (id) => { setSwapId(id); setPicking(true); };
  const remove = (id) => setItems((x) => x.filter((e) => e.id !== id));
  const reorder = () => setItems((x) => orderByFatigue(x));
  const editDay = (d) => {
    setName(d);
    setItems((existingPlan[d] || []).map((e) => ({ name: e.name, group: e.group, muscle: e.muscle || "", targetSets: e.targetSets || 3, targetReps: e.targetReps || "8-12", id: e.id || uid() })));
    if (typeof window !== "undefined" && window.scrollTo) window.scrollTo(0, 0);
  };
  const move = (id, dir) => setItems((x) => {
    const i = x.findIndex((e) => e.id === id); const j = i + dir;
    if (i < 0 || j < 0 || j >= x.length) return x;
    const n = [...x]; [n[i], n[j]] = [n[j], n[i]]; return n;
  });
  const setField = (id, k, v) => setItems((x) => x.map((e) => e.id === id ? { ...e, [k]: v } : e));
  const trimmed = name.trim();
  const exists = trimmed && existingPlan[trimmed];
  const canSave = trimmed.length > 0 && items.length > 0;
  const existingDays = Object.keys(existingPlan || {});

  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Eigener Trainingstag</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Tag bauen</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      {/* ----- Vorschlag generieren ----- */}
      <div className="rounded-2xl p-4 mb-5" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Vorschlag generieren</div>
        <div className="text-[11px] mb-2" style={{ color: C.muted }}>Muskelgruppen wählen – oder mit ▸ aufklappen und einzelne Muskeln gezielt anwählen:</div>
        <MuscleTargetPicker selected={genGroups} onToggle={toggleGroup} notes={targetNotes} />
        <div className="text-[11px] mt-3 mb-2" style={{ color: C.muted }}>Quellen einbeziehen:</div>
        <div className="flex flex-wrap gap-1.5">
          <span className="text-xs font-semibold rounded-full px-3 py-1.5" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>✓ Kraft</span>
          {[["egym", "EGym"], ["trx", "TRX"], ["keiser", "Keiser"], ["cali", "Calisthenics"]].map(([k, label]) => {
            const on = genCats[k];
            return (
              <button key={k} onClick={() => setGenCats((c) => ({ ...c, [k]: !c[k] }))} className="text-xs font-semibold rounded-full px-3 py-1.5"
                style={{ background: on ? C.accent : C.surface, color: on ? "#1A140A" : C.muted, border: `1px solid ${C.line}` }}>{on ? "✓ " : ""}{label}</button>
            );
          })}
        </div>
        <div className="flex items-center justify-between mt-3">
          <span className="text-[11px]" style={{ color: C.muted }}>Übungen pro Gruppe</span>
          <div className="flex items-center gap-2">
            <button onClick={() => setPerGroup((n) => Math.max(1, n - 1))} className="rounded-lg w-8 h-8 font-bold" style={{ color: C.muted, border: `1px solid ${C.line}` }}>−</button>
            <span className="font-bold w-5 text-center" style={{ ...NUM }}>{perGroup}</span>
            <button onClick={() => setPerGroup((n) => Math.min(5, n + 1))} className="rounded-lg w-8 h-8 font-bold" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>+</button>
          </div>
        </div>
        <button onClick={generate} disabled={!genGroups.length}
          className="w-full mt-3 rounded-xl py-3 font-bold disabled:opacity-40" style={{ background: C.accent2, color: "#0C1A15" }}>Vorschlag erstellen</button>
        <p className="text-[11px] mt-2" style={{ color: C.muted }}>🤖 = vom KI-Trainer zuletzt empfohlen (wird bevorzugt vorgeschlagen).</p>
      </div>

      <label className="block mb-4">
        <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Name des Tages</div>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="z.B. Push, Beine schwer, Ganzkörper …"
          className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />
        {exists ? <div className="text-[11px] mt-1" style={{ color: C.accent }}>„{trimmed}" existiert bereits – wird beim Speichern überschrieben.</div> : null}
      </label>

      <div className="flex items-center justify-between mb-2 gap-2">
        <div className="text-sm font-bold" style={{ color: C.text }}>Übungen ({items.length})</div>
        <div className="flex gap-1.5 shrink-0">
          {items.length > 1 && <button onClick={reorder} title="Nach optimaler Reihenfolge sortieren" className="text-xs font-semibold rounded-full px-3 py-1.5" style={{ background: C.surface, color: C.accent, border: `1px solid ${C.line}` }}>↕ Optimale Reihenfolge</button>}
          <button onClick={() => { setSwapId(null); setPicking(true); }} className="text-xs font-semibold rounded-full px-3 py-1.5" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>+ Übung</button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Noch keine Übung</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Tippe „+ Übung" und wähle aus dem Katalog.</div>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {items.map((e, idx) => (
            <div key={e.id} className="rounded-2xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="text-[10px] uppercase tracking-[0.18em] flex items-center gap-1.5">
                    <span style={{ width: 7, height: 7, borderRadius: 99, background: GROUP[e.group] || C.muted, display: "inline-block" }} />
                    <span style={{ color: GROUP[e.group] || C.muted }}>{e.group}</span>
                    {rec.has(e.name) && <span className="text-[9px] font-bold rounded px-1.5 py-0.5" style={{ color: "#1A140A", background: C.accent }}>🤖 KI</span>}
                  </div>
                  <div className="font-bold mt-0.5 truncate">{e.name}</div>
                </div>
                <div className="flex gap-1 shrink-0">
                  <button onClick={() => swap(e.id)} title="Alternative wählen" className="text-xs rounded-lg px-2 py-1" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>↺</button>
                  <button onClick={() => move(e.id, -1)} disabled={idx === 0} className="text-xs rounded-lg px-2 py-1" style={{ color: C.muted, border: `1px solid ${C.line}`, opacity: idx === 0 ? 0.4 : 1 }}>↑</button>
                  <button onClick={() => move(e.id, 1)} disabled={idx === items.length - 1} className="text-xs rounded-lg px-2 py-1" style={{ color: C.muted, border: `1px solid ${C.line}`, opacity: idx === items.length - 1 ? 0.4 : 1 }}>↓</button>
                  <button onClick={() => remove(e.id)} className="text-xs rounded-lg px-2 py-1" style={{ color: C.danger, border: `1px solid ${C.line}` }}>✕</button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <label className="block">
                  <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Sätze</div>
                  <input type="number" min="1" max="10" value={e.targetSets} onChange={(ev) => setField(e.id, "targetSets", Math.max(1, Math.min(10, parseInt(ev.target.value, 10) || 1)))}
                    className="w-full rounded-lg px-3 py-2 outline-none" style={{ background: "#0E1B17", color: C.text, border: `1px solid ${C.line}`, ...NUM }} />
                </label>
                <label className="block">
                  <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Wdh</div>
                  <input value={e.targetReps} onChange={(ev) => setField(e.id, "targetReps", ev.target.value)} placeholder="8-12"
                    className="w-full rounded-lg px-3 py-2 outline-none" style={{ background: "#0E1B17", color: C.text, border: `1px solid ${C.line}` }} />
                </label>
              </div>
            </div>
          ))}
        </div>
      )}

      <button onClick={() => canSave && onSave(trimmed, items)} disabled={!canSave}
        className="w-full mt-5 rounded-2xl py-4 font-bold text-lg disabled:opacity-40" style={{ background: C.accent, color: "#1A140A" }}>
        {exists ? "Tag überschreiben" : "Tag speichern"}
      </button>

      {existingDays.length > 0 && (
        <div className="mt-8">
          <div className="text-sm font-bold uppercase tracking-widest mb-2" style={{ color: C.accent }}>Vorhandene Tage</div>
          <div className="flex flex-col gap-2">
            {existingDays.map((d) => (
              <div key={d} className="rounded-xl p-3 flex items-center justify-between gap-2" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate">{d}</div>
                  <div className="text-xs" style={{ color: C.muted }}>{(existingPlan[d] || []).length} Übungen</div>
                </div>
                <div className="flex gap-1.5 shrink-0">
                  <button onClick={() => editDay(d)} className="text-xs font-semibold rounded-lg px-3 py-1.5" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Bearbeiten</button>
                  <button onClick={() => { if (window.confirm(`Trainingstag „${d}" löschen?`)) onDeleteDay(d); }} className="text-xs font-semibold rounded-lg px-3 py-1.5" style={{ color: C.danger, border: `1px solid ${C.line}` }}>Löschen</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {picking && <Picker mode={swapId ? "swap" : "add"} recommended={rec} onPick={add} onClose={() => { setPicking(false); setSwapId(null); }} />}
    </div>
  );
}

/* ---------- Dynamisches Training (KI-gestützt zusammengestellt) ---------- */
// Frisch bei jedem Öffnen: nutzt die vorhandenen KI-Trainer-Signale (empfohlene Übungen),
// das aktuelle Wochenvolumen, Push/Pull-Balance und die Erholung je Gruppe.
const DYN_DURATIONS = [
  { id: "kurz", label: "Kurz", per: 1, note: "1 Übung / Gruppe" },
  { id: "mittel", label: "Mittel", per: 2, note: "2 Übungen / Gruppe" },
  { id: "lang", label: "Lang", per: 3, note: "3 Übungen / Gruppe" },
];
// Bekannte Übungen: was der Nutzer schon trainiert hat (harte Sätze) oder aktuell im Plan hat.
const knownExerciseNames = (history, plan) => {
  const set = new Set();
  (history || []).filter((s) => !isCond(s)).forEach((s) =>
    (s.exercises || []).forEach((e) => { if ((e.sets || []).some(isWorkingSet)) set.add(e.name); }));
  Object.values(plan || {}).forEach((list) => (list || []).forEach((e) => e && e.name && set.add(e.name)));
  return set;
};
// Erholung: Tage seit letzter Belastung je Muskelgruppe (Infinity = nie belastet).
const daysSinceGroupTrained = (history) => {
  const last = {}; MUSCLE_GROUPS.forEach((g) => (last[g] = Infinity));
  const now = Date.now();
  (history || []).filter((s) => !isCond(s)).forEach((s) => {
    const days = (now - new Date(s.dateISO).getTime()) / 86400000;
    if (!(days >= 0)) return;
    const c = effectiveSetsByGroup([s]);
    MUSCLE_GROUPS.forEach((g) => { if ((c[g] || 0) > 0 && days < last[g]) last[g] = days; });
  });
  return last;
};
// Erholung muskelfein: Tage seit letzter Belastung je Einzelmuskel (Infinity/undefined = nie) – analog
// daysSinceGroupTrained, aber auf Muskel-Ebene für die feinen Ziele Bizeps/Trizeps/Po.
const daysSinceMuscleTrained = (history) => {
  const last = {};
  const now = Date.now();
  (history || []).forEach((s) => {
    const days = (now - new Date(s.dateISO).getTime()) / 86400000;
    if (!(days >= 0)) return;
    const c = effectiveSetsByMuscle([s]);
    Object.keys(c).forEach((mid) => { if (c[mid] > 0 && (last[mid] == null || days < last[mid])) last[mid] = days; });
  });
  return last;
};
// Erholung für den RUHEFILTER: Nur PRIMÄR-Belastung (Faktor ≥ 1) zählt, weil sekundäre
// Stimulation (z. B. Trizeps bei Bankdrücken, Faktor 0.5) keine volle 48-h-Erholung erfordert.
// KEINE Gruppen-Vererbung – Bizeps und Trizeps sind verschiedene Muskeln; nur weil Bizeps gestern
// trainiert wurde, heißt das nicht, dass Trizeps ebenfalls ruhen muss. Die korrekte Zuordnung
// (z. B. Schrägbank → chest_up statt allg. chest) liegt in den EX_MUSCLES-Mappings.
// WICHTIG: Nutzt NICHT exerciseMuscleInvolvement(), weil dessen GROUP_DEFAULT_MUSCLES-Fallback
// bei Custom-Übungen alle Muskeln einer Gruppe (z. B. Bizeps UND Trizeps für "Arme") als primär
// markieren würde. Stattdessen: nur explizite Mappings (EX_MUSCLES oder KI-Zuordnung) auswerten.
const daysSinceMusclePrimaryTrained = (history) => {
  const last = {};
  const now = Date.now();
  (history || []).forEach((s) => {
    if (isCond(s)) return;
    const days = (now - new Date(s.dateISO).getTime()) / 86400000;
    if (!(days >= 0)) return;
    (s.exercises || []).forEach((e) => {
      const n = (e.sets || []).filter(isWorkingSet).length;
      if (!n) return;
      // Primäre Muskeln OHNE GROUP_DEFAULT-Fallback ermitteln:
      const t = EX_MUSCLES[e.name];
      let primary;
      if (t) {
        primary = t.p || [];
      } else {
        const c = find(e.name);
        if (c && c.inv && (c.inv.p || []).some((m) => MUSCLES[m])) {
          primary = (c.inv.p || []).filter((m) => MUSCLES[m]);
        } else {
          // Kein explizites Mapping → Übung ignorieren (kein Gruppen-Fallback!)
          return;
        }
      }
      primary.forEach((mid) => {
        if (last[mid] == null || days < last[mid]) last[mid] = days;
      });
    });
  });
  return last;
};
// Ist-Volumen (rollierende 7 Tage) + Erholung für ein Tag-Ziel: grobe Gruppe ODER feines
// Ziel (Bizeps/Trizeps/Po). Rollierende 7 Tage statt Kalenderwoche, damit montags nicht
// alles auf 0 springt. Feine Ziele summieren die effektiven Sätze ihrer Muskeln und nehmen
// die kürzeste Pause (zuletzt belasteter Muskel).
const dayTargetVolRest = (target, history) => {
  const sessions = sessionsInLastDays(history, 7);
  if (target.group) {
    return { vol: effectiveSetsByGroup(sessions)[target.group] || 0, rest: daysSinceGroupTrained(history)[target.group] };
  }
  const muscles = target.muscles || [];
  const byM = effectiveSetsByMuscle(sessions);
  const since = daysSinceMuscleTrained(history);
  const vol = muscles.reduce((a, mid) => a + (byM[mid] || 0), 0);
  const rest = muscles.reduce((a, mid) => Math.min(a, since[mid] != null ? since[mid] : Infinity), Infinity);
  return { vol, rest };
};
// Einheitlicher Info-Text für die Ziel-Buttons, z. B. „5/6 Sätze/Wo. · 2 T. Pause".
// Wenn target übergeben wird: „Ist/Ziel Sätze/Wo.", sonst nur „Ist Sätze/Wo.".
const formatVolRestNote = ({ vol, rest, target }) => {
  const volText = target != null
    ? `${fmtSets(vol)}/${fmtSets(Math.round(target))} Sätze/Wo.`
    : (vol === 0 ? "0 Sätze/Wo." : `${fmtSets(vol)} Sätze/Wo.`);
  const parts = [volText];
  if (rest === Infinity || rest == null) parts.push("noch nie");
  else if (rest >= 1) parts.push(`${Math.round(rest)} T. Pause`);
  else parts.push("frisch belastet");
  return parts.join(" · ");
};
// Mindest-Erholungsdauer in Tagen. Muskeln, die innerhalb dieser Frist trainiert wurden, gelten als
// „in Ruhepause" und werden weder vorausgewählt noch bei der Übungsauswahl als Ziel berücksichtigt.
// Übungen, die einen ruhenden Muskel auch nur sekundär belasten, werden ebenfalls ausgefiltert.
const MIN_MUSCLE_REST_DAYS = 2; // ≈ 48 h

// Vorauswahl fürs dynamische Training – EINZELMUSKEL-BASIERT mit Erholungsfilter.
// Vorausgewählt werden alle Einzelmuskeln, die (a) ein echtes Defizit haben (Score > 0) UND
// (b) nicht in Ruhepause sind (≥ MIN_MUSCLE_REST_DAYS seit der letzten Primär-Belastung oder
// noch nie trainiert). Ergebnis: Array von Muskel-IDs (z. B. ["triceps", "forearm", "chest_up"]).
// Die UI gruppiert diese IDs visuell in ihre Muskelgruppen; buildDynamicSession konsolidiert
// sie für die Übungsauswahl (per Gruppe × Dauer, diversifyByMuscle wählt dann gezielt die
// defizitären Muskeln aus).
// Fallback: alle Muskeln der 2 Gruppen mit der längsten durchschnittlichen Pause.
const dynamicDeficitSelection = (deficit, history) => {
  const since = daysSinceMusclePrimaryTrained(history);
  const isResting = (m) => since[m] != null && since[m] < MIN_MUSCLE_REST_DAYS;
  const restingSet = new Set(Object.keys(MUSCLES).filter(isResting));
  // Prüft ob mindestens eine verfügbare Übung diesen Muskel primär trainiert,
  // ohne dabei einen ruhenden Muskel zu belasten.
  const hasViableExercise = (mid) => availableEx().some((e) => {
    const inv = exerciseMuscleInvolvement({ name: e.n, group: e.g });
    return (inv[mid] || 0) >= 1 && !Object.keys(inv).some((m) => restingSet.has(m));
  });
  // Alle Einzelmuskeln die (a) Defizit haben, (b) nicht in Ruhepause sind UND
  // (c) mindestens eine Übung existiert die sie isoliert trainierbar macht.
  const picks = Object.keys(MUSCLE_VOLUME_TARGETS).filter((m) =>
    (deficit[m] || 0) > 0 && !isResting(m) && hasViableExercise(m)
  );
  if (picks.length > 0) return picks;
  // Fallback: alle Muskeln der 2 Gruppen mit der längsten durchschnittlichen Pause.
  return MUSCLE_GROUPS.map((g) => {
    const ms = groupMuscles(g);
    const avg = ms.reduce((a, m) => a + (since[m] != null ? since[m] : 999), 0) / (ms.length || 1);
    return { g, avg };
  }).sort((a, b) => b.avg - a.avg).slice(0, 2).flatMap((x) => groupMuscles(x.g));
};
const dynItem = (e, isNew) => ({
  name: e.n, group: e.g, muscle: e.m, targetSets: 3,
  targetReps: isTimedEx({ name: e.n }) ? "30-45 Sek" : (isCompound(e.n) ? "6-10" : "8-12"),
  cat: exCat(e), isNew: !!isNew, id: uid(),
});
// Aus einer nach Priorität sortierten Liste n Einträge wählen, per Variante rotiert
// (gibt „Andere Auswahl" Abwechslung, ohne die Top-Kandidaten zu verlassen).
const rotatePick = (sorted, n, variant) => {
  if (sorted.length <= n) return sorted;
  const short = sorted.slice(0, Math.min(sorted.length, Math.max(n + 2, n * 2)));
  const off = ((variant || 0) % short.length + short.length) % short.length;
  return short.slice(off).concat(short.slice(0, off)).slice(0, n);
};
// Zusammenstellen: je Gruppe die schwächsten Muskeln (höchstes Defizit) gezielt trainieren,
// dabei Muskeln in Ruhepause (< MIN_MUSCLE_REST_DAYS) und Übungen, die ruhende Muskeln belasten,
// komplett auslassen. Anzahl pro Gruppe = Dauer (kurz 1 / mittel 2 / lang 3), ACSM-sortiert.
const buildDynamicSession = ({ groups, perGroup, known, profile, recommended, priority, variant, deficit, excludedCats, history }) => {
  const per = Math.max(1, Math.min(3, perGroup || 2));
  const kn = known || new Set(), rec = recommended || new Set(), prio = priority || new Set();
  const chosen = [], used = new Set(), usedMv = new Set();
  // Ruhende Muskeln bestimmen (< 48 h seit letzter PRIMÄR-Belastung).
  const since = daysSinceMusclePrimaryTrained(history);
  const resting = new Set(Object.keys(MUSCLES).filter((m) => since[m] != null && since[m] < MIN_MUSCLE_REST_DAYS));
  // Prüft, ob eine Übung KEINEN ruhenden Muskel belastet (weder primär noch sekundär).
  const sparesResting = (e) => {
    const inv = exerciseMuscleInvolvement({ name: e.n, group: e.g });
    return !Object.keys(inv).some((m) => resting.has(m));
  };
  // ---------- Konsolidierung: Einzelmuskel-IDs → Gruppen-Targets ----------
  // groups kann Gruppen-IDs ("Brust") UND/ODER Einzelmuskel-IDs ("triceps") enthalten.
  // Für die Übungsauswahl werden Einzelmuskel-IDs derselben Gruppe zu EINEM Gruppen-Target
  // zusammengefasst (damit die Übungszahl pro Gruppe korrekt bleibt: perGroup, nicht per Muskel).
  // Nicht-gewählte Muskeln innerhalb einer solchen Gruppe bekommen Defizit −∞, sodass
  // diversifyByMuscle nur Übungen für die gewählten Muskeln priorisiert.
  const selMuscles = new Set((groups || []).filter((id) => MUSCLES[id]));       // Einzelmuskel-IDs
  const selGroups = new Set((groups || []).filter((id) => !MUSCLES[id]));       // Gruppen-IDs
  const groupsFromMuscles = new Set();
  selMuscles.forEach((m) => { if (MUSCLES[m]) groupsFromMuscles.add(MUSCLES[m].grp); });
  // Konsolidierte Gruppe: entweder direkt gewählt ODER aus Einzelmuskeln abgeleitet (ohne Duplikate).
  const consolidatedGroups = [...selGroups];
  groupsFromMuscles.forEach((g) => { if (!selGroups.has(g)) consolidatedGroups.push(g); });
  // Defizit-Map: ruhende Muskeln UND nicht-gewählte Muskeln (in Gruppen mit Einzelauswahl) auf −∞.
  const deficitActive = {};
  Object.keys(deficit || {}).forEach((m) => {
    if (resting.has(m)) { deficitActive[m] = -Infinity; return; }
    const grp = MUSCLES[m] && MUSCLES[m].grp;
    // Gruppe wurde über Einzelmuskeln ausgewählt, aber DIESER Muskel ist nicht dabei → unterdrücken.
    if (grp && !selGroups.has(grp) && groupsFromMuscles.has(grp) && !selMuscles.has(m)) {
      deficitActive[m] = -Infinity;
    } else {
      deficitActive[m] = deficit[m] || 0;
    }
  });
  // Effektiver Pool: wenn excludedCats übergeben (DynamicTraining), diesen statt des globalen EXCLUDED_CATS nutzen.
  const basePool = excludedCats !== undefined ? allEx().filter((e) => !excludedCats.includes(exCat(e))) : availableEx();
  // KI-Priorität am stärksten, dann bereits Bekanntes, dann sonstige Empfehlungen, Verbundübungen leicht bevorzugt.
  const pref = (e) => (prio.has(e.n) ? -6 : 0) + (kn.has(e.n) ? -4 : 0) + (rec.has(e.n) ? -2 : 0) + (isCompound(e.n) ? -1 : 0);
  // Konsolidierte Gruppen-Targets (Gruppen-IDs → group-Target über targetFromSelection).
  const targets = consolidatedGroups.map((id) => targetFromSelection(id)).filter(Boolean);
  targets.forEach((t) => {
    // Pool: passende Übungen, die KEINE ruhenden Muskeln belasten.
    let pool = basePool.filter((e) => targetMatches(e, t) && !used.has(e.n) && sparesResting(e));
    // Fallback: wenn weniger als `per` Treffer überleben (weil Übungen der Gruppe ruhende Muskeln
    // sekundär belasten), wird die Ruhefilterung für diese Gruppe gelockert, damit die gewünschte
    // Anzahl pro Gruppe (per) erreicht werden kann und die Gruppe nicht unterbesetzt bleibt.
    if (pool.length < per) pool = basePool.filter((e) => targetMatches(e, t) && !used.has(e.n));
    const free = pool.filter((e) => !isAvoided({ name: e.n, group: e.g, muscle: e.m }, profile));
    if (free.length) pool = free;
    const picks = [];
    const take = (e) => { picks.push(e); usedMv.add(movementKey(e.n)); };
    // 1) Vom KI-Trainer priorisierte Übungen dieser Gruppe zuerst.
    dedupeByMovement(pool.filter((e) => prio.has(e.n)).sort((a, b) => pref(a) - pref(b) || a.n.localeCompare(b.n)), usedMv)
      .slice(0, per).forEach(take);
    // 2) Restliche Plätze über den vollen Pool, Muskel-Priorisierung nach Defizit (ruhende
    //    Muskeln mit −∞ unterdrückt → diversifyByMuscle wählt sie nie als Ziel).
    if (picks.length < per) {
      const rest = per - picks.length;
      const remain = pool.filter((e) => !picks.includes(e));
      const sorted = remain.map((e) => ({ e, s: pref(e) }))
        .sort((a, b) => a.s - b.s || a.e.n.localeCompare(b.e.n)).map((o) => o.e);
      const covered = picks.map((e) => primaryMuscleOf(e.n, e.g)).filter(Boolean);
      rotatePick(diversifyByMuscle(dedupeByMovement(sorted, usedMv), covered, deficitActive), rest, variant).forEach(take);
    }
    // 3) Auffüllen ohne Bewegungs-Dedup, falls durch Dedup zu wenige Übungen.
    if (picks.length < per) {
      const need = per - picks.length;
      pool.filter((e) => !picks.includes(e))
        .sort((a, b) => pref(a) - pref(b) || a.n.localeCompare(b.n))
        .slice(0, need).forEach(take);
    }
    // 4) Letzter Fallback: auch Übungen erlauben, die ruhende Muskeln belasten.
    if (picks.length < per) {
      const need = per - picks.length;
      basePool.filter((e) => targetMatches(e, t) && !used.has(e.n) && !picks.includes(e))
        .filter((e) => !isAvoided({ name: e.n, group: e.g, muscle: e.m }, profile))
        .sort((a, b) => pref(a) - pref(b) || a.n.localeCompare(b.n))
        .slice(0, need).forEach(take);
    }
    picks.forEach((e) => { used.add(e.n); chosen.push(dynItem(e, false)); });
  });
  // Neue Vorschläge – ebenfalls ohne Übungen, die ruhende Muskeln belasten.
  const newPool = basePool.filter((e) => targets.some((t) => targetMatches(e, t)) && !used.has(e.n) && !kn.has(e.n)
    && !isAvoided({ name: e.n, group: e.g, muscle: e.m }, profile) && sparesResting(e));
  const sortedNew = dedupeByMovement(newPool.map((e) => ({ e, s: (prio.has(e.n) ? -5 : 0) + (rec.has(e.n) ? -3 : 0) + (isCompound(e.n) ? -1 : 0) }))
    .sort((a, b) => a.s - b.s || a.e.n.localeCompare(b.e.n)).map((o) => o.e), usedMv);
  const coveredChosen = chosen.map((it) => primaryMuscleOf(it.name, it.group)).filter(Boolean);
  const suggestions = rotatePick(diversifyByMuscle(sortedNew, coveredChosen, deficitActive), per, variant).map((e) => { used.add(e.n); usedMv.add(movementKey(e.n)); return dynItem(e, true); });
  return orderByFatigue([...chosen, ...suggestions]);
};

function DynamicTraining({ history, profile, plan, aiCoach, measurements, dyn, onChange, onBack, onStart, onOpenDetail }) {
  const known = useMemo(() => knownExerciseNames(history, plan), [history, plan]);
  const recommended = useMemo(() => aiRecommendedNames(aiCoach), [aiCoach]);
  const priority = useMemo(() => aiPriorityNames(aiCoach), [aiCoach]);
  // Volumen-Defizit je Einzelmuskel (Ist der letzten 7 Tage vs. mess-angepasstes MEV/MAV-Ziel).
  // Muskeln mit dem größten Defizit werden bei der Auswahl bevorzugt; vom KI-Trainer empfohlene
  // Muskeln (aiPriorityMuscles) bekommen einen Tie-Breaker-Bonus (+0.5 MEV-Einheiten).
  const deficit = useMemo(() => muscleDeficitScores(history, measurements, aiPriorityMuscles(priority)), [history, measurements, priority, profile && profile.countSecondary]);
  // Ref verhindert, dass die Erstbefüllung ein zweites Mal läuft (z. B. bei React-Strict-Mode-
  // Double-Invoke oder wenn dyn sich durch regen ändert und der Effekt erneut triggert).
  const dynInitRef = React.useRef(false);
  // Erstbefüllung, wenn noch keine dynamische Auswahl existiert: alle Gruppen mit trainierbar-
  // defizitären Muskeln vorausgewählt (dynamicDeficitSelection mit Erholungsfilter).
  // Sobald der User die Auswahl manuell ändert, greift dieser Effekt NICHT mehr ein.
  useEffect(() => {
    if (dyn || dynInitRef.current) return;
    dynInitRef.current = true;
    const groups = dynamicDeficitSelection(deficit, history), duration = "mittel", variant = 0;
    const ec = [...EXCLUDED_CATS];
    onChange({ groups, duration, variant, excludedCats: ec, items: buildDynamicSession({ groups, perGroup: 2, known, profile, recommended, priority, variant, deficit, excludedCats: ec, history }) });
  }, [dyn]);
  // Info je Auswahl (grobe Gruppe ODER Einzelmuskel): Ist-Wochenvolumen + Erholung – dieselbe Logik
  // wie im Eigenen Tag. MUSS vor dem frühen Return stehen, damit die Hook-Reihenfolge über alle Renders
  // stabil bleibt (Rules of Hooks).
  const targetNotes = useMemo(() => {
    const map = {};
    const volTargets = muscleVolumeTargets(measurements);
    MUSCLE_GROUPS.forEach((g) => {
      const vr = dayTargetVolRest({ group: g }, history);
      const grpTarget = groupMuscles(g).reduce((a, m) => a + (volTargets[m] || 0), 0);
      map[g] = formatVolRestNote({ ...vr, target: grpTarget });
    });
    Object.keys(MUSCLES).forEach((m) => {
      const vr = dayTargetVolRest({ muscles: [m] }, history);
      map[m] = formatVolRestNote({ ...vr, target: volTargets[m] });
    });
    return map;
  }, [history, measurements]);

  if (!dyn) return null; // wird durch den Effekt gleich befüllt

  const { groups, duration, variant, items, excludedCats } = dyn;
  // Neu zusammenstellen und nach oben (App-State) melden. Manuelle Tausche in der Detailseite bleiben erhalten,
  // solange man die Auswahl (Dauer/Gruppen/Variante) nicht ändert.
  const regen = (patch) => {
    const g = patch.groups !== undefined ? patch.groups : groups;
    const dur = patch.duration !== undefined ? patch.duration : duration;
    const v = patch.variant !== undefined ? patch.variant : variant;
    const ec = patch.excludedCats !== undefined ? patch.excludedCats : (excludedCats || []);
    const p = (DYN_DURATIONS.find((d) => d.id === dur) || DYN_DURATIONS[1]).per;
    onChange({ groups: g, duration: dur, variant: v, excludedCats: ec, items: buildDynamicSession({ groups: g, perGroup: p, known, profile, recommended, priority, variant: v, deficit, excludedCats: ec, history }) });
  };
  const toggle = (id) => {
    const isGroup = MUSCLE_GROUPS.includes(id);
    let next;
    if (isGroup) {
      const ms = groupMuscles(id);
      const hasAnything = groups.includes(id) || ms.some((m) => groups.includes(m));
      // Gruppe hat aktive Einträge → alles abwählen; sonst → ganze Gruppe anwählen.
      next = hasAnything
        ? groups.filter((x) => x !== id && !ms.includes(x))
        : [...groups, id];
    } else {
      // Einzelmuskel-Toggle.
      const grp = MUSCLES[id] && MUSCLES[id].grp;
      if (grp && groups.includes(grp)) {
        // Ganze Gruppe war gewählt → zu Einzelauswahl konvertieren (alle AUSSER dem geklickten).
        const ms = groupMuscles(grp);
        next = groups.filter((x) => x !== grp).concat(ms.filter((m) => m !== id));
      } else if (groups.includes(id)) {
        // Muskel war individuell gewählt → abwählen.
        next = groups.filter((x) => x !== id);
      } else {
        // Muskel war nicht gewählt → anwählen.
        next = [...groups, id];
      }
    }
    regen({ groups: next });
  };
  const toggleCat = (cat) => {
    const ec = excludedCats || [];
    regen({ excludedCats: ec.includes(cat) ? ec.filter((c) => c !== cat) : [...ec, cat] });
  };
  const newCount = items.filter((e) => e.isNew).length;
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>🤖 Dynamisches Training</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Frisch zusammengestellt</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
        <div className="text-sm" style={{ color: C.text }}>Vorausgewählt sind die Muskeln mit dem größten Volumen-Defizit (Ist der letzten 7 Tage vs. Zielvolumen) – vorrangig aus Übungen, die du schon machst, plus neue Vorschläge zum Ausprobieren. Du kannst die Auswahl unten frei anpassen.</div>
        {aiCoach && aiCoach.generatedAt && <div className="text-[11px] mt-2" style={{ color: C.muted }}>KI-Trainer-Stand: {fmtDate(aiCoach.generatedAt)}</div>}
      </div>

      <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Dauer</div>
      <div className="flex gap-2 mb-4">
        {DYN_DURATIONS.map((d) => {
          const on = duration === d.id;
          return (
            <button key={d.id} onClick={() => regen({ duration: d.id })} className="flex-1 rounded-xl py-2.5"
              style={{ background: on ? C.accent : C.surface, color: on ? "#1A140A" : C.muted, border: `1px solid ${on ? C.accent : C.line}` }}>
              <div className="text-sm font-bold">{d.label}</div>
              <div className="text-[10px] font-semibold mt-0.5" style={{ opacity: 0.85 }}>{d.note}</div>
            </button>
          );
        })}
      </div>

      {DEVICE_CATS.length > 0 && (<>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Gerätekategorien</div>
        <div className="text-[11px] mb-2" style={{ color: C.muted }}>Deaktivierte Kategorien werden aus den Vorschlägen ausgeschlossen.</div>
        <div className="flex flex-wrap gap-2 mb-4">
          {DEVICE_CATS.map((cat) => {
            const on = !(excludedCats || []).includes(cat);
            const count = allEx().filter((e) => exCat(e) === cat).length;
            return (
              <button key={cat} onClick={() => toggleCat(cat)} className="rounded-xl px-3 py-2 flex items-center gap-1.5"
                style={{ background: on ? C.surface2 : C.surface, border: `1px solid ${on ? C.accent2 : C.line}`, opacity: on ? 1 : 0.55 }}>
                <span className="text-sm font-bold" style={{ color: on ? C.text : C.muted }}>{CAT_LABEL[cat] || cat}</span>
                <span className="text-[10px]" style={{ color: C.muted }}>{count}</span>
              </button>
            );
          })}
        </div>
      </>)}

      <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Muskelgruppen <span style={{ color: C.muted }}>· vorausgewählt nach Defizit</span></div>
      <div className="text-[11px] mb-2" style={{ color: C.muted }}>Vorausgewählt sind die Muskeln mit dem größten Volumen-Defizit. Mit ▸ aufklappen und einzelne Muskeln gezielt an-/abwählen.</div>
      <div className="mb-4">
        <MuscleTargetPicker selected={groups} onToggle={toggle} notes={targetNotes} />
      </div>

      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-bold" style={{ color: C.text }}>Vorschlag ({items.length} Übungen{newCount ? ` · ${newCount} neu` : ""})</div>
        <button onClick={() => regen({ variant: variant + 1 })} disabled={!groups.length} className="text-xs font-semibold rounded-full px-3 py-1.5 disabled:opacity-40" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>🔄 Andere Auswahl</button>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Keine Gruppe gewählt</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Wähle oben mindestens eine Muskelgruppe.</div>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {items.map((e) => (
            <div key={e.id} className="rounded-2xl p-3 flex items-center justify-between gap-2" style={{ background: C.surface, border: `1px solid ${e.isNew ? C.accent : C.line}` }}>
              <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-[0.18em] flex items-center gap-1.5 flex-wrap">
                  <span style={{ width: 7, height: 7, borderRadius: 99, background: GROUP[e.group] || C.muted, display: "inline-block" }} />
                  <span style={{ color: GROUP[e.group] || C.muted }}>{e.group}</span>
                  {e.cat && e.cat !== "kraft" && e.cat !== "custom" && <span style={{ color: C.muted }}>· {CAT_LABEL[e.cat] || e.cat}</span>}
                  {e.isNew
                    ? <span className="text-[9px] font-bold rounded px-1.5 py-0.5" style={{ color: "#1A140A", background: C.accent }}>🆕 NEU</span>
                    : (recommended.has(e.name) ? <span className="text-[9px] font-bold rounded px-1.5 py-0.5" style={{ color: "#0C1A15", background: C.accent2 }}>🤖 KI</span> : null)}
                </div>
                <div className="font-bold mt-0.5 truncate">{e.name}</div>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <span className="text-xs font-semibold rounded-full px-3 py-1" style={{ background: C.surface2, color: C.accent2, ...NUM }}>{e.targetSets}×{e.targetReps}</span>
                <button onClick={() => onOpenDetail(e)} title="Details & Alternative" className="text-xs rounded-lg px-2 py-1" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>ⓘ Info</button>
              </div>
            </div>
          ))}
        </div>
      )}

      <button onClick={() => items.length && onStart(items)} disabled={!items.length} className="w-full mt-5 rounded-2xl py-4 font-bold text-lg disabled:opacity-40" style={{ background: C.accent, color: "#1A140A" }}>Training starten</button>
      <p className="text-[11px] mt-3 text-center" style={{ color: C.muted }}>🆕 = neue Übung zum Ausprobieren · ⓘ für Details &amp; Alternative · Übungen im Training jederzeit tauschbar.</p>
    </div>
  );
}

/* ---------- Profile ---------- */
function ProfileEditor({ profile, onBack, onSave, sbToken, onWithings, onManageExercises }) {
  const [form, setForm] = useState(profile);
  const [withingsConnected, setWithingsConnected] = useState(null);
  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));
  const numberSet = (key, value, min, max) => {
    const n = Math.max(min, Math.min(max, parseInt(value, 10) || min));
    set(key, n);
  };

  useEffect(() => {
    if (!sbToken) return;
    const sbClient = window.supabase.createClient(SB_URL, SB_ANON_KEY, {
      global: { headers: { Authorization: `Bearer ${sbToken}` } },
      db: { schema: "trainer" },
      auth: { persistSession: false, autoRefreshToken: false },
    });
    sbClient.from("withings_tokens").select("withings_userid").maybeSingle()
      .then(({ data }) => setWithingsConnected(!!data))
      .catch(() => setWithingsConnected(false));
  }, [sbToken]);
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-5 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Profil</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>{form.name}</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <div className="flex flex-col gap-4">
        <ProfileSelect label="Trainingsziel" value={form.goal} options={PROFILE_GOALS} onChange={(v) => set("goal", v)} />
        <ProfileSelect label="Erfahrung" value={form.experience} options={EXPERIENCE_LEVELS} onChange={(v) => set("experience", v)} />
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Tage/Woche</div>
            <select value={form.trainingDays} onChange={(e) => set("trainingDays", Number(e.target.value))}
              className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }}>
              {[1,2,3,4,5,6,7].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </label>
          <ProfileInput label="Minuten/Einheit" type="number" min="20" max="180" value={form.sessionMinutes} onChange={(v) => numberSet("sessionMinutes", v, 20, 180)} />
        </div>
        {form.trainingDays >= 4 && form.trainingDays <= 5 && (
          <div className="text-[11px] -mt-2" style={{ color: C.muted }}>Bei 4–5 Tagen wird der letzte Trainingstag im Plan als „optional" gekennzeichnet – er kann bei Zeitmangel entfallen.</div>
        )}
        <ProfileTextarea label="Einschränkungen / Beschwerden" placeholder="z.B. Schulter, Knie, Rücken, Arzt-Hinweise" value={form.restrictions} onChange={(v) => set("restrictions", v)} />
        <ProfileTextarea label="Bevorzugte Übungen" placeholder="Übungen oder Geräte, die gut funktionieren" value={form.preferredExercises} onChange={(v) => set("preferredExercises", v)} />
        <ProfileTextarea label="Vermeiden / ungeliebte Übungen" placeholder="Übungen, Geräte oder Bewegungen, die raus sollen" value={form.avoidedExercises} onChange={(v) => set("avoidedExercises", v)} />
        <ProfileTextarea label="Notizen für den Trainer" placeholder="Alles, was die App später berücksichtigen soll" value={form.notes} onChange={(v) => set("notes", v)} />
      </div>

      {onManageExercises && (
        <button onClick={onManageExercises} className="w-full text-left mt-4 rounded-2xl p-4" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>Übungen</div>
              <div className="font-bold mt-1">Übungen verwalten</div>
              <div className="text-xs mt-1" style={{ color: C.muted }}>Umbenennen, löschen, anlegen und vom Auto-Plan ausnehmen</div>
            </div>
            <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Öffnen</span>
          </div>
        </button>
      )}

      <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Volumen-Zählung</div>
        <label className="flex items-center justify-between gap-3 cursor-pointer">
          <div>
            <div className="font-bold text-sm">Sekundäre Muskelbeteiligung zählen</div>
            <div className="text-xs mt-0.5" style={{ color: C.muted }}>
              Bei Verbundübungen zählen mitbeanspruchte Muskeln anteilig ins Wochenvolumen (große Muskeln 0,25 Sätze, kleine gar nicht). Standard: aus.
            </div>
          </div>
          <input type="checkbox" checked={form.countSecondary === true} onChange={(e) => set("countSecondary", e.target.checked)}
            className="w-5 h-5 shrink-0" style={{ accentColor: C.accent }} />
        </label>
      </div>

      <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="font-bold">Warum das wichtig ist</div>
        <p className="text-sm mt-1" style={{ color: C.muted }}>Aus diesen Profilen erzeugen wir später den passenden Plan, Volumen-Ziele, Übungsalternativen und Coach-Hinweise getrennt für Petja und Panda.</p>
      </div>

      {onWithings && (
        <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Withings / Körperkomposition</div>
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="font-bold text-sm">Withings Body Scan</div>
              <div className="text-xs mt-0.5" style={{ color: C.muted }}>
                {withingsConnected === null ? "Prüfe Verbindung…" : withingsConnected ? "Verbunden — Messungen werden synchronisiert" : "Noch nicht verbunden"}
              </div>
            </div>
            <button onClick={onWithings} className="text-sm font-semibold rounded-xl px-4 py-2" style={{ background: C.accent, color: "#0C1A15", whiteSpace: "nowrap" }}>
              {withingsConnected ? "Verwalten" : "Verbinden"}
            </button>
          </div>
        </div>
      )}

      <button onClick={() => onSave(form)} className="w-full mt-5 rounded-2xl py-4 font-bold text-lg" style={{ background: C.accent, color: "#1A140A" }}>
        Profil speichern
      </button>
    </div>
  );
}
function ProfileInput({ label, value, onChange, type = "text", ...props }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>{label}</div>
      <input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} {...props} />
    </label>
  );
}
function ProfileTextarea({ label, value, onChange, placeholder }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>{label}</div>
      <textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows="3" className="w-full rounded-xl px-3 py-3 outline-none resize-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />
    </label>
  );
}
function ProfileSelect({ label, value, options, onChange }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>{label}</div>
      <select value={value} onChange={(e) => onChange(e.target.value)} className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}

/* ---------- ExerciseManager ---------- */
function ExerciseManager({ exercises, profile, onBack, onRename, onDelete, onAdd, onSetType, onToggleAvoid, excludedCats, onToggleCat }) {
  const [q, setQ] = useState("");
  const [editName, setEditName] = useState(null); // Name der Übung, die gerade umbenannt wird
  const [draft, setDraft] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [addName, setAddName] = useState("");
  const [addGroup, setAddGroup] = useState("Brust");
  const [addComp, setAddComp] = useState(false);

  const avoided = useMemo(() => new Set(tokenizeList(profile?.avoidedExercises)), [profile]);
  const isAvoidedExact = (name) => avoided.has(name.toLowerCase());

  const ql = q.trim().toLowerCase();
  const filtered = exercises.filter((e) => ql === "" || e.n.toLowerCase().includes(ql) || (e.m || "").toLowerCase().includes(ql));
  const otherGroups = [...new Set(filtered.map((e) => e.g))].filter((g) => !MUSCLE_GROUPS.includes(g)).sort();
  const orderedGroups = [...MUSCLE_GROUPS, ...otherGroups];

  const startEdit = (name) => { setEditName(name); setDraft(name); };
  const commitEdit = async () => { const t = draft.trim(); if (t && t !== editName) await onRename(editName, t); setEditName(null); setDraft(""); };
  const submitAdd = async () => {
    const name = addName.trim();
    if (!name) return;
    if (exercises.some((e) => e.n === name)) { window.alert("Eine Übung mit diesem Namen existiert bereits."); return; }
    await onAdd({ name, group: addGroup, comp: addComp });
    setAddName(""); setAddComp(false); setShowAdd(false);
  };
  const confirmDelete = async (name) => { if (window.confirm(`„${name}" wirklich löschen? Vergangene Einheiten bleiben erhalten.`)) await onDelete(name); };

  const chip = (bg, color, label) => (
    <span className="text-[10px] font-semibold rounded-full px-2 py-0.5" style={{ background: bg, color, border: `1px solid ${C.line}` }}>{label}</span>
  );

  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Übungen</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Verwalten</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Übung oder Muskel suchen…"
        className="w-full rounded-xl px-3 py-3 outline-none mb-3" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />

      {/* Neue Übung */}
      {!showAdd ? (
        <button onClick={() => setShowAdd(true)} className="w-full rounded-xl py-3 text-sm font-semibold mb-4" style={{ background: C.accent, color: "#1A140A" }}>
          + Neue Übung
        </button>
      ) : (
        <div className="rounded-2xl p-4 mb-4 flex flex-col gap-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>Neue Übung</div>
          <input value={addName} onChange={(e) => setAddName(e.target.value)} placeholder="Name der Übung"
            className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }} />
          <div className="grid grid-cols-2 gap-3">
            <label className="block">
              <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Muskelgruppe</div>
              <select value={addGroup} onChange={(e) => setAddGroup(e.target.value)} className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }}>
                {MUSCLE_GROUPS.map((g) => <option key={g} value={g}>{g}</option>)}
              </select>
            </label>
            <label className="block">
              <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Typ</div>
              <select value={addComp ? "compound" : "isolation"} onChange={(e) => setAddComp(e.target.value === "compound")} className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }}>
                <option value="isolation">Isolation</option>
                <option value="compound">Compound</option>
              </select>
            </label>
          </div>
          <div className="flex gap-2">
            <button onClick={submitAdd} className="flex-1 rounded-xl py-3 text-sm font-bold" style={{ background: C.accent, color: "#1A140A" }}>Hinzufügen</button>
            <button onClick={() => { setShowAdd(false); setAddName(""); }} className="rounded-xl py-3 px-4 text-sm font-semibold" style={{ background: C.surface2, color: C.muted, border: `1px solid ${C.line}` }}>Abbrechen</button>
          </div>
        </div>
      )}

      {/* Gerätekategorien global ein-/ausschalten */}
      {onToggleCat && DEVICE_CATS.length > 0 && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-1" style={{ color: C.accent }}>Gerätekategorien</div>
          <p className="text-[11px] mb-3" style={{ color: C.muted }}>
            Ausgeschaltete Kategorien werden aus dem Auto-Plan und dem dynamischen Training genommen (z. B. wenn dein Studio ein Gerät nicht hat). Einzelne Übungen bleiben oben verwaltbar.
          </p>
          <div className="flex flex-col gap-2">
            {DEVICE_CATS.map((cat) => {
              const on = !(excludedCats || []).includes(cat);
              const count = exercises.filter((e) => (e.cat || "kraft") === cat).length;
              return (
                <label key={cat} className="w-full rounded-xl px-3 py-2.5 flex items-center justify-between gap-2 cursor-pointer"
                  style={{ background: on ? C.surface2 : C.surface, border: `1px solid ${on ? C.accent2 : C.line}` }}>
                  <div className="flex flex-col">
                    <span className="font-bold text-sm" style={{ color: on ? C.text : C.muted }}>{CAT_LABEL[cat] || cat}</span>
                    <span className="text-[11px]" style={{ color: C.muted }}>{count} Übungen{on ? "" : " · ausgeschlossen"}</span>
                  </div>
                  <input type="checkbox" checked={on} onChange={(ev) => onToggleCat(cat, !ev.target.checked)} />
                </label>
              );
            })}
          </div>
        </div>
      )}

      {filtered.length === 0 && <p className="text-sm text-center mt-6" style={{ color: C.muted }}>Keine Übungen gefunden.</p>}

      {orderedGroups.map((g) => {
        const items = filtered.filter((e) => e.g === g);
        if (!items.length) return null;
        return (
          <div key={g} className="mb-5">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: GROUP[g] || C.muted }} />
              <h2 className="font-bold">{g}</h2>
              <span className="text-xs" style={{ color: C.muted }}>{items.length}</span>
            </div>
            <div className="flex flex-col gap-2">
              {items.map((e) => {
                const custom = e.cat === "custom";
                const compound = isCompound(e.n);
                const avoid = isAvoidedExact(e.n);
                return (
                  <div key={e.n} className="rounded-2xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                    {editName === e.n ? (
                      <div className="flex gap-2">
                        <input autoFocus value={draft} onChange={(ev) => setDraft(ev.target.value)}
                          onKeyDown={(ev) => { if (ev.key === "Enter") commitEdit(); if (ev.key === "Escape") setEditName(null); }}
                          className="flex-1 rounded-xl px-3 py-2 outline-none" style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }} />
                        <button onClick={commitEdit} className="rounded-xl px-3 py-2 text-sm font-bold" style={{ background: C.accent2, color: "#0C1A15" }}>OK</button>
                        <button onClick={() => setEditName(null)} className="rounded-xl px-3 py-2 text-sm font-semibold" style={{ color: C.muted }}>Abbr.</button>
                      </div>
                    ) : (
                      <>
                        <div className="flex items-start justify-between gap-2">
                          <div className="min-w-0">
                            <div className="font-semibold truncate">{e.n}</div>
                            {e.m && <div className="text-[11px] mt-0.5" style={{ color: C.muted }}>{e.m}</div>}
                          </div>
                          <div className="flex items-center gap-1.5 shrink-0">
                            {custom
                              ? <button onClick={() => onSetType(e.n, !compound)} title="Typ umschalten">{chip(C.surface2, compound ? C.accent : C.accent2, compound ? "Compound" : "Isolation")}</button>
                              : chip(C.surface2, compound ? C.accent : C.accent2, compound ? "Compound" : "Isolation")}
                            {custom && chip(C.surface2, C.muted, "Eigene")}
                          </div>
                        </div>
                        <div className="flex items-center justify-between gap-2 mt-3">
                          <label className="flex items-center gap-2 text-xs" style={{ color: avoid ? C.danger : C.muted }}>
                            <input type="checkbox" checked={avoid} onChange={(ev) => onToggleAvoid(e.n, ev.target.checked)} />
                            Vom Auto-Plan ausnehmen
                          </label>
                          <div className="flex items-center gap-3">
                            <button onClick={() => startEdit(e.n)} className="text-xs font-semibold" style={{ color: C.accent2 }}>Umbenennen</button>
                            <button onClick={() => confirmDelete(e.n)} className="text-xs font-semibold" style={{ color: C.danger }}>Löschen</button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      <p className="text-[11px] mt-2" style={{ color: C.muted }}>
        Hinweis: Beim Umbenennen einer eingebauten Übung können die hinterlegten Ausführungs-Hinweise verloren gehen. Vergangene Einheiten bleiben immer erhalten.
      </p>
    </div>
  );
}

/* ---------- LoginScreen ---------- */
function LoginScreen() {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const signIn = async () => {
    if (!sb) { setErr("Supabase nicht verfügbar — Seite neu laden."); return; }
    setLoading(true); setErr(null);
    const { error } = await sb.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: window.location.origin },
    });
    if (error) { setErr(error.message); setLoading(false); }
  };

  return (
    <div className="px-5 min-h-screen flex flex-col justify-center mx-auto" style={{ maxWidth: 480 }}>
      <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Trainingstagebuch</div>
      <h1 className="text-3xl font-extrabold mt-1 mb-1" style={{ letterSpacing: "-0.02em" }}>Anmelden</h1>
      <p className="text-sm mb-8" style={{ color: C.muted }}>Melde dich mit deinem Google-Konto an, um auf dein Tagebuch zuzugreifen.</p>
      <button
        onClick={signIn} disabled={loading}
        className="w-full rounded-2xl p-4 flex items-center justify-center gap-3 font-bold text-base active:scale-[0.99] transition-transform"
        style={{ background: C.accent, color: "#0C1A15", opacity: loading ? 0.7 : 1 }}>
        {loading ? "Weiterleitung…" : "Mit Google anmelden"}
      </button>
      {err && <div className="mt-4 text-sm rounded-xl p-3" style={{ color: C.danger, background: "rgba(224,122,95,0.12)", border: `1px solid ${C.danger}` }}>{err}</div>}
    </div>
  );
}

/* ---------- WithingsView ---------- */
function WithingsView({ sbToken, onBack }) {
  const [connected, setConnected] = useState(null); // null=loading, true/false
  const [connecting, setConnecting] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);
  const [reauth, setReauth] = useState(false); // Token abgelaufen -> neu verbinden nötig
  const [measurements, setMeasurements] = useState([]);
  const [err, setErr] = useState(null);

  const fnBase = `${SB_URL}/functions/v1`;
  const authHdr = sbToken ? { Authorization: `Bearer ${sbToken}` } : {};

  useEffect(() => {
    if (!sbToken) return;
    // Withings-Token-Status prüfen (RLS-Read, nur eigene Zeile).
    const sbClient = window.supabase.createClient(SB_URL, SB_ANON_KEY, {
      global: { headers: { Authorization: `Bearer ${sbToken}` } },
      db: { schema: "trainer" },
      auth: { persistSession: false, autoRefreshToken: false },
    });
    sbClient.from("withings_tokens").select("withings_userid,updated_at").maybeSingle()
      .then(({ data }) => { setConnected(!!data); })
      .catch(() => setConnected(false));

    // Letzte Messungen laden
    sbClient.from("body_measurements")
      .select("measured_at,weight_kg,muscle_mass_kg,fat_mass_kg,fat_ratio_pct,fat_free_mass_kg,water_mass_kg,bone_mass_kg,visceral_fat,bmr_kcal,left_arm_muscle_mass_kg,right_arm_muscle_mass_kg,left_leg_muscle_mass_kg,right_leg_muscle_mass_kg,trunk_muscle_mass_kg,left_arm_fat_mass_kg,right_arm_fat_mass_kg,left_leg_fat_mass_kg,right_leg_fat_mass_kg,trunk_fat_mass_kg,left_arm_fat_free_mass_kg,right_arm_fat_free_mass_kg,left_leg_fat_free_mass_kg,right_leg_fat_free_mass_kg,trunk_fat_free_mass_kg")
      .order("measured_at", { ascending: false })
      .limit(30)
      .then(({ data }) => setMeasurements(data || []));
  }, [sbToken]);

  // Startet den OAuth-Flow — für Erstverbindung UND Neu-Verbinden (identisch).
  const connect = async () => {
    setConnecting(true); setErr(null);
    try {
      const r = await fetch(`${fnBase}/withings-oauth-start`, { method: "POST", headers: authHdr });
      const j = await r.json();
      if (!r.ok || !j.url) throw new Error(j.error || "Fehler");
      window.location.href = j.url;
    } catch (e) { setErr(String(e)); setConnecting(false); }
  };

  // Verbindung trennen — löscht serverseitig NUR die Tokens; Messungen bleiben erhalten.
  const disconnect = async () => {
    if (!window.confirm("Withings-Verbindung trennen? Deine bereits synchronisierten Messungen bleiben erhalten. Für neue Messungen musst du dich später neu verbinden.")) return;
    setDisconnecting(true); setErr(null);
    try {
      const r = await fetch(`${fnBase}/withings-disconnect`, { method: "POST", headers: authHdr });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "Trennen fehlgeschlagen");
      setConnected(false); setReauth(false);
    } catch (e) { setErr(String(e)); } finally { setDisconnecting(false); }
  };

  const sync = async () => {
    setErr(null);
    try {
      const r = await fetch(`${fnBase}/withings-sync`, { headers: authHdr });
      const j = await r.json();
      if (!r.ok) {
        // Token abgelaufen/entzogen -> neu verbinden anbieten statt nur Fehler zu zeigen.
        if (j.error === "reauth_required") { setReauth(true); throw new Error("Withings-Verbindung abgelaufen — bitte neu verbinden."); }
        if (j.error === "not_connected") { setConnected(false); throw new Error("Nicht verbunden."); }
        throw new Error(j.error || "Sync fehlgeschlagen");
      }
      window.location.reload();
    } catch (e) { setErr(String(e)); }
  };

  const latest = measurements[0] || null;

  const SegDiff = ({ label, left, right }) => {
    if (left == null && right == null) return null;
    const diff = left != null && right != null ? Math.abs(left - right).toFixed(2) : null;
    const imbalance = diff != null && parseFloat(diff) > 0.3;
    return (
      <div className="flex justify-between items-center py-1" style={{ borderBottom: `1px solid ${C.line}` }}>
        <span className="text-sm" style={{ color: C.muted }}>{label}</span>
        <span className="text-sm font-semibold" style={{ color: imbalance ? C.danger : C.text }}>
          L {left != null ? left.toFixed(2) + " kg" : "–"} / R {right != null ? right.toFixed(2) + " kg" : "–"}
          {imbalance && <span className="ml-2 text-xs" style={{ color: C.danger }}>⚠ {diff} kg Diff</span>}
        </span>
      </div>
    );
  };

  return (
    <div className="px-5 pb-10" style={{ maxWidth: 480, margin: "0 auto" }}>
      <header className="flex items-center justify-between py-4">
        <h2 className="font-extrabold text-xl">Körperdaten</h2>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>

      {/* Verbindungsstatus */}
      <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>Withings</div>
        {connected === null && <div className="text-sm" style={{ color: C.muted }}>Prüfe Verbindung…</div>}
        {connected === false && (
          <div>
            <div className="text-sm mb-3" style={{ color: C.muted }}>Noch nicht verbunden. Verbinde deine Withings-Waage, um automatisch Messungen zu synchronisieren.</div>
            <button onClick={connect} disabled={connecting}
              className="rounded-xl px-4 py-2.5 font-bold text-sm" style={{ background: C.accent, color: "#0C1A15", opacity: connecting ? 0.7 : 1 }}>
              {connecting ? "Weiterleitung…" : "Withings verbinden"}
            </button>
          </div>
        )}
        {connected === true && (
          <div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold" style={{ color: reauth ? C.danger : C.accent2 }}>
                {reauth ? "Verbindung abgelaufen" : "Verbunden"}
              </span>
              {!reauth && <button onClick={sync} className="text-sm font-semibold" style={{ color: C.accent }}>Sync</button>}
            </div>
            {reauth && (
              <div className="text-sm mt-1 mb-3" style={{ color: C.muted }}>
                Der Zugriffs-Token ist abgelaufen und ließ sich nicht erneuern. Verbinde Withings neu — deine Messungen bleiben erhalten.
              </div>
            )}
            <div className="flex gap-2 mt-3">
              <button onClick={connect} disabled={connecting}
                className="text-sm font-semibold rounded-xl px-3 py-2" style={{ background: C.accent, color: "#0C1A15", opacity: connecting ? 0.7 : 1 }}>
                {connecting ? "Weiterleitung…" : "Neu verbinden"}
              </button>
              <button onClick={disconnect} disabled={disconnecting}
                className="text-sm font-semibold rounded-xl px-3 py-2" style={{ background: C.surface2, color: C.danger, border: `1px solid ${C.line}`, opacity: disconnecting ? 0.7 : 1 }}>
                {disconnecting ? "Trenne…" : "Verbindung trennen"}
              </button>
            </div>
          </div>
        )}
        {err && <div className="mt-2 text-xs rounded-lg p-2" style={{ color: C.danger, background: "rgba(224,122,95,0.12)" }}>{err}</div>}
      </div>

      {/* Letzte Messung */}
      {latest && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-3" style={{ color: C.accent }}>Letzte Messung · {new Date(latest.measured_at).toLocaleDateString("de-DE")}</div>
          <div className="grid grid-cols-2 gap-3">
            {[
              ["Gewicht", latest.weight_kg, "kg"],
              ["Muskeln", latest.muscle_mass_kg, "kg"],
              ["Fett", latest.fat_mass_kg, "kg"],
              ["Fettanteil", latest.fat_ratio_pct, "%"],
              ["Wasser", latest.water_mass_kg, "kg"],
              ["Knochen", latest.bone_mass_kg, "kg"],
              ["Viszeral", latest.visceral_fat, ""],
              ["Grundumsatz", latest.bmr_kcal, "kcal"],
            ].map(([l, v, u]) => v != null ? (
              <div key={l} className="rounded-xl p-3" style={{ background: C.surface2 }}>
                <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>{l}</div>
                <div className="text-xl font-extrabold">{Number(v).toFixed(v >= 10 ? 1 : 2)} <span className="text-sm font-normal" style={{ color: C.muted }}>{u}</span></div>
              </div>
            ) : null)}
          </div>
        </div>
      )}

      {/* Segmental Muskelmasse + KFA */}
      {latest && (latest.left_arm_muscle_mass_kg != null || latest.right_arm_muscle_mass_kg != null || latest.left_leg_muscle_mass_kg != null) && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-3" style={{ color: C.accent }}>Segmental</div>
          {[
            ["Arm L", latest.left_arm_muscle_mass_kg, latest.left_arm_fat_mass_kg, latest.left_arm_fat_free_mass_kg],
            ["Arm R", latest.right_arm_muscle_mass_kg, latest.right_arm_fat_mass_kg, latest.right_arm_fat_free_mass_kg],
            ["Bein L", latest.left_leg_muscle_mass_kg, latest.left_leg_fat_mass_kg, latest.left_leg_fat_free_mass_kg],
            ["Bein R", latest.right_leg_muscle_mass_kg, latest.right_leg_fat_mass_kg, latest.right_leg_fat_free_mass_kg],
            ["Rumpf", latest.trunk_muscle_mass_kg, latest.trunk_fat_mass_kg, latest.trunk_fat_free_mass_kg],
          ].map(([label, muscle, fat, ff]) => {
            const kfa = fat != null && ff != null && (fat + ff) > 0 ? ((fat / (fat + ff)) * 100).toFixed(1) : null;
            const hasData = muscle != null || kfa != null;
            if (!hasData) return null;
            const armImbalance = label.startsWith("Arm") && latest.left_arm_muscle_mass_kg != null && latest.right_arm_muscle_mass_kg != null
              && Math.abs(latest.left_arm_muscle_mass_kg - latest.right_arm_muscle_mass_kg) > 0.3;
            const legImbalance = label.startsWith("Bein") && latest.left_leg_muscle_mass_kg != null && latest.right_leg_muscle_mass_kg != null
              && Math.abs(latest.left_leg_muscle_mass_kg - latest.right_leg_muscle_mass_kg) > 0.3;
            const warn = armImbalance || legImbalance;
            return (
              <div key={label} className="flex justify-between items-center py-1" style={{ borderBottom: `1px solid ${C.line}` }}>
                <span className="text-sm" style={{ color: warn ? C.danger : C.muted }}>{label}{warn ? " ⚠" : ""}</span>
                <span className="text-sm font-semibold">
                  {muscle != null && <span style={{ color: C.accent2 }}>{Number(muscle).toFixed(2)} kg</span>}
                  {kfa != null && <span style={{ color: C.danger }}> · {kfa} %KFA</span>}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* Verlaufsliste */}
      {measurements.length > 1 && (
        <div className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-3" style={{ color: C.accent }}>Verlauf</div>
          <div className="flex flex-col gap-2">
            {measurements.slice(0, 10).map((m) => (
              <div key={m.measured_at} className="flex justify-between items-center text-sm" style={{ borderBottom: `1px solid ${C.line}`, paddingBottom: 4 }}>
                <span style={{ color: C.muted }}>{new Date(m.measured_at).toLocaleDateString("de-DE")}</span>
                <span>{m.weight_kg != null ? Number(m.weight_kg).toFixed(1) + " kg" : "–"}</span>
                <span style={{ color: C.accent2 }}>{m.muscle_mass_kg != null ? Number(m.muscle_mass_kg).toFixed(1) + " M" : "–"}</span>
                <span style={{ color: C.danger }}>{m.fat_mass_kg != null ? Number(m.fat_mass_kg).toFixed(1) + " F" : "–"}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- UserSelect ---------- */
const USER_COLORS = [C.accent, C.accent2, C.danger];
function UserSelect({ onSelect, appUsers }) {
  const users = appUsers.map((u, i) => ({
    name: u.username,
    color: u.color || USER_COLORS[i % USER_COLORS.length],
    logo: `assets/logo-${u.username.toLowerCase()}.jpg`,
  }));
  return (
    <div className="px-5 min-h-screen flex flex-col justify-center mx-auto" style={{ maxWidth: 480 }}>
      <div className="flex justify-center mb-5">
        <img src="assets/logo.png?v=2" alt="Erdmännchen & Panda – dein Team" className="w-44 h-44 rounded-full object-cover" style={{ background: "#fff", boxShadow: `0 0 0 1px ${C.line}` }} />
      </div>
      <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Trainingstagebuch</div>
      <h1 className="text-3xl font-extrabold mt-1 mb-1" style={{ letterSpacing: "-0.02em", color: "#ffffff" }}>Wer trainiert?</h1>
      <p className="text-sm mb-6" style={{ color: C.muted }}>Wähle deinen Nutzer – jeder hat sein eigenes Tagebuch und seine eigenen Vorschläge.</p>
      <div className="flex flex-col gap-3">
        {users.map((u) => (
          <button key={u.name} onClick={() => onSelect(u.name)}
            className="rounded-2xl p-5 flex items-center gap-4 active:scale-[0.99] transition-transform"
            style={{ background: C.surface, border: `1px solid ${C.line}` }}>
            <img src={u.logo} alt={u.name}
              className="rounded-full object-cover"
              style={{ width: 52, height: 52, border: `2px solid ${u.color}` }} />
            <span className="font-bold text-lg" style={{ color: "#ffffff" }}>{u.name}</span>
          </button>
        ))}
      </div>
      <p className="text-[11px] mt-6" style={{ color: C.muted }}>Kein Login nötig. Nutzer jederzeit oben rechts wechselbar. Daten werden zentral in Supabase gespeichert – auf jedem Gerät verfügbar.</p>
    </div>
  );
}

/* ---------- Übungswissen ---------- */
const INFO = {
  "Schrägbank DB-Brustdrücken": { desc: "Drückbewegung auf der 30-45° Schrägbank, betont die obere Brust.", cues: ["Bank auf 30-45° – steiler trifft mehr Schulter", "Schulterblätter zusammen und nach unten fixieren", "Hanteln auf Höhe der oberen Brust absenken", "Ellbogen etwa 45° zum Körper, nicht ausstellen", "Oben nicht komplett durchdrücken"] },
  "Flachbank DB-Drücken": { desc: "Klassisches Brustdrücken flach, trifft die gesamte Brust.", cues: ["Schulterblätter fixiert, leichte Brücke ok", "Ellbogen ~45°, Handgelenke gerade", "Kontrolliert bis Brusthöhe ablassen", "Aus der Brust drücken, oben nicht sperren"] },
  "Pec Fly": { desc: "Isolationsübung, die die Brust über die Dehnung trifft.", cues: ["Leichte, fixe Ellbogenbeugung halten", "Bewegung kommt aus der Schulter, nicht den Armen", "Unten bewusste Dehnung der Brust", "Oben aktiv zusammenführen und kurz halten"] },
  "Pec Fly sitzend Keiser": { desc: "Sitzende Brust-Isolation an der Keiser-Maschine mit konstanter pneumatischer Spannung.", cues: ["Aufrecht sitzen, Rücken ans Polster", "Griffe auf Brusthöhe, Arme seitlich", "Leichte, fixe Ellbogenbeugung halten", "Kontrolliert vor dem Körper zusammenführen", "Oben kurz anspannen", "Langsam bis zur Brustdehnung öffnen"] },
  "Keiser Pec Fly (oben)": { desc: "Pec Fly an der Keiser-Station mit tiefer Griffposition – der leicht aufwärts gerichtete Zug betont die obere Brust.", cues: ["Sitz tiefer stellen, Griffe unterhalb der Brust", "Rücken ans Polster, Schulterblätter zurück und unten", "Leichte, fixe Ellbogenbeugung halten", "Hände schräg nach oben-innen zusammenführen", "Oben kurz die obere Brust anspannen", "Langsam bis zur Dehnung öffnen"] },
  "Keiser Pec Fly (Mitte)": { desc: "Pec Fly an der Keiser-Station mit Griffen auf Brusthöhe – waagerechter Zug für die mittlere/sternale Brust.", cues: ["Aufrecht sitzen, Griffe auf Brusthöhe", "Rücken ans Polster, Schulterblätter zurück und unten", "Leichte, fixe Ellbogenbeugung halten", "Hände waagerecht vor dem Körper zusammenführen", "Oben kurz anspannen", "Langsam bis zur Brustdehnung öffnen"] },
  "Keiser Pec Fly (unten)": { desc: "Pec Fly an der Keiser-Station mit hoher Griffposition – der leicht abwärts gerichtete Zug betont die untere Brust.", cues: ["Sitz höher stellen, Griffe oberhalb der Brust", "Rücken ans Polster, Schulterblätter zurück und unten", "Leichte, fixe Ellbogenbeugung halten", "Hände schräg nach unten-innen zusammenführen", "Unten die untere Brust bewusst anspannen", "Langsam bis zur Dehnung öffnen"] },
  "Brustpresse (Maschine)": { desc: "Geführtes Brustdrücken – gut für sauberen, sicheren Reiz.", cues: ["Sitz so, dass Griffe auf Brusthöhe sind", "Schulterblätter zurück und unten", "Kontrolliert drücken, oben nicht sperren"] },
  "Kabel-Crossover": { desc: "Brust-Isolation am Kabel mit konstanter Spannung.", cues: ["Leichte Vorlage des Oberkörpers", "Ellbogen leicht gebeugt fixieren", "Hände vor dem Körper zusammenführen/kreuzen"] },
  "Liegestütze": { desc: "Körpergewichtsdrücken für Brust, Schulter, Trizeps.", cues: ["Körper in gerader Linie (wie Plank)", "Ellbogen ~45°, nicht abspreizen", "Brust knapp über den Boden", "Rumpf und Gesäß fest anspannen"] },
  "Latzug (breit)": { desc: "Vertikaler Zug für die Breite des Latissimus.", cues: ["Brust raus, leichter Rücklage", "Stange zur oberen Brust ziehen", "Ellbogen nach unten denken, Lat führt", "Kontrolliert nach oben ausstrecken"] },
  "Latzug (eng)": { desc: "Enger/neutraler Griff, betont den unteren Lat.", cues: ["Neutraler oder enger Griff", "Zur oberen Brust ziehen", "Schulterblätter nach unten ziehen"] },
  "Latzug Maschine": { desc: "Geführter vertikaler Zug an der Maschine für den Latissimus.", cues: ["Breiter Obergriff an der Stange", "Oberschenkel unter dem Polster fixieren", "Stange zur oberen Brust ziehen", "Schulterblätter zusammenziehen", "Kontrolliert nach oben zurückführen"] },
  "Klimmzug": { desc: "König der Rückenübungen – Eigengewicht vertikal.", cues: ["Zuerst Schulterblätter nach unten", "Unten voll aushängen", "Brust zur Stange ziehen", "Kein Schwung aus der Hüfte"] },
  "Rudern am Kabel": { desc: "Horizontaler Zug für den mittleren Rücken.", cues: ["Neutraler Rücken, aufrecht", "Zum Bauchnabel ziehen", "Schulterblätter zusammenführen", "Ohne Schwung, kontrolliert zurück"] },
  "Einarmiges DB-Rudern": { desc: "Einseitiges Rudern für Dicke und Symmetrie.", cues: ["Rücken stabil und parallel/leicht aufrecht", "Hantel zur Hüfte ziehen", "Ellbogen nah am Körper", "Oberkörper nicht mitrotieren"] },
  "Langhantelrudern": { desc: "Schweres horizontales Ziehen für den ganzen Rücken.", cues: ["Hüfte beugen, Rücken neutral", "Stange zum unteren Brustkorb/Bauch", "Kein Hochreißen mit dem Rücken"] },
  "Reverse Fly": { desc: "Isolation für hintere Schulter und oberen Rücken.", cues: ["Vorgebeugt, Rücken neutral", "Leichte fixe Ellbogenbeugung", "Arme seitlich nach hinten heben", "Schulterblätter zusammen"] },
  "Überzüge": { desc: "Dehnt und trifft Lat und Brust über den Kopf.", cues: ["Arme leicht gebeugt fixieren", "Über den Kopf dehnen", "Aus dem Lat zurückziehen"] },
  "Schulterdrücken (DB)": { desc: "Vertikales Drücken für die vordere/seitliche Schulter.", cues: ["Kein starkes Hohlkreuz, Rumpf fest", "Hanteln von Schulterhöhe über den Kopf", "Ellbogen leicht vor der Körperlinie", "Kontrolliert ablassen"] },
  "Schulterdrücken (Maschine)": { desc: "Geführtes Überkopfdrücken.", cues: ["Griffe auf Schulterhöhe einstellen", "Kontrolliert hochdrücken, nicht sperren"] },
  "Arnold Press": { desc: "Drücken mit Rotation, trifft mehr Schulteranteile.", cues: ["Start supiniert vor der Brust", "Beim Hochdrücken nach außen drehen", "Kontrolliert und ohne Schwung"] },
  "Seitheben": { desc: "Isolation für die seitliche Schulter (Breite).", cues: ["Leichte Ellbogenbeugung halten", "Bis Schulterhöhe heben, nicht höher", "Kleiner Finger minimal höher führen", "Kein Schwung – Gewicht lieber kleiner"] },
  "Frontheben": { desc: "Isolation für die vordere Schulter.", cues: ["Vor den Körper bis Schulterhöhe", "Kontrolliert, kein Schwung"] },
  "Face Pulls": { desc: "Zug zum Gesicht für hintere Schulter und Haltung.", cues: ["Seil auf Kopfhöhe", "Zum Gesicht/Stirn ziehen", "Ellbogen hoch und nach außen", "Schulterblätter zusammen"] },
  "Bizeps DB-Curls": { desc: "Grundübung für den Bizeps.", cues: ["Ellbogen fix am Körper", "Nur der Unterarm bewegt sich", "Oben bewusst anspannen", "Langsam ablassen (kein Fallenlassen)"] },
  "Hammer DB Curls": { desc: "Neutraler Griff, trifft Bizeps und Brachialis/Unterarm.", cues: ["Neutraler Griff (Daumen oben)", "Ellbogen fixieren", "Kontrolliert beugen und strecken"] },
  "Hammer Curls Seil": { desc: "Hammer-Curls am Kabelzug mit Seilgriff – konstante Spannung auf Brachioradialis, Bizeps und Brachialis.", cues: ["Seilgriff am unteren Kabelzug", "Ellenbogen eng am Körper", "Neutraler Griff (Daumen nach oben)", "Kontrolliert beugen und strecken", "Oberarme bleiben stabil", "Handgelenke nicht abknicken"] },
  "SZ-Curls": { desc: "Curls an der SZ-Stange, schont die Handgelenke.", cues: ["Griff an den schrägen Stellen", "Ellbogen fix am Körper", "Voll strecken unten"] },
  "Preacher-Curls": { desc: "Curls am Scott-Pult – maximale Isolation.", cues: ["Oberarme flach aufs Pad", "Kein Schwung, kein Abheben", "Volle Dehnung unten kontrollieren"] },
  "Preacher Curls Maschine": { desc: "Bizeps-Isolation an der Maschine – geführte, saubere Bewegung.", cues: ["Achseln fest an das Polster", "Oberarme komplett auflegen", "Kontrolliert beugen und strecken", "Ellenbogen nicht komplett durchstrecken", "Handgelenke gerade halten"] },
  "Konzentrations-Curls": { desc: "Sitzendes, einseitiges Isolieren des Bizeps.", cues: ["Ellbogen an den Innenschenkel stützen", "Oben kurz anspannen (Peak)", "Langsam ablassen"] },
  "Kabel-Curls": { desc: "Curls am Kabel mit konstanter Spannung.", cues: ["Ellbogen fixieren", "Spannung oben und unten halten"] },
  "Trizeps Pushdown": { desc: "Drücken nach unten am Kabel – seitlicher Trizepskopf.", cues: ["Oberarme fix am Körper", "Nur im Ellbogen bewegen", "Unten ganz durchstrecken und kurz zudrücken"] },
  "Trizeps Pushdown (Untergriff)": { desc: "Pushdown im Untergriff – betont den inneren Kopf.", cues: ["Leichter wählen, streng ausführen", "Oberarme fix", "Voll durchstrecken"] },
  "Überkopf-Trizeps (Seil)": { desc: "Überkopf-Strecken – trifft den langen Kopf über die Dehnung.", cues: ["Ellbogen eng am Kopf führen", "Arme komplett strecken, oben halten", "Unten tiefe Dehnung (Hände hinter den Kopf)"] },
  "Dips": { desc: "Eigengewichts-Drücken für Trizeps (aufrecht) oder Brust (vorgelehnt).", cues: ["Aufrecht = mehr Trizeps", "Kontrolliert, nicht zu tief bei Schulterproblemen", "Schultern nicht hochziehen"] },
  "French Press": { desc: "Liegendes/sitzendes Strecken hinter dem Kopf.", cues: ["Ellbogen zeigen nach oben, fixieren", "Hinter den Kopf absenken", "Nur Unterarm bewegt"] },
  "Kniebeuge": { desc: "Grundübung für Quadrizeps und Gesäß.", cues: ["Füße schulterbreit, Zehen leicht nach außen", "Knie in Richtung der Zehen", "Mindestens bis parallel", "Rücken neutral, Rumpf fest, Druck über Mittelfuß"] },
  "Beinpresse": { desc: "Geführtes Beindrücken für Quadrizeps und Gesäß.", cues: ["Füße schulterbreit auf der Platte", "Knie nicht ganz durchstrecken/sperren", "Unterer Rücken bleibt am Polster"] },
  "Goblet-Kniebeuge": { desc: "Kniebeuge mit Hantel vor der Brust – sehr aufrecht.", cues: ["Hantel eng vor der Brust", "Oberkörper aufrecht", "Tief und kontrolliert"] },
  "Ausfallschritte": { desc: "Einbeinige Übung für Beine und Gesäß plus Stabilität.", cues: ["Großer Schritt nach vorn", "Vorderes Knie über dem Mittelfuß", "Oberkörper aufrecht", "Aus der Ferse hochdrücken"] },
  "Beinstrecker": { desc: "Isolation für den Quadrizeps.", cues: ["Drehpunkt auf Kniehöhe einstellen", "Oben kurz anspannen", "Kontrolliert ablassen"] },
  "Beinbeuger": { desc: "Isolation für die Beinrückseite (Hamstrings).", cues: ["Polster knapp über der Ferse", "Voll beugen, kontrolliert strecken", "Hüfte bleibt am Polster"] },
  "Rumänisches Kreuzheben (DB)": { desc: "Hüftbeuge für Hamstrings und Gesäß.", cues: ["Hüfte nach hinten schieben", "Nur leichte Kniebeugung", "Rücken neutral – nicht runden!", "Hanteln nah am Bein, Dehnung spüren"] },
  "Hip Thrust": { desc: "Hüftstreckung – stärkste Gesäßübung.", cues: ["Oberer Rücken an der Bank", "Hüfte voll strecken, Gesäß anspannen", "Kein Überstrecken ins Hohlkreuz", "Kinn leicht angezogen"] },
  "Wadenheben": { desc: "Isolation für die Wadenmuskulatur.", cues: ["Oben voll auf die Zehenspitzen", "Unten tiefe Dehnung", "Langsam und kontrolliert, hohe Wdh"] },
  "Plank": { desc: "Statische Rumpfübung für Tiefenstabilität.", cues: ["Körper in gerader Linie", "Bauch und Gesäß anspannen", "Becken nicht durchhängen lassen", "Ruhig weiteratmen"] },
  "Side Plank": { desc: "Seitlicher Unterarmstütz für die seitlichen Bauchmuskeln.", cues: ["Körper seitlich in einer Linie", "Hüfte aktiv nach oben", "Schulter über dem Ellbogen"] },
  "Crunch / Kabel-Crunch": { desc: "Beugung für die geraden Bauchmuskeln.", cues: ["Oberkörper einrollen, nicht nur anheben", "Nicht am Nacken ziehen", "Unten kontrolliert, oben anspannen"] },
  "Crunch auf Ball": { desc: "Crunch auf dem Gymnastikball – große Bewegungsamplitude für die geraden Bauchmuskeln.", cues: ["Rücken auf dem Gymnastikball ablegen", "Füße schulterbreit fest am Boden", "Hände hinter dem Kopf oder vor der Brust", "Oberkörper kontrolliert aufrollen", "Spannung im Bauch halten", "Langsam zurückrollen, ohne komplett abzulegen"] },
  "Beinheben": { desc: "Trifft vor allem die unteren Bauchmuskeln.", cues: ["Becken am Ende leicht einrollen", "Kein Schwung aus den Beinen", "Langsam ablassen"] },
  "Russian Twist": { desc: "Rotation für die seitlichen Bauchmuskeln.", cues: ["Oberkörper leicht zurücklehnen", "Kontrolliert von Seite zu Seite drehen", "Rotation aus dem Rumpf, nicht den Armen"] },
  "Käfer (Dead Bug)": { desc: "Anti-Streck-Übung für tiefe Rumpfstabilität.", cues: ["Gegengleich Arm und Bein ausstrecken", "Unteren Rücken am Boden halten", "Langsam und kontrolliert"] },
  "Bankdrücken (Langhantel)": { desc: "Die Grundübung für Brustkraft und -masse.", cues: ["Schulterblätter fixiert, leichte Brücke", "Stange zur unteren Brust führen", "Ellbogen ~45°, Füße fest am Boden", "Gleichmäßig nach oben drücken"] },
  "Schrägbank Langhantel-Drücken": { desc: "Schrägbankdrücken mit Langhantel für die obere Brust.", cues: ["Bank auf 30-45°", "Stange zur oberen Brust", "Ellbogen ~45°"] },
  "Negativbank-Drücken": { desc: "Drücken auf der Negativbank, betont die untere Brust.", cues: ["Leichte Negativneigung genügt", "Stange zur unteren Brust", "Kontrolliert ablassen"] },
  "T-Bar Rudern": { desc: "Schweres Rudern für die Dicke des Rückens.", cues: ["Hüfte gebeugt, Rücken neutral", "Zum Bauch ziehen", "Schulterblätter zusammen"] },
  "Maschinen-Rudern": { desc: "Geführtes Rudern für den mittleren Rücken.", cues: ["Brust ans Polster", "Zum Körper ziehen", "Schulterblätter zusammenführen"] },
  "Kreuzheben": { desc: "Ganzkörper-Grundübung für die gesamte Rückseite.", cues: ["Stange nah am Schienbein", "Rücken neutral – nicht runden!", "Aus Beinen und Hüfte hochdrücken", "Schulterblätter fixiert, kein Hochreißen"] },
  "Rückenstrecker (Hyperextension)": { desc: "Kräftigt den unteren Rücken und das Gesäß.", cues: ["Nur bis zur Hüftstreckung", "Nicht überstrecken ins Hohlkreuz", "Kontrolliert auf und ab"] },
  "Rücken Extension Gerät": { desc: "Isolation für den unteren Rücken (Erector spinae) am Gerät.", cues: ["Polster auf Hüfthöhe einstellen", "Füße fest fixieren", "Kontrolliert nach unten beugen und aufrichten", "Überstreckung vermeiden", "Blick nach unten gerichtet"] },
  "Overhead Press (Langhantel)": { desc: "Stehendes Überkopfdrücken für starke Schultern.", cues: ["Rumpf fest, kein starkes Hohlkreuz", "Stange über den Kopf drücken", "Kopf am Ende leicht durchschieben"] },
  "Kabel-Seitheben": { desc: "Seitheben am Kabel mit konstanter Spannung.", cues: ["Kabel von unten/hinten", "Leichte Ellbogenbeugung", "Bis Schulterhöhe heben"] },
  "Upright Row": { desc: "Aufrechtes Rudern für seitliche Schulter und Trapez.", cues: ["Nicht zu eng greifen (schulterschonend)", "Ellbogen nach oben/außen führen", "Bis etwa Brusthöhe"] },
  "Nackenheben (Shrugs)": { desc: "Isolation für den oberen Trapez.", cues: ["Schultern gerade hochziehen", "Oben kurz halten", "Nicht kreisen"] },
  "Langhantel-Curls": { desc: "Bizeps-Grundübung mit der Langhantel.", cues: ["Ellbogen fix am Körper", "Kein Schwung aus der Hüfte", "Unten voll strecken"] },
  "Schrägbank-Curls (Incline)": { desc: "Curls zurückgelehnt – starke Dehnung des langen Bizepskopfes.", cues: ["Arme hängen senkrecht nach unten", "Volle Dehnung zulassen", "Ellbogen fixieren"] },
  "Spider-Curls": { desc: "Vorgelehnte Curls für maximale Bizeps-Spannung.", cues: ["Brust am Pad/vorgelehnt", "Arme senkrecht", "Streng ohne Schwung"] },
  "Enges Bankdrücken": { desc: "Bankdrücken mit engem Griff, Trizeps-Schwerpunkt.", cues: ["Schulterbreiter Griff", "Ellbogen nah am Körper", "Zur unteren Brust"] },
  "Kickbacks": { desc: "Trizeps-Isolation mit Strecken nach hinten.", cues: ["Oberarm parallel und fix", "Nur im Ellbogen strecken", "Oben kurz anspannen"] },
  "Trizeps-Maschine": { desc: "Geführtes Trizeps-Strecken.", cues: ["Oberarme fixiert", "Voll durchstrecken", "Kontrolliert zurück"] },
  "Handgelenks-Curls": { desc: "Isolation für die Unterarm-Beuger.", cues: ["Unterarme aufgelegt", "Nur das Handgelenk bewegt", "Volle Amplitude, hohe Wdh"] },
  "Frontkniebeuge": { desc: "Kniebeuge mit Last vorn – sehr quad-betont und aufrecht.", cues: ["Ellbogen hoch (Rack-Position)", "Oberkörper aufrecht", "Tief und kontrolliert"] },
  "Hackenschmidt-Kniebeuge": { desc: "Geführte Kniebeuge an der Maschine, Quad-Fokus.", cues: ["Rücken am Polster", "Füße passend zur Tiefe", "Knie nicht sperren"] },
  "Bulgarian Split Squat": { desc: "Einbeinige Kniebeuge, intensiv für Quad und Gesäß.", cues: ["Hinterer Fuß erhöht", "Vorderes Knie über dem Mittelfuß", "Oberkörper aufrecht"] },
  "Beinbeuger (sitzend)": { desc: "Sitzende Variante für die Beinrückseite.", cues: ["Polster über der Ferse", "Voll beugen", "Kontrolliert strecken"] },
  "Abduktoren-Maschine": { desc: "Trainiert die seitliche Gesäßmuskulatur.", cues: ["Aufrecht sitzen", "Kontrolliert nach außen", "Kurz halten"] },
  "Adduktoren-Maschine": { desc: "Trainiert die Oberschenkelinnenseite.", cues: ["Kontrolliert zusammenführen", "Volle Amplitude", "Nicht zurückschnellen lassen"] },
  "Wadenheben (sitzend)": { desc: "Sitzendes Wadenheben, betont den Soleus.", cues: ["Knie gebeugt", "Voll auf die Zehen", "Tiefe Dehnung unten"] },
  "Hängendes Beinheben": { desc: "Hängendes Beinheben für die unteren Bauchmuskeln.", cues: ["Becken einrollen", "Kein Schwung", "Langsam ablassen"] },
  "Ab Wheel (Bauchroller)": { desc: "Anspruchsvolle Rumpfübung mit dem Rad.", cues: ["Rumpf fest, kein Hohlkreuz", "Nur so weit wie kontrollierbar", "Bauch durchgehend anspannen"] },
  "Mountain Climbers": { desc: "Dynamische Rumpf- und Konditionsübung.", cues: ["Stabile Plank-Position", "Knie zügig zur Brust", "Hüfte ruhig halten"] },
};
const fallbackInfo = (e) => ({
  desc: `${e.name} – Übung für ${e.group}${e.muscle ? " (" + e.muscle + ")" : ""}.`,
  cues: ["Sauber und kontrolliert ausführen", "Volle Bewegungsamplitude nutzen", "Zielmuskel bewusst anspannen", "Letzte 1-2 Wdh nahe ans Versagen"],
});

/* ---------- Übungsbilder aus free-exercise-db (Public Domain / Unlicense) ----------
   Deutsch→Englisch-Zuordnung, Laufzeit-Laden, Fallback auf MuscleFigure. */
const EXDB_BASE = "https://raw.githubusercontent.com/yuhonas/free-exercise-db/main/exercises/";
const EXDB_JSON = [
  "https://cdn.jsdelivr.net/gh/yuhonas/free-exercise-db@main/dist/exercises.json",
  "https://raw.githubusercontent.com/yuhonas/free-exercise-db/main/dist/exercises.json",
];
let _exDbPromise = null;
const loadExDb = () => {
  if (!_exDbPromise) {
    _exDbPromise = (async () => {
      for (const url of EXDB_JSON) {
        try {
          const ctrl = new AbortController();
          const to = setTimeout(() => ctrl.abort(), 9000);
          const r = await fetch(url, { signal: ctrl.signal });
          clearTimeout(to);
          if (r.ok) { const j = await r.json(); if (Array.isArray(j) && j.length) return j; }
        } catch (e) {}
      }
      return [];
    })();
  }
  return _exDbPromise;
};
// Direkter Bildpfad ohne Index: free-exercise-db id = Name mit Unterstrichen.
const fedbImg = (exactName) => exactName ? `${EXDB_BASE}${exactName.replace(/ /g, "_")}/0.jpg` : null;
// Zuordnung deutscher Katalogname -> englische Stichworte (free-exercise-db)
const EX_ALIAS = {
  "Bankdrücken (Langhantel)": "barbell bench press", "Schrägbank DB-Brustdrücken": "incline dumbbell press",
  "Schrägbank Langhantel-Drücken": "barbell incline bench", "Flachbank DB-Drücken": "dumbbell bench press",
  "Negativbank-Drücken": "decline barbell bench", "Brustpresse (Maschine)": "leverage chest press",
  "Pec Fly": "butterfly", "Kabel-Crossover": "cable crossover", "Liegestütze": "pushups",
  "Latzug (breit)": "wide-grip lat pulldown", "Latzug (eng)": "close-grip front lat pulldown", "Latzug Maschine": "wide-grip lat pulldown",
  "Klimmzug": "pullups", "Langhantelrudern": "bent over barbell row", "T-Bar Rudern": "t-bar row",
  "Rudern am Kabel": "seated cable rows", "Maschinen-Rudern": "leverage high row", "Einarmiges DB-Rudern": "one-arm dumbbell row",
  "Überzüge": "straight-arm pulldown", "Reverse Fly": "reverse machine flyes", "Kreuzheben": "barbell deadlift",
  "Rückenstrecker (Hyperextension)": "hyperextensions", "Rücken Extension Gerät": "hyperextensions back extensions", "Rumänisches Kreuzheben (DB)": "romanian deadlift",
  "Schulterdrücken (DB)": "dumbbell shoulder press", "Overhead Press (Langhantel)": "standing military press",
  "Schulterdrücken (Maschine)": "machine shoulder military press", "Arnold Press": "arnold press",
  "Seitheben": "side lateral raise", "Kabel-Seitheben": "cable lateral raise", "Frontheben": "front dumbbell raise",
  "Face Pulls": "face pull", "Upright Row": "upright barbell row", "Nackenheben (Shrugs)": "dumbbell shrug",
  "Bizeps DB-Curls": "dumbbell bicep curl", "Langhantel-Curls": "barbell curl", "SZ-Curls": "ez bar curl",
  "Hammer DB Curls": "hammer curls", "Hammer Curls Seil": "cable hammer curls rope", "Preacher-Curls": "preacher curl", "Preacher Curls Maschine": "machine preacher curls", "Konzentrations-Curls": "concentration curls",
  "Crunch auf Ball": "exercise ball crunch",
  "Kabel-Curls": "standing biceps cable curl", "Schrägbank-Curls (Incline)": "incline dumbbell curl", "Spider-Curls": "spider curl",
  "Trizeps Pushdown": "triceps pushdown", "Trizeps Pushdown (Untergriff)": "reverse grip triceps pushdown",
  "Überkopf-Trizeps (Seil)": "cable overhead triceps extension", "Dips": "dips triceps", "Enges Bankdrücken": "close-grip barbell bench press",
  "French Press": "lying triceps extension", "Kickbacks": "tricep dumbbell kickback", "Handgelenks-Curls": "barbell wrist curl",
  "Kniebeuge": "barbell squat", "Frontkniebeuge": "front barbell squat", "Goblet-Kniebeuge": "goblet squat",
  "Hackenschmidt-Kniebeuge": "hack squat", "Beinpresse": "leg press", "Ausfallschritte": "barbell lunge",
  "Bulgarian Split Squat": "split squat", "Beinstrecker": "leg extensions", "Beinbeuger": "lying leg curls",
  "Beinbeuger (sitzend)": "seated leg curl", "Wadenheben": "standing calf raises", "Wadenheben (sitzend)": "seated calf raise",
  "Hip Thrust": "barbell hip thrust", "Abduktoren-Maschine": "thigh abductor", "Adduktoren-Maschine": "thigh adductor",
  "Beinheben": "lying leg raise", "Hängendes Beinheben": "hanging leg raise", "Crunch / Kabel-Crunch": "cable crunch",
  "Plank": "plank", "Side Plank": "side bridge", "Russian Twist": "russian twist", "Mountain Climbers": "mountain climbers",
  "Ab Wheel (Bauchroller)": "barbell ab rollout",
  // Calisthenics (Bilder aus free-exercise-db, falls vorhanden)
  "Chin-up (Untergriff)": "chin-up", "Australian Pull-up (Inverted Row)": "inverted row", "Muscle-up": "muscle up",
  "Diamant-Liegestütze": "push-ups close triceps", "Breite Liegestütze": "push-ups", "Negativ-Liegestütze": "decline push-up",
  "Pike-Liegestütze": "handstand push-ups", "Handstand-Liegestütze": "handstand push-ups", "Archer-Liegestütze": "push-ups",
  "Barren-Dips": "dips triceps version", "Bank-Dips": "bench dips", "Glute Bridge": "butt lift bridge",
  "Sissy Squat": "sissy squat", "Burpee": "burpees", "Wadenheben (Körpergewicht)": "standing calf raises",
  "Nordic Hamstring Curl": "natural glute ham raise",
  // Keiser (pneumatisch): es gibt keine frei lizenzierten Keiser-Markenfotos – daher
  // bewegungsgleiche Public-Domain-Illustrationen (Kabel/Maschine) aus free-exercise-db.
  "Keiser Brustpresse": "leverage chest press", "Pec Fly sitzend Keiser": "butterfly",
  "Keiser Kabel-Fly von unten (obere Brust)": "low cable fly", "Keiser Kabel-Fly Mitte (mittlere Brust)": "cable crossover", "Keiser Kabel-Fly von oben (untere Brust)": "cable crossover",
  "Keiser Pec Fly (oben)": "butterfly", "Keiser Pec Fly (Mitte)": "butterfly", "Keiser Pec Fly (unten)": "butterfly",
  "Keiser Latzug": "wide-grip lat pulldown", "Keiser Kabel-Rudern": "seated cable rows",
  "Keiser Schulterdrücken": "machine shoulder military press", "Keiser Seitheben am Kabel": "cable lateral raise",
  "Keiser Bizeps-Curl": "standing biceps cable curl", "Keiser Trizeps-Pushdown": "triceps pushdown",
  "Keiser Kniebeuge": "barbell squat", "Keiser Beinpresse": "leg press",
  "Keiser Hip Extension (Kabel)": "pull through", "Keiser Kabel-Crunch": "cable crunch",
  "Keiser Holzhacker von oben (High-to-Low)": "wood chop", "Keiser Holzhacker von unten (Low-to-High)": "wood chop",
  "TRX Rudern": "trx suspension rows",
  "TRX Power Pull": "trx power pull",
  "TRX Y-Fly": "trx y raise",
  "TRX T-Fly": "trx t raise",
  "TRX Face Pull": "face pulls",
  "TRX Brustpresse": "trx chest press",
  "TRX Brustfliegende": "trx chest fly",
  "TRX Atomic Push-up": "trx atomic push-up",
  "TRX Bizeps-Curl": "trx bicep curl",
  "TRX Trizeps-Strecken": "trx tricep extension",
  "TRX Kniebeuge": "trx squat",
  "TRX Ausfallschritt": "trx lunge",
  "TRX Pistol Squat (assistiert)": "trx pistol squat",
  "TRX Hamstring Curl": "trx hamstring curl",
  "TRX Hip Press": "trx hip press",
  "TRX Plank": "trx plank",
  "TRX Pike": "trx pike",
  "TRX Knee Tuck": "trx knee tuck",
  "TRX Mountain Climber": "trx mountain climber",
  "TRX Oblique Crunch": "trx oblique crunch",
};
const _norm = (s) => (s || "").toLowerCase();
const findExEntry = (db, name) => {
  const alias = EX_ALIAS[name]; if (!alias || !db || !db.length) return null;
  const words = _norm(alias).split(/\s+/).filter(Boolean);
  let best = null, bestScore = 0;
  for (const e of db) {
    const n = _norm(e.name);
    const score = words.filter((w) => n.includes(w)).length;
    if (score > bestScore) { bestScore = score; best = e; }
  }
  return (best && bestScore >= Math.ceil(words.length * 0.6)) ? best : null;
};
// Exakte free-exercise-db-Namen für den Direkt-Pfad (ohne Index). id = Name mit Unterstrichen.
const EX_FEDB = {
  "Bankdrücken (Langhantel)": "Barbell Bench Press - Medium Grip", "Schrägbank DB-Brustdrücken": "Incline Dumbbell Press",
  "Flachbank DB-Drücken": "Dumbbell Bench Press", "Pec Fly": "Butterfly", "Kabel-Crossover": "Cable Crossover", "Liegestütze": "Pushups",
  "Latzug (breit)": "Wide-Grip Lat Pulldown", "Latzug Maschine": "Wide-Grip Lat Pulldown", "Klimmzug": "Pullups", "Langhantelrudern": "Bent Over Barbell Row",
  // Hyperextensions-Bildordner lässt die Klammern weg → "Hyperextensions Back Extensions".
  "Rücken Extension Gerät": "Hyperextensions Back Extensions", "Preacher Curls Maschine": "Machine Preacher Curls",
  "Hammer Curls Seil": "Cable Hammer Curls - Rope Attachment", "Crunch auf Ball": "Exercise Ball Crunch", "Pec Fly sitzend Keiser": "Butterfly",
  "Rudern am Kabel": "Seated Cable Rows", "Einarmiges DB-Rudern": "One-Arm Dumbbell Row", "Kreuzheben": "Barbell Deadlift",
  "Schulterdrücken (DB)": "Dumbbell Shoulder Press", "Seitheben": "Side Lateral Raise", "Face Pulls": "Face Pull",
  "Nackenheben (Shrugs)": "Dumbbell Shrug", "Langhantel-Curls": "Barbell Curl", "Hammer DB Curls": "Hammer Curls",
  "Trizeps Pushdown": "Triceps Pushdown", "Kniebeuge": "Barbell Squat", "Frontkniebeuge": "Front Barbell Squat",
  "Beinpresse": "Leg Press", "Ausfallschritte": "Barbell Lunge", "Beinstrecker": "Leg Extensions", "Beinbeuger": "Lying Leg Curls",
  "Wadenheben": "Standing Calf Raises", "Plank": "Plank", "Crunch / Kabel-Crunch": "Cable Crunch", "Hängendes Beinheben": "Hanging Leg Raise",
  "Dips": "Dips - Triceps Version", "Enges Bankdrücken": "Close-Grip Barbell Bench Press", "Hip Thrust": "Barbell Hip Thrust",
};
// Übungsbild-Galerie (alle Bilder der Übung, horizontal swipebar). Zeigt nichts, wenn kein Bild ladbar.
function ExerciseImages({ name }) {
  const [urls, setUrls] = useState([]);
  const [bad, setBad] = useState({});
  useEffect(() => {
    let alive = true;
    const out = [];
    // Eigene Übung mit vom KI-Trainer ergänztem Bild (free-exercise-db-id oder volle URL)?
    const custom = find(name);
    if (custom && custom.img) {
      if (/^https?:\/\//.test(custom.img)) out.push(custom.img);
      else { const id = custom.img.replace(/ /g, "_"); out.push(`${EXDB_BASE}${id}/0.jpg`, `${EXDB_BASE}${id}/1.jpg`); }
    }
    const exact = EX_FEDB[name];
    if (exact) { const id = exact.replace(/ /g, "_"); out.push(`${EXDB_BASE}${id}/0.jpg`, `${EXDB_BASE}${id}/1.jpg`); }
    setUrls(out); setBad({});
    loadExDb().then((db) => {
      if (!alive) return;
      const e = findExEntry(db, name);
      if (e && e.images && e.images.length) {
        const more = e.images.map((p) => EXDB_BASE + p);
        setUrls((u) => Array.from(new Set([...more, ...u])));
      }
    });
    return () => { alive = false; };
  }, [name]);
  const live = urls.filter((u) => !bad[u]);
  if (!live.length) return null;
  return (
    <div>
      <div className="flex gap-2 rounded-2xl" style={{ overflowX: "auto", scrollSnapType: "x mandatory", WebkitOverflowScrolling: "touch" }}>
        {live.map((u) => (
          <img key={u} src={u} alt={name} loading="lazy" onError={() => setBad((b) => ({ ...b, [u]: true }))}
            style={{ flex: "0 0 100%", scrollSnapAlign: "center", width: "100%", maxHeight: 280, objectFit: "contain", background: "#0E1B17", borderRadius: 16, border: `1px solid ${C.line}` }} />
        ))}
      </div>
      {live.length > 1 && <div className="text-[11px] text-center mt-1" style={{ color: C.muted }}>← wischen für weitere Bilder ({live.length}) →</div>}
    </div>
  );
}

/* ---------- Übungs-Muskelfigur via body-muscles (Primär/Sekundär hervorgehoben) ---------- */
function ExerciseMuscleFigure({ exercise }) {
  const ref = React.useRef(null);
  const chartRef = React.useRef(null);
  const [view, setView] = useState("FRONT");
  const [lib, setLib] = useState(typeof window !== "undefined" ? window.BodyMuscles : null);
  useEffect(() => {
    if (lib || typeof window === "undefined") return;
    let n = 0; const iv = setInterval(() => { if (window.BodyMuscles) { setLib(window.BodyMuscles); clearInterval(iv); } else if (++n > 40) clearInterval(iv); }, 150);
    return () => clearInterval(iv);
  }, [lib]);
  const bodyState = useMemo(() => {
    const mi = exerciseMuscleInvolvementDisplay(exercise);
    const st = {};
    Object.keys(MUSCLES).forEach((m) => {
      const f = mi[m]; const intensity = f >= 1 ? 10 : f > 0 ? 5 : 0;
      if (intensity) MUSCLES[m].lib.forEach((id) => { const prev = st[id] ? st[id].intensity : 0; st[id] = { intensity: Math.max(prev, intensity), selected: false }; });
    });
    return st;
  }, [exercise]);
  useEffect(() => {
    if (!lib || !ref.current) return;
    try {
      chartRef.current = new lib.BodyChart(ref.current, { view: lib.ViewSide.FRONT, bodyState, ariaLabel: `Beanspruchte Muskeln: ${exercise.name}` });
    } catch (e) { console.error("BodyChart init failed", e); }
    return () => { try { chartRef.current && chartRef.current.destroy(); } catch (e) {} };
  }, [lib]);
  useEffect(() => { try { chartRef.current && chartRef.current.update({ bodyState }); } catch (e) {} }, [bodyState]);
  useEffect(() => { if (lib && chartRef.current) try { chartRef.current.update({ view: view === "FRONT" ? lib.ViewSide.FRONT : lib.ViewSide.BACK }); } catch (e) {} }, [view, lib]);

  if (!lib) return <div className="rounded-2xl p-6 text-center text-sm" style={{ background: C.surface, border: `1px dashed ${C.line}`, color: C.muted }}>Muskelfigur wird geladen … (braucht Internet)</div>;
  return (
    <div>
      <div className="flex gap-2 mb-2">
        {[["FRONT", "Vorderseite"], ["BACK", "Rückseite"]].map(([v, label]) => (
          <button key={v} onClick={() => setView(v)} className="flex-1 rounded-xl py-1.5 text-xs font-semibold"
            style={{ background: view === v ? C.surface2 : "transparent", color: view === v ? C.accent2 : C.muted, border: `1px solid ${view === v ? C.accent2 : C.line}` }}>{label}</button>
        ))}
      </div>
      <div ref={ref} style={{ maxWidth: 300, margin: "0 auto" }} />
      <div className="flex items-center justify-center gap-4 mt-1 text-[11px]" style={{ color: C.muted }}>
        <span className="flex items-center gap-1"><span style={{ width: 10, height: 10, borderRadius: 3, background: "#E0564A", display: "inline-block" }} />Primär</span>
        <span className="flex items-center gap-1"><span style={{ width: 10, height: 10, borderRadius: 3, background: "#E8B04B", display: "inline-block" }} />Sekundär</span>
      </div>
    </div>
  );
}

/* ---------- MuscleFigure (schematische Illustration) ---------- */
function MuscleFigure({ group }) {
  const gc = GROUP[group] || C.accent2;
  const base = C.surface2, line = C.line;
  const fill = (g) => (g === group ? gc : base);
  return (
    <svg viewBox="0 0 120 180" width="120" height="180" aria-label={`Beanspruchte Region: ${group}`}>
      {/* Beine */}
      <rect x="46" y="104" width="12" height="56" rx="6" fill={fill("Beine")} stroke={line} />
      <rect x="62" y="104" width="12" height="56" rx="6" fill={fill("Beine")} stroke={line} />
      {/* Arme */}
      <rect x="20" y="50" width="11" height="56" rx="5.5" fill={fill("Arme")} stroke={line} />
      <rect x="89" y="50" width="11" height="56" rx="5.5" fill={fill("Arme")} stroke={line} />
      {/* Lats / Rücken (Seitenstreifen am Torso) */}
      <rect x="36" y="52" width="8" height="40" rx="4" fill={fill("Rücken")} stroke={line} />
      <rect x="76" y="52" width="8" height="40" rx="4" fill={fill("Rücken")} stroke={line} />
      {/* Torso oben = Brust */}
      <rect x="42" y="46" width="36" height="26" rx="6" fill={fill("Brust")} stroke={line} />
      {/* Torso unten = Bauch */}
      <rect x="44" y="72" width="32" height="34" rx="6" fill={fill("Bauch")} stroke={line} />
      {/* Schultern */}
      <circle cx="36" cy="46" r="9" fill={fill("Schulter")} stroke={line} />
      <circle cx="84" cy="46" r="9" fill={fill("Schulter")} stroke={line} />
      {/* Kopf */}
      <circle cx="60" cy="22" r="11" fill={base} stroke={line} />
    </svg>
  );
}

/* ---------- MiniChart (Gewichtsentwicklung) ---------- */
function MiniChart({ data }) {
  if (data.length < 2)
    return <div className="text-sm rounded-xl p-4" style={{ color: C.muted, background: C.surface, border: `1px solid ${C.line}` }}>Ab der zweiten erfassten Einheit zeige ich hier deine Entwicklung.</div>;
  const W = 320, H = 170, pad = 30;
  const ws = data.map((d) => d.weight);
  const min = Math.min(...ws), max = Math.max(...ws), span = (max - min) || 1;
  const n = data.length;
  const x = (i) => pad + (i / (n - 1)) * (W - pad - 12);
  const y = (v) => pad - 6 + (1 - (v - min) / span) * (H - pad - 26);
  const pts = data.map((d, i) => `${x(i)},${y(d.weight)}`).join(" ");
  const delta = data[n - 1].weight - data[0].weight;
  return (
    <div className="rounded-xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
      <div className="flex items-baseline justify-between mb-1 px-1">
        <span className="text-xs" style={{ color: C.muted }}>Bestes Satz-Gewicht je Einheit</span>
        <span className="text-xs font-bold" style={{ color: delta >= 0 ? C.accent2 : C.danger, ...NUM }}>{delta >= 0 ? "+" : ""}{delta} kg</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: "block" }}>
        <line x1={pad} y1={y(min)} x2={W - 12} y2={y(min)} stroke={C.line} />
        <line x1={pad} y1={y(max)} x2={W - 12} y2={y(max)} stroke={C.line} />
        <text x={4} y={y(max) + 4} fontSize="10" fill={C.muted} style={NUM}>{max}</text>
        <text x={4} y={y(min) + 4} fontSize="10" fill={C.muted} style={NUM}>{min}</text>
        <polyline points={pts} fill="none" stroke={C.accent} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
        {data.map((d, i) => (
          <g key={i}>
            <circle cx={x(i)} cy={y(d.weight)} r="3.5" fill={C.accent} />
            {(i === 0 || i === n - 1) && <text x={x(i)} y={H - 8} fontSize="9" fill={C.muted} textAnchor={i === 0 ? "start" : "end"}>{d.label}</text>}
          </g>
        ))}
      </svg>
    </div>
  );
}

/* ---------- ExerciseDetail ---------- */
function ExerciseDetail({ exercise, history, onBack, onOpen, canEditSession, onReplace, onAddToSession, onExclude }) {
  const info = getInfo(exercise.name);
  const muscles = exercise.muscle || info.muscles;
  const gc = GROUP[exercise.group] || C.muted;
  const alts = alternatives(exercise.name);
  const sorted = [...history].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO));
  const withEx = sorted
    .map((s) => ({ s, e: (s.exercises || []).find((x) => x.name === exercise.name && (x.sets || []).length) }))
    .filter((o) => o.e);
  const last5 = withEx.slice(0, 5);
  const chart = [...withEx].reverse().map((o) => {
    const b = bestSet(o.e.sets);
    return { weight: b.weight, reps: b.reps, label: fmtDate(o.s.dateISO).replace(".", "") };
  });

  return (
    <div className="px-5 pb-12">
      <header className="pt-6 pb-3 flex items-center justify-between sticky top-0 z-10" style={{ background: C.bg }}>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>‹ Zurück</button>
        <span className="text-[10px] uppercase tracking-[0.18em]" style={{ color: gc }}>{exercise.group}</span>
      </header>

      <h1 className="text-2xl font-extrabold leading-tight" style={{ letterSpacing: "-0.02em" }}>{exercise.name}</h1>

      <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <ExerciseMuscleFigure exercise={exercise} />
      </div>

      <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Muskel-Beteiligung</h2>
      {(() => {
        const mi = exerciseMuscleInvolvementDisplay(exercise);
        const rows = Object.keys(mi).sort((a, b) => mi[b] - mi[a]);
        return (
          <div className="rounded-2xl overflow-hidden" style={{ border: `1px solid ${C.line}` }}>
            {rows.map((mid, i) => {
              const grp = muscleGroup(mid);
              return (
                <div key={mid} className="flex items-center justify-between px-4 py-2.5" style={{ background: i % 2 ? "#0E1B17" : C.surface, borderTop: i ? `1px solid ${C.line}` : "none" }}>
                  <div className="flex items-center gap-2 text-sm min-w-0">
                    <span style={{ width: 8, height: 8, borderRadius: 99, background: GROUP[grp] || C.muted, display: "inline-block" }} />
                    <span className="truncate">{muscleLabel(mid)}</span>
                    <span className="text-[10px] shrink-0" style={{ color: C.muted }}>· {grp}</span>
                  </div>
                  <span className="text-xs font-semibold rounded-full px-2.5 py-0.5 shrink-0" style={{ background: mi[mid] >= 1 ? C.accent2 : C.surface2, color: mi[mid] >= 1 ? "#0C1A15" : C.accent }}>
                    {mi[mid] >= 1 ? "Primär · 1,0" : "Sekundär · 0,5"}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })()}
      <p className="text-[11px] mt-1.5" style={{ color: C.muted }}>Effektive Sätze: pro Satz zählt jeder Primärmuskel 1,0 und jeder Sekundärmuskel 0,5 (Forschungsstandard „fractional set counting").</p>

      <div className="mt-6">
        <ExerciseImages name={exercise.name} />
      </div>

      <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <p className="text-sm" style={{ color: C.text }}>{info.desc}</p>
        <div className="text-[10px] uppercase tracking-widest mt-3" style={{ color: gc }}>Muskelgruppe</div>
        <div className="text-sm font-bold">{exercise.group}</div>
        <div className="text-[10px] uppercase tracking-widest mt-2" style={{ color: gc }}>Konkrete Muskeln</div>
        <div className="text-sm">{muscles}</div>
      </div>

      <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Worauf achten</h2>
      <ul className="flex flex-col gap-2">
        {info.cues.map((c, i) => (
          <li key={i} className="flex gap-2 text-sm" style={{ color: C.text }}>
            <span style={{ color: C.accent2 }}>›</span><span>{c}</span>
          </li>
        ))}
      </ul>

      {alts.length > 0 && (
        <>
          <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-1" style={{ color: C.accent }}>Alternativen</h2>
          <p className="text-xs mb-2" style={{ color: C.muted }}>Gleiche oder ähnliche Muskeln{canEditSession ? " – ersetzen, ergänzen oder antippen zum Ansehen." : " – tippen zum Ansehen."}</p>
          <div className="flex flex-col gap-2">
            {alts.map((a) => (
              <div key={a.name} className="rounded-xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <button onClick={() => onOpen(a, exercise.sessionExId)} className="w-full text-left">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold">{a.name}</span>
                    <span className="flex items-center gap-1 shrink-0">
                      {a.cat && a.cat !== "kraft" && <span className="text-[10px] font-semibold rounded-md px-2 py-0.5" style={{ color: C.accent, background: "#0E1B17", border: `1px solid ${C.line}` }}>{CAT_LABEL[a.cat] || a.cat}</span>}
                      <span className="text-[10px] font-semibold rounded-md px-2 py-0.5" style={{ color: GROUP[a.group] || C.muted, background: "#0E1B17" }}>{a.group}</span>
                    </span>
                  </div>
                  <div className="text-xs mt-1" style={{ color: C.muted }}>{a.muscle}</div>
                </button>
                {canEditSession && (
                  <div className="flex gap-2 mt-2.5">
                    {exercise.sessionExId && (
                      <button onClick={() => onReplace(a)} className="flex-1 rounded-lg py-2 font-semibold text-xs" style={{ background: C.accent2, color: "#0C1A15" }}>Übung ersetzen</button>
                    )}
                    <button onClick={() => onAddToSession(a)} className="flex-1 rounded-lg py-2 font-semibold text-xs" style={{ background: C.surface2, color: C.accent, border: `1px solid ${C.line}` }}>Zum Training hinzufügen</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {onExclude && (
        <button onClick={() => { if (window.confirm(`„${exercise.name}" künftig nicht mehr automatisch im dynamischen Training vorschlagen?`)) onExclude(exercise.name); }}
          className="w-full mt-6 rounded-xl py-3 font-semibold text-sm" style={{ background: "transparent", color: C.danger, border: `1px solid ${C.line}` }}>
          Übung von automatischer Auswahl ausnehmen
        </button>
      )}

      <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Letzte 5 Einheiten</h2>
      {last5.length === 0 ? (
        <div className="text-sm rounded-xl p-4" style={{ color: C.muted, background: C.surface, border: `1px dashed ${C.line}` }}>Noch nichts erfasst – nach deiner ersten Einheit erscheint hier dein Verlauf.</div>
      ) : (
        <div className="flex flex-col gap-2">
          {last5.map((o, i) => (
            <div key={i} className="rounded-xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <div className="text-xs font-semibold mb-1.5" style={{ color: C.muted }}>{fmtDate(o.s.dateISO)} · {o.s.day}</div>
              <div className="flex flex-wrap gap-1.5">
                {o.e.sets.map((x, k) => (
                  <span key={k} className="text-xs rounded-md px-2 py-0.5 font-semibold" style={{ background: "#0E1B17", color: C.text, ...NUM }}>{fmtSet(x)}{x.rir !== undefined ? ` · RIR ${x.rir}` : ""}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Entwicklung</h2>
      <MiniChart data={chart} />
    </div>
  );
}

/* ---------- Wochenvolumen je Muskelgruppe ---------- */
function VolumeBar({ n, scale }) {
  const status = groupStatus(n);
  const pctMin = (SET_MIN / scale) * 100;
  const pctZone = ((SET_MAX - SET_MIN) / scale) * 100;
  const pctFill = (Math.min(n, scale) / scale) * 100;
  return (
    <div className="relative rounded-full overflow-hidden" style={{ height: 12, background: "#0E1B17", border: `1px solid ${C.line}` }}>
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMin}%`, width: `${pctZone}%`, background: "rgba(95,185,154,0.16)" }} />
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMin}%`, width: 1, background: C.accent2, opacity: 0.5 }} />
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMin + pctZone}%`, width: 1, background: C.accent2, opacity: 0.5 }} />
      <div className="absolute top-0 bottom-0 rounded-full" style={{ left: 0, width: `${pctFill}%`, background: STATUS_COLOR[status] }} />
    </div>
  );
}
// Per-Muskel-Balken: Ist-Volumen gegen die muskelspezifische MEV–MAV-Zielzone (aus MUSCLE_VOLUME_TARGETS).
function MuscleVolumeBar({ v, mev, mav }) {
  const scale = Math.max(mav * 1.15, v, 1);
  const status = v === 0 ? "none" : v < mev ? "low" : v > mav ? "high" : "ok";
  const pctMev = (mev / scale) * 100;
  const pctZone = ((mav - mev) / scale) * 100;
  const pctFill = (Math.min(v, scale) / scale) * 100;
  return (
    <div className="relative rounded-full overflow-hidden" style={{ height: 6, background: "#0E1B17", border: `1px solid ${C.line}` }}>
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMev}%`, width: `${pctZone}%`, background: "rgba(95,185,154,0.16)" }} />
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMev}%`, width: 1, background: C.accent2, opacity: 0.5 }} />
      <div className="absolute top-0 bottom-0" style={{ left: `${pctMev + pctZone}%`, width: 1, background: C.accent2, opacity: 0.5 }} />
      <div className="absolute top-0 bottom-0 rounded-full" style={{ left: 0, width: `${pctFill}%`, background: STATUS_COLOR[status] }} />
    </div>
  );
}
// Muskelkarte für die Wochenübersicht: nutzt dieselbe body-muscles-Library wie BodyMuscleMap,
// färbt die Muskeln aber nach Volumen-Status (STATUS_COLOR) statt Heatmap. Die Library kennt nur
// eine gelb→rot-Palette, deshalb überschreiben wir die Pfad-Farben direkt (chartRef.musclePaths)
// nach jedem Update. Klick auf einen Muskel zeigt daneben Ist-Volumen, MEV & MAV.
function WeekBodyMap({ muscleEff }) {
  const ref = React.useRef(null);
  const chartRef = React.useRef(null);
  const [view, setView] = useState("FRONT");
  const [selM, setSelM] = useState(null);
  const [lib, setLib] = useState(typeof window !== "undefined" ? window.BodyMuscles : null);

  useEffect(() => {
    if (lib || typeof window === "undefined") return;
    let n = 0; const iv = setInterval(() => {
      if (window.BodyMuscles) { setLib(window.BodyMuscles); clearInterval(iv); }
      else if (++n > 40) clearInterval(iv);
    }, 150);
    return () => clearInterval(iv);
  }, [lib]);

  const statusByMuscle = useMemo(() => {
    const out = {};
    Object.keys(MUSCLES).forEach((m) => {
      const t = MUSCLE_VOLUME_TARGETS[m];
      const v = (muscleEff || {})[m] || 0;
      out[m] = !t ? (v > 0 ? "ok" : "none")
        : v === 0 ? "none" : v < t.mev ? "low" : v > t.mav ? "high" : "ok";
    });
    return out;
  }, [muscleEff]);

  const colorByLibId = useMemo(() => {
    const out = {};
    const bestVol = {};
    Object.keys(MUSCLES).forEach((m) => {
      const st = statusByMuscle[m];
      const v = (muscleEff || {})[m] || 0;
      const info = { col: STATUS_COLOR[st] || C.line, active: st !== "none" };
      MUSCLES[m].lib.forEach((id) => {
        // Mehrere Muskeln teilen sich Pfade (z. B. chest / chest_up / chest_low, glutes / abductors).
        // Nicht überschreiben, sondern den Muskel mit dem höheren Volumen behalten – sonst
        // übermalt eine untrainierte Teilregion die Färbung des trainierten Muskels (grau).
        if (!(id in out) || v > bestVol[id]) { out[id] = info; bestVol[id] = v; }
      });
    });
    return out;
  }, [statusByMuscle, muscleEff]);

  // bodyState nur für Auswahl-Highlight (weißer Rand + Glow der Library); Farbe setzen wir selbst.
  const bodyState = useMemo(() => {
    const st = {};
    Object.keys(MUSCLES).forEach((m) => {
      const sel = selM === m;
      MUSCLES[m].lib.forEach((id) => { st[id] = { intensity: 1, selected: sel }; });
    });
    return st;
  }, [selM]);

  const colRef = React.useRef(colorByLibId); colRef.current = colorByLibId;
  const selRef = React.useRef(selM); selRef.current = selM;
  const colorize = () => {
    const ch = chartRef.current; if (!ch || !ch.musclePaths) return;
    ch.musclePaths.forEach((el, id) => {
      const info = colRef.current[id];
      const m = LIBID_MUSCLE[id];
      el.setAttribute("fill", info ? info.col : C.line);
      el.style.fillOpacity = (info && info.active) || selRef.current === m ? "1" : "0.5";
    });
  };

  useEffect(() => {
    if (!lib || !ref.current) return;
    try {
      chartRef.current = new lib.BodyChart(ref.current, {
        view: lib.ViewSide.FRONT, bodyState, ariaLabel: "Muskelkarte – Wochenvolumen-Status je Muskel",
        onMuscleClick: (id) => { const m = LIBID_MUSCLE[id]; if (m) setSelM((p) => (p === m ? null : m)); },
      });
      colorize();
    } catch (e) { console.error("BodyChart init failed", e); }
    return () => { try { chartRef.current && chartRef.current.destroy(); } catch (e) {} };
  }, [lib]);
  useEffect(() => { try { if (chartRef.current) { chartRef.current.update({ bodyState }); colorize(); } } catch (e) {} }, [bodyState]);
  useEffect(() => { if (lib && chartRef.current) try { chartRef.current.update({ view: view === "FRONT" ? lib.ViewSide.FRONT : lib.ViewSide.BACK }); colorize(); } catch (e) {} }, [view, lib]);
  useEffect(() => { colorize(); }, [colorByLibId]);

  const tSel = selM ? MUSCLE_VOLUME_TARGETS[selM] : null;
  const vSel = selM ? ((muscleEff || {})[selM] || 0) : 0;
  const stSel = selM ? statusByMuscle[selM] : null;
  const STATUS_TEXT = { none: "diese Woche nicht trainiert", low: "unter der Zielzone (MEV)", ok: "in der Zielzone", high: "über der oberen Grenze (MAV)" };

  return (
    <div className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
      <div className="flex gap-2 mb-3">
        {[["FRONT", "Vorderseite"], ["BACK", "Rückseite"]].map(([v, label]) => (
          <button key={v} onClick={() => setView(v)} className="flex-1 rounded-xl py-1.5 text-sm font-semibold"
            style={{ background: view === v ? C.surface2 : "transparent", color: view === v ? C.accent2 : C.muted, border: `1px solid ${view === v ? C.accent2 : C.line}` }}>{label}</button>
        ))}
      </div>
      {!lib ? (
        <div className="text-sm text-center py-6" style={{ color: C.muted }}>Muskelkarte wird geladen … (braucht Internet). Erscheint nichts, bitte Seite neu laden.</div>
      ) : (
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
          <div ref={ref} style={{ width: 130, flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0, paddingTop: 2 }}>
            {selM ? (
              <>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-bold text-sm leading-tight">{muscleLabel(selM)}</div>
                    <div className="text-[11px]" style={{ color: C.muted }}>{muscleGroup(selM)}</div>
                  </div>
                  <button onClick={() => setSelM(null)} className="text-xs shrink-0 ml-2" style={{ color: C.muted }} aria-label="Auswahl schließen">✕</button>
                </div>
                <div className="flex items-baseline justify-between text-xs mt-2 mb-1">
                  <span style={{ color: C.muted }}>Ist-Volumen</span>
                  <span style={{ ...NUM }}><b style={{ color: C.text }}>{fmtSets(vSel)}</b> eff. Sätze</span>
                </div>
                {tSel ? (
                  <>
                    <MuscleVolumeBar v={vSel} mev={tSel.mev} mav={tSel.mav} />
                    <div className="flex justify-between text-[11px] mt-1.5" style={{ ...NUM, color: C.muted }}>
                      <span>MEV {tSel.mev}</span><span>MAV {tSel.mav}</span>
                    </div>
                  </>
                ) : <div className="text-[11px] mt-1" style={{ color: C.muted }}>Keine muskelspezifische Zielzone hinterlegt.</div>}
                <div className="text-[11px] mt-2 font-semibold" style={{ color: STATUS_COLOR[stSel] || C.muted }}>{STATUS_TEXT[stSel]}</div>
              </>
            ) : (
              <>
                <div className="text-xs mb-2.5" style={{ color: C.muted }}>Tippe einen Muskel für Ist-Volumen, MEV &amp; MAV.</div>
                <div className="flex flex-col gap-1.5">
                  {[["ok", "in Zielzone (MEV–MAV)"], ["low", "unter Ziel"], ["high", "über Ziel"], ["none", "nicht trainiert"]].map(([s, lab]) => (
                    <div key={s} className="flex items-center gap-2 text-[11px]">
                      <span style={{ width: 11, height: 11, borderRadius: 3, background: STATUS_COLOR[s], display: "inline-block", opacity: s === "none" ? 0.5 : 1 }} />
                      <span style={{ color: C.muted }}>{lab}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {lib && <div className="text-[11px] text-center mt-2" style={{ color: C.muted }}>Waden, Beinbeuger, Gesäß, Trizeps, hintere Schulter &amp; Rücken auf der <b style={{ color: C.accent2 }}>Rückseite</b>.</div>}
    </div>
  );
}

function WeeklyVolume({ history, onBack, onAnalyze }) {
  const buckets = useMemo(() => weeklyBuckets(history), [history]);
  const [wi, setWi] = useState(0);
  const cur = buckets[wi];
  const counts = cur ? effectiveSetsByGroup(cur.sessions) : null;
  const muscleEff = cur ? effectiveSetsByMuscle(cur.sessions) : {};
  const [expanded, setExpanded] = useState(null);
  const prev = buckets[wi + 1];
  const prevCounts = prev ? effectiveSetsByGroup(prev.sessions) : null;
  const totalHard = counts ? Object.values(counts).reduce((a, b) => a + b, 0) : 0;
  const scale = counts ? Math.max(SET_MAX + 4, ...Object.values(counts)) : SET_MAX + 4;
  const hints = counts ? balanceHints(counts) : [];

  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Wochenvolumen</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Harte Sätze</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>

      {!buckets.length ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Noch keine Daten</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Nach deinen ersten Einheiten erscheint hier das Wochenvolumen je Muskelgruppe.</div>
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between rounded-2xl p-3 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
            <button onClick={() => setWi((i) => Math.min(buckets.length - 1, i + 1))} disabled={wi >= buckets.length - 1} className="rounded-lg px-3 py-1.5 text-sm font-bold" style={{ color: wi >= buckets.length - 1 ? C.muted : C.accent2, opacity: wi >= buckets.length - 1 ? 0.4 : 1 }}>‹</button>
            <div className="text-center">
              <div className="font-bold">{fmtWeekRange(cur.key)}</div>
              <div className="text-xs" style={{ color: C.muted }}>{wi === 0 ? "aktuelle Woche" : `vor ${wi} Woche${wi > 1 ? "n" : ""}`} · {cur.sessions.length} Einheiten · {fmtSets(totalHard)} eff. Sätze</div>
            </div>
            <button onClick={() => setWi((i) => Math.max(0, i - 1))} disabled={wi === 0} className="rounded-lg px-3 py-1.5 text-sm font-bold" style={{ color: wi === 0 ? C.muted : C.accent2, opacity: wi === 0 ? 0.4 : 1 }}>›</button>
          </div>

          {/* 1) Muskelkarte nach Volumen-Status */}
          <WeekBodyMap muscleEff={muscleEff} />

          {/* 2) Letzte Trainingseinheiten dieser Woche */}
          <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Trainingseinheiten <span className="font-normal normal-case tracking-normal" style={{ color: C.muted }}>· {cur.sessions.length}</span></h2>
          <div className="flex flex-col gap-2 mb-2">
            {[...cur.sessions].sort((a, b) => new Date(b.dateISO) - new Date(a.dateISO)).map((s) => {
              const strength = !isCond(s);
              return (
                <button key={s.id} onClick={() => strength && onAnalyze && onAnalyze(s)} className="w-full text-left rounded-xl p-3"
                  style={{ background: C.surface, border: `1px solid ${isCond(s) ? condAccent(s.type) : C.line}`, cursor: strength && onAnalyze ? "pointer" : "default" }}>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-semibold text-sm">{isCond(s) ? `${condIcon(s.type)} ${s.activity}` : s.day}</div>
                      <div className="text-[11px]" style={{ color: C.muted }}>{fmtDate(s.dateISO)}</div>
                    </div>
                    <div className="text-right text-[11px]" style={{ color: C.muted }}>
                      {isCond(s) ? (
                        <div><b style={{ color: C.text, ...NUM }}>{s.durationMin}</b> Min</div>
                      ) : (
                        <>
                          <div><b style={{ color: C.text, ...NUM }}>{totalSets(s)}</b> Sätze</div>
                          <div><b style={{ color: C.text, ...NUM }}>{Math.round(volume(s)).toLocaleString("de-DE")}</b> kg</div>
                        </>
                      )}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>

          {/* 3) Volumen-Balken je Gruppe (aufklappbar bis Einzelmuskel) */}
          <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Volumen je Muskelgruppe</h2>
          <div className="flex flex-col gap-3.5">
            {MUSCLE_GROUPS.map((g) => {
              const n = counts[g];
              const delta = prevCounts ? n - prevCounts[g] : null;
              const open = expanded === g;
              const muscles = Object.keys(MUSCLES).filter((m) => MUSCLES[m].grp === g).map((m) => ({ m, v: muscleEff[m] || 0 })).sort((a, b) => b.v - a.v);
              return (
                <div key={g}>
                  <button onClick={() => setExpanded(open ? null : g)} className="w-full text-left">
                    <div className="flex items-center justify-between mb-1.5">
                      <div className="flex items-center gap-2">
                        <span style={{ width: 8, height: 8, borderRadius: 99, background: GROUP[g] || C.muted, display: "inline-block" }} />
                        <span className="font-semibold text-sm">{g}</span>
                        {muscles.length > 0 && <span className="text-[10px]" style={{ color: C.muted }}>{open ? "▾" : "▸"}</span>}
                      </div>
                      <div className="text-xs" style={{ ...NUM, color: C.muted }}>
                        <b style={{ color: C.text }}>{fmtSets(n)}</b> eff. Sätze
                        {delta != null && Math.abs(delta) >= 0.05 && <span style={{ color: delta > 0 ? C.accent2 : C.danger }}> · {delta > 0 ? "+" : ""}{fmtSets(delta)}</span>}
                      </div>
                    </div>
                    <VolumeBar n={n} scale={scale} />
                  </button>
                  {open && (
                    <div className="mt-2 ml-4 flex flex-col gap-2.5">
                      {muscles.map(({ m, v }) => {
                        const t = MUSCLE_VOLUME_TARGETS[m];
                        return (
                          <div key={m} className="flex flex-col gap-1">
                            <div className="flex items-center justify-between text-xs" style={{ color: C.muted }}>
                              <span>{muscleLabel(m)}</span>
                              <span style={{ ...NUM }}>
                                <b style={{ color: C.text }}>{fmtSets(v)}</b> eff. Sätze
                                {t && <span> · MEV {t.mev} · MAV {t.mav}</span>}
                              </span>
                            </div>
                            {t && <MuscleVolumeBar v={v} mev={t.mev} mav={t.mav} />}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="text-[11px] mt-3" style={{ color: C.muted }}>Zielkorridor {SET_MIN}–{SET_MAX} effektive Sätze/Woche (Primär 1,0 · Sekundär 0,5). Unter Ziel = gelb, im Ziel = grün, deutlich darüber = rot. Gruppe aufklappen zeigt je Muskel Ist-Volumen gegen die muskelspezifische Zielzone <b style={{ color: C.text }}>MEV</b> (Minimum fürs Wachstum) bis <b style={{ color: C.text }}>MAV</b> (obere produktive Grenze).</div>

          <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Hinweise</h2>
          <div className="flex flex-col gap-2">
            {hints.map((h, i) => (
              <div key={i} className="rounded-xl p-3 text-sm flex gap-2" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <span style={{ color: STATUS_COLOR[h.tone] || C.muted }}>●</span>
                <span style={{ color: C.text }}>{h.text}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ---------- Trainingsanalyse nach der Einheit ---------- */
const TONE_COLOR = { progress: C.accent2, easy: C.accent, caution: C.danger, neutral: C.muted, ok: C.accent2 };
function SessionAnalysis({ session, history, onBack, onHistory, onOpenDetail }) {
  const a = useMemo(() => analyzeSession(session, history), [session, history]);
  const [expG, setExpG] = useState(null);
  const activeGroups = MUSCLE_GROUPS.filter((g) => a.groups[g] > 0);
  const gScale = Math.max(1, ...activeGroups.map((g) => a.groups[g]));
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Auswertung</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>{session.day}</h1>
          <div className="text-xs mt-1" style={{ color: C.muted }}>{fmtDate(session.dateISO)}</div>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Fertig</button>
      </header>

      <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface2, border: `1px solid ${TONE_COLOR[a.verdictTone] || C.line}` }}>
        <div className="text-xs uppercase tracking-widest" style={{ color: TONE_COLOR[a.verdictTone] || C.accent }}>Fazit</div>
        <div className="font-bold mt-1 leading-snug">{a.verdict}</div>
      </div>

      {session.note && session.note.trim() && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
          <div className="text-xs uppercase tracking-widest mb-1" style={{ color: C.accent }}>📝 Deine Notiz</div>
          <div className="text-sm leading-snug whitespace-pre-wrap" style={{ color: C.text }}>{session.note}</div>
        </div>
      )}

      <div className="grid grid-cols-3 gap-2 mb-4">
        {[
          { k: "Volumen", v: `${Math.round(a.vol).toLocaleString("de-DE")}`, u: "kg", sub: a.volPct != null ? `${a.volPct > 0 ? "+" : ""}${a.volPct}% vs. letztes Mal` : "erste Einheit" },
          { k: "Sätze", v: a.sets, u: "", sub: `${activeGroups.length} Muskelgruppen` },
          { k: "Ø RIR", v: a.avgRir != null ? a.avgRir.toFixed(1) : "–", u: "", sub: a.avgRir == null ? "kein RIR erfasst" : a.avgRir < 1 ? "sehr hart" : a.avgRir <= 2 ? "ideal" : "Reserven" },
        ].map((c) => (
          <div key={c.k} className="rounded-2xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
            <div className="text-[10px] uppercase tracking-widest" style={{ color: C.muted }}>{c.k}</div>
            <div className="font-extrabold text-xl mt-1" style={{ ...NUM }}>{c.v}<span className="text-xs font-semibold" style={{ color: C.muted }}>{c.u ? " " + c.u : ""}</span></div>
            <div className="text-[10px] mt-1" style={{ color: C.muted }}>{c.sub}</div>
          </div>
        ))}
      </div>

      {a.prs.length > 0 && (
        <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.accent2}` }}>
          <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent2 }}>Neue Rekorde 🏆</div>
          <div className="flex flex-col gap-1.5">
            {a.prs.map((p, i) => (
              <div key={i} className="flex items-center justify-between text-sm">
                <span className="font-semibold">{p.name}</span>
                <span style={{ ...NUM, color: C.text }}>{p.weight} kg × {p.reps}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {(a.failCount > 0 || a.easyCount > 0) && (
        <div className="rounded-xl p-3 mb-4 text-sm" style={{ background: C.surface, border: `1px solid ${C.line}`, color: C.muted }}>
          Intensität: {a.failCount > 0 && <span><b style={{ color: C.danger }}>{a.failCount}</b> Sätze bis Versagen (RIR 0)</span>}
          {a.failCount > 0 && a.easyCount > 0 && " · "}
          {a.easyCount > 0 && <span><b style={{ color: C.accent }}>{a.easyCount}</b> Sätze mit Reserve (RIR ≥ 3)</span>}
        </div>
      )}

      <h2 className="text-sm font-bold uppercase tracking-widest mt-2 mb-2" style={{ color: C.accent }}>Muskelgruppen heute <span className="font-normal normal-case tracking-normal" style={{ color: C.muted }}>· tippen für Muskeln</span></h2>
      <div className="flex flex-col gap-2.5 mb-2">
        {activeGroups.map((g) => {
          const open = expG === g;
          const muscles = Object.keys(MUSCLES).filter((m) => MUSCLES[m].grp === g).map((m) => ({ m, v: a.muscles[m] || 0 })).filter((o) => o.v > 0).sort((x, y) => y.v - x.v);
          return (
            <div key={g}>
              <button onClick={() => setExpG(open ? null : g)} className="w-full text-left">
                <div className="flex items-center justify-between mb-1">
                  <div className="flex items-center gap-2 text-sm font-semibold">
                    <span style={{ width: 8, height: 8, borderRadius: 99, background: GROUP[g] || C.muted, display: "inline-block" }} />{g}
                    {muscles.length > 0 && <span className="text-[10px]" style={{ color: C.muted }}>{open ? "▾" : "▸"}</span>}
                  </div>
                  <span className="text-xs" style={{ ...NUM, color: C.muted }}>{fmtSets(a.groups[g])} eff. Sätze</span>
                </div>
                <div className="rounded-full overflow-hidden" style={{ height: 8, background: "#0E1B17" }}>
                  <div style={{ height: "100%", width: `${(a.groups[g] / gScale) * 100}%`, background: GROUP[g] || C.accent2 }} />
                </div>
              </button>
              {open && (
                <div className="mt-1.5 ml-4 flex flex-col gap-1">
                  {muscles.map(({ m, v }) => (
                    <div key={m} className="flex items-center justify-between text-xs" style={{ color: C.muted }}>
                      <span>{muscleLabel(m)}</span>
                      <span style={{ ...NUM }}><b style={{ color: C.text }}>{fmtSets(v)}</b> eff. Sätze</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.accent }}>Nächstes Mal</h2>
      <div className="flex flex-col gap-2">
        {a.tips.map((t, i) => (
          <button key={i} onClick={() => onOpenDetail && onOpenDetail({ name: t.name, group: t.group, muscle: t.muscle })} className="text-left rounded-xl p-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
            <div className="font-semibold text-sm">{t.name}</div>
            <div className="text-xs mt-0.5" style={{ color: TONE_COLOR[t.tone] || C.muted }}>{t.text}</div>
          </button>
        ))}
      </div>

      <button onClick={onHistory} className="w-full mt-6 rounded-2xl py-3 text-sm font-semibold" style={{ background: C.surface, color: C.accent2, border: `1px solid ${C.line}` }}>Ganzen Verlauf ansehen</button>
    </div>
  );
}

/* ---------- Rechner: Hantelscheiben + Aufwärmsätze ---------- */
const PLATES_KG = [25, 20, 15, 10, 5, 2.5, 1.25, 0.5];
const platesPerSide = (total, bar, plates = PLATES_KG) => {
  const diff = (Number(total) || 0) - (Number(bar) || 0);
  if (diff < 0) return { invalid: true, perSide: 0, plates: [], remainder: 0 };
  let rem = Math.round((diff / 2) * 100) / 100;
  const out = [];
  for (const p of plates) { while (rem >= p - 1e-9) { out.push(p); rem = Math.round((rem - p) * 100) / 100; } }
  return { invalid: false, perSide: diff / 2, plates: out, remainder: rem };
};
const round2_5 = (x) => Math.round((Number(x) || 0) / 2.5) * 2.5;
const warmupSets = (working) => {
  const w = Number(working) || 0;
  if (w <= 0) return [];
  return [
    { label: "Leere Stange / Mobilität", weight: null, reps: "8–10" },
    { label: "40 %", weight: round2_5(w * 0.4), reps: "8" },
    { label: "60 %", weight: round2_5(w * 0.6), reps: "5" },
    { label: "80 %", weight: round2_5(w * 0.8), reps: "3" },
  ];
};
function ToolsView({ onBack }) {
  const [weight, setWeight] = useState("");
  const [bar, setBar] = useState(20);
  const w = parseNum(weight);
  const valid = Number.isFinite(w) && w > 0;
  const pp = valid ? platesPerSide(w, bar) : null;
  const wu = valid ? warmupSets(w) : [];
  const inp = { background: C.surface, color: C.text, border: `1px solid ${C.line}`, ...NUM };
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>🧮 Rechner</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Scheiben & Aufwärmen</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <div className="grid grid-cols-2 gap-3">
        <label className="block">
          <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Arbeitsgewicht (kg)</div>
          <input type="text" inputMode="decimal" value={weight} onChange={(e) => setWeight(e.target.value)} placeholder="z.B. 100"
            className="w-full rounded-xl px-3 py-3 outline-none" style={inp} />
        </label>
        <label className="block">
          <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Stange (kg)</div>
          <input type="text" inputMode="decimal" value={bar} onChange={(e) => setBar(e.target.value)} placeholder="20"
            className="w-full rounded-xl px-3 py-3 outline-none" style={inp} />
        </label>
      </div>

      {/* Hantelscheiben */}
      <div className="rounded-2xl p-4 mt-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent2 }}>Hantelscheiben je Seite</div>
        {!valid ? (
          <div className="text-sm" style={{ color: C.muted }}>Gewicht eingeben.</div>
        ) : pp.invalid ? (
          <div className="text-sm" style={{ color: C.danger }}>Zielgewicht ist kleiner als die Stange.</div>
        ) : pp.plates.length === 0 ? (
          <div className="text-sm" style={{ color: C.muted }}>Nur die Stange ({parseNum(bar) || 0} kg) – keine Scheiben.</div>
        ) : (
          <>
            <div className="flex flex-wrap gap-1.5">
              {pp.plates.map((p, i) => (
                <span key={i} className="text-sm font-bold rounded-lg px-2.5 py-1" style={{ background: "#0E1B17", color: C.accent2, border: `1px solid ${C.line}`, ...NUM }}>{String(p).replace(".", ",")}</span>
              ))}
            </div>
            <div className="text-xs mt-2" style={{ color: C.muted }}>
              je Seite <b style={{ color: C.text, ...NUM }}>{String(Math.round(pp.perSide * 100) / 100).replace(".", ",")}</b> kg
              {pp.remainder > 0 && <span style={{ color: C.danger }}> · {String(pp.remainder).replace(".", ",")} kg nicht exakt darstellbar</span>}
            </div>
          </>
        )}
      </div>

      {/* Aufwärmsätze */}
      <div className="rounded-2xl p-4 mt-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
        <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent2 }}>Aufwärmsätze</div>
        {!valid ? (
          <div className="text-sm" style={{ color: C.muted }}>Gewicht eingeben.</div>
        ) : (
          <div className="flex flex-col gap-1.5">
            {wu.map((s, i) => (
              <div key={i} className="flex items-center justify-between rounded-lg px-3 py-2" style={{ background: "#0E1B17" }}>
                <span className="text-xs font-semibold" style={{ color: C.muted }}>{s.label}</span>
                <span className="font-bold" style={{ ...NUM }}>{s.weight == null ? "—" : `${String(s.weight).replace(".", ",")} kg`} × {s.reps}</span>
              </div>
            ))}
            <div className="text-[11px] mt-1" style={{ color: C.muted }}>Richtwert vor schweren Grundübungen; danach das Arbeitsgewicht. Auf 2,5 kg gerundet.</div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ---------- Körpermesswerte ---------- */
// Stabile Eingabe-Komponente auf Modulebene: NICHT innerhalb des Renders definieren,
// sonst bekommt React bei jedem Tastendruck eine neue Komponenten-Identität → Input wird
// neu gemountet → Cursor springt. Wert/onChange kommen als Props (kontrolliert).
function NumField({ label, value, onChange, placeholder, accent }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: accent || C.muted }}>{label}</div>
      <input type="text" inputMode="decimal" value={value} onChange={onChange} placeholder={placeholder}
        className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, ...NUM }} />
    </label>
  );
}
// Bild (auch HEIC vom iPhone) → herunterskaliertes JPEG-DataURL. Safari/iOS dekodiert HEIC
// nativ; EXIF-Ausrichtung wird beim Zeichnen angewendet. Inhaltliche Drehung des Waagen-
// Displays übernimmt später die KI-Auswertung.
async function fileToJpegDataUrl(file, maxPx = 1500, quality = 0.82) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = () => reject(new Error("decode"));
      im.src = url;
    });
    let w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    if (!w || !h) throw new Error("empty");
    const scale = Math.min(1, maxPx / Math.max(w, h));
    w = Math.max(1, Math.round(w * scale)); h = Math.max(1, Math.round(h * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
    return canvas.toDataURL("image/jpeg", quality);
  } finally { URL.revokeObjectURL(url); }
}

/* ---------- Körperzusammensetzungs-Figur via body-muscles (seitliche Legende) ---------- */
const BCF_ARM_L = ["biceps-left","triceps-long-left","triceps-lateral-left","forearm-left","forearm-flexors-left","forearm-extensors-left","shoulder-front-left","shoulder-side-left","deltoid-rear-left"];
const BCF_ARM_R = ["biceps-right","triceps-long-right","triceps-lateral-right","forearm-right","forearm-flexors-right","forearm-extensors-right","shoulder-front-right","shoulder-side-right","deltoid-rear-right"];
const BCF_TRUNK = ["chest-upper-left","chest-upper-right","chest-lower-left","chest-lower-right","abs-upper-left","abs-upper-right","abs-lower-left","abs-lower-right","obliques-left","obliques-right","lats-upper-left","lats-mid-left","lats-lower-left","lats-upper-right","lats-mid-right","lats-lower-right","lower-back-erectors-left","lower-back-erectors-right","traps-upper-left","traps-upper-right"];
const BCF_LEG_L = ["quads-left","hamstrings-medial-left","hamstrings-lateral-left","adductors-left","calves-gastroc-medial-left","calves-gastroc-lateral-left","calves-soleus-left","gluteus-maximus-left","gluteus-medius-left"];
const BCF_LEG_R = ["quads-right","hamstrings-medial-right","hamstrings-lateral-right","adductors-right","calves-gastroc-medial-right","calves-gastroc-lateral-right","calves-soleus-right","gluteus-maximus-right","gluteus-medius-right"];

function BodyCompositionFigure({ wEntry, prevWEntry }) {
  const [mode, setMode] = useState("muscle");
  const ref = React.useRef(null);
  const chartRef = React.useRef(null);
  const [lib, setLib] = useState(typeof window !== "undefined" ? window.BodyMuscles : null);

  useEffect(() => {
    if (lib || typeof window === "undefined") return;
    let n = 0;
    const iv = setInterval(() => {
      if (window.BodyMuscles) { setLib(window.BodyMuscles); clearInterval(iv); }
      else if (++n > 40) clearInterval(iv);
    }, 150);
    return () => clearInterval(iv);
  }, [lib]);

  const bcfNorm = (val, lo, hi) => val == null ? 0 : Math.max(1, Math.min(10, Math.round((val - lo) / (hi - lo) * 10)));

  const isMuscle = mode === "muscle";

  const bodyState = useMemo(() => {
    if (!wEntry) return {};
    const w = wEntry.weight_kg;
    const pct = (kg) => kg != null && w ? (kg / w) * 100 : null;
    const kfa = (fat, ff) => fat != null && ff != null ? (fat / (fat + ff)) * 100 : null;
    let iAL, iAR, iT, iLL, iLR;
    if (isMuscle) {
      // hoch = hohe Intensität; nach hue-rotate(120deg) wird Rot→Grün (viel Muskel = grün)
      iAL = bcfNorm(pct(wEntry.left_arm_muscle_mass_kg), 3, 7);
      iAR = bcfNorm(pct(wEntry.right_arm_muscle_mass_kg), 3, 7);
      iT  = bcfNorm(pct(wEntry.trunk_muscle_mass_kg), 30, 50);
      iLL = bcfNorm(pct(wEntry.left_leg_muscle_mass_kg), 10, 18);
      iLR = bcfNorm(pct(wEntry.right_leg_muscle_mass_kg), 10, 18);
    } else {
      // hoch = hohe Intensität; keine Rotation → viel Fett = rot (Library-Heatmap passt)
      iAL = bcfNorm(kfa(wEntry.left_arm_fat_mass_kg, wEntry.left_arm_fat_free_mass_kg), 5, 30);
      iAR = bcfNorm(kfa(wEntry.right_arm_fat_mass_kg, wEntry.right_arm_fat_free_mass_kg), 5, 30);
      iT  = bcfNorm(kfa(wEntry.trunk_fat_mass_kg, wEntry.trunk_fat_free_mass_kg), 5, 40);
      iLL = bcfNorm(kfa(wEntry.left_leg_fat_mass_kg, wEntry.left_leg_fat_free_mass_kg), 5, 30);
      iLR = bcfNorm(kfa(wEntry.right_leg_fat_mass_kg, wEntry.right_leg_fat_free_mass_kg), 5, 30);
    }
    const st = {};
    BCF_ARM_L.forEach(id => { st[id] = { intensity: iAL }; });
    BCF_ARM_R.forEach(id => { st[id] = { intensity: iAR }; });
    BCF_TRUNK.forEach(id => { st[id] = { intensity: iT }; });
    BCF_LEG_L.forEach(id => { st[id] = { intensity: iLL }; });
    BCF_LEG_R.forEach(id => { st[id] = { intensity: iLR }; });
    return st;
  }, [wEntry, isMuscle]);

  useEffect(() => {
    if (!lib || !ref.current || !wEntry) return;
    try {
      chartRef.current = new lib.BodyChart(ref.current, {
        view: lib.ViewSide.FRONT, bodyState, ariaLabel: "Körperzusammensetzung – Segmente",
      });
    } catch (e) { console.error("BodyChart init failed", e); }
    return () => { try { if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; } } catch (e) {} };
  }, [lib, wEntry]);

  useEffect(() => {
    try { if (chartRef.current) chartRef.current.update({ bodyState }); } catch (e) {}
  }, [bodyState]);

  if (!wEntry) return null;

  const w = wEntry.weight_kg;
  const n1 = (v) => v != null ? +Number(v).toFixed(1) : null;
  const fmt = (v) => v == null ? "—" : `${n1(v)} kg`;
  const pctBWRaw = (kg) => kg != null && w ? +((kg / w) * 100) : null;
  const kfaRaw = (fat, ff) => fat != null && ff != null ? +((fat / (fat + ff)) * 100) : null;

  // body-muscles library heatmap: intensity 1=light-yellow → 10=dark-red (same 10 steps as library)
  const HEAT = ["#fde047","#facc15","#eab308","#fb923c","#f97316","#ea580c","#ef4444","#dc2626","#b91c1c","#7f1d1d"];
  const applyHueRotSat = (hex, deg, sat) => {
    const p = (s, i) => parseInt(s.slice(i,i+2),16);
    const r = p(hex,1), g = p(hex,3), b = p(hex,5);
    const rad = deg*Math.PI/180, c = Math.cos(rad), sn = Math.sin(rad);
    let R = r*(0.213+c*0.787-sn*0.213)+g*(0.715-c*0.715-sn*0.715)+b*(0.072-c*0.072+sn*0.928);
    let G = r*(0.213-c*0.213+sn*0.143)+g*(0.715+c*0.285+sn*0.140)+b*(0.072-c*0.072-sn*0.283);
    let B = r*(0.213-c*0.213-sn*0.787)+g*(0.715-c*0.715+sn*0.715)+b*(0.072+c*0.928+sn*0.072);
    const gr = 0.2126*R+0.7152*G+0.0722*B;
    R = gr+(R-gr)*sat; G = gr+(G-gr)*sat; B = gr+(B-gr)*sat;
    const h = v => Math.round(Math.min(255,Math.max(0,v))).toString(16).padStart(2,'0');
    return '#'+h(R)+h(G)+h(B);
  };
  const segColor = (intensity) => {
    const hex = HEAT[Math.max(0, Math.min(9, Math.round(intensity) - 1))];
    return isMuscle ? applyHueRotSat(hex, 120, 1.2) : hex;
  };
  const trendArrow = (cur, prev) => {
    if (cur == null || prev == null || Math.abs(cur - prev) < 0.01) return null;
    const up = cur > prev;
    const good = isMuscle ? up : !up;
    return <span style={{ marginLeft: 4, fontSize: 11, color: good ? GRN : RED }}>{up ? "↑" : "↓"}</span>;
  };

  const segs = isMuscle ? [
    { lbl: "Torso",  kg: wEntry.trunk_muscle_mass_kg,      pRaw: pctBWRaw(wEntry.trunk_muscle_mass_kg),     prevRaw: prevWEntry ? pctBWRaw(prevWEntry.trunk_muscle_mass_kg) : null,     i: bcfNorm(pctBWRaw(wEntry.trunk_muscle_mass_kg), 30, 50) },
    { lbl: "Arm L",  kg: wEntry.left_arm_muscle_mass_kg,   pRaw: pctBWRaw(wEntry.left_arm_muscle_mass_kg),  prevRaw: prevWEntry ? pctBWRaw(prevWEntry.left_arm_muscle_mass_kg) : null,  i: bcfNorm(pctBWRaw(wEntry.left_arm_muscle_mass_kg), 3, 7) },
    { lbl: "Arm R",  kg: wEntry.right_arm_muscle_mass_kg,  pRaw: pctBWRaw(wEntry.right_arm_muscle_mass_kg), prevRaw: prevWEntry ? pctBWRaw(prevWEntry.right_arm_muscle_mass_kg) : null, i: bcfNorm(pctBWRaw(wEntry.right_arm_muscle_mass_kg), 3, 7) },
    { lbl: "Bein L", kg: wEntry.left_leg_muscle_mass_kg,   pRaw: pctBWRaw(wEntry.left_leg_muscle_mass_kg),  prevRaw: prevWEntry ? pctBWRaw(prevWEntry.left_leg_muscle_mass_kg) : null,  i: bcfNorm(pctBWRaw(wEntry.left_leg_muscle_mass_kg), 10, 18) },
    { lbl: "Bein R", kg: wEntry.right_leg_muscle_mass_kg,  pRaw: pctBWRaw(wEntry.right_leg_muscle_mass_kg), prevRaw: prevWEntry ? pctBWRaw(prevWEntry.right_leg_muscle_mass_kg) : null, i: bcfNorm(pctBWRaw(wEntry.right_leg_muscle_mass_kg), 10, 18) },
  ] : [
    { lbl: "Torso",  kg: wEntry.trunk_fat_mass_kg,         pRaw: kfaRaw(wEntry.trunk_fat_mass_kg, wEntry.trunk_fat_free_mass_kg),                           prevRaw: kfaRaw(prevWEntry?.trunk_fat_mass_kg, prevWEntry?.trunk_fat_free_mass_kg),                           i: bcfNorm(kfaRaw(wEntry.trunk_fat_mass_kg, wEntry.trunk_fat_free_mass_kg), 5, 40) },
    { lbl: "Arm L",  kg: wEntry.left_arm_fat_mass_kg,      pRaw: kfaRaw(wEntry.left_arm_fat_mass_kg, wEntry.left_arm_fat_free_mass_kg),                     prevRaw: kfaRaw(prevWEntry?.left_arm_fat_mass_kg, prevWEntry?.left_arm_fat_free_mass_kg),                     i: bcfNorm(kfaRaw(wEntry.left_arm_fat_mass_kg, wEntry.left_arm_fat_free_mass_kg), 5, 30) },
    { lbl: "Arm R",  kg: wEntry.right_arm_fat_mass_kg,     pRaw: kfaRaw(wEntry.right_arm_fat_mass_kg, wEntry.right_arm_fat_free_mass_kg),                   prevRaw: kfaRaw(prevWEntry?.right_arm_fat_mass_kg, prevWEntry?.right_arm_fat_free_mass_kg),                   i: bcfNorm(kfaRaw(wEntry.right_arm_fat_mass_kg, wEntry.right_arm_fat_free_mass_kg), 5, 30) },
    { lbl: "Bein L", kg: wEntry.left_leg_fat_mass_kg,      pRaw: kfaRaw(wEntry.left_leg_fat_mass_kg, wEntry.left_leg_fat_free_mass_kg),                     prevRaw: kfaRaw(prevWEntry?.left_leg_fat_mass_kg, prevWEntry?.left_leg_fat_free_mass_kg),                     i: bcfNorm(kfaRaw(wEntry.left_leg_fat_mass_kg, wEntry.left_leg_fat_free_mass_kg), 5, 30) },
    { lbl: "Bein R", kg: wEntry.right_leg_fat_mass_kg,     pRaw: kfaRaw(wEntry.right_leg_fat_mass_kg, wEntry.right_leg_fat_free_mass_kg),                   prevRaw: kfaRaw(prevWEntry?.right_leg_fat_mass_kg, prevWEntry?.right_leg_fat_free_mass_kg),                   i: bcfNorm(kfaRaw(wEntry.right_leg_fat_mass_kg, wEntry.right_leg_fat_free_mass_kg), 5, 30) },
  ];

  const RED = "#D94545", YLW = "#E8C84A", GRN = "#3DBE7B";
  const gradBar = isMuscle
    ? `linear-gradient(to right, ${RED}, ${YLW}, ${GRN})`
    : `linear-gradient(to right, ${GRN}, ${YLW}, ${RED})`;

  if (!lib) return (
    <div className="rounded-2xl p-4 text-center text-sm" style={{ background: C.surface, border: `1px dashed ${C.line}`, color: C.muted }}>
      Körperfigur wird geladen…
    </div>
  );

  return (
    <div className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
      {/* Mode toggle */}
      <div className="flex gap-2 mb-3">
        {[["muscle", "Muskeln"], ["fat", "Körperfett"]].map(([m, lbl]) => (
          <button key={m} onClick={() => setMode(m)} className="flex-1 rounded-xl py-1.5 text-sm font-semibold"
            style={{ background: mode === m ? C.surface2 : "transparent",
              color: mode === m ? C.accent2 : C.muted,
              border: `1px solid ${mode === m ? C.accent2 : C.line}` }}>
            {lbl}
          </button>
        ))}
      </div>

      {/* Figur (links, kleiner) + Legende (rechts) */}
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        {/* body-muscles Figur mit CSS-Farbtransformation */}
        <div
          ref={ref}
          style={{
            width: 120,
            flexShrink: 0,
            // Muskeln: Rot→Grün per hue-rotate (hohe Intensität = viel Muskel → grün)
            // Fett: keine Rotation, Library-Heatmap gelb→rot passt (viel Fett = rot)
            filter: isMuscle ? "hue-rotate(120deg) saturate(1.2)" : "none",
          }}
        />

        {/* Rechte Seite: Farbskala + Segmentwerte */}
        <div style={{ flex: 1, minWidth: 0, paddingTop: 4 }}>
          {/* Gradient-Legende */}
          <div style={{ marginBottom: 10 }}>
            <div style={{ height: 7, borderRadius: 4, background: gradBar, marginBottom: 3 }} />
            <div className="flex justify-between" style={{ fontSize: 10, color: C.muted }}>
              <span style={{ color: isMuscle ? RED : GRN }}>{isMuscle ? "wenig" : "niedrig"}</span>
              <span style={{ color: isMuscle ? GRN : RED }}>{isMuscle ? "viel" : "hoch"}</span>
            </div>
          </div>

          {/* Segmentwerte */}
          <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 8 }}>
            <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: C.accent, marginBottom: 7 }}>
              {isMuscle ? "Muskelmasse" : "Körperfett"} · Seg.
            </div>
            {segs.map(({ lbl, kg, pRaw, prevRaw, i }) => (
              <div key={lbl} style={{ display: "flex", alignItems: "center", marginBottom: 5, fontSize: 12 }}>
                <span style={{ width: 10, height: 10, borderRadius: 2, flexShrink: 0, marginRight: 6, background: segColor(i) }} />
                <span style={{ color: C.muted, flexShrink: 0 }}>{lbl}</span>
                <span style={{ color: C.text, fontVariantNumeric: "tabular-nums", marginLeft: "auto" }}>{fmt(kg)}</span>
                <span style={{ color: C.muted, fontVariantNumeric: "tabular-nums", width: 44, textAlign: "right", fontSize: 10.5 }}>
                  {pRaw != null ? `${pRaw.toFixed(1)} %` : "—"}
                  {trendArrow(pRaw, prevRaw)}
                </span>
              </div>
            ))}
            <div style={{ fontSize: 9, color: C.muted, marginTop: 4 }}>
              {isMuscle ? "% v. Körpergewicht" : "% = KFA des Segments"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TrendSparklines({ wData, metrics }) {
  const cutoff = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  // Merge dates from both sources, last 30 days, oldest→newest
  const allDates = [...new Set([
    ...Object.keys(wData),
    ...(metrics || []).map(e => e.dateISO?.slice(0, 10)).filter(Boolean),
  ])].filter(d => d >= cutoff).sort();

  const series = [
    {
      lbl: "Gewicht", unit: "kg", color: "#E8B04B",
      val: d => wData[d]?.weight_kg ?? (metrics || []).find(e => e.dateISO?.slice(0,10) === d)?.weightKg ?? null,
    },
    {
      lbl: "KFA", unit: "%", color: "#D94545",
      val: d => wData[d]?.fat_ratio_pct ?? (metrics || []).find(e => e.dateISO?.slice(0,10) === d)?.fatTotal ?? null,
    },
    {
      lbl: "Muskeln", unit: "%", color: "#5FB99A",
      val: d => {
        const w = wData[d];
        if (w?.muscle_mass_kg != null && w?.weight_kg != null) return +((w.muscle_mass_kg / w.weight_kg) * 100).toFixed(1);
        const m = (metrics || []).find(e => e.dateISO?.slice(0,10) === d);
        return m?.musclePct ?? (m?.muscleMassKg != null && m?.weightKg ? +((m.muscleMassKg / m.weightKg) * 100).toFixed(1) : null);
      },
    },
  ];

  if (allDates.length < 2) return null;
  const H = 36, W = "100%";

  return (
    <div className="rounded-2xl p-4 mb-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
      <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: C.accent, marginBottom: 10 }}>
        Verlauf 30 Tage
      </div>
      {series.map(({ lbl, unit, color, val }) => {
        const pts = allDates.map(d => val(d)).filter(v => v != null);
        if (pts.length < 2) return null;
        const mn = Math.min(...pts), mx = Math.max(...pts);
        const range = mx - mn || 1;
        const values = allDates.map(val).filter(v => v != null);
        const indexedPts = allDates.map((d, i) => [i, val(d)]).filter(([, v]) => v != null);
        const xScale = (i) => (i / (allDates.length - 1)) * 100;
        const yScale = (v) => H - ((v - mn) / range) * (H - 4) - 2;
        const poly = indexedPts.map(([i, v]) => `${xScale(i)},${yScale(v)}`).join(" ");
        const first = values[0], last = values[values.length - 1];
        const diff = last - first;
        return (
          <div key={lbl} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <span style={{ width: 42, fontSize: 10, color: C.muted, flexShrink: 0 }}>{lbl}</span>
            <svg style={{ flex: 1 }} height={H} viewBox={`0 0 100 ${H}`} preserveAspectRatio="none">
              <polyline points={poly} fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
            </svg>
            <span style={{ width: 70, fontSize: 10, textAlign: "right", flexShrink: 0, color: C.muted, fontVariantNumeric: "tabular-nums" }}>
              <b style={{ color: C.text }}>{last.toFixed(1)} {unit}</b>
              <span style={{ marginLeft: 4, color: diff === 0 ? C.muted : (diff > 0 ? (lbl === "Muskeln" ? "#3DBE7B" : "#D94545") : (lbl === "Muskeln" ? "#D94545" : "#3DBE7B")) }}>
                {diff > 0 ? "↑" : diff < 0 ? "↓" : ""}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}

/* ---------- Foto-Tagebuch ---------- */
const POSE_META = [
  { key: "front", label: "Front" },
  { key: "side", label: "Seite" },
  { key: "back", label: "Rücken" },
];
const POSE_LABEL = { front: "Front", side: "Seite", back: "Rücken" };

// Halbtransparente Pose-Silhouetten als Positionierungshilfe über dem Kamerabild.
function PoseSilhouette({ pose }) {
  const fill = "#FFFFFF";
  const common = { fill, opacity: 0.3, stroke: "#FFFFFF", strokeOpacity: 0.4, strokeWidth: 1 };
  const wrap = { position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none" };
  if (pose === "side") {
    // Profil: Kopf seitlich, ein Arm, leicht nach vorn gebeugter Rumpf.
    return (
      <svg viewBox="0 0 100 200" preserveAspectRatio="xMidYMid meet" style={wrap}>
        <circle cx="54" cy="20" r="12" {...common} />
        <path {...common} d="M50 33 C58 33 62 40 60 50 L62 92 C62 100 60 108 58 118 L60 150 L56 190 L48 190 L48 150 L46 118 C44 108 44 98 44 88 L40 60 C39 48 42 36 50 33 Z" />
        <path {...common} d="M56 56 C66 60 72 72 70 88 L66 110 L60 108 L62 88 C62 76 58 66 52 62 Z" />
      </svg>
    );
  }
  // Front / Rücken: symmetrische stehende Figur, Arme leicht abgespreizt.
  const body = "M50 34 C57 34 61 39 62 46 L72 52 C77 55 79 60 79 66 L77 98 L71 98 L69 68 L64 62 L64 104 L66 150 L62 192 L54 192 L52 122 L48 122 L46 192 L38 192 L34 150 L36 104 L36 62 L31 68 L29 98 L23 98 L21 66 C21 60 23 55 28 52 L38 46 C39 39 43 34 50 34 Z";
  return (
    <svg viewBox="0 0 100 200" preserveAspectRatio="xMidYMid meet" style={wrap}>
      <circle cx="50" cy="20" r="12" {...common} />
      <path {...common} d={body} />
      {pose === "back" && <line x1="50" y1="46" x2="50" y2="118" stroke="#FFFFFF" strokeOpacity={0.35} strokeWidth={1.5} strokeDasharray="4 3" />}
    </svg>
  );
}

// Körperdaten beider Quellen (lokale Erfassung tt_*_bodymetrics + Withings/Supabase) zu einer nach
// Datum aufsteigend sortierten Reihe {dateISO, weightKg, fatPct, muscleMassKg} zusammenführen.
// Pro Tag Felder mergen (lokal zuerst, Withings ergänzt fehlende Werte) – gleiche Logik wie die Home-Karte.
const mergedBodyData = (bodyMetrics, measurements) => {
  const num = (v) => (typeof v === "number" && isFinite(v)) ? v : (v != null && v !== "" && isFinite(Number(v)) ? Number(v) : null);
  const byDay = new Map();
  const put = (dateISO, w, fat, musc) => {
    if (!dateISO) return;
    const day = String(dateISO).slice(0, 10);
    const prev = byDay.get(day) || { dateISO: day + "T00:00:00.000Z" };
    if (prev.weightKg == null) prev.weightKg = num(w);
    if (prev.fatPct == null) prev.fatPct = num(fat);
    if (prev.muscleMassKg == null) prev.muscleMassKg = num(musc);
    byDay.set(day, prev);
  };
  (bodyMetrics || []).forEach((m) => put(m.dateISO, m.weightKg, m.fatTotal, m.muscleMassKg));
  (measurements || []).forEach((m) => put(m.dateISO, m.weightKg, m.fatPct, m.muscleMassKg));
  return [...byDay.values()].sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO));
};
// Nächstgelegene Körpermessung zu einem Foto-Datum (innerhalb maxDays Tagen), sonst null.
const nearestBodyData = (list, iso, maxDays) => {
  const t = new Date(iso).getTime();
  let best = null, bestD = Infinity;
  (list || []).forEach((m) => {
    const d = Math.abs(new Date(m.dateISO).getTime() - t) / 86400000;
    if (d < bestD && d <= (maxDays || 21)) { bestD = d; best = m; }
  });
  return best;
};

function PhotoDiaryView({ photos, user, onUpload, onDelete, onBack, bodyMetrics, measurements }) {
  const [pose, setPose] = useState("front");
  const [filter, setFilter] = useState("all");
  const [camOn, setCamOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const videoRef = React.useRef(null);
  const streamRef = React.useRef(null);
  const fileRef = React.useRef(null);
  // Vergleichsmodus (Vorher/Nachher-Slider, nur Fotos gleicher Pose)
  const [cmp, setCmp] = useState(false);
  const [cmpPose, setCmpPose] = useState("front");
  const [leftFile, setLeftFile] = useState(null);
  const [rightFile, setRightFile] = useState(null);
  const [slider, setSlider] = useState(50);
  const cmpRef = React.useRef(null);
  const draggingRef = React.useRef(false);
  const bodyList = useMemo(() => mergedBodyData(bodyMetrics, measurements), [bodyMetrics, measurements]);

  const stopCam = () => {
    if (streamRef.current) { try { streamRef.current.getTracks().forEach((t) => t.stop()); } catch (e) {} streamRef.current = null; }
    setCamOn(false);
  };
  const startCam = async () => {
    setErr(null);
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { setErr("Kamera wird von diesem Gerät/Browser nicht unterstützt."); return; }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: "environment" } }, audio: false });
      streamRef.current = stream;
      setCamOn(true);
      // Video-Element ist erst nach dem Re-Render vorhanden.
      requestAnimationFrame(() => { requestAnimationFrame(() => { if (videoRef.current) { videoRef.current.srcObject = stream; videoRef.current.play().catch(() => {}); } }); });
    } catch (e) { setErr("Kamerazugriff verweigert oder nicht möglich."); }
  };
  useEffect(() => () => stopCam(), []); // Kamera beim Verlassen sicher stoppen

  const capture = async () => {
    const v = videoRef.current;
    if (!v || !v.videoWidth) return;
    const canvas = document.createElement("canvas");
    canvas.width = v.videoWidth; canvas.height = v.videoHeight;
    canvas.getContext("2d").drawImage(v, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
    setBusy(true);
    const ok = await onUpload(dataUrl, pose, new Date().toISOString());
    setBusy(false);
    if (ok) stopCam(); else setErr("Speichern fehlgeschlagen.");
  };

  const onFiles = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setBusy(true); setErr(null);
    let fail = 0;
    for (const f of files) {
      const dataUrl = await new Promise((resolve) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = () => resolve(null); r.readAsDataURL(f); });
      const takenAt = f.lastModified ? new Date(f.lastModified).toISOString() : new Date().toISOString();
      if (!dataUrl || !(await onUpload(dataUrl, pose, takenAt))) fail++;
    }
    setBusy(false);
    if (fail) setErr(`${fail} Bild(er) konnten nicht gespeichert werden.`);
  };

  const shown = (photos || []).filter((p) => filter === "all" || p.pose === filter);
  const imgUrl = (p) => `/api/phototagebuch?user=${encodeURIComponent(user)}&file=${encodeURIComponent(p.file)}`;
  const poseBtn = (key, label, active, onClick) => (
    <button key={key} onClick={onClick} className="rounded-xl px-3 py-2 text-sm font-semibold"
      style={{ background: active ? C.surface2 : C.surface, color: active ? C.accent2 : C.muted, border: `1px solid ${active ? C.accent2 : C.line}` }}>{label}</button>
  );

  // ----- Vergleichsmodus: nur Fotos gleicher Pose, chronologisch (alt → neu) -----
  const cmpShots = (photos || []).filter((p) => p.pose === cmpPose).sort((a, b) => new Date(a.takenAt) - new Date(b.takenAt));
  useEffect(() => {
    if (!cmp) return;
    const files = cmpShots.map((p) => p.file);
    if (!files.includes(leftFile)) setLeftFile(files[0] || null);
    if (!files.includes(rightFile)) setRightFile(files[files.length - 1] || null);
  }, [cmp, cmpPose, photos]);
  const leftPhoto = cmpShots.find((p) => p.file === leftFile) || null;
  const rightPhoto = cmpShots.find((p) => p.file === rightFile) || null;
  const leftBody = leftPhoto ? nearestBodyData(bodyList, leftPhoto.takenAt, 21) : null;
  const rightBody = rightPhoto ? nearestBodyData(bodyList, rightPhoto.takenAt, 21) : null;
  const setFromClientX = (clientX) => {
    const el = cmpRef.current; if (!el) return;
    const r = el.getBoundingClientRect();
    setSlider(Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100)));
  };
  const onSlideDown = (e) => { draggingRef.current = true; setFromClientX(e.clientX); try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_) {} };
  const onSlideMove = (e) => { if (draggingRef.current) setFromClientX(e.clientX); };
  const onSlideUp = () => { draggingRef.current = false; };
  // Körperdaten-Delta-Karte: betterDir +1 = höher besser, -1 = niedriger besser, 0 = neutral.
  const cmpMetric = (label, unit, lv, rv, betterDir) => {
    const has = (v) => typeof v === "number" && isFinite(v);
    const d = (has(lv) && has(rv)) ? rv - lv : null;
    let col = C.muted, arrow = "";
    if (d != null && Math.abs(d) >= 0.05) {
      arrow = d > 0 ? "▲" : "▼";
      if (betterDir !== 0) col = ((betterDir > 0 ? d > 0 : d < 0)) ? C.accent2 : C.danger;
    }
    return (
      <div className="rounded-xl p-2.5" style={{ background: C.surface2, border: `1px solid ${C.line}` }}>
        <div className="text-[10px] uppercase tracking-wide mb-1" style={{ color: C.muted }}>{label}</div>
        <div className="flex items-baseline justify-between" style={NUM}>
          <span className="text-xs" style={{ color: C.muted }}>{has(lv) ? lv.toFixed(1) : "–"}</span>
          <span className="text-xs" style={{ color: C.text }}>→ {has(rv) ? rv.toFixed(1) : "–"}</span>
        </div>
        <div className="text-xs font-bold mt-0.5" style={{ ...NUM, color: col }}>{d == null ? "–" : `${arrow} ${d > 0 ? "+" : ""}${d.toFixed(1)} ${unit}`}</div>
      </div>
    );
  };

  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>📸 Foto-Tagebuch</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Fortschrittsfotos</h1>
        </div>
        <button onClick={() => { stopCam(); onBack(); }} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
      </header>

      <div className="text-[10px] uppercase tracking-widest mb-1.5" style={{ color: C.muted }}>Pose wählen</div>
      <div className="grid grid-cols-3 gap-2 mb-4">
        {POSE_META.map((p) => poseBtn(p.key, p.label, pose === p.key, () => setPose(p.key)))}
      </div>

      {camOn ? (
        <div className="mb-4">
          <div className="relative w-full rounded-2xl overflow-hidden" style={{ background: "#000", aspectRatio: "3 / 4", border: `1px solid ${C.line}` }}>
            <video ref={videoRef} autoPlay playsInline muted style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
            <PoseSilhouette pose={pose} />
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <button onClick={capture} disabled={busy} className="rounded-xl py-3 text-sm font-bold" style={{ background: C.accent2, color: C.bg, opacity: busy ? 0.6 : 1 }}>
              {busy ? "…" : "📷 Auslösen"}
            </button>
            <button onClick={stopCam} className="rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface, color: C.danger, border: `1px solid ${C.line}` }}>Kamera aus</button>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2 mb-4">
          <button onClick={startCam} className="rounded-xl py-3 text-sm font-semibold" style={{ background: C.surface2, color: C.accent2, border: `1px solid ${C.line}` }}>
            📷 Kamera ({POSE_LABEL[pose]})
          </button>
          <label className="rounded-xl py-3 text-sm font-semibold text-center cursor-pointer" style={{ background: C.surface, color: C.accent, border: `1px solid ${C.line}` }}>
            🖼 Aus Galerie
            <input ref={fileRef} type="file" accept="image/*" multiple className="hidden"
              onChange={(e) => { const fs = e.target.files; e.target.value = ""; onFiles(fs); }} />
          </label>
        </div>
      )}

      {busy && !camOn && <div className="text-xs mb-3" style={{ color: C.muted }}>Wird hochgeladen…</div>}
      {err && <div className="text-xs mb-3" style={{ color: C.danger }}>{err}</div>}

      <div className="flex items-center justify-between mb-2 mt-6">
        <h2 className="text-sm font-bold uppercase tracking-widest" style={{ color: C.accent }}>Galerie ({shown.length})</h2>
        <button onClick={() => setCmp((c) => !c)} className="text-xs font-semibold rounded-full px-3 py-1.5"
          style={{ background: cmp ? C.accent2 : C.surface2, color: cmp ? C.bg : C.accent2, border: `1px solid ${C.accent2}` }}>
          {cmp ? "✓ Fertig" : "⇋ Vergleichen"}
        </button>
      </div>

      {cmp && (
        <div className="rounded-2xl p-3 mb-4" style={{ background: C.surface, border: `1px solid ${C.accent2}` }}>
          <div className="text-[10px] uppercase tracking-widest mb-1.5" style={{ color: C.muted }}>Pose (nur gleiche Pose vergleichbar)</div>
          <div className="grid grid-cols-3 gap-2 mb-3">
            {POSE_META.map((p) => poseBtn("c_" + p.key, p.label, cmpPose === p.key, () => setCmpPose(p.key)))}
          </div>
          {cmpShots.length < 2 ? (
            <div className="text-sm rounded-xl p-3" style={{ color: C.muted, background: C.surface2, border: `1px solid ${C.line}` }}>
              Mindestens zwei Fotos der Pose „{POSE_LABEL[cmpPose]}" nötig, um zu vergleichen.
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-2 mb-3">
                <div>
                  <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.accent }}>Vorher</div>
                  <select value={leftFile || ""} onChange={(e) => setLeftFile(e.target.value)} className="w-full rounded-lg px-2 py-1.5 text-xs"
                    style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }}>
                    {cmpShots.map((p) => <option key={p.file} value={p.file}>{fmtDate(p.takenAt)}</option>)}
                  </select>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.accent2 }}>Nachher</div>
                  <select value={rightFile || ""} onChange={(e) => setRightFile(e.target.value)} className="w-full rounded-lg px-2 py-1.5 text-xs"
                    style={{ background: C.surface2, color: C.text, border: `1px solid ${C.line}` }}>
                    {cmpShots.map((p) => <option key={p.file} value={p.file}>{fmtDate(p.takenAt)}</option>)}
                  </select>
                </div>
              </div>

              <div ref={cmpRef} onPointerDown={onSlideDown} onPointerMove={onSlideMove} onPointerUp={onSlideUp} onPointerCancel={onSlideUp}
                className="relative w-full rounded-2xl overflow-hidden select-none"
                style={{ aspectRatio: "3 / 4", background: "#000", border: `1px solid ${C.line}`, touchAction: "none", cursor: "ew-resize" }}>
                {rightPhoto && <img src={imgUrl(rightPhoto)} alt="Nachher" draggable={false}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none" }} />}
                {leftPhoto && <img src={imgUrl(leftPhoto)} alt="Vorher" draggable={false}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none", clipPath: `inset(0 ${100 - slider}% 0 0)` }} />}
                <div className="text-[10px] font-bold rounded-full px-2 py-0.5" style={{ position: "absolute", top: 8, left: 8, background: "rgba(0,0,0,0.55)", color: "#fff" }}>Vorher · {leftPhoto ? fmtDate(leftPhoto.takenAt) : "–"}</div>
                <div className="text-[10px] font-bold rounded-full px-2 py-0.5" style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,0.55)", color: "#fff" }}>Nachher · {rightPhoto ? fmtDate(rightPhoto.takenAt) : "–"}</div>
                <div style={{ position: "absolute", top: 0, bottom: 0, left: `${slider}%`, width: 2, background: "#fff", transform: "translateX(-1px)", pointerEvents: "none", boxShadow: "0 0 6px rgba(0,0,0,0.6)" }}>
                  <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 34, height: 34, borderRadius: "50%", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", color: "#111", fontSize: 15, fontWeight: 700, boxShadow: "0 1px 5px rgba(0,0,0,0.5)" }}>⇋</div>
                </div>
              </div>
              <div className="text-[10px] text-center mt-1.5" style={{ color: C.muted }}>Trennlinie ziehen, um zwischen den Fotos überzublenden.</div>

              <div className="mt-3">
                <div className="text-[10px] uppercase tracking-widest mb-1.5" style={{ color: C.muted }}>Körperdaten im Zeitraum</div>
                {(!leftBody && !rightBody) ? (
                  <div className="text-xs rounded-xl p-3" style={{ color: C.muted, background: C.surface2, border: `1px solid ${C.line}` }}>
                    Keine Körperdaten in der Nähe dieser Aufnahmedaten (±21 Tage).
                  </div>
                ) : (
                  <>
                    <div className="grid grid-cols-3 gap-2">
                      {cmpMetric("Gewicht", "kg", leftBody && leftBody.weightKg, rightBody && rightBody.weightKg, 0)}
                      {cmpMetric("Fettanteil", "%", leftBody && leftBody.fatPct, rightBody && rightBody.fatPct, -1)}
                      {cmpMetric("Muskelmasse", "kg", leftBody && leftBody.muscleMassKg, rightBody && rightBody.muscleMassKg, +1)}
                    </div>
                    <div className="text-[10px] mt-1.5" style={{ color: C.muted }}>Werte je nächster Messung zum Foto-Datum. Grün = Verbesserung, Rot = Verschlechterung.</div>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      )}

      <div className="flex gap-2 mb-3">
        {poseBtn("all", "Alle", filter === "all", () => setFilter("all"))}
        {POSE_META.map((p) => poseBtn("f_" + p.key, p.label, filter === p.key, () => setFilter(p.key)))}
      </div>

      {shown.length === 0 ? (
        <div className="text-sm rounded-xl p-4" style={{ color: C.muted, background: C.surface, border: `1px solid ${C.line}` }}>
          Noch keine Fotos. Nutze die Kamera mit Silhouette oder lade Bilder aus der Galerie – nach Pose gefiltert vergleichst du später deinen Fortschritt.
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          {shown.map((p) => (
            <div key={p.file} className="rounded-xl overflow-hidden relative" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <img src={imgUrl(p)} alt={p.pose} onClick={() => setLightbox(p)} loading="lazy"
                style={{ width: "100%", aspectRatio: "3 / 4", objectFit: "cover", cursor: "pointer", display: "block" }} />
              <div className="px-1.5 py-1 flex items-center justify-between">
                <div>
                  <div className="text-[10px] font-semibold" style={{ color: C.text }}>{fmtDate(p.takenAt)}</div>
                  <div className="text-[9px] uppercase tracking-wide" style={{ color: C.accent2 }}>{POSE_LABEL[p.pose] || p.pose}</div>
                </div>
                <button onClick={() => { if (window.confirm("Foto löschen?")) onDelete(p.file); }} className="text-[11px]" style={{ color: C.danger }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {lightbox && (
        <div onClick={() => setLightbox(null)} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.9)" }}>
          <div className="max-w-full max-h-full flex flex-col items-center gap-2">
            <img src={imgUrl(lightbox)} alt={lightbox.pose} style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", borderRadius: 12 }} />
            <div className="text-sm" style={{ color: C.text }}>{fmtDate(lightbox.takenAt)} · {POSE_LABEL[lightbox.pose] || lightbox.pose}</div>
          </div>
        </div>
      )}
    </div>
  );
}

function BodyMetricsView({ metrics, photos, onSave, onDelete, onAddPhotos, onDeletePhoto, onBack, sbToken }) {
  const todayValue = dateInputValue(new Date().toISOString());
  const [subview, setSubview] = useState(null);
  const [dateISO, setDateISO] = useState(new Date().toISOString());
  const EMPTY = { weightKg: "", bmi: "", fatTotal: "", fatMassKg: "", fatArms: "", fatTorso: "", fatLegs: "",
    musclePct: "", muscleMassKg: "", muscleTrunk: "", muscleArmL: "", muscleArmR: "", muscleLegL: "", muscleLegR: "",
    bodyWaterPct: "", visceralFat: "", bmr: "", metabolicAge: "", boneMassKg: "" };
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [wData, setWData] = useState({});
  const [wOnlyEntries, setWOnlyEntries] = useState([]);
  const [syncing, setSyncing] = useState(false);
  const [syncErr, setSyncErr] = useState(null);
  const fnBase = `${SB_URL}/functions/v1`;
  const authHdr = sbToken ? { Authorization: `Bearer ${sbToken}` } : {};

  const loadMeasurements = () => {
    if (!sbToken) return Promise.resolve();
    const sbClient = window.supabase.createClient(SB_URL, SB_ANON_KEY, {
      global: { headers: { Authorization: `Bearer ${sbToken}` } },
      db: { schema: "trainer" },
      auth: { persistSession: false, autoRefreshToken: false },
    });
    return sbClient.from("body_measurements")
      .select("measured_at,source,weight_kg,fat_ratio_pct,fat_mass_kg,fat_free_mass_kg,muscle_mass_kg,bone_mass_kg,water_mass_kg,visceral_fat,bmr_kcal,trunk_muscle_mass_kg,left_arm_muscle_mass_kg,right_arm_muscle_mass_kg,left_leg_muscle_mass_kg,right_leg_muscle_mass_kg,left_arm_fat_mass_kg,right_arm_fat_mass_kg,left_leg_fat_mass_kg,right_leg_fat_mass_kg,trunk_fat_mass_kg,left_arm_fat_free_mass_kg,right_arm_fat_free_mass_kg,left_leg_fat_free_mass_kg,right_leg_fat_free_mass_kg,trunk_fat_free_mass_kg")
      .order("measured_at", { ascending: false })
      .limit(90)
      .then(({ data }) => {
        const map = {};
        for (const row of (data || [])) {
          const d = row.measured_at.slice(0, 10);
          if (!map[d] || (row.left_arm_muscle_mass_kg != null && map[d].left_arm_muscle_mass_kg == null)) map[d] = row;
        }
        setWData(map);
        const kvDates = new Set((metrics || []).map(e => e.dateISO?.slice(0, 10)).filter(Boolean));
        const wOnly = Object.keys(map)
          .filter(d => !kvDates.has(d))
          .map(d => ({ id: `w_${d}`, dateISO: d + 'T00:00:00.000Z', _withingsOnly: true }));
        setWOnlyEntries(wOnly);
      });
  };

  // Withings-Sync (dieselbe Edge Function wie in WithingsView). Danach Daten neu laden statt Reload.
  const sync = async (silent) => {
    if (!sbToken) return;
    setSyncing(true); setSyncErr(null);
    try {
      const r = await fetch(`${fnBase}/withings-sync`, { headers: authHdr });
      const j = await r.json();
      if (!r.ok) {
        if (j.error === "reauth_required") throw new Error("Withings-Verbindung abgelaufen — unter „Körperdaten“ neu verbinden.");
        if (j.error === "not_connected") throw new Error("Withings nicht verbunden — unter „Körperdaten“ verbinden.");
        throw new Error(j.error || "Sync fehlgeschlagen");
      }
      await loadMeasurements();
    } catch (e) {
      if (!silent) setSyncErr(String(e));
    } finally {
      setSyncing(false);
    }
  };

  useEffect(() => {
    if (!sbToken) return;
    // Vorhandene Daten sofort anzeigen und parallel im Hintergrund synchronisieren (blockiert die UI nicht).
    loadMeasurements();
    sync(true);
  }, [sbToken]);
  const set = (k, v) => setF((o) => ({ ...o, [k]: v }));
  const nf = (k, label, ph, accent) => <NumField label={label} value={f[k]} onChange={(e) => set(k, e.target.value)} placeholder={ph} accent={accent} />;
  const onPickPhotos = async (e) => {
    const files = Array.from(e.target.files || []); e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const items = [];
      for (const file of files) {
        try { items.push({ takenAt: new Date(file.lastModified || Date.now()).toISOString(), dataUrl: await fileToJpegDataUrl(file) }); }
        catch (err) { /* nicht dekodierbares Bild überspringen */ }
      }
      if (!items.length) { window.alert("Konnte keine Bilder lesen."); return; }
      const n = await onAddPhotos(items);
      if (!n) window.alert("Upload fehlgeschlagen – keine Verbindung zum Server.");
    } finally { setBusy(false); }
  };
  const onChangeDate = (e) => {
    const v = e.target.value; if (!v) return;
    const [y, m, dd] = v.split("-").map(Number);
    const d = new Date(dateISO); if (Number.isNaN(d.getTime())) d.setTime(Date.now());
    d.setFullYear(y, m - 1, dd); setDateISO(d.toISOString());
  };
  const anyVal = Object.values(f).some((v) => String(v).trim() !== "");
  const save = () => { if (!anyVal) return; onSave({ dateISO, ...f }); setF(EMPTY); setSubview(null); };
  const cutoff30 = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const combined = [...(metrics || []), ...wOnlyEntries]
    .filter(e => (e.dateISO || "").slice(0, 10) >= cutoff30)
    .sort((a, b) => b.dateISO.localeCompare(a.dateISO));
  const fmtN = (v, u) => (v == null ? "—" : `${v}${u || ""}`);
  const delta = (cur, prev, u, goodDown) => {
    if (cur == null || prev == null) return null;
    const d = Math.round((cur - prev) * 10) / 10;
    if (d === 0) return <span style={{ color: C.muted }}>±0</span>;
    const improved = goodDown ? d < 0 : d > 0;
    return <span style={{ color: improved ? C.accent2 : C.danger }}>{d > 0 ? "+" : ""}{d}{u || ""}</span>;
  };

  const sortedWDates = Object.keys(wData).sort().reverse();
  const latestWDate = sortedWDates[0];
  const latestWEntry = latestWDate ? wData[latestWDate] : null;
  const prevWEntry = sortedWDates[1] ? wData[sortedWDates[1]] : null;

  // MANUELLE ERFASSUNG SUBVIEW
  if (subview === "manual") {
    return (
      <div className="px-5 pb-12">
        <header className="pt-8 pb-4 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Körpermesswerte</div>
            <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Manuelle Erfassung</h1>
          </div>
          <button onClick={() => setSubview(null)} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
        </header>
        <div className="flex flex-col gap-4">
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Datum</div>
            <input type="date" value={dateInputValue(dateISO)} max={todayValue} onChange={onChangeDate}
              className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, colorScheme: "dark" }} />
          </label>
          <div className="grid grid-cols-2 gap-2">
            {nf("weightKg", "Gewicht (kg)", "z.B. 78,5")}
            {nf("bmi", "BMI", "z.B. 24,1")}
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.accent2 }}>Körperfett</div>
            <div className="grid grid-cols-2 gap-2">
              {nf("fatTotal", "Gesamt (%)", "z.B. 15,9")}
              {nf("fatMassKg", "Fettmasse (kg)", "z.B. 12,5")}
              {nf("fatArms", "Arme (%)", "")}
              {nf("fatTorso", "Torso (%)", "")}
              {nf("fatLegs", "Beine (%)", "")}
            </div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.accent2 }}>Muskelmasse</div>
            <div className="grid grid-cols-2 gap-2">
              {nf("musclePct", "Anteil (%)", "z.B. 79,9")}
              {nf("muscleMassKg", "Masse gesamt (kg)", "z.B. 63,0")}
            </div>
            <div className="grid grid-cols-3 gap-2 mt-2">
              {nf("muscleTrunk", "Torso (kg)", "")}
              {nf("muscleArmL", "Arm L (kg)", "")}
              {nf("muscleArmR", "Arm R (kg)", "")}
              {nf("muscleLegL", "Bein L (kg)", "")}
              {nf("muscleLegR", "Bein R (kg)", "")}
            </div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.accent2 }}>Weitere Werte</div>
            <div className="grid grid-cols-2 gap-2">
              {nf("bodyWaterPct", "Körperwasser (%)", "")}
              {nf("visceralFat", "Viszeralfett", "Stufe")}
              {nf("bmr", "Grundumsatz (kcal)", "")}
              {nf("metabolicAge", "Stoffwechselalter", "Jahre")}
              {nf("boneMassKg", "Knochenmasse (kg)", "")}
            </div>
          </div>
        </div>
        <button onClick={save} disabled={!anyVal}
          className="w-full mt-6 rounded-2xl py-4 font-bold text-lg disabled:opacity-40" style={{ background: C.accent, color: "#10201B" }}>
          Messung speichern
        </button>
        <p className="text-[11px] text-center mt-3" style={{ color: C.muted }}>Leere Felder werden ausgelassen. Werte gehen an den KI-Trainer.</p>
      </div>
    );
  }

  // HAUPTANSICHT
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Körpermesswerte</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Verlauf</h1>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => sync(false)} disabled={syncing} className="text-sm font-semibold" style={{ color: C.accent, opacity: syncing ? 0.6 : 1 }}>
            {syncing ? "Sync…" : "Withings Sync"}
          </button>
          <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.muted }}>Zurück</button>
        </div>
      </header>

      {syncErr && <div className="mb-3 text-xs rounded-lg p-2" style={{ color: C.danger, background: "rgba(224,122,95,0.12)" }}>{syncErr}</div>}

      {latestWEntry && <div className="mb-4"><BodyCompositionFigure wEntry={latestWEntry} prevWEntry={prevWEntry} /></div>}
      <TrendSparklines wData={wData} metrics={metrics} />

      <div className="grid grid-cols-2 gap-3 mb-6">
        <button onClick={() => setSubview("manual")}
          className="rounded-2xl py-4 font-bold text-sm" style={{ background: C.surface, border: `1px solid ${C.line}`, color: C.text }}>
          + Manuell erfassen
        </button>
        <label className="rounded-2xl py-4 font-bold text-sm text-center cursor-pointer"
          style={{ background: C.surface, border: `1px solid ${C.line}`, color: busy ? C.muted : C.text, display: "block" }}>
          {busy ? "Lade hoch …" : "+ Fotos hochladen"}
          <input type="file" accept="image/*" multiple className="hidden" disabled={busy} onChange={onPickPhotos} />
        </label>
      </div>

      {(photos || []).length > 0 && (
        <div className="mb-6">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-2" style={{ color: C.accent }}>TANITA-Fotos</h2>
          <p className="text-[11px] mb-3" style={{ color: C.muted }}>Fotografiere die Anzeige(n) der Waage und lade sie hoch – auch mehrere Screens auf einmal. Der KI-Trainer liest die Werte aus.</p>
          <div className="flex flex-col gap-2">
            {(photos || []).map((p) => (
              <div key={p.id} className="flex items-center justify-between rounded-xl px-3 py-2" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <div>
                  <div className="font-semibold text-sm">{fmtDate(p.takenAt)}</div>
                  <div className="text-[11px]" style={{ color: p.status === "processed" ? C.accent2 : C.accent }}>
                    {p.status === "processed" ? "✓ ausgewertet" : "wartet auf KI-Auswertung"}
                  </div>
                </div>
                <button onClick={() => onDeletePhoto(p.id)} className="text-xs" style={{ color: C.danger }}>löschen</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {combined.length > 0 && (
        <div className="mt-8">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-3" style={{ color: C.accent }}>Verlauf ({combined.length})</h2>
          <div className="flex flex-col gap-2">
            {combined.map((e, i) => {
              const prev = combined[i + 1];
              const w = e.dateISO ? wData[e.dateISO.slice(0, 10)] : null;
              const isWOnly = !!e._withingsOnly;
              const segKfa = (fat, ff) => fat != null && ff != null && (fat + ff) > 0 ? +((fat / (fat + ff)) * 100).toFixed(1) : null;
              const n1 = (v) => v != null ? +Number(v).toFixed(1) : null;
              const n2 = (v) => v != null ? +Number(v).toFixed(2) : null;
              const pctOfWeight = (part, total) => part != null && total != null && total > 0 ? +((part / total) * 100).toFixed(1) : null;
              const prevWeightOf = (entry) => {
                if (!entry) return null;
                if (entry._withingsOnly) return n1(wData[entry.dateISO?.slice(0, 10)]?.weight_kg);
                return entry.weightKg ?? null;
              };
              const eff = {
                weightKg: isWOnly ? n1(w?.weight_kg) : e.weightKg,
                fatTotal: isWOnly ? n1(w?.fat_ratio_pct) : e.fatTotal,
                fatMassKg: e.fatMassKg ?? n1(w?.fat_mass_kg),
                muscleMassKg: e.muscleMassKg ?? n1(w?.muscle_mass_kg),
                musclePct: isWOnly ? null : e.musclePct,
                bodyWaterPct: isWOnly ? null : e.bodyWaterPct,
                visceralFat: e.visceralFat ?? w?.visceral_fat,
                bmr: e.bmr ?? n1(w?.bmr_kcal),
                muscleTrunk: e.muscleTrunk ?? n1(w?.trunk_muscle_mass_kg),
                muscleArmL: e.muscleArmL ?? n2(w?.left_arm_muscle_mass_kg),
                muscleArmR: e.muscleArmR ?? n2(w?.right_arm_muscle_mass_kg),
                muscleLegL: e.muscleLegL ?? n1(w?.left_leg_muscle_mass_kg),
                muscleLegR: e.muscleLegR ?? n1(w?.right_leg_muscle_mass_kg),
                fatArms: e.fatArms ?? (w?.left_arm_fat_mass_kg != null && w?.left_arm_fat_free_mass_kg != null && w?.right_arm_fat_mass_kg != null && w?.right_arm_fat_free_mass_kg != null
                  ? segKfa(w.left_arm_fat_mass_kg + w.right_arm_fat_mass_kg, w.left_arm_fat_free_mass_kg + w.right_arm_fat_free_mass_kg) : null),
                fatTorso: e.fatTorso ?? segKfa(w?.trunk_fat_mass_kg, w?.trunk_fat_free_mass_kg),
                fatLegs: e.fatLegs ?? (w?.left_leg_fat_mass_kg != null && w?.left_leg_fat_free_mass_kg != null && w?.right_leg_fat_mass_kg != null && w?.right_leg_fat_free_mass_kg != null
                  ? segKfa(w.left_leg_fat_mass_kg + w.right_leg_fat_mass_kg, w.left_leg_fat_free_mass_kg + w.right_leg_fat_free_mass_kg) : null),
                muscleArmLPct: pctOfWeight(w?.left_arm_muscle_mass_kg, w?.weight_kg),
                muscleArmRPct: pctOfWeight(w?.right_arm_muscle_mass_kg, w?.weight_kg),
                muscleLegLPct: pctOfWeight(w?.left_leg_muscle_mass_kg, w?.weight_kg),
                muscleLegRPct: pctOfWeight(w?.right_leg_muscle_mass_kg, w?.weight_kg),
                muscleTrunkPct: pctOfWeight(w?.trunk_muscle_mass_kg, w?.weight_kg),
                fatTrunkKg: n1(w?.trunk_fat_mass_kg),
                fatArmLKg: n1(w?.left_arm_fat_mass_kg),
                fatArmRKg: n1(w?.right_arm_fat_mass_kg),
                fatLegLKg: n1(w?.left_leg_fat_mass_kg),
                fatLegRKg: n1(w?.right_leg_fat_mass_kg),
                fatArmLPct: segKfa(w?.left_arm_fat_mass_kg, w?.left_arm_fat_free_mass_kg),
                fatArmRPct: segKfa(w?.right_arm_fat_mass_kg, w?.right_arm_fat_free_mass_kg),
                fatLegLPct: segKfa(w?.left_leg_fat_mass_kg, w?.left_leg_fat_free_mass_kg),
                fatLegRPct: segKfa(w?.right_leg_fat_mass_kg, w?.right_leg_fat_free_mass_kg),
              };
              const sourceBadge = w
                ? <span style={{ color: C.accent2, fontSize: 10, fontWeight: 700, marginLeft: 6 }}>● Withings</span>
                : (!isWOnly ? <span style={{ color: C.muted, fontSize: 10, marginLeft: 6 }}>Tanita/manuell</span> : null);
              return (
                <div key={e.id} className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                  <div className="flex items-center justify-between">
                    <div className="font-bold text-sm">{fmtDate(e.dateISO)}{sourceBadge}</div>
                    {!isWOnly && <button onClick={() => onDelete(e.id)} className="text-xs" style={{ color: C.danger }}>löschen</button>}
                  </div>
                  <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
                    <div style={{ color: C.muted }}>Gewicht <b style={{ color: C.text, ...NUM }}>{fmtN(eff.weightKg, " kg")}</b> {prev && delta(eff.weightKg, prevWeightOf(prev), " kg", true)}</div>
                    <div style={{ color: C.muted }}>Muskelmasse <b style={{ color: C.text, ...NUM }}>{fmtN(eff.muscleMassKg, " kg")}</b></div>
                    <div style={{ color: C.muted }}>KFA ges. <b style={{ color: C.text, ...NUM }}>{fmtN(eff.fatTotal, " %")}</b></div>
                    <div style={{ color: C.muted }}>Fettmasse <b style={{ color: C.text, ...NUM }}>{fmtN(eff.fatMassKg, " kg")}</b></div>
                    {eff.musclePct != null && <div style={{ color: C.muted }}>Muskel <b style={{ color: C.text, ...NUM }}>{fmtN(eff.musclePct, " %")}</b></div>}
                    {eff.bodyWaterPct != null && <div style={{ color: C.muted }}>Wasser <b style={{ color: C.text, ...NUM }}>{fmtN(eff.bodyWaterPct, " %")}</b></div>}
                    {eff.visceralFat != null && <div style={{ color: C.muted }}>Viszeral <b style={{ color: C.text, ...NUM }}>{fmtN(eff.visceralFat, "")}</b></div>}
                    {eff.bmr != null && <div style={{ color: C.muted }}>Grundumsatz <b style={{ color: C.text, ...NUM }}>{fmtN(eff.bmr, " kcal")}</b></div>}
                    {(() => {
                      const rows = [
                        ["Torso",  eff.fatTrunkKg, eff.fatTorso,  eff.muscleTrunk, eff.muscleTrunkPct],
                        ["Arm L",  eff.fatArmLKg,  eff.fatArmLPct, eff.muscleArmL,  eff.muscleArmLPct],
                        ["Arm R",  eff.fatArmRKg,  eff.fatArmRPct, eff.muscleArmR,  eff.muscleArmRPct],
                        ["Bein L", eff.fatLegLKg,  eff.fatLegLPct, eff.muscleLegL,  eff.muscleLegLPct],
                        ["Bein R", eff.fatLegRKg,  eff.fatLegRPct, eff.muscleLegR,  eff.muscleLegRPct],
                      ].filter(([, fkg, , mkg]) => fkg != null || mkg != null);
                      if (!rows.length) return null;
                      const TD = ({ children, right }) => (
                        <td style={{ padding: "2px 4px", color: C.text, fontVariantNumeric: "tabular-nums", textAlign: right ? "right" : "left", whiteSpace: "nowrap" }}>{children}</td>
                      );
                      const TH = ({ children }) => (
                        <th style={{ padding: "0 4px 4px", color: C.muted, fontSize: 9, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", textAlign: "left" }}>{children}</th>
                      );
                      return (
                        <div style={{ gridColumn: "1 / -1", marginTop: 6, borderTop: `1px solid ${C.line}`, paddingTop: 6 }}>
                          <table style={{ width: "100%", fontSize: 11, borderCollapse: "collapse" }}>
                            <thead>
                              <tr>
                                <TH>Seg.</TH>
                                <TH>KFA kg</TH>
                                <TH>KFA %</TH>
                                <TH>Musk. kg</TH>
                                <TH>Musk. %</TH>
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map(([lbl, fkg, fpct, mkg, mpct]) => (
                                <tr key={lbl}>
                                  <td style={{ padding: "2px 4px", color: C.muted, fontSize: 11 }}>{lbl}</td>
                                  <TD right>{fkg != null ? `${fkg} kg` : "—"}</TD>
                                  <TD right>{fpct != null ? `${fpct} %` : "—"}</TD>
                                  <TD right>{mkg != null ? `${mkg} kg` : "—"}</TD>
                                  <TD right>{mpct != null ? `${mpct} %` : "—"}</TD>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    })()}
                  </div>
                  {!isWOnly && (() => {
                    const hx = [
                      e.restingHR != null ? `Ruhepuls ${e.restingHR}` : null,
                      e.hrv != null ? `HRV ${e.hrv} ms` : null,
                      e.sleepHours != null ? `Schlaf ${String(e.sleepHours).replace(".", ",")} h` : null,
                      e.activeKcal != null ? `aktiv ${e.activeKcal} kcal` : null,
                      e.dietaryKcal != null ? `Nahrung ${e.dietaryKcal} kcal` : null,
                      e.proteinG != null ? `Protein ${e.proteinG} g` : null,
                      e.steps != null ? `${e.steps} Schritte` : null,
                      e.vo2max != null ? `VO₂max ${String(e.vo2max).replace(".", ",")}` : null,
                    ].filter(Boolean);
                    return hx.length ? <div className="mt-2 pt-2 text-xs" style={{ color: C.muted, borderTop: `1px solid ${C.line}` }}>{hx.join(" · ")}</div> : null;
                  })()}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- Cardio / Yoga Erfassung ---------- */
function ConditioningSession({ entry, onChange, onSave, onCancel }) {
  const isYoga = entry.type === "yoga";
  const isCore = entry.type === "core";
  const isCardio = entry.type === "cardio";
  const accent = condAccent(entry.type);
  const label = isYoga ? "★ Yoga" : isCore ? "🔥 Core" : "♥ Cardio";
  const calIcon = isYoga ? "Stern ★" : isCore ? "Flamme 🔥" : "Herz ♥";
  const set = (k, v) => onChange({ ...entry, [k]: v });
  const onChangeDate = (e) => {
    const v = e.target.value; if (!v) return;
    const [y, m, dd] = v.split("-").map(Number);
    const d = new Date(entry.dateISO); if (Number.isNaN(d.getTime())) d.setTime(Date.now());
    d.setFullYear(y, m - 1, dd); set("dateISO", d.toISOString());
  };
  const canSave = Number(entry.durationMin) > 0;
  const todayValue = dateInputValue(new Date().toISOString());
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-4 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: accent }}>{label}</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>{entry.activity}</h1>
        </div>
        <button onClick={onCancel} className="text-sm font-semibold" style={{ color: C.muted }}>Abbrechen</button>
      </header>

      <div className="flex flex-col gap-4">
        <label className="block">
          <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Datum</div>
          <input type="date" value={dateInputValue(entry.dateISO)} max={todayValue} onChange={onChangeDate}
            className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, colorScheme: "dark" }} />
        </label>
        <label className="block">
          <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Dauer (Minuten)</div>
          <input type="number" inputMode="numeric" min="0" value={entry.durationMin} onChange={(e) => set("durationMin", e.target.value)} placeholder="z.B. 30"
            className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, ...NUM }} />
        </label>
        {isCardio && (
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Distanz (km)</div>
            <input type="text" inputMode="decimal" value={entry.distanceKm} onChange={(e) => set("distanceKm", e.target.value)} placeholder="z.B. 5,0"
              className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}`, ...NUM }} />
          </label>
        )}
        {isCore && (
          <p className="text-[11px] rounded-xl p-3" style={{ color: C.muted, background: C.surface, border: `1px solid ${C.line}` }}>Planks, Side Planks, Crunches, V-Hold … zählt als <b style={{ color: C.accent2 }}>2 Bauch-Sätze</b> im Wochenvolumen.</p>
        )}
        <label className="block">
          <div className="text-[10px] uppercase tracking-widest mb-1" style={{ color: C.muted }}>Notiz (optional)</div>
          <input type="text" value={entry.note} onChange={(e) => set("note", e.target.value)} placeholder="z.B. Zone 2, locker"
            className="w-full rounded-xl px-3 py-3 outline-none" style={{ background: C.surface, color: C.text, border: `1px solid ${C.line}` }} />
        </label>
      </div>

      <button onClick={() => canSave && onSave(entry)} disabled={!canSave}
        className="w-full mt-6 rounded-2xl py-4 font-bold text-lg disabled:opacity-40" style={{ background: accent, color: "#10201B" }}>
        Einheit speichern
      </button>
      <p className="text-[11px] text-center mt-3" style={{ color: C.muted }}>Erscheint im Kalender als {calIcon} am gewählten Tag.</p>
    </div>
  );
}

/* ---------- Apple-Style Ringe ---------- */
function Rings({ fills, size = 44, stroke }) {
  const sw = stroke || Math.max(3, size * 0.12);
  const gap = sw * 0.45;
  const cx = size / 2, cy = size / 2;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {RING_GROUPS.map((g, i) => {
        const r = size / 2 - sw / 2 - i * (sw + gap);
        if (r <= 1) return null;
        const c = 2 * Math.PI * r;
        const frac = Math.max(0, Math.min(1, (fills && fills[g]) || 0));
        const col = GROUP[g] || C.accent2;
        return (
          <g key={g} transform={`rotate(-90 ${cx} ${cy})`}>
            <circle cx={cx} cy={cy} r={r} fill="none" stroke={col} strokeOpacity="0.18" strokeWidth={sw} />
            <circle cx={cx} cy={cy} r={r} fill="none" stroke={col} strokeWidth={sw} strokeLinecap="round" strokeDasharray={`${frac * c} ${c}`} />
          </g>
        );
      })}
    </svg>
  );
}

/* ---------- Kalender ---------- */
const MONTHS_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
function Calendar({ history, onBack, onAnalyze, onOpenDetail }) {
  const dmap = useMemo(() => byDay(history), [history]);
  const now = new Date();
  const [cur, setCur] = useState({ y: now.getFullYear(), m: now.getMonth() });
  const [sel, setSel] = useState(null);
  const first = new Date(cur.y, cur.m, 1);
  const startPad = (first.getDay() + 6) % 7;
  const daysInMonth = new Date(cur.y, cur.m + 1, 0).getDate();
  const todayKey = dayKey(now.toISOString());
  const cells = [];
  for (let i = 0; i < startPad; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  const prevMonth = () => setCur((c) => (c.m === 0 ? { y: c.y - 1, m: 11 } : { y: c.y, m: c.m - 1 }));
  const nextMonth = () => setCur((c) => (c.m === 11 ? { y: c.y + 1, m: 0 } : { y: c.y, m: c.m + 1 }));
  const keyFor = (d) => `${cur.y}-${String(cur.m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const selSessions = sel ? (dmap.get(sel) || []) : [];

  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-3 flex items-center justify-between">
        <h1 className="text-3xl font-extrabold" style={{ letterSpacing: "-0.02em" }}>Kalender</h1>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>

      <div className="flex items-center justify-between mb-3">
        <button onClick={prevMonth} className="rounded-lg px-3 py-1.5 font-bold" style={{ color: C.accent2 }}>‹</button>
        <div className="font-bold">{MONTHS_DE[cur.m]} {cur.y}</div>
        <button onClick={nextMonth} className="rounded-lg px-3 py-1.5 font-bold" style={{ color: C.accent2 }}>›</button>
      </div>

      <div className="grid grid-cols-7 gap-1 mb-1">
        {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((w) => (
          <div key={w} className="text-center text-[10px] font-semibold" style={{ color: C.muted }}>{w}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (d == null) return <div key={`p${i}`} />;
          const k = keyFor(d);
          const sessions = dmap.get(k) || [];
          const r = sessions.length ? dayRings(sessions) : null;
          const isToday = k === todayKey;
          const isSel = k === sel;
          return (
            <button key={k} onClick={() => setSel(isSel ? null : k)}
              className="rounded-lg flex flex-col items-center justify-start pt-1 pb-1"
              style={{ aspectRatio: "1 / 1", background: isSel ? C.surface2 : "transparent", border: `1px solid ${isToday ? C.accent : isSel ? C.line : "transparent"}` }}>
              <span className="text-[10px] leading-none" style={{ ...NUM, color: isToday ? C.accent : C.muted }}>{d}</span>
              <div className="flex-1 flex items-center justify-center">
                {r ? <Rings fills={r.fills} size={26} /> : <span style={{ width: 26, height: 26 }} />}
              </div>
              <div className="h-3 leading-none text-[9px]">
                {r && r.yoga && <span style={{ color: C.accent }}>★</span>}
                {r && r.cardio && <span style={{ color: C.danger }}>♥</span>}
                {r && r.core && <span>🔥</span>}
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-x-3 gap-y-1 mt-3 text-[11px]" style={{ color: C.muted }}>
        {RING_GROUPS.map((g) => (
          <span key={g} className="flex items-center gap-1"><span style={{ width: 8, height: 8, borderRadius: 99, background: GROUP[g], display: "inline-block" }} />{g}</span>
        ))}
        <span className="flex items-center gap-1"><span style={{ color: C.accent }}>★</span> Yoga</span>
        <span className="flex items-center gap-1"><span style={{ color: C.danger }}>♥</span> Cardio</span>
        <span className="flex items-center gap-1">🔥 Core</span>
      </div>
      <div className="text-[11px] mt-1" style={{ color: C.muted }}>Ring schließt bei {DAY_RING_TARGET} harten Sätzen der Gruppe an diesem Tag.</div>

      {sel && (
        <div className="mt-5">
          <h2 className="text-sm font-bold uppercase tracking-widest mb-2" style={{ color: C.accent }}>{fmtDate(sel + "T12:00:00")}</h2>
          {selSessions.length === 0 ? (
            <div className="text-sm rounded-xl p-4" style={{ color: C.muted, background: C.surface, border: `1px dashed ${C.line}` }}>Kein Training an diesem Tag.</div>
          ) : (
            <div className="flex flex-col gap-2">
              {selSessions.map((s) => (
                <div key={s.id} className="rounded-xl p-3 flex items-center justify-between gap-2" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                  <div className="min-w-0">
                    <div className="font-semibold text-sm">{isCond(s) ? `${condIcon(s.type)} ${s.activity}` : s.day}</div>
                    <div className="text-xs" style={{ color: C.muted }}>
                      {isCond(s) ? `${s.durationMin} Min${s.type === "cardio" && s.distanceKm > 0 ? ` · ${s.distanceKm} km` : ""}` : `${totalSets(s)} Sätze · ${Math.round(volume(s)).toLocaleString("de-DE")} kg`}
                    </div>
                  </div>
                  {!isCond(s) && <button onClick={() => onAnalyze(s)} className="text-xs font-semibold rounded-lg px-3 py-1.5 shrink-0" style={{ background: C.accent, color: "#1A140A" }}>Auswertung</button>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ---------- Mapping unserer 6 Gruppen auf die body-muscles-IDs (exakt) ---------- */
const GROUP_LIB_IDS = {
  "Brust": ["chest-upper-left", "chest-upper-right", "chest-lower-left", "chest-lower-right"],
  "Rücken": ["lats-upper-left", "lats-mid-left", "lats-lower-left", "lats-upper-right", "lats-mid-right", "lats-lower-right", "lower-back-erectors-left", "lower-back-ql-left", "lower-back-erectors-right", "lower-back-ql-right", "spine"],
  "Schulter": ["shoulder-front-left", "shoulder-front-right", "shoulder-side-left", "shoulder-side-right", "deltoid-rear-left", "deltoid-rear-right", "traps-upper-left", "traps-mid-left", "traps-lower-left", "traps-upper-right", "traps-mid-right", "traps-lower-right"],
  "Arme": ["biceps-left", "biceps-right", "triceps-long-left", "triceps-lateral-left", "triceps-long-right", "triceps-lateral-right", "forearm-left", "forearm-right", "forearm-flexors-left", "forearm-extensors-left", "forearm-flexors-right", "forearm-extensors-right"],
  "Beine": ["quads-left", "quads-right", "hamstrings-medial-left", "hamstrings-lateral-left", "hamstrings-medial-right", "hamstrings-lateral-right", "adductors-left", "adductors-right", "tibialis-anterior-left", "tibialis-anterior-right", "calves-gastroc-medial-left", "calves-gastroc-lateral-left", "calves-soleus-left", "calves-gastroc-medial-right", "calves-gastroc-lateral-right", "calves-soleus-right", "gluteus-medius-left", "gluteus-maximus-left", "gluteus-medius-right", "gluteus-maximus-right", "hip-flexor-left", "hip-flexor-right"],
  "Bauch": ["abs-upper-left", "abs-upper-right", "abs-lower-left", "abs-lower-right", "serratus-anterior-left", "serratus-anterior-right", "obliques-left", "obliques-right"],
};
const LIBID_GROUP = {};
Object.keys(GROUP_LIB_IDS).forEach((g) => GROUP_LIB_IDS[g].forEach((id) => (LIBID_GROUP[id] = g)));

/* ---------- Muskelkarte via body-muscles (BodyChart), konkrete Muskeln ---------- */
const LIBID_MUSCLE = {};
Object.keys(MUSCLES).forEach((m) => MUSCLES[m].lib.forEach((id) => (LIBID_MUSCLE[id] = m)));

function BodyMuscleMap({ muscleEff, detail }) {
  const ref = React.useRef(null);
  const chartRef = React.useRef(null);
  const [view, setView] = useState("FRONT");
  const [selM, setSelM] = useState(null);
  const [lib, setLib] = useState(typeof window !== "undefined" ? window.BodyMuscles : null);

  // Library evtl. noch nicht geladen -> kurz pollen.
  useEffect(() => {
    if (lib || typeof window === "undefined") return;
    let n = 0; const iv = setInterval(() => {
      if (window.BodyMuscles) { setLib(window.BodyMuscles); clearInterval(iv); }
      else if (++n > 40) clearInterval(iv);
    }, 150);
    return () => clearInterval(iv);
  }, [lib]);

  const bodyState = useMemo(() => {
    const max = Math.max(1, ...Object.values(muscleEff || {}));
    const st = {};
    Object.keys(MUSCLES).forEach((m) => {
      const eff = (muscleEff || {})[m] || 0;
      const intensity = eff <= 0 ? 0 : Math.max(2, Math.min(10, Math.round((eff / max) * 10)));
      MUSCLES[m].lib.forEach((id) => { const prev = st[id] ? st[id].intensity : 0; const sel = (st[id] && st[id].selected) || selM === m; st[id] = { intensity: Math.max(prev, intensity), selected: sel }; });
    });
    return st;
  }, [muscleEff, selM]);

  useEffect(() => {
    if (!lib || !ref.current) return;
    try {
      chartRef.current = new lib.BodyChart(ref.current, {
        view: lib.ViewSide.FRONT, bodyState, ariaLabel: "Muskelkarte – effektive Sätze pro Muskel",
        onMuscleClick: (id) => { const m = LIBID_MUSCLE[id]; if (m) setSelM((p) => (p === m ? null : m)); },
      });
    } catch (e) { console.error("BodyChart init failed", e); }
    return () => { try { chartRef.current && chartRef.current.destroy(); } catch (e) {} };
  }, [lib]);
  useEffect(() => { try { chartRef.current && chartRef.current.update({ bodyState }); } catch (e) {} }, [bodyState]);
  useEffect(() => { if (lib && chartRef.current) try { chartRef.current.update({ view: view === "FRONT" ? lib.ViewSide.FRONT : lib.ViewSide.BACK }); } catch (e) {} }, [view, lib]);

  if (!lib) return <div className="rounded-2xl p-6 text-center text-sm" style={{ background: C.surface, border: `1px dashed ${C.line}`, color: C.muted }}>Muskelkarte wird geladen … (braucht Internet). Erscheint nichts, bitte Seite neu laden.</div>;

  const exForSel = selM ? (detail[selM] || {}) : null;
  const names = exForSel ? Object.keys(exForSel).sort((a, b) => exForSel[b] - exForSel[a]) : [];
  return (
    <div>
      <div className="flex gap-2 mb-3">
        {[["FRONT", "Vorderseite"], ["BACK", "Rückseite"]].map(([v, label]) => (
          <button key={v} onClick={() => setView(v)} className="flex-1 rounded-xl py-2 text-sm font-semibold"
            style={{ background: view === v ? C.surface2 : "transparent", color: view === v ? C.accent2 : C.muted, border: `1px solid ${view === v ? C.accent2 : C.line}` }}>{label}</button>
        ))}
      </div>
      <div ref={ref} style={{ maxWidth: 360, margin: "0 auto" }} />
      <div className="text-[11px] text-center mt-1" style={{ color: C.muted }}>Heatmap nach effektiven Sätzen: wenig (hell/gelb) → viel Training (rot). Tippe einen Muskel an.</div>
      <div className="text-[11px] text-center mt-0.5" style={{ color: C.muted }}>Waden, Beinbeuger, Gesäß, Trizeps, hintere Schulter & Rücken siehst du auf der <b style={{ color: C.accent2 }}>Rückseite</b>.</div>

      <div className="mt-4 rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}`, minHeight: 80 }}>
        {selM ? (
          <>
            <div className="flex items-center justify-between">
              <div className="font-bold">{muscleLabel(selM)} <span className="text-xs font-normal" style={{ color: C.muted }}>· {muscleGroup(selM)}</span></div>
              <div className="text-xs font-semibold rounded-full px-3 py-1" style={{ background: C.surface2, color: C.accent2 }}>{fmtSets((muscleEff || {})[selM] || 0)} eff. Sätze</div>
            </div>
            {names.length ? (
              <div className="mt-2 flex flex-col gap-1.5">
                {names.map((n) => (
                  <div key={n} className="flex items-center justify-between text-sm">
                    <span className="truncate pr-2">{n}</span>
                    <span style={{ ...NUM, color: C.muted }}>{fmtSets(exForSel[n])}×</span>
                  </div>
                ))}
              </div>
            ) : <div className="text-sm mt-1" style={{ color: C.muted }}>In diesem Zeitraum nicht trainiert.</div>}
          </>
        ) : <div className="text-sm" style={{ color: C.muted }}>Tippe auf einen Muskel, um zu sehen, welche Übungen ihn wie stark (effektive Sätze) trainiert haben.</div>}
      </div>
    </div>
  );
}

function MusclesView({ history, onBack }) {
  const [days, setDays] = useState(30);
  const { muscleEff, detail, count } = useMemo(() => {
    const cut = Date.now() - days * 86400000;
    const sessions = (history || []).filter((s) => !isCond(s) && (days === 0 || new Date(s.dateISO).getTime() >= cut));
    const muscleEff = effectiveSetsByMuscle(sessions);
    const detail = {};
    let count = 0;
    sessions.forEach((s) => (s.exercises || []).forEach((e) => {
      const n = (e.sets || []).filter(isWorkingSet).length; if (!n) return; count++;
      const mi = exerciseMuscleInvolvement(e);
      Object.keys(mi).forEach((mid) => { const f = mi[mid]; if (f < 1 && e.logSecondary === false) return; detail[mid] = detail[mid] || {}; detail[mid][e.name] = (detail[mid][e.name] || 0) + n * f; });
    }));
    return { muscleEff, detail, count };
  }, [history, days]);
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-3 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>Muskelkarte</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Trainingsfrequenz</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>
      <div className="flex gap-2 mb-4">
        {[[7, "7 Tage"], [30, "30 Tage"], [0, "Alle"]].map(([d, label]) => (
          <button key={d} onClick={() => setDays(d)} className="flex-1 rounded-xl py-2 text-sm font-semibold"
            style={{ background: days === d ? C.accent : C.surface, color: days === d ? "#1A140A" : C.muted, border: `1px solid ${C.line}` }}>{label}</button>
        ))}
      </div>
      {count === 0 ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Keine Daten im Zeitraum</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Absolviere Workouts – die Karte färbt sich nach effektiven Sätzen pro Muskel.</div>
        </div>
      ) : <BodyMuscleMap muscleEff={muscleEff} detail={detail} />}
    </div>
  );
}

/* ---------- KI-Trainer ---------- */
const CHANGE_LABEL = (ch) => {
  if (!ch || !ch.op) return null;
  if (ch.op === "add") return `+ ${ch.name} in „${ch.day}"`;
  if (ch.op === "remove") return `− ${ch.name} aus „${ch.day}"`;
  if (ch.op === "replace") return `„${ch.name}" → „${ch.toName}" in „${ch.day}"`;
  if (ch.op === "set_sets") return `${ch.name}: ${ch.sets} Sätze (in „${ch.day}")`;
  if (ch.op === "set_reps") return `${ch.name}: ${ch.reps} Wdh (in „${ch.day}")`;
  if (ch.op === "add_day") return `neuer Tag „${ch.day}" (${(ch.exercises || []).length} Übungen)`;
  return null;
};
// Minimaler Markdown-Renderer: ## Überschriften, - Listen, **fett**, Absätze.
function mdInline(text) {
  return String(text).split(/(\*\*[^*]+\*\*)/g).map((p, i) => {
    const m = /^\*\*([^*]+)\*\*$/.exec(p);
    return m ? <strong key={i} style={{ color: C.text }}>{m[1]}</strong> : <React.Fragment key={i}>{p}</React.Fragment>;
  });
}
function Markdown({ text }) {
  const lines = String(text || "").split(/\r?\n/);
  const blocks = []; let para = [], list = [];
  const flushPara = () => { if (para.length) { blocks.push({ t: "p", c: para.join(" ") }); para = []; } };
  const flushList = () => { if (list.length) { blocks.push({ t: "ul", c: list.slice() }); list = []; } };
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushPara(); flushList(); continue; }
    let m;
    if ((m = /^#{1,6}\s+(.*)$/.exec(line))) { flushPara(); flushList(); blocks.push({ t: "h", c: m[1] }); }
    else if ((m = /^[-*]\s+(.*)$/.exec(line))) { flushPara(); list.push({ n: "•", c: m[1] }); }
    else if ((m = /^(\d+)[.)]\s+(.*)$/.exec(line))) { flushPara(); list.push({ n: m[1] + ".", c: m[2] }); }
    else { flushList(); para.push(line); }
  }
  flushPara(); flushList();
  return (
    <div className="flex flex-col gap-2">
      {blocks.map((b, i) => b.t === "h"
        ? <div key={i} className="text-sm font-bold mt-1" style={{ color: C.accent2 }}>{mdInline(b.c)}</div>
        : b.t === "ul"
          ? <ul key={i} className="flex flex-col gap-1">{b.c.map((it, j) => <li key={j} className="text-sm flex gap-2 leading-relaxed" style={{ color: C.text }}><span className="shrink-0 font-semibold" style={{ color: C.accent2 }}>{it.n}</span><span>{mdInline(it.c)}</span></li>)}</ul>
          : <p key={i} className="text-sm leading-relaxed" style={{ color: C.text }}>{mdInline(b.c)}</p>)}
    </div>
  );
}

function AiCoachView({ coach, history, measurements, onBack, onDecide, onPotential }) {
  const potential = useMemo(() => musclePotential(history || [], measurements || []), [history, measurements]);
  const topPotential = potential.slice(0, 3);
  const sugs = (coach && coach.suggestions) || [];
  const pending = sugs.filter((s) => s.status === "pending" || !s.status);
  const decided = sugs.filter((s) => s.status === "accepted" || s.status === "declined");
  const a = (coach && coach.analysis) || {};
  const NEW_SECTIONS = [["overview", "Überblick"], ["training", "Training & Leistung"], ["body", "Körper & Muskelmasse"], ["nutrition", "Ernährung"], ["recovery", "Erholung & Schlaf"], ["optimization", "Optimierung"]];
  const hasNew = NEW_SECTIONS.some(([k]) => a[k]);
  const sections = hasNew ? NEW_SECTIONS : [["last", "Letztes Training"], ["week", "Letzte 7 Tage"], ["month", "Letzte 30 Tage"], ["body", "Körpermesswerte"]];
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-3 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>🤖 KI-Trainer</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Einschätzung</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>

      {!coach ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Noch keine KI-Auswertung</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Die Analyse läuft stündlich automatisch. Nach deinem nächsten abgeschlossenen Training erscheint hier die Einschätzung.</div>
        </div>
      ) : (
        <>
          <div className="text-[11px] mb-3" style={{ color: C.muted }}>Stand: {coach.generatedAt ? fmtDate(coach.generatedAt) + " " + new Date(coach.generatedAt).toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }) : "–"}</div>

          {sections.map(([key, title]) => a[key] ? (
            <div key={key} className="rounded-2xl p-4 mb-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <div className="text-xs uppercase tracking-widest mb-2" style={{ color: C.accent }}>{title}</div>
              <Markdown text={a[key]} />
            </div>
          ) : null)}

          {topPotential.length > 0 && (
            <button onClick={onPotential} className="w-full text-left rounded-2xl p-4 mb-3" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-widest" style={{ color: C.accent }}>💪 Muskel-Potenzial</div>
                <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: C.accent2, border: `1px solid ${C.line}` }}>Alle ansehen</span>
              </div>
              <div className="flex flex-col gap-1.5 mt-2.5">
                {topPotential.map((m) => (
                  <div key={m.mid} className="flex items-center justify-between text-sm">
                    <span style={{ color: C.text }}>{m.label} <span style={{ color: C.muted }}>· {fmtSets(m.v)}/{m.mev}–{m.mav} Sätze</span></span>
                    <span className="font-bold" style={{ ...NUM, color: m.score >= 66 ? C.accent : m.score >= 33 ? C.accent2 : C.muted }}>{m.score}</span>
                  </div>
                ))}
              </div>
            </button>
          )}

          <h2 className="text-sm font-bold uppercase tracking-widest mt-5 mb-2" style={{ color: C.accent }}>Vorschläge {pending.length > 0 && <span style={{ color: C.muted }}>· {pending.length} offen</span>}</h2>
          {pending.length === 0 && <div className="text-sm rounded-xl p-4 mb-2" style={{ color: C.muted, background: C.surface, border: `1px dashed ${C.line}` }}>Keine offenen Vorschläge.</div>}
          <div className="flex flex-col gap-2">
            {pending.map((s) => (
              <div key={s.id} className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <div className="font-bold">{s.title}</div>
                {s.detail && <div className="text-sm mt-1" style={{ color: C.muted }}>{s.detail}</div>}
                {CHANGE_LABEL(s.change) && <div className="text-xs mt-2 rounded-lg px-3 py-1.5 inline-block" style={{ background: "#0E1B17", color: C.accent2 }}>{CHANGE_LABEL(s.change)}</div>}
                <div className="flex gap-2 mt-3">
                  <button onClick={() => onDecide(s.id, true)} className="flex-1 rounded-xl py-2.5 font-bold text-sm" style={{ background: C.accent2, color: "#0C1A15" }}>Ja{s.change ? " · übernehmen" : ""}</button>
                  <button onClick={() => onDecide(s.id, false)} className="flex-1 rounded-xl py-2.5 font-bold text-sm" style={{ background: "transparent", color: C.danger, border: `1px solid ${C.line}` }}>Nein</button>
                </div>
              </div>
            ))}
          </div>

          {decided.length > 0 && (
            <>
              <h2 className="text-sm font-bold uppercase tracking-widest mt-6 mb-2" style={{ color: C.muted }}>Bereits entschieden</h2>
              <div className="flex flex-col gap-2">
                {decided.map((s) => (
                  <div key={s.id} className="rounded-xl p-3 flex items-center justify-between gap-2" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                    <div className="min-w-0">
                      <div className="text-sm font-semibold truncate">{s.title}</div>
                      {CHANGE_LABEL(s.change) && <div className="text-[11px]" style={{ color: C.muted }}>{CHANGE_LABEL(s.change)}</div>}
                    </div>
                    <span className="text-xs font-semibold rounded-full px-3 py-1 shrink-0" style={{ color: s.status === "accepted" ? C.accent2 : C.danger, border: `1px solid ${C.line}` }}>{s.status === "accepted" ? "✓ übernommen" : "✕ abgelehnt"}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

/* ---------- Muskel-Potenzial-Report ---------- */
// Wochen-Bestwerte (e1RM) einer Übung, chronologisch aufsteigend – Basis für Progressions-/Stagnationsanalyse.
const exerciseWeeklyBest = (name, history) => {
  const byWk = new Map();
  (history || []).forEach((h) => {
    if (isCond(h)) return;
    const e = (h.exercises || []).find((x) => x.name === name);
    if (!e) return;
    const best = (e.sets || []).filter(isWorkingSet).reduce((m, x) => Math.max(m, est1RM(x.weight, x.reps)), 0);
    if (!best) return;
    const wk = weekKey(h.dateISO);
    byWk.set(wk, Math.max(byWk.get(wk) || 0, best));
  });
  return [...byWk.entries()].sort((a, b) => a[0].localeCompare(b[0])).map(([wk, best]) => ({ wk, best }));
};
// Trainingswochen seit dem letzten e1RM-Bestwert (0 = diese Woche noch gestiegen). null bei < 2 Wochen Daten.
const weeksSincePR = (series) => {
  if (!series || series.length < 2) return null;
  let maxV = -Infinity, maxIdx = 0;
  series.forEach((p, i) => { if (p.best > maxV + 1e-6) { maxV = p.best; maxIdx = i; } });
  return series.length - 1 - maxIdx;
};
// Potenzial je Muskel (nur Muskeln, die in den letzten 8 Wochen trainiert wurden), sortiert nach Score absteigend.
// Score = 55 % Volumen-Defizit (Ist der letzten 7 Tage vs. obere Grenze MAV) + 45 % Stagnation
// (Wochen ohne neuen e1RM-Bestwert der Primär-Übungen). Hoher Score = untertrainiert und/oder stagniert.
const musclePotential = (history, measurements) => {
  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const vol7 = effectiveSetsByMuscle(sessionsInLastDays(history, 7), true);
  const vol56 = effectiveSetsByMuscle(sessionsInLastDays(history, 56), true);
  const recent = sessionsInLastDays(history, 56);
  const exByMuscle = {}; // mid -> Set(Übungsnamen), bei denen der Muskel primär beteiligt ist
  recent.forEach((s) => {
    if (isCond(s)) return;
    (s.exercises || []).forEach((e) => {
      if (!(e.sets || []).some(isWorkingSet)) return;
      const mi = exerciseMuscleInvolvement(e, true);
      Object.keys(mi).forEach((mid) => { if (mi[mid] >= 1) { (exByMuscle[mid] = exByMuscle[mid] || new Set()).add(e.name); } });
    });
  });
  const out = [];
  Object.keys(MUSCLE_VOLUME_TARGETS).forEach((mid) => {
    const trained = (vol56[mid] || 0) > 0 || (exByMuscle[mid] && exByMuscle[mid].size > 0);
    if (!trained) return;
    const lm = MUSCLE_VOLUME_TARGETS[mid];
    const v = vol7[mid] || 0;
    let bestStagn = null;
    (exByMuscle[mid] ? [...exByMuscle[mid]] : []).forEach((name) => {
      const w = weeksSincePR(exerciseWeeklyBest(name, history));
      if (w != null) bestStagn = bestStagn == null ? w : Math.min(bestStagn, w);
    });
    const under = clamp01((lm.mav - v) / lm.mav);          // 1 = weit unter MAV, 0 = an/über MAV
    const stagn = bestStagn == null ? 0.4 : clamp01(bestStagn / 5);
    const score = Math.round(100 * (0.55 * under + 0.45 * stagn));
    out.push({ mid, group: muscleGroup(mid), label: muscleLabel(mid), v, mev: lm.mev, mav: lm.mav, stagnWeeks: bestStagn,
      exNames: exByMuscle[mid] ? [...exByMuscle[mid]] : [], score });
  });
  return out.sort((a, b) => b.score - a.score);
};
// Konkrete Empfehlung je Muskel. tone: low/caution/ok für die Einfärbung.
const potentialAdvice = (m) => {
  const need = Math.max(1, Math.ceil(m.mev - m.v));
  if (m.v === 0) return { text: `Nicht trainiert – mit ${m.mev} Sätzen/Woche (MEV) einsteigen.`, tone: "low" };
  if (m.v < m.mev) return { text: `Volumen erhöhen auf ${m.mev}+ Sätze/Woche (+${need}). Aktuell ${fmtSets(m.v)}.`, tone: "low" };
  if (m.stagnWeeks != null && m.stagnWeeks >= 3) return { text: `Progression stockt seit ${m.stagnWeeks} Wochen – Gewicht/Wdh. steigern oder Übungsvariante wechseln.`, tone: "caution" };
  if (m.v < m.mav) return { text: `Reiz erhöhen: Richtung ${m.mav} Sätze oder Last steigern.`, tone: "ok" };
  return { text: `Hohes Volumen (${fmtSets(m.v)} Sätze) – Fokus auf saubere Progression & Erholung.`, tone: "ok" };
};
const POTENTIAL_ADVICE_COLOR = { low: C.accent, caution: C.accent, ok: C.accent2 };

function MusclePotentialView({ history, measurements, onBack }) {
  const items = useMemo(() => musclePotential(history, measurements), [history, measurements]);
  const scoreColor = (s) => (s >= 66 ? C.accent : s >= 33 ? C.accent2 : C.muted);
  const scoreLabel = (s) => (s >= 66 ? "hohes Potenzial" : s >= 33 ? "mittleres Potenzial" : "gut ausgereizt");
  return (
    <div className="px-5 pb-12">
      <header className="pt-8 pb-3 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.25em]" style={{ color: C.accent }}>💪 Muskel-Potenzial</div>
          <h1 className="text-3xl font-extrabold mt-1" style={{ letterSpacing: "-0.02em" }}>Ungenutztes Potenzial</h1>
        </div>
        <button onClick={onBack} className="text-sm font-semibold" style={{ color: C.accent2 }}>Zurück</button>
      </header>
      <div className="text-sm mb-4" style={{ color: C.muted }}>Muskeln mit dem größten Wachstumsspielraum zuerst – Kombination aus Volumen unter der Zielzone und stockender Progression.</div>
      {items.length === 0 ? (
        <div className="rounded-2xl p-6 text-center" style={{ background: C.surface, border: `1px dashed ${C.line}` }}>
          <div className="font-semibold">Noch keine Trainingsdaten</div>
          <div className="text-sm mt-1" style={{ color: C.muted }}>Sobald du Einheiten protokollierst, erscheint hier die Potenzial-Analyse je Muskel.</div>
        </div>
      ) : (
        <div className="flex flex-col gap-2.5">
          {items.map((m) => {
            const adv = potentialAdvice(m);
            return (
              <div key={m.mid} className="rounded-2xl p-4" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-bold leading-tight">{m.label}</div>
                    <div className="text-[11px]" style={{ color: C.muted }}>{m.group}</div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="text-lg font-extrabold" style={{ ...NUM, color: scoreColor(m.score) }}>{m.score}</div>
                    <div className="text-[10px] uppercase tracking-wide" style={{ color: scoreColor(m.score) }}>{scoreLabel(m.score)}</div>
                  </div>
                </div>
                <div className="mt-3 mb-1 flex items-baseline justify-between text-xs" style={NUM}>
                  <span style={{ color: C.muted }}>Wochenvolumen</span>
                  <span><b style={{ color: C.text }}>{fmtSets(m.v)}</b> Sätze · Ziel {m.mev}–{m.mav}</span>
                </div>
                <MuscleVolumeBar v={m.v} mev={m.mev} mav={m.mav} />
                <div className="flex items-center gap-2 mt-2.5 text-[11px]">
                  {m.stagnWeeks == null
                    ? <span style={{ color: C.muted }}>Progression: zu wenig Daten</span>
                    : m.stagnWeeks === 0
                      ? <span style={{ color: C.accent2 }}>▲ Gewicht steigt aktuell</span>
                      : <span style={{ color: m.stagnWeeks >= 3 ? C.accent : C.muted }}>Stagnation: {m.stagnWeeks} Woche{m.stagnWeeks > 1 ? "n" : ""} ohne neuen Bestwert</span>}
                </div>
                <div className="text-xs mt-2 rounded-lg px-3 py-2" style={{ background: "#0E1B17", color: POTENTIAL_ADVICE_COLOR[adv.tone] }}>{adv.text}</div>
              </div>
            );
          })}
        </div>
      )}
      <div className="text-[11px] mt-4" style={{ color: C.muted }}>Score = 55 % Volumen-Defizit (Ist vs. obere Grenze MAV) + 45 % Stagnation (Wochen ohne e1RM-Bestwert). Zielzone <b style={{ color: C.text }}>MEV</b> (Minimum fürs Wachstum) bis <b style={{ color: C.text }}>MAV</b> (obere produktive Grenze).</div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(React.createElement(App));
